import { proxyCustomElement, HTMLElement, createEvent, h, Host, Fragment, forceUpdate } from '@stencil/core/internal/client';
import { c as createCommonjsModule$1, A as ANALYTICS_LINK_IDS, D as DROPDOWN_FIELDS, a as DEFAULT_PARAM_NAMES, b as DATE_RANGE_DEFAULTS, l as lodash, d as defineCustomElement$4 } from './wdpr-party-mix-select2.js';

var luxon$1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

// these aren't really private, but nor are they really useful to document
/**
 * @private
 */
var LuxonError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(LuxonError, _Error);
  function LuxonError() {
    return _Error.apply(this, arguments) || this;
  }
  return LuxonError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * @private
 */
var InvalidDateTimeError = /*#__PURE__*/function (_LuxonError) {
  _inheritsLoose(InvalidDateTimeError, _LuxonError);
  function InvalidDateTimeError(reason) {
    return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
  }
  return InvalidDateTimeError;
}(LuxonError);

/**
 * @private
 */
var InvalidIntervalError = /*#__PURE__*/function (_LuxonError2) {
  _inheritsLoose(InvalidIntervalError, _LuxonError2);
  function InvalidIntervalError(reason) {
    return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
  }
  return InvalidIntervalError;
}(LuxonError);

/**
 * @private
 */
var InvalidDurationError = /*#__PURE__*/function (_LuxonError3) {
  _inheritsLoose(InvalidDurationError, _LuxonError3);
  function InvalidDurationError(reason) {
    return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
  }
  return InvalidDurationError;
}(LuxonError);

/**
 * @private
 */
var ConflictingSpecificationError = /*#__PURE__*/function (_LuxonError4) {
  _inheritsLoose(ConflictingSpecificationError, _LuxonError4);
  function ConflictingSpecificationError() {
    return _LuxonError4.apply(this, arguments) || this;
  }
  return ConflictingSpecificationError;
}(LuxonError);

/**
 * @private
 */
var InvalidUnitError = /*#__PURE__*/function (_LuxonError5) {
  _inheritsLoose(InvalidUnitError, _LuxonError5);
  function InvalidUnitError(unit) {
    return _LuxonError5.call(this, "Invalid unit " + unit) || this;
  }
  return InvalidUnitError;
}(LuxonError);

/**
 * @private
 */
var InvalidArgumentError = /*#__PURE__*/function (_LuxonError6) {
  _inheritsLoose(InvalidArgumentError, _LuxonError6);
  function InvalidArgumentError() {
    return _LuxonError6.apply(this, arguments) || this;
  }
  return InvalidArgumentError;
}(LuxonError);

/**
 * @private
 */
var ZoneIsAbstractError = /*#__PURE__*/function (_LuxonError7) {
  _inheritsLoose(ZoneIsAbstractError, _LuxonError7);
  function ZoneIsAbstractError() {
    return _LuxonError7.call(this, "Zone is an abstract class") || this;
  }
  return ZoneIsAbstractError;
}(LuxonError);

/**
 * @private
 */

var n = "numeric",
  s = "short",
  l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

/**
 * @interface
 */
var Zone = /*#__PURE__*/function () {
  function Zone() {}
  var _proto = Zone.prototype;
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  _proto.offsetName = function offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */;
  _proto.formatOffset = function formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */;
  _proto.offset = function offset(ts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */;
  _proto.equals = function equals(otherZone) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */;
  _createClass(Zone, [{
    key: "type",
    get:
    /**
     * The type of zone
     * @abstract
     * @type {string}
     */
    function get() {
      throw new ZoneIsAbstractError();
    }

    /**
     * The name of this zone.
     * @abstract
     * @type {string}
     */
  }, {
    key: "name",
    get: function get() {
      throw new ZoneIsAbstractError();
    }

    /**
     * The IANA name of this zone.
     * Defaults to `name` if not overwritten by a subclass.
     * @abstract
     * @type {string}
     */
  }, {
    key: "ianaName",
    get: function get() {
      return this.name;
    }

    /**
     * Returns whether the offset is known to be fixed for the whole year.
     * @abstract
     * @type {boolean}
     */
  }, {
    key: "isUniversal",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }, {
    key: "isValid",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }]);
  return Zone;
}();

var singleton$1 = null;

/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */
var SystemZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(SystemZone, _Zone);
  function SystemZone() {
    return _Zone.apply(this, arguments) || this;
  }
  var _proto = SystemZone.prototype;
  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
      locale = _ref.locale;
    return parseZoneInfo(ts, format, locale);
  }

  /** @override **/;
  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/;
  _proto.offset = function offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }

  /** @override **/;
  _proto.equals = function equals(otherZone) {
    return otherZone.type === "system";
  }

  /** @override **/;
  _createClass(SystemZone, [{
    key: "type",
    get: /** @override **/
    function get() {
      return "system";
    }

    /** @override **/
  }, {
    key: "name",
    get: function get() {
      return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    /** @override **/
  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "instance",
    get:
    /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */
    function get() {
      if (singleton$1 === null) {
        singleton$1 = new SystemZone();
      }
      return singleton$1;
    }
  }]);
  return SystemZone;
}(Zone);

var dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted),
    fMonth = parsed[1],
    fDay = parsed[2],
    fYear = parsed[3],
    fadOrBc = parsed[4],
    fHour = parsed[5],
    fMinute = parsed[6],
    fSecond = parsed[7];
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date);
  var filled = [];
  for (var i = 0; i < formatted.length; i++) {
    var _formatted$i = formatted[i],
      type = _formatted$i.type,
      value = _formatted$i.value;
    var pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
var ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */
var IANAZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(IANAZone, _Zone);
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  IANAZone.create = function create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }

  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */;
  IANAZone.resetCache = function resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }

  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */;
  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
    return this.isValidZone(s);
  }

  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */;
  IANAZone.isValidZone = function isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  };
  function IANAZone(name) {
    var _this;
    _this = _Zone.call(this) || this;
    /** @private **/
    _this.zoneName = name;
    /** @private **/
    _this.valid = IANAZone.isValidZone(name);
    return _this;
  }

  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  var _proto = IANAZone.prototype;
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
      locale = _ref.locale;
    return parseZoneInfo(ts, format, locale, this.name);
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */;
  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */;
  _proto.offset = function offset(ts) {
    var date = new Date(ts);
    if (isNaN(date)) return NaN;
    var dtf = makeDTF(this.name);
    var _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
      year = _ref2[0],
      month = _ref2[1],
      day = _ref2[2],
      adOrBc = _ref2[3],
      hour = _ref2[4],
      minute = _ref2[5],
      second = _ref2[6];
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }

    // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
    var adjustedHour = hour === 24 ? 0 : hour;
    var asUTC = objToLocalTS({
      year: year,
      month: month,
      day: day,
      hour: adjustedHour,
      minute: minute,
      second: second,
      millisecond: 0
    });
    var asTS = +date;
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }

  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */;
  _proto.equals = function equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }

  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */;
  _createClass(IANAZone, [{
    key: "type",
    get: function get() {
      return "iana";
    }

    /**
     * The name of this zone (i.e. the IANA zone name).
     * @override
     * @type {string}
     */
  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }

    /**
     * Returns whether the offset is known to be fixed for the whole year:
     * Always returns false for all IANA zones.
     * @override
     * @type {boolean}
     */
  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.valid;
    }
  }]);
  return IANAZone;
}(Zone);

var _excluded = ["base"],
  _excluded2 = ["padTo", "floor"];

// todo - remap caching

var intlLFCache = {};
function getCachedLF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var key = JSON.stringify([locString, opts]);
  var dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
var intlDTCache = {};
function getCachedDTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var key = JSON.stringify([locString, opts]);
  var dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
var intlNumCache = {};
function getCachedINF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var key = JSON.stringify([locString, opts]);
  var inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
var intlRelCache = {};
function getCachedRTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var _opts = opts;
    var cacheKeyOpts = _objectWithoutPropertiesLoose(_opts, _excluded); // exclude `base` from the options
  var key = JSON.stringify([locString, cacheKeyOpts]);
  var inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
var weekInfoCache = {};
function getCachedWeekInfo(locString) {
  var data = weekInfoCache[locString];
  if (!data) {
    var locale = new Intl.Locale(locString);
    // browsers currently implement this as a property, but spec says it should be a getter function
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}
function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:

  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u

  // private subtags and unicode subtags have ordering requirements,
  // and we're not properly parsing this, so just strip out the
  // private ones if they exist.
  var xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  var uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    var options;
    var selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      var smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    var _options = options,
      numberingSystem = _options.numberingSystem,
      calendar = _options.calendar;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += "-ca-" + outputCalendar;
    }
    if (numberingSystem) {
      localeStr += "-nu-" + numberingSystem;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  var ms = [];
  for (var i = 1; i <= 12; i++) {
    var dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
function mapWeekdays(f) {
  var ms = [];
  for (var i = 1; i <= 7; i++) {
    var dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
  var mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}

/**
 * @private
 */
var PolyNumberFormatter = /*#__PURE__*/function () {
  function PolyNumberFormatter(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
      var otherOpts = _objectWithoutPropertiesLoose(opts, _excluded2);
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      var intlOpts = _extends({
        useGrouping: false
      }, opts);
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  var _proto = PolyNumberFormatter.prototype;
  _proto.format = function format(i) {
    if (this.inf) {
      var fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(_fixed, this.padTo);
    }
  };
  return PolyNumberFormatter;
}();
/**
 * @private
 */
var PolyDateFormatter = /*#__PURE__*/function () {
  function PolyDateFormatter(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = undefined;
    var z = undefined;
    if (this.opts.timeZone) {
      // Don't apply any workarounds if a timeZone is explicitly provided in opts
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      var gmtOffset = -1 * (dt.offset / 60);
      var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
        // we manually apply the offset and substitute the zone as needed.
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
          minutes: dt.offset
        });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      // Custom zones can have any offset / offsetName so we just manually
      // apply the offset and substitute the zone as needed.
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({
        minutes: dt.offset
      });
      this.originalZone = dt.zone;
    }
    var intlOpts = _extends({}, this.opts);
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  var _proto2 = PolyDateFormatter.prototype;
  _proto2.format = function format() {
    if (this.originalZone) {
      // If we have to substitute in the actual zone name, we have to use
      // formatToParts so that the timezone can be replaced.
      return this.formatToParts().map(function (_ref) {
        var value = _ref.value;
        return value;
      }).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  };
  _proto2.formatToParts = function formatToParts() {
    var _this = this;
    var parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map(function (part) {
        if (part.type === "timeZoneName") {
          var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
            locale: _this.dt.locale,
            format: _this.opts.timeZoneName
          });
          return _extends({}, part, {
            value: offsetName
          });
        } else {
          return part;
        }
      });
    }
    return parts;
  };
  _proto2.resolvedOptions = function resolvedOptions() {
    return this.dtf.resolvedOptions();
  };
  return PolyDateFormatter;
}();
/**
 * @private
 */
var PolyRelFormatter = /*#__PURE__*/function () {
  function PolyRelFormatter(intl, isEnglish, opts) {
    this.opts = _extends({
      style: "long"
    }, opts);
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  var _proto3 = PolyRelFormatter.prototype;
  _proto3.format = function format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  };
  _proto3.formatToParts = function formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  };
  return PolyRelFormatter;
}();
var fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};

/**
 * @private
 */
var Locale = /*#__PURE__*/function () {
  Locale.fromOpts = function fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
  };
  Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
    if (defaultToEN === void 0) {
      defaultToEN = false;
    }
    var specifiedLocale = locale || Settings.defaultLocale;
    // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
    var localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    var numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    var outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    var weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  };
  Locale.resetCache = function resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  };
  Locale.fromObject = function fromObject(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
      locale = _ref2.locale,
      numberingSystem = _ref2.numberingSystem,
      outputCalendar = _ref2.outputCalendar,
      weekSettings = _ref2.weekSettings;
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  };
  function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    var _parseLocaleString = parseLocaleString(locale),
      parsedLocale = _parseLocaleString[0],
      parsedNumberingSystem = _parseLocaleString[1],
      parsedOutputCalendar = _parseLocaleString[2];
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  var _proto4 = Locale.prototype;
  _proto4.listingMode = function listingMode() {
    var isActuallyEn = this.isEnglish();
    var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  };
  _proto4.clone = function clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
  };
  _proto4.redefaultToEN = function redefaultToEN(alts) {
    if (alts === void 0) {
      alts = {};
    }
    return this.clone(_extends({}, alts, {
      defaultToEN: true
    }));
  };
  _proto4.redefaultToSystem = function redefaultToSystem(alts) {
    if (alts === void 0) {
      alts = {};
    }
    return this.clone(_extends({}, alts, {
      defaultToEN: false
    }));
  };
  _proto4.months = function months$1(length, format) {
    var _this2 = this;
    if (format === void 0) {
      format = false;
    }
    return listStuff(this, length, months, function () {
      var intl = format ? {
          month: length,
          day: "numeric"
        } : {
          month: length
        },
        formatStr = format ? "format" : "standalone";
      if (!_this2.monthsCache[formatStr][length]) {
        _this2.monthsCache[formatStr][length] = mapMonths(function (dt) {
          return _this2.extract(dt, intl, "month");
        });
      }
      return _this2.monthsCache[formatStr][length];
    });
  };
  _proto4.weekdays = function weekdays$1(length, format) {
    var _this3 = this;
    if (format === void 0) {
      format = false;
    }
    return listStuff(this, length, weekdays, function () {
      var intl = format ? {
          weekday: length,
          year: "numeric",
          month: "long",
          day: "numeric"
        } : {
          weekday: length
        },
        formatStr = format ? "format" : "standalone";
      if (!_this3.weekdaysCache[formatStr][length]) {
        _this3.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
          return _this3.extract(dt, intl, "weekday");
        });
      }
      return _this3.weekdaysCache[formatStr][length];
    });
  };
  _proto4.meridiems = function meridiems$1() {
    var _this4 = this;
    return listStuff(this, undefined, function () {
      return meridiems;
    }, function () {
      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
      if (!_this4.meridiemCache) {
        var intl = {
          hour: "numeric",
          hourCycle: "h12"
        };
        _this4.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
          return _this4.extract(dt, intl, "dayperiod");
        });
      }
      return _this4.meridiemCache;
    });
  };
  _proto4.eras = function eras$1(length) {
    var _this5 = this;
    return listStuff(this, length, eras, function () {
      var intl = {
        era: length
      };

      // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!_this5.eraCache[length]) {
        _this5.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
          return _this5.extract(dt, intl, "era");
        });
      }
      return _this5.eraCache[length];
    });
  };
  _proto4.extract = function extract(dt, intlOpts, field) {
    var df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find(function (m) {
        return m.type.toLowerCase() === field;
      });
    return matching ? matching.value : null;
  };
  _proto4.numberFormatter = function numberFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }
    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  };
  _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
    if (intlOpts === void 0) {
      intlOpts = {};
    }
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  };
  _proto4.relFormatter = function relFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  };
  _proto4.listFormatter = function listFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }
    return getCachedLF(this.intl, opts);
  };
  _proto4.isEnglish = function isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  };
  _proto4.getWeekSettings = function getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  };
  _proto4.getStartOfWeek = function getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  };
  _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  };
  _proto4.getWeekendDays = function getWeekendDays() {
    return this.getWeekSettings().weekend;
  };
  _proto4.equals = function equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  };
  _proto4.toString = function toString() {
    return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
  };
  _createClass(Locale, [{
    key: "fastNumbers",
    get: function get() {
      if (this.fastNumbersCached == null) {
        this.fastNumbersCached = supportsFastNumbers(this);
      }
      return this.fastNumbersCached;
    }
  }]);
  return Locale;
}();

var singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
var FixedOffsetZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(FixedOffsetZone, _Zone);
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  FixedOffsetZone.instance = function instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }

  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */;
  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
    if (s) {
      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  };
  function FixedOffsetZone(offset) {
    var _this;
    _this = _Zone.call(this) || this;
    /** @private **/
    _this.fixed = offset;
    return _this;
  }

  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  var _proto = FixedOffsetZone.prototype;
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  _proto.offsetName = function offsetName() {
    return this.name;
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */;
  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.fixed, format);
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */;
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  _proto.offset = function offset() {
    return this.fixed;
  }

  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */;
  _proto.equals = function equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }

  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */;
  _createClass(FixedOffsetZone, [{
    key: "type",
    get: function get() {
      return "fixed";
    }

    /**
     * The name of this zone.
     * All fixed zones' names always start with "UTC" (plus optional offset)
     * @override
     * @type {string}
     */
  }, {
    key: "name",
    get: function get() {
      return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
    }

    /**
     * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
     *
     * @override
     * @type {string}
     */
  }, {
    key: "ianaName",
    get: function get() {
      if (this.fixed === 0) {
        return "Etc/UTC";
      } else {
        return "Etc/GMT" + formatOffset(-this.fixed, "narrow");
      }
    }
  }, {
    key: "isUniversal",
    get: function get() {
      return true;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "utcInstance",
    get:
    /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */
    function get() {
      if (singleton === null) {
        singleton = new FixedOffsetZone(0);
      }
      return singleton;
    }
  }]);
  return FixedOffsetZone;
}(Zone);

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
var InvalidZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(InvalidZone, _Zone);
  function InvalidZone(zoneName) {
    var _this;
    _this = _Zone.call(this) || this;
    /**  @private */
    _this.zoneName = zoneName;
    return _this;
  }

  /** @override **/
  var _proto = InvalidZone.prototype;
  /** @override **/
  _proto.offsetName = function offsetName() {
    return null;
  }

  /** @override **/;
  _proto.formatOffset = function formatOffset() {
    return "";
  }

  /** @override **/;
  _proto.offset = function offset() {
    return NaN;
  }

  /** @override **/;
  _proto.equals = function equals() {
    return false;
  }

  /** @override **/;
  _createClass(InvalidZone, [{
    key: "type",
    get: function get() {
      return "invalid";
    }

    /** @override **/
  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }

    /** @override **/
  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);
  return InvalidZone;
}(Zone);

/**
 * @private
 */
function normalizeZone(input, defaultZone) {
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    var lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone;else if (lowered === "local" || lowered === "system") return SystemZone.instance;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  var value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (var key in numberingSystemsUTF16) {
          var _numberingSystemsUTF = numberingSystemsUTF16[key],
            min = _numberingSystemsUTF[0],
            max = _numberingSystemsUTF[1];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}

// cache of {numberingSystem: {append: regex}}
var digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}
function digitRegex(_ref, append) {
  var numberingSystem = _ref.numberingSystem;
  if (append === void 0) {
    append = "";
  }
  var ns = numberingSystem || "latn";
  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append]) {
    digitRegexCache[ns][append] = new RegExp("" + numberingSystems[ns] + append);
  }
  return digitRegexCache[ns][append];
}

var now = function now() {
    return Date.now();
  },
  defaultZone = "system",
  defaultLocale = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  twoDigitCutoffYear = 60,
  throwOnInvalid,
  defaultWeekSettings = null;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */
var Settings = /*#__PURE__*/function () {
  function Settings() {}
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  Settings.resetCaches = function resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  };
  _createClass(Settings, null, [{
    key: "now",
    get:
    /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */
    function get() {
      return now;
    }

    /**
     * Set the callback for returning the current timestamp.
     * The function should return a number, which will be interpreted as an Epoch millisecond count
     * @type {function}
     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
     */,
    set: function set(n) {
      now = n;
    }

    /**
     * Set the default time zone to create DateTimes in. Does not affect existing instances.
     * Use the value "system" to reset this value to the system's time zone.
     * @type {string}
     */
  }, {
    key: "defaultZone",
    get:
    /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */
    function get() {
      return normalizeZone(defaultZone, SystemZone.instance);
    }

    /**
     * Get the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */,
    set: function set(zone) {
      defaultZone = zone;
    }
  }, {
    key: "defaultLocale",
    get: function get() {
      return defaultLocale;
    }

    /**
     * Set the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */,
    set: function set(locale) {
      defaultLocale = locale;
    }

    /**
     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
  }, {
    key: "defaultNumberingSystem",
    get: function get() {
      return defaultNumberingSystem;
    }

    /**
     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */,
    set: function set(numberingSystem) {
      defaultNumberingSystem = numberingSystem;
    }

    /**
     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
  }, {
    key: "defaultOutputCalendar",
    get: function get() {
      return defaultOutputCalendar;
    }

    /**
     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */,
    set: function set(outputCalendar) {
      defaultOutputCalendar = outputCalendar;
    }

    /**
     * @typedef {Object} WeekSettings
     * @property {number} firstDay
     * @property {number} minimalDays
     * @property {number[]} weekend
     */

    /**
     * @return {WeekSettings|null}
     */
  }, {
    key: "defaultWeekSettings",
    get: function get() {
      return defaultWeekSettings;
    }

    /**
     * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
     * how many days are required in the first week of a year.
     * Does not affect existing instances.
     *
     * @param {WeekSettings|null} weekSettings
     */,
    set: function set(weekSettings) {
      defaultWeekSettings = validateWeekSettings(weekSettings);
    }

    /**
     * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
     * @type {number}
     */
  }, {
    key: "twoDigitCutoffYear",
    get: function get() {
      return twoDigitCutoffYear;
    }

    /**
     * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
     * @type {number}
     * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
     * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
     * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
     * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
     * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
     */,
    set: function set(cutoffYear) {
      twoDigitCutoffYear = cutoffYear % 100;
    }

    /**
     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */
  }, {
    key: "throwOnInvalid",
    get: function get() {
      return throwOnInvalid;
    }

    /**
     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */,
    set: function set(t) {
      throwOnInvalid = t;
    }
  }]);
  return Settings;
}();

var Invalid = /*#__PURE__*/function () {
  function Invalid(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  var _proto = Invalid.prototype;
  _proto.toMessage = function toMessage() {
    if (this.explanation) {
      return this.reason + ": " + this.explanation;
    } else {
      return this.reason;
    }
  };
  return Invalid;
}();

var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function dayOfWeek(year, month, day) {
  var d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  var js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex(function (i) {
      return i < ordinal;
    }),
    day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day: day
  };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}

/**
 * @private
 */

function gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
  if (minDaysInFirstWeek === void 0) {
    minDaysInFirstWeek = 4;
  }
  if (startOfWeek === void 0) {
    startOfWeek = 1;
  }
  var year = gregObj.year,
    month = gregObj.month,
    day = gregObj.day,
    ordinal = computeOrdinal(year, month, day),
    weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7),
    weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return _extends({
    weekYear: weekYear,
    weekNumber: weekNumber,
    weekday: weekday
  }, timeObject(gregObj));
}
function weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
  if (minDaysInFirstWeek === void 0) {
    minDaysInFirstWeek = 4;
  }
  if (startOfWeek === void 0) {
    startOfWeek = 1;
  }
  var weekYear = weekData.weekYear,
    weekNumber = weekData.weekNumber,
    weekday = weekData.weekday,
    weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek),
    yearInDays = daysInYear(weekYear);
  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek,
    year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
    month = _uncomputeOrdinal.month,
    day = _uncomputeOrdinal.day;
  return _extends({
    year: year,
    month: month,
    day: day
  }, timeObject(weekData));
}
function gregorianToOrdinal(gregData) {
  var year = gregData.year,
    month = gregData.month,
    day = gregData.day;
  var ordinal = computeOrdinal(year, month, day);
  return _extends({
    year: year,
    ordinal: ordinal
  }, timeObject(gregData));
}
function ordinalToGregorian(ordinalData) {
  var year = ordinalData.year,
    ordinal = ordinalData.ordinal;
  var _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
    month = _uncomputeOrdinal2.month,
    day = _uncomputeOrdinal2.day;
  return _extends({
    year: year,
    month: month,
    day: day
  }, timeObject(ordinalData));
}

/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */
function usesLocalWeekValues(obj, loc) {
  var hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    var hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return {
      minDaysInFirstWeek: 4,
      startOfWeek: 1
    };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
  if (minDaysInFirstWeek === void 0) {
    minDaysInFirstWeek = 4;
  }
  if (startOfWeek === void 0) {
    startOfWeek = 1;
  }
  var validYear = isInteger(obj.weekYear),
    validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)),
    validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  var validYear = isInteger(obj.year),
    validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  var validYear = isInteger(obj.year),
    validMonth = integerBetween(obj.month, 1, 12),
    validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  var hour = obj.hour,
    minute = obj.minute,
    second = obj.second,
    millisecond = obj.millisecond;
  var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
    validMinute = integerBetween(minute, 0, 59),
    validSecond = integerBetween(second, 0, 59),
    validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

// CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce(function (best, next) {
    var pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce(function (a, k) {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function (v) {
      return !integerBetween(v, 1, 7);
    })) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}

// NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}
function padStart(input, n) {
  if (n === void 0) {
    n = 2;
  }
  var isNeg = input < 0;
  var padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    var f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}
function roundTo(number, digits, towardZero) {
  if (towardZero === void 0) {
    towardZero = false;
  }
  var factor = Math.pow(10, digits),
    rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  var modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);

  // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
    // so if obj.year is in 99, but obj.day makes it roll over into year 100,
    // the calculations done by Date.UTC are using year 2000 - which is incorrect
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}

// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  var fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
  if (minDaysInFirstWeek === void 0) {
    minDaysInFirstWeek = 4;
  }
  if (startOfWeek === void 0) {
    startOfWeek = 1;
  }
  var weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  var weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
  if (timeZone === void 0) {
    timeZone = null;
  }
  var date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  var modified = _extends({
    timeZoneName: offsetFormat
  }, intlOpts);
  var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
    return m.type.toLowerCase() === "timezonename";
  });
  return parsed ? parsed.value : null;
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  var offHour = parseInt(offHourStr, 10);

  // don't || this because we want to preserve -0
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  var offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function asNumber(value) {
  var numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  var normalized = {};
  for (var u in obj) {
    if (hasOwnProperty(obj, u)) {
      var v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}

/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */
function formatOffset(offset, format) {
  var hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return "" + sign + padStart(hours, 2) + ":" + padStart(minutes, 2);
    case "narrow":
      return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
    case "techie":
      return "" + sign + padStart(hours, 2) + padStart(minutes, 2);
    default:
      throw new RangeError("Value format " + format + " is out of range for property format");
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}

/**
 * @private
 */

var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [].concat(monthsNarrow);
    case "short":
      return [].concat(monthsShort);
    case "long":
      return [].concat(monthsLong);
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [].concat(weekdaysNarrow);
    case "short":
      return [].concat(weekdaysShort);
    case "long":
      return [].concat(weekdaysLong);
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
var meridiems = ["AM", "PM"];
var erasLong = ["Before Christ", "Anno Domini"];
var erasShort = ["BC", "AD"];
var erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [].concat(erasNarrow);
    case "short":
      return [].concat(erasShort);
    case "long":
      return [].concat(erasLong);
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric, narrow) {
  if (numeric === void 0) {
    numeric = "always";
  }
  if (narrow === void 0) {
    narrow = false;
  }
  var units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    var isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : "next " + units[unit][0];
      case -1:
        return isDay ? "yesterday" : "last " + units[unit][0];
      case 0:
        return isDay ? "today" : "this " + units[unit][0];
    }
  }

  var isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}

function stringifyTokens(splits, tokenToString) {
  var s = "";
  for (var _iterator = _createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;) {
    var token = _step.value;
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}
var _macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};

/**
 * @private
 */
var Formatter = /*#__PURE__*/function () {
  Formatter.create = function create(locale, opts) {
    if (opts === void 0) {
      opts = {};
    }
    return new Formatter(locale, opts);
  };
  Formatter.parseFormat = function parseFormat(fmt) {
    // white-space is always considered a literal in user-provided formats
    // the " " token has a special meaning (see unitForToken)

    var current = null,
      currentFull = "",
      bracketed = false;
    var splits = [];
    for (var i = 0; i < fmt.length; i++) {
      var c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed || /^\s+$/.test(currentFull),
        val: currentFull
      });
    }
    return splits;
  };
  Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
    return _macroTokenToFormatOpts[token];
  };
  function Formatter(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  var _proto = Formatter.prototype;
  _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    var df = this.systemLoc.dtFormatter(dt, _extends({}, this.opts, opts));
    return df.format();
  };
  _proto.dtFormatter = function dtFormatter(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    return this.loc.dtFormatter(dt, _extends({}, this.opts, opts));
  };
  _proto.formatDateTime = function formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  };
  _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  };
  _proto.formatInterval = function formatInterval(interval, opts) {
    var df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  };
  _proto.resolvedOptions = function resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  };
  _proto.num = function num(n, p) {
    if (p === void 0) {
      p = 0;
    }
    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }
    var opts = _extends({}, this.opts);
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n);
  };
  _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
    var _this = this;
    var knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = function string(opts, extract) {
        return _this.loc.extract(dt, opts, extract);
      },
      formatOffset = function formatOffset(opts) {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }
        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = function meridiem() {
        return knownEnglish ? meridiemForDateTime(dt) : string({
          hour: "numeric",
          hourCycle: "h12"
        }, "dayperiod");
      },
      month = function month(length, standalone) {
        return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
          month: length
        } : {
          month: length,
          day: "numeric"
        }, "month");
      },
      weekday = function weekday(length, standalone) {
        return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
          weekday: length
        } : {
          weekday: length,
          month: "long",
          day: "numeric"
        }, "weekday");
      },
      maybeMacro = function maybeMacro(token) {
        var formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return _this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = function era(length) {
        return knownEnglish ? eraForDateTime(dt, length) : string({
          era: length
        }, "era");
      },
      tokenToString = function tokenToString(token) {
        // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
        switch (token) {
          // ms
          case "S":
            return _this.num(dt.millisecond);
          case "u":
          // falls through
          case "SSS":
            return _this.num(dt.millisecond, 3);
          // seconds
          case "s":
            return _this.num(dt.second);
          case "ss":
            return _this.num(dt.second, 2);
          // fractional seconds
          case "uu":
            return _this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return _this.num(Math.floor(dt.millisecond / 100));
          // minutes
          case "m":
            return _this.num(dt.minute);
          case "mm":
            return _this.num(dt.minute, 2);
          // hours
          case "h":
            return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return _this.num(dt.hour);
          case "HH":
            return _this.num(dt.hour, 2);
          // offset
          case "Z":
            // like +6
            return formatOffset({
              format: "narrow",
              allowZ: _this.opts.allowZ
            });
          case "ZZ":
            // like +06:00
            return formatOffset({
              format: "short",
              allowZ: _this.opts.allowZ
            });
          case "ZZZ":
            // like +0600
            return formatOffset({
              format: "techie",
              allowZ: _this.opts.allowZ
            });
          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, {
              format: "short",
              locale: _this.loc.locale
            });
          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, {
              format: "long",
              locale: _this.loc.locale
            });
          // zone
          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems
          case "a":
            return meridiem();
          // dates
          case "d":
            return useDateTimeFormatter ? string({
              day: "numeric"
            }, "day") : _this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({
              day: "2-digit"
            }, "day") : _this.num(dt.day, 2);
          // weekdays - standalone
          case "c":
            // like 1
            return _this.num(dt.weekday);
          case "ccc":
            // like 'Tues'
            return weekday("short", true);
          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);
          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format
          case "E":
            // like 1
            return _this.num(dt.weekday);
          case "EEE":
            // like 'Tues'
            return weekday("short", false);
          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);
          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone
          case "L":
            // like 1
            return useDateTimeFormatter ? string({
              month: "numeric",
              day: "numeric"
            }, "month") : _this.num(dt.month);
          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter ? string({
              month: "2-digit",
              day: "numeric"
            }, "month") : _this.num(dt.month, 2);
          case "LLL":
            // like Jan
            return month("short", true);
          case "LLLL":
            // like January
            return month("long", true);
          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format
          case "M":
            // like 1
            return useDateTimeFormatter ? string({
              month: "numeric"
            }, "month") : _this.num(dt.month);
          case "MM":
            // like 01
            return useDateTimeFormatter ? string({
              month: "2-digit"
            }, "month") : _this.num(dt.month, 2);
          case "MMM":
            // like Jan
            return month("short", false);
          case "MMMM":
            // like January
            return month("long", false);
          case "MMMMM":
            // like J
            return month("narrow", false);
          // years
          case "y":
            // like 2014
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year);
          case "yy":
            // like 14
            return useDateTimeFormatter ? string({
              year: "2-digit"
            }, "year") : _this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            // like 0012
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year, 4);
          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year, 6);
          // eras
          case "G":
            // like AD
            return era("short");
          case "GG":
            // like Anno Domini
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return _this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return _this.num(dt.weekYear, 4);
          case "W":
            return _this.num(dt.weekNumber);
          case "WW":
            return _this.num(dt.weekNumber, 2);
          case "n":
            return _this.num(dt.localWeekNumber);
          case "nn":
            return _this.num(dt.localWeekNumber, 2);
          case "ii":
            return _this.num(dt.localWeekYear.toString().slice(-2), 2);
          case "iiii":
            return _this.num(dt.localWeekYear, 4);
          case "o":
            return _this.num(dt.ordinal);
          case "ooo":
            return _this.num(dt.ordinal, 3);
          case "q":
            // like 1
            return _this.num(dt.quarter);
          case "qq":
            // like 01
            return _this.num(dt.quarter, 2);
          case "X":
            return _this.num(Math.floor(dt.ts / 1000));
          case "x":
            return _this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  };
  _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
    var _this2 = this;
    var tokenToField = function tokenToField(token) {
        switch (token[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "w":
            return "week";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      },
      tokenToString = function tokenToString(lildur) {
        return function (token) {
          var mapped = tokenToField(token);
          if (mapped) {
            return _this2.num(lildur.get(mapped), token.length);
          } else {
            return token;
          }
        };
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce(function (found, _ref) {
        var literal = _ref.literal,
          val = _ref.val;
        return literal ? found : found.concat(val);
      }, []),
      collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
        return t;
      }));
    return stringifyTokens(tokens, tokenToString(collapsed));
  };
  return Formatter;
}();

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes() {
  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }
  var full = regexes.reduce(function (f, r) {
    return f + r.source;
  }, "");
  return RegExp("^" + full + "$");
}
function combineExtractors() {
  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    extractors[_key2] = arguments[_key2];
  }
  return function (m) {
    return extractors.reduce(function (_ref, ex) {
      var mergedVals = _ref[0],
        mergedZone = _ref[1],
        cursor = _ref[2];
      var _ex = ex(m, cursor),
        val = _ex[0],
        zone = _ex[1],
        next = _ex[2];
      return [_extends({}, mergedVals, val), zone || mergedZone, next];
    }, [{}, null, 1]).slice(0, 2);
  };
}
function parse(s) {
  if (s == null) {
    return [null, null];
  }
  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    patterns[_key3 - 1] = arguments[_key3];
  }
  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
    var _patterns$_i = _patterns[_i],
      regex = _patterns$_i[0],
      extractor = _patterns$_i[1];
    var m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse() {
  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    keys[_key4] = arguments[_key4];
  }
  return function (match, cursor) {
    var ret = {};
    var i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = "(?:" + offsetRegex.source + "?(?:\\[(" + ianaRegex.source + ")\\])?)?";
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + isoExtendedZone);
var isoTimeExtensionRegex = RegExp("(?:T" + isoTimeRegex.source + ")?");
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?");
var sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");
function int(match, pos, fallback) {
  var m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match, cursor) {
  var item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match, cursor) {
  var item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match, cursor) {
  var local = !match[cursor] && !match[cursor + 1],
    fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match, cursor) {
  var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO time parsing

var isoTimeOnly = RegExp("^T?" + isoTimeBaseRegex.source + "$");

// ISO duration parsing

var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match) {
  var s = match[0],
    yearStr = match[1],
    monthStr = match[2],
    weekStr = match[3],
    dayStr = match[4],
    hourStr = match[5],
    minuteStr = match[6],
    secondStr = match[7],
    millisecondsStr = match[8];
  var hasNegativePrefix = s[0] === "-";
  var negativeSeconds = secondStr && secondStr[0] === "-";
  var maybeNegate = function maybeNegate(num, force) {
    if (force === void 0) {
      force = false;
    }
    return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
  };
  return [{
    years: maybeNegate(parseFloating(yearStr)),
    months: maybeNegate(parseFloating(monthStr)),
    weeks: maybeNegate(parseFloating(weekStr)),
    days: maybeNegate(parseFloating(dayStr)),
    hours: maybeNegate(parseFloating(hourStr)),
    minutes: maybeNegate(parseFloating(minuteStr)),
    seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
    milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
  }];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}

// RFC 2822/5322
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match) {
  var weekdayStr = match[1],
    dayStr = match[2],
    monthStr = match[3],
    yearStr = match[4],
    hourStr = match[5],
    minuteStr = match[6],
    secondStr = match[7],
    obsOffset = match[8],
    milOffset = match[9],
    offHourStr = match[10],
    offMinuteStr = match[11],
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  var offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset)];
}
function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}

// http date

var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match) {
  var weekdayStr = match[1],
    dayStr = match[2],
    monthStr = match[3],
    yearStr = match[4],
    hourStr = match[5],
    minuteStr = match[6],
    secondStr = match[7],
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match) {
  var weekdayStr = match[1],
    monthStr = match[2],
    dayStr = match[3],
    hourStr = match[4],
    minuteStr = match[5],
    secondStr = match[6],
    yearStr = match[7],
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);

/*
 * @private
 */

function parseISODate(s) {
  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
}
function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s) {
  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}
function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
}

var INVALID$2 = "Invalid Duration";

// unit conversion constants
var lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000
    },
    hours: {
      minutes: 60,
      seconds: 60 * 60,
      milliseconds: 60 * 60 * 1000
    },
    minutes: {
      seconds: 60,
      milliseconds: 60 * 1000
    },
    seconds: {
      milliseconds: 1000
    }
  },
  casualMatrix = _extends({
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000
    }
  }, lowOrderMatrix),
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = _extends({
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: daysInYearAccurate * 24 / 4,
      minutes: daysInYearAccurate * 24 * 60 / 4,
      seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
    }
  }, lowOrderMatrix);

// units ordered by size
var orderedUnits$1 = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
var reverseUnits = orderedUnits$1.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear) {
  if (clear === void 0) {
    clear = false;
  }
  // deep merge for vals
  var conf = {
    values: clear ? alts.values : _extends({}, dur.values, alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  var _vals$milliseconds;
  var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
  for (var _iterator = _createForOfIteratorHelperLoose(reverseUnits.slice(1)), _step; !(_step = _iterator()).done;) {
    var unit = _step.value;
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  // the logic below assumes the overall value of the duration is positive
  // if this is not the case, factor is used to make it so
  var factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        var previousVal = vals[previous] * factor;
        var conv = matrix[current][previous];

        // if (previousVal < 0):
        // lower order unit is negative (e.g. { years: 2, days: -2 })
        // normalize this by reducing the higher order unit by the appropriate amount
        // and increasing the lower order unit
        // this can never make the higher order unit negative, because this function only operates
        // on positive durations, so the amount of time represented by the lower order unit cannot
        // be larger than the higher order unit
        // else:
        // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
        // in this case we attempt to convert as much as possible from the lower order unit into
        // the higher order one
        //
        // Math.floor takes care of both of these cases, rounding away from 0
        // if previousVal < 0 it makes the absolute value larger
        // if previousVal >= it makes the absolute value smaller
        var rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);

  // try to convert any decimals into smaller units if possible
  // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
  orderedUnits$1.reduce(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        var fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
  var newVals = {};
  for (var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */
var Duration = /*#__PURE__*/function (_Symbol$for) {
  /**
   * @private
   */
  function Duration(config) {
    var accurate = config.conversionAccuracy === "longterm" || false;
    var matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }

    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.matrix = matrix;
    /**
     * @access private
     */
    this.isLuxonDuration = true;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  Duration.fromMillis = function fromMillis(count, opts) {
    return Duration.fromObject({
      milliseconds: count
    }, opts);
  }

  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */;
  Duration.fromObject = function fromObject(obj, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }

  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */;
  Duration.fromDurationLike = function fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    }
  }

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */;
  Duration.fromISO = function fromISO(text, opts) {
    var _parseISODuration = parseISODuration(text),
      parsed = _parseISODuration[0];
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }

  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */;
  Duration.fromISOTime = function fromISOTime(text, opts) {
    var _parseISOTimeOnly = parseISOTimeOnly(text),
      parsed = _parseISOTimeOnly[0];
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }

  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */;
  Duration.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({
        invalid: invalid
      });
    }
  }

  /**
   * @private
   */;
  Duration.normalizeUnit = function normalizeUnit(unit) {
    var normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }

  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */;
  Duration.isDuration = function isDuration(o) {
    return o && o.isLuxonDuration || false;
  }

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */;
  var _proto = Duration.prototype;
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    var fmtOpts = _extends({}, opts, {
      floor: opts.round !== false && opts.floor !== false
    });
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }

  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */;
  _proto.toHuman = function toHuman(opts) {
    var _this = this;
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid) return INVALID$2;
    var l = orderedUnits$1.map(function (unit) {
      var val = _this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return _this.loc.numberFormatter(_extends({
        style: "unit",
        unitDisplay: "long"
      }, opts, {
        unit: unit.slice(0, -1)
      })).format(val);
    }).filter(function (n) {
      return n;
    });
    return this.loc.listFormatter(_extends({
      type: "conjunction",
      style: opts.listStyle || "narrow"
    }, opts)).format(l);
  }

  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */;
  _proto.toObject = function toObject() {
    if (!this.isValid) return {};
    return _extends({}, this.values);
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */;
  _proto.toISO = function toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;
    var s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */;
  _proto.toISOTime = function toISOTime(opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid) return null;
    var millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;
    opts = _extends({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts, {
      includeOffset: false
    });
    var dateTime = DateTime.fromMillis(millis, {
      zone: "UTC"
    });
    return dateTime.toISOTime(opts);
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */;
  _proto.toJSON = function toJSON() {
    return this.toISO();
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */;
  _proto.toString = function toString() {
    return this.toISO();
  }

  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */;
  _proto[_Symbol$for] = function () {
    if (this.isValid) {
      return "Duration { values: " + JSON.stringify(this.values) + " }";
    } else {
      return "Duration { Invalid, reason: " + this.invalidReason + " }";
    }
  }

  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */;
  _proto.toMillis = function toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }

  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */;
  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */;
  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration),
      result = {};
    for (var _i2 = 0, _orderedUnits = orderedUnits$1; _i2 < _orderedUnits.length; _i2++) {
      var k = _orderedUnits[_i2];
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, {
      values: result
    }, true);
  }

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */;
  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }

  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */;
  _proto.mapUnits = function mapUnits(fn) {
    if (!this.isValid) return this;
    var result = {};
    for (var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++) {
      var k = _Object$keys[_i3];
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, {
      values: result
    }, true);
  }

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */;
  _proto.get = function get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */;
  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var mixed = _extends({}, this.values, normalizeObject(values, Duration.normalizeUnit));
    return clone$1(this, {
      values: mixed
    });
  }

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */;
  _proto.reconfigure = function reconfigure(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      locale = _ref.locale,
      numberingSystem = _ref.numberingSystem,
      conversionAccuracy = _ref.conversionAccuracy,
      matrix = _ref.matrix;
    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem
    });
    var opts = {
      loc: loc,
      matrix: matrix,
      conversionAccuracy: conversionAccuracy
    };
    return clone$1(this, opts);
  }

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */;
  _proto.as = function as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */;
  _proto.normalize = function normalize() {
    if (!this.isValid) return this;
    var vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, {
      values: vals
    }, true);
  }

  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */;
  _proto.rescale = function rescale() {
    if (!this.isValid) return this;
    var vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, {
      values: vals
    }, true);
  }

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */;
  _proto.shiftTo = function shiftTo() {
    for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
      units[_key] = arguments[_key];
    }
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map(function (u) {
      return Duration.normalizeUnit(u);
    });
    var built = {},
      accumulated = {},
      vals = this.toObject();
    var lastUnit;
    for (var _i4 = 0, _orderedUnits2 = orderedUnits$1; _i4 < _orderedUnits2.length; _i4++) {
      var k = _orderedUnits2[_i4];
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        var own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (var ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }

        // plus anything that's already in this unit
        if (isNumber(vals[k])) {
          own += vals[k];
        }

        // only keep the integer part for now in the hopes of putting any decimal part
        // into a smaller unit later
        var i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;

        // otherwise, keep it in the wings to boil it later
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty
    for (var key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$1(this, {
      values: built
    }, true);
  }

  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */;
  _proto.shiftToAll = function shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
  }

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */;
  _proto.negate = function negate() {
    if (!this.isValid) return this;
    var negated = {};
    for (var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++) {
      var k = _Object$keys2[_i5];
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, {
      values: negated
    }, true);
  }

  /**
   * Get the years.
   * @type {number}
   */;
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }
    for (var _i6 = 0, _orderedUnits3 = orderedUnits$1; _i6 < _orderedUnits3.length; _i6++) {
      var u = _orderedUnits3[_i6];
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  };
  _createClass(Duration, [{
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }

    /**
     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
     *
     * @type {string}
     */
  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
  }, {
    key: "years",
    get: function get() {
      return this.isValid ? this.values.years || 0 : NaN;
    }

    /**
     * Get the quarters.
     * @type {number}
     */
  }, {
    key: "quarters",
    get: function get() {
      return this.isValid ? this.values.quarters || 0 : NaN;
    }

    /**
     * Get the months.
     * @type {number}
     */
  }, {
    key: "months",
    get: function get() {
      return this.isValid ? this.values.months || 0 : NaN;
    }

    /**
     * Get the weeks
     * @type {number}
     */
  }, {
    key: "weeks",
    get: function get() {
      return this.isValid ? this.values.weeks || 0 : NaN;
    }

    /**
     * Get the days.
     * @type {number}
     */
  }, {
    key: "days",
    get: function get() {
      return this.isValid ? this.values.days || 0 : NaN;
    }

    /**
     * Get the hours.
     * @type {number}
     */
  }, {
    key: "hours",
    get: function get() {
      return this.isValid ? this.values.hours || 0 : NaN;
    }

    /**
     * Get the minutes.
     * @type {number}
     */
  }, {
    key: "minutes",
    get: function get() {
      return this.isValid ? this.values.minutes || 0 : NaN;
    }

    /**
     * Get the seconds.
     * @return {number}
     */
  }, {
    key: "seconds",
    get: function get() {
      return this.isValid ? this.values.seconds || 0 : NaN;
    }

    /**
     * Get the milliseconds.
     * @return {number}
     */
  }, {
    key: "milliseconds",
    get: function get() {
      return this.isValid ? this.values.milliseconds || 0 : NaN;
    }

    /**
     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
     * on invalid DateTimes or Intervals.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }

    /**
     * Returns an error code if this Duration became invalid, or null if the Duration is valid
     * @return {string}
     */
  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }

    /**
     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);
  return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));

var INVALID$1 = "Invalid Interval";

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
  } else {
    return null;
  }
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */
var Interval = /*#__PURE__*/function (_Symbol$for) {
  /**
   * @private
   */
  function Interval(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.isLuxonInterval = true;
  }

  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  Interval.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({
        invalid: invalid
      });
    }
  }

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */;
  Interval.fromDateTimes = function fromDateTimes(start, end) {
    var builtStart = friendlyDateTime(start),
      builtEnd = friendlyDateTime(end);
    var validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */;
  Interval.after = function after(start, duration) {
    var dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */;
  Interval.before = function before(end, duration) {
    var dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }

  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */;
  Interval.fromISO = function fromISO(text, opts) {
    var _split = (text || "").split("/", 2),
      s = _split[0],
      e = _split[1];
    if (s && e) {
      var start, startIsValid;
      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }
      var end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        var dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        var _dur = Duration.fromISO(s, opts);
        if (_dur.isValid) {
          return Interval.before(end, _dur);
        }
      }
    }
    return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
  }

  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */;
  Interval.isInterval = function isInterval(o) {
    return o && o.isLuxonInterval || false;
  }

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */;
  var _proto = Interval.prototype;
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  _proto.length = function length(unit) {
    if (unit === void 0) {
      unit = "milliseconds";
    }
    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
  }

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */;
  _proto.count = function count(unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }
    if (!this.isValid) return NaN;
    var start = this.start.startOf(unit, opts);
    var end;
    if (opts != null && opts.useLocaleWeeks) {
      end = this.end.reconfigure({
        locale: start.locale
      });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */;
  _proto.hasSame = function hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */;
  _proto.isEmpty = function isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */;
  _proto.isAfter = function isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */;
  _proto.isBefore = function isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */;
  _proto.contains = function contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */;
  _proto.set = function set(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      start = _ref.start,
      end = _ref.end;
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */;
  _proto.splitAt = function splitAt() {
    var _this = this;
    if (!this.isValid) return [];
    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }
    var sorted = dateTimes.map(friendlyDateTime).filter(function (d) {
        return _this.contains(d);
      }).sort(function (a, b) {
        return a.toMillis() - b.toMillis();
      }),
      results = [];
    var s = this.s,
      i = 0;
    while (s < this.e) {
      var added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }
    return results;
  }

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */;
  _proto.splitBy = function splitBy(duration) {
    var dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    var s = this.s,
      idx = 1,
      next;
    var results = [];
    while (s < this.e) {
      var added = this.start.plus(dur.mapUnits(function (x) {
        return x * idx;
      }));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }
    return results;
  }

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */;
  _proto.divideEqually = function divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.overlaps = function overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.abutsStart = function abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.abutsEnd = function abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }

  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.engulfs = function engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */;
  _proto.intersection = function intersection(other) {
    if (!this.isValid) return this;
    var s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;
    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */;
  _proto.union = function union(other) {
    if (!this.isValid) return this;
    var s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }

  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */;
  Interval.merge = function merge(intervals) {
    var _intervals$sort$reduc = intervals.sort(function (a, b) {
        return a.s - b.s;
      }).reduce(function (_ref2, item) {
        var sofar = _ref2[0],
          current = _ref2[1];
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      }, [[], null]),
      found = _intervals$sort$reduc[0],
      final = _intervals$sort$reduc[1];
    if (final) {
      found.push(final);
    }
    return found;
  }

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */;
  Interval.xor = function xor(intervals) {
    var _Array$prototype;
    var start = null,
      currentCount = 0;
    var results = [],
      ends = intervals.map(function (i) {
        return [{
          time: i.s,
          type: "s"
        }, {
          time: i.e,
          type: "e"
        }];
      }),
      flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
      arr = flattened.sort(function (a, b) {
        return a.time - b.time;
      });
    for (var _iterator = _createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;) {
      var i = _step.value;
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return Interval.merge(results);
  }

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */;
  _proto.difference = function difference() {
    var _this2 = this;
    for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      intervals[_key2] = arguments[_key2];
    }
    return Interval.xor([this].concat(intervals)).map(function (i) {
      return _this2.intersection(i);
    }).filter(function (i) {
      return i && !i.isEmpty();
    });
  }

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */;
  _proto.toString = function toString() {
    if (!this.isValid) return INVALID$1;
    return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
  }

  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */;
  _proto[_Symbol$for] = function () {
    if (this.isValid) {
      return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
    } else {
      return "Interval { Invalid, reason: " + this.invalidReason + " }";
    }
  }

  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */;
  _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
    if (formatOpts === void 0) {
      formatOpts = DATE_SHORT;
    }
    if (opts === void 0) {
      opts = {};
    }
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */;
  _proto.toISO = function toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISO(opts) + "/" + this.e.toISO(opts);
  }

  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */;
  _proto.toISODate = function toISODate() {
    if (!this.isValid) return INVALID$1;
    return this.s.toISODate() + "/" + this.e.toISODate();
  }

  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */;
  _proto.toISOTime = function toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
  }

  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */;
  _proto.toFormat = function toFormat(dateFormat, _temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
      _ref3$separator = _ref3.separator,
      separator = _ref3$separator === void 0 ? " – " : _ref3$separator;
    if (!this.isValid) return INVALID$1;
    return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
  }

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */;
  _proto.toDuration = function toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }

  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */;
  _proto.mapEndpoints = function mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  };
  _createClass(Interval, [{
    key: "start",
    get: function get() {
      return this.isValid ? this.s : null;
    }

    /**
     * Returns the end of the Interval
     * @type {DateTime}
     */
  }, {
    key: "end",
    get: function get() {
      return this.isValid ? this.e : null;
    }

    /**
     * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
     * @type {boolean}
     */
  }, {
    key: "isValid",
    get: function get() {
      return this.invalidReason === null;
    }

    /**
     * Returns an error code if this Interval is invalid, or null if the Interval is valid
     * @type {string}
     */
  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }

    /**
     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);
  return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */
var Info = /*#__PURE__*/function () {
  function Info() {}
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  Info.hasDST = function hasDST(zone) {
    if (zone === void 0) {
      zone = Settings.defaultZone;
    }
    var proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.isUniversal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */;
  Info.isValidIANAZone = function isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }

  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */;
  Info.normalizeZone = function normalizeZone$1(input) {
    return normalizeZone(input, Settings.defaultZone);
  }

  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */;
  Info.getStartOfWeek = function getStartOfWeek(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? null : _ref$locale,
      _ref$locObj = _ref.locObj,
      locObj = _ref$locObj === void 0 ? null : _ref$locObj;
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }

  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */;
  Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      _ref2$locale = _ref2.locale,
      locale = _ref2$locale === void 0 ? null : _ref2$locale,
      _ref2$locObj = _ref2.locObj,
      locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }

  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */;
  Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
      _ref3$locale = _ref3.locale,
      locale = _ref3$locale === void 0 ? null : _ref3$locale,
      _ref3$locObj = _ref3.locObj,
      locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
    // copy the array, because we cache it internally
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */;
  Info.months = function months(length, _temp4) {
    if (length === void 0) {
      length = "long";
    }
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
      _ref4$locale = _ref4.locale,
      locale = _ref4$locale === void 0 ? null : _ref4$locale,
      _ref4$numberingSystem = _ref4.numberingSystem,
      numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem,
      _ref4$locObj = _ref4.locObj,
      locObj = _ref4$locObj === void 0 ? null : _ref4$locObj,
      _ref4$outputCalendar = _ref4.outputCalendar,
      outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */;
  Info.monthsFormat = function monthsFormat(length, _temp5) {
    if (length === void 0) {
      length = "long";
    }
    var _ref5 = _temp5 === void 0 ? {} : _temp5,
      _ref5$locale = _ref5.locale,
      locale = _ref5$locale === void 0 ? null : _ref5$locale,
      _ref5$numberingSystem = _ref5.numberingSystem,
      numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem,
      _ref5$locObj = _ref5.locObj,
      locObj = _ref5$locObj === void 0 ? null : _ref5$locObj,
      _ref5$outputCalendar = _ref5.outputCalendar,
      outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */;
  Info.weekdays = function weekdays(length, _temp6) {
    if (length === void 0) {
      length = "long";
    }
    var _ref6 = _temp6 === void 0 ? {} : _temp6,
      _ref6$locale = _ref6.locale,
      locale = _ref6$locale === void 0 ? null : _ref6$locale,
      _ref6$numberingSystem = _ref6.numberingSystem,
      numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem,
      _ref6$locObj = _ref6.locObj,
      locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */;
  Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
    if (length === void 0) {
      length = "long";
    }
    var _ref7 = _temp7 === void 0 ? {} : _temp7,
      _ref7$locale = _ref7.locale,
      locale = _ref7$locale === void 0 ? null : _ref7$locale,
      _ref7$numberingSystem = _ref7.numberingSystem,
      numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem,
      _ref7$locObj = _ref7.locObj,
      locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */;
  Info.meridiems = function meridiems(_temp8) {
    var _ref8 = _temp8 === void 0 ? {} : _temp8,
      _ref8$locale = _ref8.locale,
      locale = _ref8$locale === void 0 ? null : _ref8$locale;
    return Locale.create(locale).meridiems();
  }

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */;
  Info.eras = function eras(length, _temp9) {
    if (length === void 0) {
      length = "short";
    }
    var _ref9 = _temp9 === void 0 ? {} : _temp9,
      _ref9$locale = _ref9.locale,
      locale = _ref9$locale === void 0 ? null : _ref9$locale;
    return Locale.create(locale, null, "gregory").eras(length);
  }

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */;
  Info.features = function features() {
    return {
      relative: hasRelative(),
      localeWeek: hasLocaleWeekInfo()
    };
  };
  return Info;
}();

function dayDiff(earlier, later) {
  var utcDayStart = function utcDayStart(dt) {
      return dt.toUTC(0, {
        keepLocalTime: true
      }).startOf("day").valueOf();
    },
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  var differs = [["years", function (a, b) {
    return b.year - a.year;
  }], ["quarters", function (a, b) {
    return b.quarter - a.quarter + (b.year - a.year) * 4;
  }], ["months", function (a, b) {
    return b.month - a.month + (b.year - a.year) * 12;
  }], ["weeks", function (a, b) {
    var days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ["days", dayDiff]];
  var results = {};
  var earlier = cursor;
  var lowestOrder, highWater;

  /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */
  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
    var _differs$_i = _differs[_i],
      unit = _differs$_i[0],
      differ = _differs$_i[1];
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        // we overshot the end point, backtrack cursor by 1
        results[unit]--;
        cursor = earlier.plus(results);

        // if we are still overshooting now, we need to backtrack again
        // this happens in certain situations when diffing times in different zones,
        // because this calculation ignores time zones
        if (cursor > later) {
          // keep the "overshot by 1" around as highWater
          highWater = cursor;
          // backtrack cursor by 1
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function _diff (earlier, later, units, opts) {
  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
    cursor = _highOrderDiffs[0],
    results = _highOrderDiffs[1],
    highWater = _highOrderDiffs[2],
    lowestOrder = _highOrderDiffs[3];
  var remainingMillis = later - cursor;
  var lowerOrderUnits = units.filter(function (u) {
    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
  });
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      var _cursor$plus;
      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  var duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    var _Duration$fromMillis;
    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}

var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post) {
  if (post === void 0) {
    post = function post(i) {
      return i;
    };
  }
  return {
    regex: regex,
    deser: function deser(_ref) {
      var s = _ref[0];
      return post(parseDigits(s));
    }
  };
}
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = "[ " + NBSP + "]";
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s) {
  return s.replace(/\./g, "") // ignore dots that were made optional
  .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
  .toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: function deser(_ref2) {
        var s = _ref2[0];
        return strings.findIndex(function (i) {
          return stripInsensitivities(s) === stripInsensitivities(i);
        }) + startIndex;
      }
    };
  }
}
function offset(regex, groups) {
  return {
    regex: regex,
    deser: function deser(_ref3) {
      var h = _ref3[1],
        m = _ref3[2];
      return signedOffset(h, m);
    },
    groups: groups
  };
}
function simple(regex) {
  return {
    regex: regex,
    deser: function deser(_ref4) {
      var s = _ref4[0];
      return s;
    }
  };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

/**
 * @param token
 * @param {Locale} loc
 */
function unitForToken(token, loc) {
  var one = digitRegex(loc),
    two = digitRegex(loc, "{2}"),
    three = digitRegex(loc, "{3}"),
    four = digitRegex(loc, "{4}"),
    six = digitRegex(loc, "{6}"),
    oneOrTwo = digitRegex(loc, "{1,2}"),
    oneToThree = digitRegex(loc, "{1,3}"),
    oneToSix = digitRegex(loc, "{1,6}"),
    oneToNine = digitRegex(loc, "{1,9}"),
    twoToFour = digitRegex(loc, "{2,4}"),
    fourToSix = digitRegex(loc, "{4,6}"),
    literal = function literal(t) {
      return {
        regex: RegExp(escapeToken(t.val)),
        deser: function deser(_ref5) {
          var s = _ref5[0];
          return s;
        },
        literal: true
      };
    },
    unitate = function unitate(t) {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        // era
        case "G":
          return oneOf(loc.eras("short"), 0);
        case "GG":
          return oneOf(loc.eras("long"), 0);
        // years
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        // months
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true), 1);
        case "MMMM":
          return oneOf(loc.months("long", true), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false), 1);
        // dates
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        // ordinals
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        // time
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        // meridiem
        case "a":
          return oneOf(loc.meridiems(), 0);
        // weekYear (k)
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, untruncateYear);
        // weekNumber (W)
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        // weekdays
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true), 1);
        // offset/zone
        case "Z":
        case "ZZ":
          return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
        case "ZZZ":
          return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
        // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
        // because we don't have any way to figure out what they are
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        // this special-case "token" represents a place where a macro-token expanded into a white-space literal
        // in this case we accept any non-newline white-space
        case " ":
          return simple(/[^\S\n\r]/);
        default:
          return literal(t);
      }
    };
  var unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  var type = part.type,
    value = part.value;
  if (type === "literal") {
    var isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  var style = formatOpts[type];

  // The user might have explicitly specified hour12 or hourCycle
  // if so, respect their decision
  // if not, refer back to the resolvedOpts, which are based on the locale
  var actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      // tokens only differentiate between 24 hours or not,
      // so we do not need to check hourCycle here, which is less supported anyways
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  var val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val: val
    };
  }
  return undefined;
}
function buildRegex(units) {
  var re = units.map(function (u) {
    return u.regex;
  }).reduce(function (f, r) {
    return f + "(" + r.source + ")";
  }, "");
  return ["^" + re + "$", units];
}
function match(input, regex, handlers) {
  var matches = input.match(regex);
  if (matches) {
    var all = {};
    var matchIndex = 1;
    for (var i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        var h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  var toField = function toField(token) {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  var zone = null;
  var specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  var vals = Object.keys(matches).reduce(function (r, k) {
    var f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [vals, zone, specificOffset];
}
var dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  var formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  var tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(undefined)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  var _Array$prototype;
  return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function (t) {
    return maybeExpandMacroToken(t, locale);
  }));
}

/**
 * @private
 */

var TokenParser = /*#__PURE__*/function () {
  function TokenParser(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map(function (t) {
      return unitForToken(t, locale);
    });
    this.disqualifyingUnit = this.units.find(function (t) {
      return t.invalidReason;
    });
    if (!this.disqualifyingUnit) {
      var _buildRegex = buildRegex(this.units),
        regexString = _buildRegex[0],
        handlers = _buildRegex[1];
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  var _proto = TokenParser.prototype;
  _proto.explainFromTokens = function explainFromTokens(input) {
    if (!this.isValid) {
      return {
        input: input,
        tokens: this.tokens,
        invalidReason: this.invalidReason
      };
    } else {
      var _match = match(input, this.regex, this.handlers),
        rawMatches = _match[0],
        matches = _match[1],
        _ref6 = matches ? dateTimeFromMatches(matches) : [null, null, undefined],
        result = _ref6[0],
        zone = _ref6[1],
        specificOffset = _ref6[2];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
      }
      return {
        input: input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: rawMatches,
        matches: matches,
        result: result,
        zone: zone,
        specificOffset: specificOffset
      };
    }
  };
  _createClass(TokenParser, [{
    key: "isValid",
    get: function get() {
      return !this.disqualifyingUnit;
    }
  }, {
    key: "invalidReason",
    get: function get() {
      return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
    }
  }]);
  return TokenParser;
}();
function explainFromTokens(locale, input, format) {
  var parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
  var _explainFromTokens = explainFromTokens(locale, input, format),
    result = _explainFromTokens.result,
    zone = _explainFromTokens.zone,
    specificOffset = _explainFromTokens.specificOffset,
    invalidReason = _explainFromTokens.invalidReason;
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  var formatter = Formatter.create(locale, formatOpts);
  var df = formatter.dtFormatter(getDummyDateTime());
  var parts = df.formatToParts();
  var resolvedOpts = df.resolvedOptions();
  return parts.map(function (p) {
    return tokenForPart(p, formatOpts, resolvedOpts);
  });
}

var INVALID = "Invalid DateTime";
var MAX_DATE = 8.64e15;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}

// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}

/**
 * @param {DateTime} dt
 */
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
  }
  return dt.localWeekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
  var current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(_extends({}, current, alts, {
    old: current
  }));
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  var o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  var o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;
  var d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  var oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = _extends({}, inst.c, {
      year: year,
      month: month,
      day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }),
    millisToAdd = Duration.fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds
    }).as("milliseconds"),
    localTS = objToLocalTS(c);
  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
    ts = _fixOffset[0],
    o = _fixOffset[1];
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }
  return {
    ts: ts,
    o: o
  };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  var setZone = opts.setZone,
    zone = opts.zone;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    var interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, _extends({}, opts, {
        zone: interpretationZone,
        specificOffset: specificOffset
      }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ) {
  if (allowZ === void 0) {
    allowZ = true;
  }
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ: allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function _toISODate(o, extended) {
  var longFormat = o.c.year > 9999 || o.c.year < 0;
  var c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}
function _toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  var c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }
  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);
    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}

// defaults for unspecified units in the supported calendars
var defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  };

// Units in the supported calendars, sorted by bigness
var orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];

// standardize case and plurality in units
function normalizeUnit(unit) {
  var normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}

// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === undefined) {
      zoneOffsetTs = Settings.now();
    }
    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
  var zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  var loc = Locale.fromObject(opts);
  var ts, o;

  // assume we have the higher-order units
  if (!isUndefined(obj.year)) {
    for (var _i = 0, _orderedUnits = orderedUnits; _i < _orderedUnits.length; _i++) {
      var u = _orderedUnits[_i];
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    var offsetProvis = guessOffsetForZone(zone);
    var _objToTS = objToTS(obj, offsetProvis, zone);
    ts = _objToTS[0];
    o = _objToTS[1];
  } else {
    ts = Settings.now();
  }
  return new DateTime({
    ts: ts,
    zone: zone,
    loc: loc,
    o: o
  });
}
function diffRelative(start, end, opts) {
  var round = isUndefined(opts.round) ? true : opts.round,
    format = function format(c, unit) {
      c = roundTo(c, round || opts.calendary ? 0 : 2, true);
      var formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = function differ(unit) {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (var _iterator = _createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;) {
    var unit = _step.value;
    var count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  var opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}

/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */
var zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */
var zoneOffsetGuessCache = {};

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */
var DateTime = /*#__PURE__*/function (_Symbol$for) {
  /**
   * @access private
   */
  function DateTime(config) {
    var zone = config.zone || Settings.defaultZone;
    var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    var c = null,
      o = null;
    if (!invalid) {
      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        var _ref = [config.old.c, config.old.o];
        c = _ref[0];
        o = _ref[1];
      } else {
        // If an offset has been passed and we have not been called from
        // clone(), we can trust it and avoid the offset calculation.
        var ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }

    /**
     * @access private
     */
    this._zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.invalid = invalid;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.localWeekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
    /**
     * @access private
     */
    this.isLuxonDateTime = true;
  }

  // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  DateTime.now = function now() {
    return new DateTime({});
  }

  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */;
  DateTime.local = function local() {
    var _lastOpts = lastOpts(arguments),
      opts = _lastOpts[0],
      args = _lastOpts[1],
      year = args[0],
      month = args[1],
      day = args[2],
      hour = args[3],
      minute = args[4],
      second = args[5],
      millisecond = args[6];
    return quickDT({
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second,
      millisecond: millisecond
    }, opts);
  }

  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */;
  DateTime.utc = function utc() {
    var _lastOpts2 = lastOpts(arguments),
      opts = _lastOpts2[0],
      args = _lastOpts2[1],
      year = args[0],
      month = args[1],
      day = args[2],
      hour = args[3],
      minute = args[4],
      second = args[5],
      millisecond = args[6];
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second,
      millisecond: millisecond
    }, opts);
  }

  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */;
  DateTime.fromJSDate = function fromJSDate(date, options) {
    if (options === void 0) {
      options = {};
    }
    var ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }
    var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }

  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */;
  DateTime.fromMillis = function fromMillis(milliseconds, options) {
    if (options === void 0) {
      options = {};
    }
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }

  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */;
  DateTime.fromSeconds = function fromSeconds(seconds, options) {
    if (options === void 0) {
      options = {};
    }
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }

  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */;
  DateTime.fromObject = function fromObject(obj, opts) {
    if (opts === void 0) {
      opts = {};
    }
    obj = obj || {};
    var zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    var loc = Locale.fromObject(opts);
    var normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    var _usesLocalWeekValues = usesLocalWeekValues(normalized, loc),
      minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek,
      startOfWeek = _usesLocalWeekValues.startOfWeek;
    var tsNow = Settings.now(),
      offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;

    // configure ourselves to deal with gregorian dates or week stuff
    var units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    var foundFirst = false;
    for (var _iterator2 = _createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;) {
      var u = _step2.value;
      var v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
      invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }

    // compute the actual time
    var gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
      _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
      tsFinal = _objToTS2[0],
      offsetFinal = _objToTS2[1],
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc: loc
      });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
    }
    if (!inst.isValid) {
      return DateTime.invalid(inst.invalid);
    }
    return inst;
  }

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */;
  DateTime.fromISO = function fromISO(text, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _parseISODate = parseISODate(text),
      vals = _parseISODate[0],
      parsedZone = _parseISODate[1];
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */;
  DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _parseRFC2822Date = parseRFC2822Date(text),
      vals = _parseRFC2822Date[0],
      parsedZone = _parseRFC2822Date[1];
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */;
  DateTime.fromHTTP = function fromHTTP(text, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _parseHTTPDate = parseHTTPDate(text),
      vals = _parseHTTPDate[0],
      parsedZone = _parseHTTPDate[1];
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }

  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */;
  DateTime.fromFormat = function fromFormat(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    var _opts = opts,
      _opts$locale = _opts.locale,
      locale = _opts$locale === void 0 ? null : _opts$locale,
      _opts$numberingSystem = _opts.numberingSystem,
      numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
      localeToUse = Locale.fromOpts({
        locale: locale,
        numberingSystem: numberingSystem,
        defaultToEN: true
      }),
      _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
      vals = _parseFromTokens[0],
      parsedZone = _parseFromTokens[1],
      specificOffset = _parseFromTokens[2],
      invalid = _parseFromTokens[3];
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    }
  }

  /**
   * @deprecated use fromFormat instead
   */;
  DateTime.fromString = function fromString(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    return DateTime.fromFormat(text, fmt, opts);
  }

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */;
  DateTime.fromSQL = function fromSQL(text, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _parseSQL = parseSQL(text),
      vals = _parseSQL[0],
      parsedZone = _parseSQL[1];
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }

  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */;
  DateTime.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({
        invalid: invalid
      });
    }
  }

  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */;
  DateTime.isDateTime = function isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }

  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */;
  DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
    if (localeOpts === void 0) {
      localeOpts = {};
    }
    var tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map(function (t) {
      return t ? t.val : null;
    }).join("");
  }

  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */;
  DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
    if (localeOpts === void 0) {
      localeOpts = {};
    }
    var expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map(function (t) {
      return t.val;
    }).join("");
  };
  DateTime.resetCache = function resetCache() {
    zoneOffsetTs = undefined;
    zoneOffsetGuessCache = {};
  }

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */;
  var _proto = DateTime.prototype;
  _proto.get = function get(unit) {
    return this[unit];
  }

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */;
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  _proto.getPossibleOffsets = function getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    var dayMs = 86400000;
    var minuteMs = 60000;
    var localTS = objToLocalTS(this.c);
    var oEarlier = this.zone.offset(localTS - dayMs);
    var oLater = this.zone.offset(localTS + dayMs);
    var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    var o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    var ts1 = localTS - o1 * minuteMs;
    var ts2 = localTS - o2 * minuteMs;
    var c1 = tsToObj(ts1, o1);
    var c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [clone(this, {
        ts: ts1
      }), clone(this, {
        ts: ts2
      })];
    }
    return [this];
  }

  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */;
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
      locale = _Formatter$create$res.locale,
      numberingSystem = _Formatter$create$res.numberingSystem,
      calendar = _Formatter$create$res.calendar;
    return {
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: calendar
    };
  }

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */;
  _proto.toUTC = function toUTC(offset, opts) {
    if (offset === void 0) {
      offset = 0;
    }
    if (opts === void 0) {
      opts = {};
    }
    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */;
  _proto.toLocal = function toLocal() {
    return this.setZone(Settings.defaultZone);
  }

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */;
  _proto.setZone = function setZone(zone, _temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$keepLocalTime = _ref2.keepLocalTime,
      keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime,
      _ref2$keepCalendarTim = _ref2.keepCalendarTime,
      keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      var newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        var offsetGuess = zone.offset(this.ts);
        var asObj = this.toObject();
        var _objToTS3 = objToTS(asObj, offsetGuess, zone);
        newTS = _objToTS3[0];
      }
      return clone(this, {
        ts: newTS,
        zone: zone
      });
    }
  }

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */;
  _proto.reconfigure = function reconfigure(_temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
      locale = _ref3.locale,
      numberingSystem = _ref3.numberingSystem,
      outputCalendar = _ref3.outputCalendar;
    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: outputCalendar
    });
    return clone(this, {
      loc: loc
    });
  }

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */;
  _proto.setLocale = function setLocale(locale) {
    return this.reconfigure({
      locale: locale
    });
  }

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */;
  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    var _usesLocalWeekValues2 = usesLocalWeekValues(normalized, this.loc),
      minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek,
      startOfWeek = _usesLocalWeekValues2.startOfWeek;
    var settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    var mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(_extends({}, gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(_extends({}, gregorianToOrdinal(this.c), normalized));
    } else {
      mixed = _extends({}, this.toObject(), normalized);

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    var _objToTS4 = objToTS(mixed, this.o, this.zone),
      ts = _objToTS4[0],
      o = _objToTS4[1];
    return clone(this, {
      ts: ts,
      o: o
    });
  }

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */;
  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */;
  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */;
  _proto.startOf = function startOf(unit, _temp3) {
    var _ref4 = _temp3 === void 0 ? {} : _temp3,
      _ref4$useLocaleWeeks = _ref4.useLocaleWeeks,
      useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
    if (!this.isValid) return this;
    var o = {},
      normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        var startOfWeek = this.loc.getStartOfWeek();
        var weekday = this.weekday;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      var q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }

  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */;
  _proto.endOf = function endOf(unit, opts) {
    var _this$plus;
    return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
  }

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */;
  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */;
  _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
    if (formatOpts === void 0) {
      formatOpts = DATE_SHORT;
    }
    if (opts === void 0) {
      opts = {};
    }
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }

  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */;
  _proto.toLocaleParts = function toLocaleParts(opts) {
    if (opts === void 0) {
      opts = {};
    }
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */;
  _proto.toISO = function toISO(_temp4) {
    var _ref5 = _temp4 === void 0 ? {} : _temp4,
      _ref5$format = _ref5.format,
      format = _ref5$format === void 0 ? "extended" : _ref5$format,
      _ref5$suppressSeconds = _ref5.suppressSeconds,
      suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds,
      _ref5$suppressMillise = _ref5.suppressMilliseconds,
      suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise,
      _ref5$includeOffset = _ref5.includeOffset,
      includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset,
      _ref5$extendedZone = _ref5.extendedZone,
      extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone;
    if (!this.isValid) {
      return null;
    }
    var ext = format === "extended";
    var c = _toISODate(this, ext);
    c += "T";
    c += _toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */;
  _proto.toISODate = function toISODate(_temp5) {
    var _ref6 = _temp5 === void 0 ? {} : _temp5,
      _ref6$format = _ref6.format,
      format = _ref6$format === void 0 ? "extended" : _ref6$format;
    if (!this.isValid) {
      return null;
    }
    return _toISODate(this, format === "extended");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */;
  _proto.toISOWeekDate = function toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */;
  _proto.toISOTime = function toISOTime(_temp6) {
    var _ref7 = _temp6 === void 0 ? {} : _temp6,
      _ref7$suppressMillise = _ref7.suppressMilliseconds,
      suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise,
      _ref7$suppressSeconds = _ref7.suppressSeconds,
      suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds,
      _ref7$includeOffset = _ref7.includeOffset,
      includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset,
      _ref7$includePrefix = _ref7.includePrefix,
      includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix,
      _ref7$extendedZone = _ref7.extendedZone,
      extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone,
      _ref7$format = _ref7.format,
      format = _ref7$format === void 0 ? "extended" : _ref7$format;
    if (!this.isValid) {
      return null;
    }
    var c = includePrefix ? "T" : "";
    return c + _toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
  }

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */;
  _proto.toRFC2822 = function toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */;
  _proto.toHTTP = function toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */;
  _proto.toSQLDate = function toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return _toISODate(this, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */;
  _proto.toSQLTime = function toSQLTime(_temp7) {
    var _ref8 = _temp7 === void 0 ? {} : _temp7,
      _ref8$includeOffset = _ref8.includeOffset,
      includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset,
      _ref8$includeZone = _ref8.includeZone,
      includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone,
      _ref8$includeOffsetSp = _ref8.includeOffsetSpace,
      includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
    var fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */;
  _proto.toSQL = function toSQL(opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid) {
      return null;
    }
    return this.toSQLDate() + " " + this.toSQLTime(opts);
  }

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */;
  _proto.toString = function toString() {
    return this.isValid ? this.toISO() : INVALID;
  }

  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */;
  _proto[_Symbol$for] = function () {
    if (this.isValid) {
      return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
    } else {
      return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    }
  }

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */;
  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }

  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */;
  _proto.toMillis = function toMillis() {
    return this.isValid ? this.ts : NaN;
  }

  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */;
  _proto.toSeconds = function toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }

  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */;
  _proto.toUnixInteger = function toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1000) : NaN;
  }

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */;
  _proto.toJSON = function toJSON() {
    return this.toISO();
  }

  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */;
  _proto.toBSON = function toBSON() {
    return this.toJSDate();
  }

  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */;
  _proto.toObject = function toObject(opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid) return {};
    var base = _extends({}, this.c);
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }

  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */;
  _proto.toJSDate = function toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */;
  _proto.diff = function diff(otherDateTime, unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    var durOpts = _extends({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);
    var units = maybeArray(unit).map(Duration.normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = _diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }

  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */;
  _proto.diffNow = function diffNow(unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }
    if (opts === void 0) {
      opts = {};
    }
    return this.diff(DateTime.now(), unit, opts);
  }

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */;
  _proto.until = function until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */;
  _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    var inputMs = otherDateTime.valueOf();
    var adjustedToZone = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }

  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */;
  _proto.equals = function equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }

  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */;
  _proto.toRelative = function toRelative(options) {
    if (options === void 0) {
      options = {};
    }
    if (!this.isValid) return null;
    var base = options.base || DateTime.fromObject({}, {
        zone: this.zone
      }),
      padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    var units = ["years", "months", "days", "hours", "minutes", "seconds"];
    var unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), _extends({}, options, {
      numeric: "always",
      units: units,
      unit: unit
    }));
  }

  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */;
  _proto.toRelativeCalendar = function toRelativeCalendar(options) {
    if (options === void 0) {
      options = {};
    }
    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({}, {
      zone: this.zone
    }), this, _extends({}, options, {
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    }));
  }

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */;
  DateTime.min = function min() {
    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.min);
  }

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */;
  DateTime.max = function max() {
    for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      dateTimes[_key2] = arguments[_key2];
    }
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.max);
  }

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */;
  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      _options$locale = _options.locale,
      locale = _options$locale === void 0 ? null : _options$locale,
      _options$numberingSys = _options.numberingSystem,
      numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
      localeToUse = Locale.fromOpts({
        locale: locale,
        numberingSystem: numberingSystem,
        defaultToEN: true
      });
    return explainFromTokens(localeToUse, text, fmt);
  }

  /**
   * @deprecated use fromFormatExplain instead
   */;
  DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }
    return DateTime.fromFormatExplain(text, fmt, options);
  }

  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */;
  DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
    if (options === void 0) {
      options = {};
    }
    var _options2 = options,
      _options2$locale = _options2.locale,
      locale = _options2$locale === void 0 ? null : _options2$locale,
      _options2$numberingSy = _options2.numberingSystem,
      numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy,
      localeToUse = Locale.fromOpts({
        locale: locale,
        numberingSystem: numberingSystem,
        defaultToEN: true
      });
    return new TokenParser(localeToUse, fmt);
  }

  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */;
  DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
    }
    var _opts2 = opts,
      _opts2$locale = _opts2.locale,
      locale = _opts2$locale === void 0 ? null : _opts2$locale,
      _opts2$numberingSyste = _opts2.numberingSystem,
      numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste,
      localeToUse = Locale.fromOpts({
        locale: locale,
        numberingSystem: numberingSystem,
        defaultToEN: true
      });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
    }
    var _formatParser$explain = formatParser.explainFromTokens(text),
      result = _formatParser$explain.result,
      zone = _formatParser$explain.zone,
      specificOffset = _formatParser$explain.specificOffset,
      invalidReason = _formatParser$explain.invalidReason;
    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    }
  }

  // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */;
  _createClass(DateTime, [{
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }

    /**
     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
     * @type {string}
     */
  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }

    /**
     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }

    /**
     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }

    /**
     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }

    /**
     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "outputCalendar",
    get: function get() {
      return this.isValid ? this.loc.outputCalendar : null;
    }

    /**
     * Get the time zone associated with this DateTime.
     * @type {Zone}
     */
  }, {
    key: "zone",
    get: function get() {
      return this._zone;
    }

    /**
     * Get the name of the time zone.
     * @type {string}
     */
  }, {
    key: "zoneName",
    get: function get() {
      return this.isValid ? this.zone.name : null;
    }

    /**
     * Get the year
     * @example DateTime.local(2017, 5, 25).year //=> 2017
     * @type {number}
     */
  }, {
    key: "year",
    get: function get() {
      return this.isValid ? this.c.year : NaN;
    }

    /**
     * Get the quarter
     * @example DateTime.local(2017, 5, 25).quarter //=> 2
     * @type {number}
     */
  }, {
    key: "quarter",
    get: function get() {
      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }

    /**
     * Get the month (1-12).
     * @example DateTime.local(2017, 5, 25).month //=> 5
     * @type {number}
     */
  }, {
    key: "month",
    get: function get() {
      return this.isValid ? this.c.month : NaN;
    }

    /**
     * Get the day of the month (1-30ish).
     * @example DateTime.local(2017, 5, 25).day //=> 25
     * @type {number}
     */
  }, {
    key: "day",
    get: function get() {
      return this.isValid ? this.c.day : NaN;
    }

    /**
     * Get the hour of the day (0-23).
     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
     * @type {number}
     */
  }, {
    key: "hour",
    get: function get() {
      return this.isValid ? this.c.hour : NaN;
    }

    /**
     * Get the minute of the hour (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
     * @type {number}
     */
  }, {
    key: "minute",
    get: function get() {
      return this.isValid ? this.c.minute : NaN;
    }

    /**
     * Get the second of the minute (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
     * @type {number}
     */
  }, {
    key: "second",
    get: function get() {
      return this.isValid ? this.c.second : NaN;
    }

    /**
     * Get the millisecond of the second (0-999).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
     * @type {number}
     */
  }, {
    key: "millisecond",
    get: function get() {
      return this.isValid ? this.c.millisecond : NaN;
    }

    /**
     * Get the week year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
     * @type {number}
     */
  }, {
    key: "weekYear",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }

    /**
     * Get the week number of the week year (1-52ish).
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
     * @type {number}
     */
  }, {
    key: "weekNumber",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }

    /**
     * Get the day of the week.
     * 1 is Monday and 7 is Sunday
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekday //=> 4
     * @type {number}
     */
  }, {
    key: "weekday",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }

    /**
     * Returns true if this date is on a weekend according to the locale, false otherwise
     * @returns {boolean}
     */
  }, {
    key: "isWeekend",
    get: function get() {
      return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
    }

    /**
     * Get the day of the week according to the locale.
     * 1 is the first day of the week and 7 is the last day of the week.
     * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
     * @returns {number}
     */
  }, {
    key: "localWeekday",
    get: function get() {
      return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
    }

    /**
     * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
     * because the week can start on different days of the week (see localWeekday) and because a different number of days
     * is required for a week to count as the first week of a year.
     * @returns {number}
     */
  }, {
    key: "localWeekNumber",
    get: function get() {
      return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
    }

    /**
     * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
     * differently, see localWeekNumber.
     * @returns {number}
     */
  }, {
    key: "localWeekYear",
    get: function get() {
      return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
    }

    /**
     * Get the ordinal (meaning the day of the year)
     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
     * @type {number|DateTime}
     */
  }, {
    key: "ordinal",
    get: function get() {
      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }

    /**
     * Get the human readable short month name, such as 'Oct'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
     * @type {string}
     */
  }, {
    key: "monthShort",
    get: function get() {
      return this.isValid ? Info.months("short", {
        locObj: this.loc
      })[this.month - 1] : null;
    }

    /**
     * Get the human readable long month name, such as 'October'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthLong //=> October
     * @type {string}
     */
  }, {
    key: "monthLong",
    get: function get() {
      return this.isValid ? Info.months("long", {
        locObj: this.loc
      })[this.month - 1] : null;
    }

    /**
     * Get the human readable short weekday, such as 'Mon'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
     * @type {string}
     */
  }, {
    key: "weekdayShort",
    get: function get() {
      return this.isValid ? Info.weekdays("short", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }

    /**
     * Get the human readable long weekday, such as 'Monday'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
     * @type {string}
     */
  }, {
    key: "weekdayLong",
    get: function get() {
      return this.isValid ? Info.weekdays("long", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }

    /**
     * Get the UTC offset of this DateTime in minutes
     * @example DateTime.now().offset //=> -240
     * @example DateTime.utc().offset //=> 0
     * @type {number}
     */
  }, {
    key: "offset",
    get: function get() {
      return this.isValid ? +this.o : NaN;
    }

    /**
     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */
  }, {
    key: "offsetNameShort",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "short",
          locale: this.locale
        });
      } else {
        return null;
      }
    }

    /**
     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */
  }, {
    key: "offsetNameLong",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "long",
          locale: this.locale
        });
      } else {
        return null;
      }
    }

    /**
     * Get whether this zone's offset ever changes, as in a DST.
     * @type {boolean}
     */
  }, {
    key: "isOffsetFixed",
    get: function get() {
      return this.isValid ? this.zone.isUniversal : null;
    }

    /**
     * Get whether the DateTime is in a DST.
     * @type {boolean}
     */
  }, {
    key: "isInDST",
    get: function get() {
      if (this.isOffsetFixed) {
        return false;
      } else {
        return this.offset > this.set({
          month: 1,
          day: 1
        }).offset || this.offset > this.set({
          month: 5
        }).offset;
      }
    }
  }, {
    key: "isInLeapYear",
    get: function get() {
      return isLeapYear(this.year);
    }

    /**
     * Returns the number of days in this DateTime's month
     * @example DateTime.local(2016, 2).daysInMonth //=> 29
     * @example DateTime.local(2016, 3).daysInMonth //=> 31
     * @type {number}
     */
  }, {
    key: "daysInMonth",
    get: function get() {
      return daysInMonth(this.year, this.month);
    }

    /**
     * Returns the number of days in this DateTime's year
     * @example DateTime.local(2016).daysInYear //=> 366
     * @example DateTime.local(2013).daysInYear //=> 365
     * @type {number}
     */
  }, {
    key: "daysInYear",
    get: function get() {
      return this.isValid ? daysInYear(this.year) : NaN;
    }

    /**
     * Returns the number of weeks in this DateTime's year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2004).weeksInWeekYear //=> 53
     * @example DateTime.local(2013).weeksInWeekYear //=> 52
     * @type {number}
     */
  }, {
    key: "weeksInWeekYear",
    get: function get() {
      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }

    /**
     * Returns the number of weeks in this DateTime's local week year
     * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
     * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
     * @type {number}
     */
  }, {
    key: "weeksInLocalWeekYear",
    get: function get() {
      return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
    }
  }], [{
    key: "DATE_SHORT",
    get: function get() {
      return DATE_SHORT;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_MED",
    get: function get() {
      return DATE_MED;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_MED_WITH_WEEKDAY",
    get: function get() {
      return DATE_MED_WITH_WEEKDAY;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_FULL",
    get: function get() {
      return DATE_FULL;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_HUGE",
    get: function get() {
      return DATE_HUGE;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_SIMPLE",
    get: function get() {
      return TIME_SIMPLE;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_SECONDS",
    get: function get() {
      return TIME_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_WITH_SHORT_OFFSET;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_WITH_LONG_OFFSET;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_SIMPLE",
    get: function get() {
      return TIME_24_SIMPLE;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_SECONDS",
    get: function get() {
      return TIME_24_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_24_WITH_SHORT_OFFSET;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_24_WITH_LONG_OFFSET;
    }

    /**
     * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_SHORT",
    get: function get() {
      return DATETIME_SHORT;
    }

    /**
     * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_SHORT_WITH_SECONDS",
    get: function get() {
      return DATETIME_SHORT_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED",
    get: function get() {
      return DATETIME_MED;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED_WITH_SECONDS",
    get: function get() {
      return DATETIME_MED_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED_WITH_WEEKDAY",
    get: function get() {
      return DATETIME_MED_WITH_WEEKDAY;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_FULL",
    get: function get() {
      return DATETIME_FULL;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_FULL_WITH_SECONDS",
    get: function get() {
      return DATETIME_FULL_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_HUGE",
    get: function get() {
      return DATETIME_HUGE;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_HUGE_WITH_SECONDS",
    get: function get() {
      return DATETIME_HUGE_WITH_SECONDS;
    }
  }]);
  return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
  }
}

var VERSION = "3.5.0";

exports.DateTime = DateTime;
exports.Duration = Duration;
exports.FixedOffsetZone = FixedOffsetZone;
exports.IANAZone = IANAZone;
exports.Info = Info;
exports.Interval = Interval;
exports.InvalidZone = InvalidZone;
exports.Settings = Settings;
exports.SystemZone = SystemZone;
exports.VERSION = VERSION;
exports.Zone = Zone;
//# sourceMappingURL=luxon.js.map
});

const wdprCheckboxCss = ":host{--font-family-base:var(--font-family-base-theme, InspireTWDC);--font-family-light:var(--font-family-light-theme, InspireTWDCLight);--font-family-heavy:var(--font-family-heavy-theme, InspireTWDCHeavy);--font-family-black:var(--font-family-black-theme, InspireTWDCBlack);--font-family-medium:var(--font-family-medium-theme, InspireTWDCMedium);--font-family-roman:var(--font-family-roman-theme, InspireTWDCRoman);--font-family-book:var(--font-family-book-theme, InspireTWDCBook);--font-weight-light:var(--font-weight-light-theme, 200);--font-weight-heavy:var(--font-weight-heavy-theme, 700);--font-weight-black:var(--font-weight-black-theme, 900);--font-weight-medium:var(--font-weight-medium-theme, 500);--font-weight-roman:var(--font-weight-roman-theme, 400);--font-weight-book:var(--font-weight-book-theme, 400);--font50-line-height:var(--font50-line-height-theme, 60px);--font40-line-height:var(--font40-line-height-theme, 50px);--font36-line-height:var(--font36-line-height-theme, 48px);--font28-line-height:var(--font28-line-height-theme, 36px);--font24-line-height:var(--font24-line-height-theme, 32px);--font20-line-height:var(--font20-line-height-theme, 28px);--font18-line-height:var(--font18-line-height-theme, 26px);--font16-line-height:var(--font16-line-height-theme, 24px);--font14-line-height:var(--font14-line-height-theme, 20px);--font12-line-height:var(--font12-line-height-theme, 20px)}:host{--font-base:{\n    font-family: var(--font-family-base)}; --font-light:{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}; --font-heavy:{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}; --font-black:{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}; --font-medium:{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}; --font-roman:{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}; --font-book:{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}; --font50:{font-size:50px;line-height:var(--font50-line-height)}; --font40:{font-size:40px;line-height:var(--font40-line-height)}; --font36:{font-size:36px;line-height:var(--font36-line-height)}; --font28:{font-size:28px;line-height:var(--font28-line-height)}; --font24:{font-size:24px;line-height:var(--font24-line-height)}; --font20:{font-size:20px;line-height:var(--font20-line-height)}; --font18:{font-size:18px;line-height:var(--font18-line-height)}; --font16:{font-size:16px;line-height:var(--font16-line-height)}; --font14:{font-size:14px;line-height:var(--font14-line-height)}; --font12:{font-size:12px;line-height:var(--font12-line-height)}; } .font-base,.checkbox-label{font-family:var(--font-family-base)}.light{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}.heavy{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}.black{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}.medium{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}.roman{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}.book{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.font50{font-size:50px;line-height:var(--font50-line-height)}.font40{font-size:40px;line-height:var(--font40-line-height)}.font36{font-size:36px;line-height:var(--font36-line-height)}.font28{font-size:28px;line-height:var(--font28-line-height)}.font24{font-size:24px;line-height:var(--font24-line-height)}.font20{font-size:20px;line-height:var(--font20-line-height)}.font18{font-size:18px;line-height:var(--font18-line-height)}.font16{font-size:16px;line-height:var(--font16-line-height)}.font14{font-size:14px;line-height:var(--font14-line-height)}.font12{font-size:12px;line-height:var(--font12-line-height)}.font-lg-1{font-size:50px;line-height:var(--font50-line-height)}.font-lg-2{font-size:40px;line-height:var(--font40-line-height)}.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}@media only screen and (min-width: 481px) and (max-width: 1179.98px){.font-lg-1,.font-lg-2,.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}@media only screen and (max-width: 480.98px){.font-lg-1,.font-lg-2,.font-md-1,.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}:host{font-family:var(--font-family-base)}:host{--icon-font-family:var(--icon-font-family-theme, \"pepmdx\")}.di{font-family:var(--icon-font-family, \"pepmdx\") !important;font-style:normal;font-size:inherit}.di50{font-size:50px}.di40{font-size:40px}.di36{font-size:36px}.di28{font-size:28px}.di24{font-size:24px}.di20{font-size:20px}.di18{font-size:18px}.di16{font-size:16px}.di14{font-size:14px}.di12{font-size:12px}.di10{font-size:10px}.di-disney-resort::before,.di-E001::before{content:\"\\e001\"}.di-california-adventure::before,.di-E002::before{content:\"\\e002\"}.di-disney-paris::before,.di-E003::before{content:\"\\e003\"}.di-shanghai-disney-resort::before,.di-E004::before{content:\"\\e004\"}.di-hong-kong-disney::before,.di-E005::before{content:\"\\e005\"}.di-tokyo-disney::before,.di-E006::before{content:\"\\e006\"}.di-aulani-resort-hawaii::before,.di-E007::before{content:\"\\e007\"}.di-adventure-by-disney::before,.di-E008::before{content:\"\\e008\"}.di-disney-park-generic-castle::before,.di-E009::before{content:\"\\e009\"}.di-leadership::before,.di-E00A::before{content:\"\\e00a\"}.di-selection-training::before,.di-E00B::before{content:\"\\e00b\"}.di-quality-service::before,.di-E00C::before{content:\"\\e00c\"}.di-brand-royalty::before,.di-E00D::before{content:\"\\e00d\"}.di-creativity-innovate::before,.di-E00E::before{content:\"\\e00e\"}.di-business-excellence::before,.di-E00F::before{content:\"\\e00f\"}.di-medical-excellence::before,.di-E010::before{content:\"\\e010\"}.di-catalogs::before,.di-E011::before{content:\"\\e011\"}.di-disney-park::before,.di-E012::before{content:\"\\e012\"}.di-disneyland-resort::before,.di-E013::before{content:\"\\e013\"}.di-city-hall-services::before,.di-E014::before{content:\"\\e014\"}.di-hkdl-magic-access::before,.di-E015::before{content:\"\\e015\"}.di-downtown-disney::before,.di-E016::before{content:\"\\e016\"}.di-wedding-engagements::before,.di-E017::before{content:\"\\e017\"}.di-weddings-ever-after-blog::before,.di-E018::before{content:\"\\e018\"}.di-weddings-bridal-boutique::before,.di-E019::before{content:\"\\e019\"}.di-shdr-disneytown::before,.di-E01A::before{content:\"\\e01a\"}.di-shdr-wishing-star-park::before,.di-E01B::before{content:\"\\e01b\"}.di-shop-disney-parks-app::before,.di-E01C::before{content:\"\\e01c\"}.di-shop-disney-parks-bag::before,.di-E01D::before{content:\"\\e01d\"}.di-shop-disney-bag::before,.di-E01E::before{content:\"\\e01e\"}.di-style-guide::before,.di-E020::before{content:\"\\e020\"}.di-star-wars::before,.di-E021::before{content:\"\\e021\"}.di-sw-galaxys-edge-hub::before,.di-E022::before{content:\"\\e022\"}.di-rundisney-medals::before,.di-E023::before{content:\"\\e023\"}.di-rundisney-shirts::before,.di-E024::before{content:\"\\e024\"}.di-rundisney-snacks::before,.di-E025::before{content:\"\\e025\"}.di-disneyland-calender::before,.di-E026::before{content:\"\\e026\"}.di-california-adventure-calender::before,.di-E027::before{content:\"\\e027\"}.di-genie-product::before,.di-E028::before{content:\"\\e028\"}.di-all-parks-and-resorts::before,.di-E040::before{content:\"\\e040\"}.di-magic-kingdom::before,.di-E041::before{content:\"\\e041\"}.di-epcot::before,.di-E042::before{content:\"\\e042\"}.di-animal-kingdom::before,.di-E043::before{content:\"\\e043\"}.di-hollywood-studios::before,.di-E044::before{content:\"\\e044\"}.di-typhoon-lagoon::before,.di-E045::before{content:\"\\e045\"}.di-blizzard-beach::before,.di-E046::before{content:\"\\e046\"}.di-disney-springs::before,.di-E047::before{content:\"\\e047\"}.di-espn-wide-world-sports::before,.di-E048::before{content:\"\\e048\"}.di-resorts::before,.di-E049::before{content:\"\\e049\"}.di-disney-beach-resorts::before,.di-E04A::before{content:\"\\e04a\"}.di-disney-boardwalk::before,.di-E04B::before{content:\"\\e04b\"}.di-all-categories::before,.di-E04C::before{content:\"\\e04c\"}.di-cirque-du-soleil-la-nouba::before,.di-E04D::before{content:\"\\e04d\"}.di-star-wars-galactic-starcruiser::before,.di-E04E::before{content:\"\\e04e\"}.di-disney-cruise-line::before,.di-E080::before{content:\"\\e080\"}.di-dcl-our-ships::before,.di-E081::before{content:\"\\e081\"}.di-dcl-destinations::before,.di-E082::before{content:\"\\e082\"}.di-dcl-onboard-fun::before,.di-E083::before{content:\"\\e083\"}.di-dcl-new-cruisers::before,.di-E084::before{content:\"\\e084\"}.di-dcl-port-adventures::before,.di-E085::before{content:\"\\e085\"}.di-app-instructions::before,.di-E086::before{content:\"\\e086\"}.di-featured-article::before,.di-E087::before{content:\"\\e087\"}.di-drink-of-the-day::before,.di-E088::before{content:\"\\e088\"}.di-view-folio::before,.di-E08A::before{content:\"\\e08a\"}.di-key-to-the-world::before,.di-E08B::before{content:\"\\e08b\"}.di-in-room-entertainment::before,.di-E08C::before{content:\"\\e08c\"}.di-ship-directory::before,.di-E08D::before{content:\"\\e08d\"}.di-theatre::before,.di-E08E::before{content:\"\\e08e\"}.di-disembarkation::before,.di-E08F::before{content:\"\\e08f\"}.di-wash-hands::before,.di-E094::before{content:\"\\e094\"}.di-security-notice::before,.di-E095::before{content:\"\\e095\"}.di-environmental-message::before,.di-E096::before{content:\"\\e096\"}.di-room-upgrade::before,.di-E098::before{content:\"\\e098\"}.di-castaway-club-member::before,.di-E09A::before{content:\"\\e09a\"}.di-dcl-open-house::before,.di-E09B::before{content:\"\\e09b\"}.di-stateroom-balcony::before,.di-E09F::before{content:\"\\e09f\"}.di-cart-empty::before,.di-E0C0::before{content:\"\\e0c0\"}.di-cart-full::before,.di-E0C1::before{content:\"\\e0c1\"}.di-tickets::before,.di-E0C2::before{content:\"\\e0c2\"}.di-fastpass-plus::before,.di-E0C3::before{content:\"\\e0c3\"}.di-fastpasses-set::before,.di-E0C4::before{content:\"\\e0c4\"}.di-fastpasses-copy-set::before,.di-E0C5::before{content:\"\\e0c5\"}.di-cancel-fastpasses::before,.di-E0C6::before{content:\"\\e0c6\"}.di-water-park::before,.di-E0C7::before{content:\"\\e0c7\"}.di-vacation-packages::before,.di-E0C8::before{content:\"\\e0c8\"}.di-personal-magic::before,.di-E0C9::before{content:\"\\e0c9\"}.di-florida-resident::before,.di-E0CA::before{content:\"\\e0ca\"}.di-disney-vacation-club-info::before,.di-E0CB::before{content:\"\\e0cb\"}.di-annual-passholder::before,.di-E0CC::before{content:\"\\e0cc\"}.di-us-military::before,.di-E0CD::before{content:\"\\e0cd\"}.di-special-offers-dollar-sign::before,.di-E0CE::before{content:\"\\e0ce\"}.di-booking-rooms-packages::before,.di-E0CF::before{content:\"\\e0cf\"}.di-old-fastpass::before,.di-E0D0::before{content:\"\\e0d0\"}.di-certificate::before,.di-E0D1::before{content:\"\\e0d1\"}.di-will-call-tickets::before,.di-E0D2::before{content:\"\\e0d2\"}.di-entrance-pass::before,.di-E0D3::before{content:\"\\e0d3\"}.di-guest-pass::before,.di-E0D4::before{content:\"\\e0d4\"}.di-city-pass::before,.di-E0D5::before{content:\"\\e0d5\"}.di-california::before,.di-E0D6::before{content:\"\\e0d6\"}.di-southern-california::before,.di-E0D7::before{content:\"\\e0d7\"}.di-etickets::before,.di-E0D8::before{content:\"\\e0d8\"}.di-compare-offers::before,.di-E0D9::before{content:\"\\e0d9\"}.di-baja-california-resident::before,.di-E0DA::before{content:\"\\e0da\"}.di-area-attractions::before,.di-E0DB::before{content:\"\\e0db\"}.di-anaheim-resort-transit::before,.di-E0DC::before{content:\"\\e0dc\"}.di-edit-fastpass::before,.di-E0DD::before{content:\"\\e0dd\"}.di-in-park-merchandise::before,.di-E0E0::before{content:\"\\e0e0\"}.di-travel-insurance::before,.di-E0E1::before{content:\"\\e0e1\"}.di-texas-resident::before,.di-E0E2::before{content:\"\\e0e2\"}.di-canadian-resident::before,.di-E0E3::before{content:\"\\e0e3\"}.di-add-tickets::before,.di-E0E4::before{content:\"\\e0e4\"}.di-splurge::before,.di-E0E5::before{content:\"\\e0e5\"}.di-disneyland-annual-passes::before,.di-E0E6::before{content:\"\\e0e6\"}.di-dlr-tickets-passes::before,.di-E0E7::before{content:\"\\e0e7\"}.di-get-vacation-offer-recommended::before,.di-E0E8::before{content:\"\\e0e8\"}.di-get-vacation-offer-guest-created::before,.di-E0E9::before{content:\"\\e0e9\"}.di-shdr-fastpass::before,.di-E0EA::before{content:\"\\e0ea\"}.di-currency-convertor::before,.di-E0EB::before{content:\"\\e0eb\"}.di-call-to-buy-tickets::before,.di-E0EC::before{content:\"\\e0ec\"}.di-wdw-tickets-and-passes::before,.di-E0ED::before{content:\"\\e0ed\"}.di-renew-annual-pass::before,.di-E0EE::before{content:\"\\e0ee\"}.di-renew-annual-pass-dlr::before,.di-E0EF::before{content:\"\\e0ef\"}.di-annual-pass-wdw::before,.di-E0F0::before{content:\"\\e0f0\"}.di-mobile-order::before,.di-E0F1::before{content:\"\\e0f1\"}.di-fastpass::before,.di-E0F2::before{content:\"\\e0f2\"}.di-ticket-ap-upgrade::before,.di-E0F3::before{content:\"\\e0f3\"}.di-shdr-premium-access::before,.di-E0F4::before{content:\"\\e0f4\"}.di-shdr-tickets-and-passes::before,.di-E0F5::before{content:\"\\e0f5\"}.di-shdr-seasonal-pass::before,.di-E0F6::before{content:\"\\e0f6\"}.di-shdr-fastpass-reverse::before,.di-E0F7::before{content:\"\\e0f7\"}.di-disney-maxpass::before,.di-E0F8::before{content:\"\\e0f8\"}.di-shdr-premium-access-chinese::before,.di-E0F9::before{content:\"\\e0f9\"}.di-hawaii-resident::before,.di-E0FA::before{content:\"\\e0fa\"}.di-club-33-membership::before,.di-E0FB::before{content:\"\\e0fb\"}.di-order-grocery-delivery::before,.di-E0FC::before{content:\"\\e0fc\"}.di-special-offers::before,.di-E0FD::before{content:\"\\e0fd\"}.di-prebook-fastpass::before,.di-E0FE::before{content:\"\\e0fe\"}.di-upgrade-offer::before,.di-E0FF::before{content:\"\\e0ff\"}.di-mdx::before,.di-E100::before{content:\"\\e100\"}.di-about-me::before,.di-E101::before{content:\"\\e101\"}.di-friends-family::before,.di-E102::before{content:\"\\e102\"}.di-account-settings::before,.di-E103::before{content:\"\\e103\"}.di-magicbands-v2::before,.di-E104::before{content:\"\\e104\"}.di-magic-cards::before,.di-E105::before{content:\"\\e105\"}.di-pin-payment-methods::before,.di-E106::before{content:\"\\e106\"}.di-communication-references::before,.di-E107::before{content:\"\\e107\"}.di-wishlist::before,.di-E108::before{content:\"\\e108\"}.di-link-existing-reservation::before,.di-E109::before{content:\"\\e109\"}.di-guest-entered-schedule-item::before,.di-E10A::before{content:\"\\e10a\"}.di-birthday::before,.di-E10B::before{content:\"\\e10b\"}.di-memory-maker::before,.di-E10C::before{content:\"\\e10c\"}.di-memory-maker-2::before,.di-E10D::before{content:\"\\e10d\"}.di-passes-and-memberships::before,.di-E10E::before{content:\"\\e10e\"}.di-link-mdx-tickets-passes::before,.di-E10F::before{content:\"\\e10f\"}.di-link-mdx-resort-reservations::before,.di-E110::before{content:\"\\e110\"}.di-link-mdx-dining-reservations::before,.di-E111::before{content:\"\\e111\"}.di-link-dlr-tickets::before,.di-E112::before{content:\"\\e112\"}.di-link-main-entrance::before,.di-E113::before{content:\"\\e113\"}.di-digital-key::before,.di-E115::before{content:\"\\e115\"}.di-wishlist-item-added::before,.di-E116::before{content:\"\\e116\"}.di-wishlist-empty::before,.di-E117::before{content:\"\\e117\"}.di-magicbands-original::before,.di-E118::before{content:\"\\e118\"}.di-all-activities::before,.di-E140::before{content:\"\\e140\"}.di-attractions::before,.di-E141::before{content:\"\\e141\"}.di-characters::before,.di-E142::before{content:\"\\e142\"}.di-entertainment::before,.di-E143::before{content:\"\\e143\"}.di-tours-events::before,.di-E144::before{content:\"\\e144\"}.di-in-park-shopping::before,.di-E145::before{content:\"\\e145\"}.di-spas::before,.di-E146::before{content:\"\\e146\"}.di-tour::before,.di-E14C::before{content:\"\\e14c\"}.di-spring-break::before,.di-E14D::before{content:\"\\e14d\"}.di-fireworks::before,.di-E14E::before{content:\"\\e14e\"}.di-shows::before,.di-E14F::before{content:\"\\e14f\"}.di-dining::before,.di-E180::before{content:\"\\e180\"}.di-dining-plan::before,.di-E181::before{content:\"\\e181\"}.di-dining-plan-accepted::before,.di-E182::before{content:\"\\e182\"}.di-dining-plan-not-accepted::before,.di-E183::before{content:\"\\e183\"}.di-dining-reservation::before,.di-E184::before{content:\"\\e184\"}.di-menu::before,.di-E185::before{content:\"\\e185\"}.di-prix-fixe-qsr::before,.di-E186::before{content:\"\\e186\"}.di-prix-fixe-tsr::before,.di-E187::before{content:\"\\e187\"}.di-entrees-qsr::before,.di-E188::before{content:\"\\e188\"}.di-entrees-tsr::before,.di-E189::before{content:\"\\e189\"}.di-beverages::before,.di-E18A::before{content:\"\\e18a\"}.di-wine::before,.di-E18B::before{content:\"\\e18b\"}.di-beer::before,.di-E18C::before{content:\"\\e18c\"}.di-cocktails::before,.di-E18D::before{content:\"\\e18d\"}.di-appetizers::before,.di-E18E::before{content:\"\\e18e\"}.di-sandwiches::before,.di-E18F::before{content:\"\\e18f\"}.di-beef-pork-chicken::before,.di-E190::before{content:\"\\e190\"}.di-seafood::before,.di-E191::before{content:\"\\e191\"}.di-pasta::before,.di-E192::before{content:\"\\e192\"}.di-salads::before,.di-E193::before{content:\"\\e193\"}.di-sides::before,.di-E194::before{content:\"\\e194\"}.di-desserts::before,.di-E195::before{content:\"\\e195\"}.di-buffet::before,.di-E196::before{content:\"\\e196\"}.di-favorites::before,.di-E197::before{content:\"\\e197\"}.di-kids-picks::before,.di-E198::before{content:\"\\e198\"}.di-featured-items::before,.di-E199::before{content:\"\\e199\"}.di-nutritional-content::before,.di-E19A::before{content:\"\\e19a\"}.di-nutritional-information::before,.di-E19B::before{content:\"\\e19b\"}.di-gluten-free::before,.di-E19C::before{content:\"\\e19c\"}.di-dairy-free::before,.di-E19D::before{content:\"\\e19d\"}.di-character-dining::before,.di-E19E::before{content:\"\\e19e\"}.di-mockey-food-seal::before,.di-E19F::before{content:\"\\e19f\"}.di-priority-seating::before,.di-E1A1::before{content:\"\\e1a1\"}.di-vegetarian::before,.di-E1A2::before{content:\"\\e1a2\"}.di-raw-food::before,.di-E1A3::before{content:\"\\e1a3\"}.di-guest-favorite-food::before,.di-E1A4::before{content:\"\\e1a4\"}.di-mobile-order-food::before,.di-E1A5::before{content:\"\\e1a5\"}.di-adult-table-service::before,.di-E1A6::before{content:\"\\e1a6\"}.di-celebration-cakes::before,.di-E1A7::before{content:\"\\e1a7\"}.di-disney-dining-plan::before,.di-E1A8::before{content:\"\\e1a8\"}.di-disney-deluxe-dining-plan::before,.di-E1A9::before{content:\"\\e1a9\"}.di-coffee-mug::before,.di-E1AA::before{content:\"\\e1aa\"}.di-mobile-order-food::before,.di-E1AB::before{content:\"\\e1ab\"}.di-qs-dining-card::before,.di-E1AC::before{content:\"\\e1ac\"}.di-allergy-friendly::before,.di-E1AD::before{content:\"\\e1ad\"}.di-kids-meals::before,.di-E1AE::before{content:\"\\e1ae\"}.di-dining-check-in::before,.di-E1AF::before{content:\"\\e1af\"}.di-sports-recreation::before,.di-E1C0::before{content:\"\\e1c0\"}.di-campfire::before,.di-E1C1::before{content:\"\\e1c1\"}.di-snorkeling::before,.di-E1C2::before{content:\"\\e1c2\"}.di-swimming::before,.di-E1C3::before{content:\"\\e1c3\"}.di-boating::before,.di-E1C4::before{content:\"\\e1c4\"}.di-running::before,.di-E1C5::before{content:\"\\e1c5\"}.di-fitness-room::before,.di-E1C6::before{content:\"\\e1c6\"}.di-game::before,.di-E1C7::before{content:\"\\e1c7\"}.di-shuffleboard::before,.di-E1C8::before{content:\"\\e1c8\"}.di-parasailing::before,.di-E1C9::before{content:\"\\e1c9\"}.di-playground::before,.di-E1CA::before{content:\"\\e1ca\"}.di-horseback-riding::before,.di-E1CB::before{content:\"\\e1cb\"}.di-pool-tables::before,.di-E1CC::before{content:\"\\e1cc\"}.di-fishing::before,.di-E1CD::before{content:\"\\e1cd\"}.di-volleyball::before,.di-E1CE::before{content:\"\\e1ce\"}.di-basketball::before,.di-E1CF::before{content:\"\\e1cf\"}.di-cycling::before,.di-E1D0::before{content:\"\\e1d0\"}.di-explore::before,.di-E1D1::before{content:\"\\e1d1\"}.di-disneyland-recreation::before,.di-E1D2::before{content:\"\\e1d2\"}.di-baseball::before,.di-E1D4::before{content:\"\\e1d4\"}.di-field-hockey::before,.di-E1D5::before{content:\"\\e1d5\"}.di-football::before,.di-E1D6::before{content:\"\\e1d6\"}.di-gymnastics::before,.di-E1D7::before{content:\"\\e1d7\"}.di-lacrosse::before,.di-E1D8::before{content:\"\\e1d8\"}.di-crosscountry::before,.di-E1D9::before{content:\"\\e1d9\"}.di-soccer::before,.di-E1DA::before{content:\"\\e1da\"}.di-softball-fastpitch::before,.di-E1DB::before{content:\"\\e1db\"}.di-softball-slowpitch::before,.di-E1DC::before{content:\"\\e1dc\"}.di-track-field::before,.di-E1DD::before{content:\"\\e1dd\"}.di-tennis-court::before,.di-E1DE::before{content:\"\\e1de\"}.di-generic-sports::before,.di-E1DF::before{content:\"\\e1df\"}.di-maps::before,.di-E200::before{content:\"\\e200\"}.di-guest-services::before,.di-E201::before{content:\"\\e201\"}.di-concierge::before,.di-E202::before{content:\"\\e202\"}.di-resort-checkin::before,.di-E203::before{content:\"\\e203\"}.di-celebration::before,.di-E204::before{content:\"\\e204\"}.di-aeds::before,.di-E205::before{content:\"\\e205\"}.di-smoking-area::before,.di-E206::before{content:\"\\e206\"}.di-no-smoking::before,.di-E207::before{content:\"\\e207\"}.di-lost-found::before,.di-E208::before{content:\"\\e208\"}.di-baby-care-center::before,.di-E209::before{content:\"\\e209\"}.di-currency-exchange::before,.di-E20A::before{content:\"\\e20a\"}.di-atm::before,.di-E20B::before{content:\"\\e20b\"}.di-restrooms::before,.di-E20C::before{content:\"\\e20c\"}.di-first-aid::before,.di-E20D::before{content:\"\\e20d\"}.di-laundry::before,.di-E20E::before{content:\"\\e20e\"}.di-valet::before,.di-E20F::before{content:\"\\e20f\"}.di-in-room-babysitting::before,.di-E210::before{content:\"\\e210\"}.di-business-center::before,.di-E211::before{content:\"\\e211\"}.di-cabanas::before,.di-E212::before{content:\"\\e212\"}.di-ecv::before,.di-E213::before{content:\"\\e213\"}.di-strollers::before,.di-E214::before{content:\"\\e214\"}.di-parking-lot::before,.di-E215::before{content:\"\\e215\"}.di-kennel::before,.di-E216::before{content:\"\\e216\"}.di-package-pick-up::before,.di-E217::before{content:\"\\e217\"}.di-gas-station::before,.di-E218::before{content:\"\\e218\"}.di-pin-trading::before,.di-E219::before{content:\"\\e219\"}.di-translation-devices::before,.di-E21A::before{content:\"\\e21a\"}.di-wedding-ceremonies::before,.di-E21B::before{content:\"\\e21b\"}.di-resort-amenities::before,.di-E21C::before{content:\"\\e21c\"}.di-movies-under-the-stars::before,.di-E21D::before{content:\"\\e21d\"}.di-kodak-picture-spot::before,.di-E21E::before{content:\"\\e21e\"}.di-locker-rentals::before,.di-E21F::before{content:\"\\e21f\"}.di-here-now::before,.di-E220::before{content:\"\\e220\"}.di-current-location::before,.di-E221::before{content:\"\\e221\"}.di-supervise-children::before,.di-E222::before{content:\"\\e222\"}.di-rider-swap::before,.di-E223::before{content:\"\\e223\"}.di-service-dog::before,.di-E224::before{content:\"\\e224\"}.di-free-disney-wifi::before,.di-E225::before{content:\"\\e225\"}.di-generic-wifi::before,.di-E226::before{content:\"\\e226\"}.di-location-pin::before,.di-E22B::before{content:\"\\e22b\"}.di-disney-express-luggage::before,.di-E22D::before{content:\"\\e22d\"}.di-picnic-area::before,.di-E230::before{content:\"\\e230\"}.di-nikon-picture-spot::before,.di-E236::before{content:\"\\e236\"}.di-atm-2::before,.di-E237::before{content:\"\\e237\"}.di-drinking-fountains::before,.di-E238::before{content:\"\\e238\"}.di-package-express::before,.di-E239::before{content:\"\\e239\"}.di-kingdom-club-bellman::before,.di-E23A::before{content:\"\\e23a\"}.di-in-park-info::before,.di-E23B::before{content:\"\\e23b\"}.di-magical-coin-press-machine::before,.di-E23C::before{content:\"\\e23c\"}.di-stroller-parking::before,.di-E23D::before{content:\"\\e23d\"}.di-electric-car-charging-station::before,.di-E23E::before{content:\"\\e23e\"}.di-parade-route-show-area::before,.di-E23F::before{content:\"\\e23f\"}.di-alert::before,.di-E240::before{content:\"\\e240\"}.di-checkmark::before,.di-E241::before{content:\"\\e241\"}.di-faqs::before,.di-E242::before{content:\"\\e242\"}.di-quick-answer::before,.di-E243::before{content:\"\\e243\"}.di-disney-parks-blog::before,.di-E244::before{content:\"\\e244\"}.di-sms::before,.di-E245::before{content:\"\\e245\"}.di-press-center::before,.di-E246::before{content:\"\\e246\"}.di-moms-panel::before,.di-E247::before{content:\"\\e247\"}.di-park-schedule::before,.di-E248::before{content:\"\\e248\"}.di-time::before,.di-E249::before{content:\"\\e249\"}.di-privacy-policies::before,.di-E24A::before{content:\"\\e24a\"}.di-terms-conditions::before,.di-E24B::before{content:\"\\e24b\"}.di-accessibility::before,.di-E24C::before{content:\"\\e24c\"}.di-pre-arrival-tips::before,.di-E24D::before{content:\"\\e24d\"}.di-reservations::before,.di-E24E::before{content:\"\\e24e\"}.di-registration::before,.di-E24F::before{content:\"\\e24f\"}.di-help-support::before,.di-E250::before{content:\"\\e250\"}.di-learn-more::before,.di-E251::before{content:\"\\e251\"}.di-email::before,.di-E252::before{content:\"\\e252\"}.di-chat::before,.di-E253::before{content:\"\\e253\"}.di-call::before,.di-E254::before{content:\"\\e254\"}.di-14-days-notice::before,.di-E255::before{content:\"\\e255\"}.di-6-months-notice::before,.di-E256::before{content:\"\\e256\"}.di-blackout-days::before,.di-E257::before{content:\"\\e257\"}.di-3-days-notice::before,.di-E258::before{content:\"\\e258\"}.di-website-support::before,.di-E259::before{content:\"\\e259\"}.di-restriction::before,.di-E25A::before{content:\"\\e25a\"}.di-recommendation::before,.di-E25B::before{content:\"\\e25b\"}.di-na-dash::before,.di-E25C::before{content:\"\\e25c\"}.di-magic-morning::before,.di-E25D::before{content:\"\\e25d\"}.di-global-languages::before,.di-E25E::before{content:\"\\e25e\"}.di-good-neighbor-hotel::before,.di-E25F::before{content:\"\\e25f\"}.di-travel-information::before,.di-E261::before{content:\"\\e261\"}.di-visiting-with-groups::before,.di-E262::before{content:\"\\e262\"}.di-visiting-with-children::before,.di-E263::before{content:\"\\e263\"}.di-disney-like-light::before,.di-E266::before{content:\"\\e266\"}.di-disney-like-dark::before,.di-E267::before{content:\"\\e267\"}.di-written-aids::before,.di-E268::before{content:\"\\e268\"}.di-generations-travel::before,.di-E269::before{content:\"\\e269\"}.di-empty-chat::before,.di-E26A::before{content:\"\\e26a\"}.di-filled-chat::before,.di-E26B::before{content:\"\\e26b\"}.di-empty-checkbox::before,.di-E26C::before{content:\"\\e26c\"}.di-selected-solid-checkbox::before,.di-E26D::before{content:\"\\e26d\"}.di-selected-disabled::before,.di-E26E::before{content:\"\\e26e\"}.di-indeterminate::before,.di-E26F::before{content:\"\\e26f\"}.di-10-days-notice::before,.di-E270::before{content:\"\\e270\"}.di-wdw-ap-blockout-cal::before,.di-E271::before{content:\"\\e271\"}.di-flexible-ticket::before,.di-E272::before{content:\"\\e272\"}.di-ride-height::before,.di-E275::before{content:\"\\e275\"}.di-adults::before,.di-E276::before{content:\"\\e276\"}.di-teens-tweens::before,.di-E277::before{content:\"\\e277\"}.di-kids::before,.di-E278::before{content:\"\\e278\"}.di-price-range::before,.di-E279::before{content:\"\\e279\"}.di-price-range-outlined::before,.di-E27A::before{content:\"\\e27a\"}.di-time-outlined::before,.di-E27B::before{content:\"\\e27b\"}.di-all-parks-available::before,.di-E27C::before{content:\"\\e27c\"}.di-some-parks-available::before,.di-E27D::before{content:\"\\e27d\"}.di-my-media::before,.di-E280::before{content:\"\\e280\"}.di-images::before,.di-E281::before{content:\"\\e281\"}.di-videos::before,.di-E282::before{content:\"\\e282\"}.di-photo-pass::before,.di-E283::before{content:\"\\e283\"}.di-photo-pass-plus::before,.di-E284::before{content:\"\\e284\"}.di-media-favorites::before,.di-E285::before{content:\"\\e285\"}.di-photo-fun::before,.di-E286::before{content:\"\\e286\"}.di-disney-vision::before,.di-E287::before{content:\"\\e287\"}.di-dvd-cd::before,.di-E288::before{content:\"\\e288\"}.di-shdr-photopass::before,.di-E289::before{content:\"\\e289\"}.di-order-dvd::before,.di-E28B::before{content:\"\\e28b\"}.di-presented-in-3d::before,.di-E28C::before{content:\"\\e28c\"}.di-guest-photos::before,.di-E28D::before{content:\"\\e28d\"}.di-on-demand::before,.di-E28E::before{content:\"\\e28e\"}.di-live-stream::before,.di-E28F::before{content:\"\\e28f\"}.di-photopass-lenses::before,.di-E290::before{content:\"\\e290\"}.di-monorail::before,.di-E2C0::before{content:\"\\e2c0\"}.di-bus::before,.di-E2C1::before{content:\"\\e2c1\"}.di-car::before,.di-E2C2::before{content:\"\\e2c2\"}.di-boat::before,.di-E2C3::before{content:\"\\e2c3\"}.di-taxi::before,.di-E2C4::before{content:\"\\e2c4\"}.di-flight::before,.di-E2C5::before{content:\"\\e2c5\"}.di-return-flight::before,.di-E2C6::before{content:\"\\e2c6\"}.di-walking::before,.di-E2C7::before{content:\"\\e2c7\"}.di-free-shuttle::before,.di-E2C8::before{content:\"\\e2c8\"}.di-hkdl-mtr-disney-resort-line::before,.di-E2CE::before{content:\"\\e2ce\"}.di-bus-schedule::before,.di-E2CF::before{content:\"\\e2cf\"}.di-minnie-vans-ride-share::before,.di-E2D0::before{content:\"\\e2d0\"}.di-transportation-multiple::before,.di-E2D1::before{content:\"\\e2d1\"}.di-wdw-skylinero::before,.di-E2D2::before{content:\"\\e2d2\"}.di-close-button::before,.di-E300::before{content:\"\\e300\"}.di-add-button::before,.di-E301::before{content:\"\\e301\"}.di-information::before,.di-E302::before{content:\"\\e302\"}.di-share::before,.di-E303::before{content:\"\\e303\"}.di-download::before,.di-E304::before{content:\"\\e304\"}.di-show-filters::before,.di-E305::before{content:\"\\e305\"}.di-hide-filters::before,.di-E306::before{content:\"\\e306\"}.di-3d-spin::before,.di-E307::before{content:\"\\e307\"}.di-media-play-button::before,.di-E308::before{content:\"\\e308\"}.di-media-pause-button::before,.di-E309::before{content:\"\\e309\"}.di-pdf::before,.di-E30A::before{content:\"\\e30a\"}.di-duplicate-offer::before,.di-E30B::before{content:\"\\e30b\"}.di-next::before,.di-E30C::before{content:\"\\e30c\"}.di-previous::before,.di-E30D::before{content:\"\\e30d\"}.di-print::before,.di-E30F::before{content:\"\\e30f\"}.di-search::before,.di-E310::before{content:\"\\e310\"}.di-calendar-month::before,.di-E311::before{content:\"\\e311\"}.di-calendar-day-view::before,.di-E312::before{content:\"\\e312\"}.di-more::before,.di-E313::before{content:\"\\e313\"}.di-menu-global-nav::before,.di-E314::before{content:\"\\e314\"}.di-menus-button::before,.di-E315::before{content:\"\\e315\"}.di-norgie-opened::before,.di-E316::before{content:\"\\e316\"}.di-upload::before,.di-E317::before{content:\"\\e317\"}.di-lists::before,.di-E318::before{content:\"\\e318\"}.di-filter::before,.di-E319::before{content:\"\\e319\"}.di-scan-barcode::before,.di-E31A::before{content:\"\\e31a\"}.di-keyboard-entry::before,.di-E31B::before{content:\"\\e31b\"}.di-download-mobile-app::before,.di-E31C::before{content:\"\\e31c\"}.di-view-gallery::before,.di-E31D::before{content:\"\\e31d\"}.di-see-info-page-button::before,.di-E31E::before{content:\"\\e31e\"}.di-media-gallery-photo-button::before,.di-E31F::before{content:\"\\e31f\"}.di-media-gallery-video-button::before,.di-E320::before{content:\"\\e320\"}.di-refresh::before,.di-E321::before{content:\"\\e321\"}.di-compose-message::before,.di-E322::before{content:\"\\e322\"}.di-add-contact::before,.di-E323::before{content:\"\\e323\"}.di-contact-list::before,.di-E324::before{content:\"\\e324\"}.di-norgie-up::before,.di-E325::before{content:\"\\e325\"}.di-norgie-left::before,.di-E326::before{content:\"\\e326\"}.di-mobile-app::before,.di-E327::before{content:\"\\e327\"}.di-home::before,.di-E328::before{content:\"\\e328\"}.di-return-arrow::before,.di-E329::before{content:\"\\e329\"}.di-share-2::before,.di-E32A::before{content:\"\\e32a\"}.di-delete-button::before,.di-E32B::before{content:\"\\e32b\"}.di-fast-forward-button::before,.di-E32C::before{content:\"\\e32c\"}.di-rewind-button::before,.di-E32D::before{content:\"\\e32d\"}.di-pulldown::before,.di-E32E::before{content:\"\\e32e\"}.di-increase-button::before,.di-E32F::before{content:\"\\e32f\"}.di-decrease-button::before,.di-E330::before{content:\"\\e330\"}.di-flip-turn-over::before,.di-E331::before{content:\"\\e331\"}.di-previous-2::before,.di-E332::before{content:\"\\e332\"}.di-next-2::before,.di-E333::before{content:\"\\e333\"}.di-arrow-back::before,.di-E334::before{content:\"\\e334\"}.di-arrow-up::before,.di-E335::before{content:\"\\e335\"}.di-arrow-down::before,.di-E336::before{content:\"\\e336\"}.di-expand-gallery::before,.di-E337::before{content:\"\\e337\"}.di-360-video::before,.di-E338::before{content:\"\\e338\"}.di-volume-control::before,.di-E339::before{content:\"\\e339\"}.di-app-card-info::before,.di-E33A::before{content:\"\\e33a\"}.di-app-card-flip::before,.di-E33B::before{content:\"\\e33b\"}.di-close-reversed::before,.di-E33E::before{content:\"\\e33e\"}.di-expand-show-more::before,.di-E33F::before{content:\"\\e33f\"}.di-wheelchair-accessibility::before,.di-E340::before{content:\"\\e340\"}.di-transfer-from-wheelchair::before,.di-E341::before{content:\"\\e341\"}.di-transfer-to-wheelchair::before,.di-E342::before{content:\"\\e342\"}.di-transfer-to-wheelchair-then-ride::before,.di-E343::before{content:\"\\e343\"}.di-ambulatory::before,.di-E344::before{content:\"\\e344\"}.di-visual-impairment::before,.di-E345::before{content:\"\\e345\"}.di-hearing-impairment::before,.di-E346::before{content:\"\\e346\"}.di-sign-language::before,.di-E347::before{content:\"\\e347\"}.di-audio-description::before,.di-E348::before{content:\"\\e348\"}.di-handheld-captioning::before,.di-E349::before{content:\"\\e349\"}.di-reflective-captioning::before,.di-E34A::before{content:\"\\e34a\"}.di-closed-captioning::before,.di-E34B::before{content:\"\\e34b\"}.di-physicial-consideration-red-yellow::before,.di-E34C::before{content:\"\\e34c\"}.di-scary-consideration-yellow::before,.di-E34D::before{content:\"\\e34d\"}.di-dlp-mobility-disabilities::before,.di-E34E::before{content:\"\\e34e\"}.di-dlp-hearing-disabilities::before,.di-E34F::before{content:\"\\e34f\"}.di-dlp-visual-disabilities::before,.di-E350::before{content:\"\\e350\"}.di-photosensitive-epilepsy::before,.di-E351::before{content:\"\\e351\"}.di-dlp-mental-cognitive-disabilities::before,.di-E352::before{content:\"\\e352\"}.di-suitable-for-amputees::before,.di-E353::before{content:\"\\e353\"}.di-suitable-for-difficulty-standing::before,.di-E354::before{content:\"\\e354\"}.di-capable-of-climbing-steps::before,.di-E355::before{content:\"\\e355\"}.di-disabilities-services::before,.di-E356::before{content:\"\\e356\"}.di-disabilities-guide-book::before,.di-E357::before{content:\"\\e357\"}.di-wheelchair-rental::before,.di-E358::before{content:\"\\e358\"}.di-disabilities-designated-viewing::before,.di-E359::before{content:\"\\e359\"}.di-may-remain-in-wheelchair::before,.di-E35A::before{content:\"\\e35a\"}.di-must-be-ambulatory-2::before,.di-E35B::before{content:\"\\e35b\"}.di-suitable-for-blind::before,.di-E35C::before{content:\"\\e35c\"}.di-suitable-for-autism::before,.di-E35D::before{content:\"\\e35d\"}.di-sign-language-2::before,.di-E35E::before{content:\"\\e35e\"}.di-tactile-maps::before,.di-E35F::before{content:\"\\e35f\"}.di-braille-guide-books::before,.di-E360::before{content:\"\\e360\"}.di-suitable-for-learning-disabilities::before,.di-E361::before{content:\"\\e361\"}.di-induction-loop::before,.di-E362::before{content:\"\\e362\"}.di-dimly-lit-space::before,.di-E363::before{content:\"\\e363\"}.di-light-rain-indoors::before,.di-E364::before{content:\"\\e364\"}.di-show-contains-bubble::before,.di-E365::before{content:\"\\e365\"}.di-hdd-illness::before,.di-E366::before{content:\"\\e366\"}.di-open-captioning::before,.di-E367::before{content:\"\\e367\"}.di-magnetic-fields::before,.di-E368::before{content:\"\\e368\"}.di-open-captioning-square::before,.di-E369::before{content:\"\\e369\"}.di-gifts::before,.di-E380::before{content:\"\\e380\"}.di-character-calls::before,.di-E381::before{content:\"\\e381\"}.di-performing-arts::before,.di-E382::before{content:\"\\e382\"}.di-education::before,.di-E383::before{content:\"\\e383\"}.di-lock::before,.di-E384::before{content:\"\\e384\"}.di-facebook::before,.di-E385::before{content:\"\\e385\"}.di-twitter::before,.di-E386::before{content:\"\\e386\"}.di-youtube::before,.di-E387::before{content:\"\\e387\"}.di-instagram::before,.di-E388::before{content:\"\\e388\"}.di-pinterest::before,.di-E389::before{content:\"\\e389\"}.di-google-plus::before,.di-E38A::before{content:\"\\e38a\"}.di-disney-cast::before,.di-E38B::before{content:\"\\e38b\"}.di-disney-response::before,.di-E38C::before{content:\"\\e38c\"}.di-thrill-seekers::before,.di-E38E::before{content:\"\\e38e\"}.di-doll::before,.di-E390::before{content:\"\\e390\"}.di-front-desk::before,.di-E391::before{content:\"\\e391\"}.di-movies::before,.di-E392::before{content:\"\\e392\"}.di-unlocked::before,.di-E393::before{content:\"\\e393\"}.di-tumblr::before,.di-E394::before{content:\"\\e394\"}.di-services::before,.di-E395::before{content:\"\\e395\"}.di-old-photopass-plus::before,.di-E396::before{content:\"\\e396\"}.di-hkdl-sina-weibo-social::before,.di-E397::before{content:\"\\e397\"}.di-hkdl-baidu-tieba-social::before,.di-E398::before{content:\"\\e398\"}.di-hkdl-webchat-social::before,.di-E399::before{content:\"\\e399\"}.di-disney-wild-about-safety::before,.di-E39A::before{content:\"\\e39a\"}.di-romantic-celebration::before,.di-E39B::before{content:\"\\e39b\"}.di-facebook-icon-alone::before,.di-E39C::before{content:\"\\e39c\"}.di-twitter-icon-alone::before,.di-E39D::before{content:\"\\e39d\"}.di-snapchat::before,.di-E39E::before{content:\"\\e39e\"}.di-photopass-attraction-id::before,.di-E39F::before{content:\"\\e39f\"}.di-achievement::before,.di-E3A0::before{content:\"\\e3a0\"}.di-apple-music::before,.di-E3A1::before{content:\"\\e3a1\"}.di-apple-music-alternate::before,.di-E3A2::before{content:\"\\e3a2\"}.di-watches-time::before,.di-E3A3::before{content:\"\\e3a3\"}.di-magic-coming-soon::before,.di-E3A4::before{content:\"\\e3a4\"}.di-winter::before,.di-E3E4::before{content:\"\\e3e4\"}.di-spring::before,.di-E3E5::before{content:\"\\e3e5\"}.di-summer::before,.di-E3E6::before{content:\"\\e3e6\"}.di-autumn::before,.di-E3E7::before{content:\"\\e3e7\"}.di-pack-for-weather::before,.di-E3E8::before{content:\"\\e3e8\"}.di-single-rider::before,.di-E440::before{content:\"\\e440\"}.di-atm-china::before,.di-E441::before{content:\"\\e441\"}.di-wayfinding-slight-left::before,.di-E442::before{content:\"\\e442\"}.di-wayfinding-slight-right::before,.di-E443::before{content:\"\\e443\"}.di-wayfinding-turn-left::before,.di-E444::before{content:\"\\e444\"}.di-wayfinding-turn-right::before,.di-E445::before{content:\"\\e445\"}.di-wayfinding-hard-left::before,.di-E446::before{content:\"\\e446\"}.di-wayfinding-hard-right::before,.di-E447::before{content:\"\\e447\"}.di-wayfinding-left::before,.di-E448::before{content:\"\\e448\"}.di-wayfinding-right::before,.di-E449::before{content:\"\\e449\"}.di-wayfinding-forward::before,.di-E44A::before{content:\"\\e44a\"}.di-wayfinding-back::before,.di-E44B::before{content:\"\\e44b\"}.di-wayfinding-forward-back::before,.di-E44C::before{content:\"\\e44c\"}.di-wayfinding-right-left::before,.di-E44D::before{content:\"\\e44d\"}.di-wayfinding-around-slight-left::before,.di-E44E::before{content:\"\\e44e\"}.di-wayfinding-around-slight-right::before,.di-E44F::before{content:\"\\e44f\"}.di-wayfinding-around-turn-left::before,.di-E450::before{content:\"\\e450\"}.di-wayfinding-around-turn-right::before,.di-E451::before{content:\"\\e451\"}.di-wayfinding-around-hard-left::before,.di-E452::before{content:\"\\e452\"}.di-wayfinding-around-hard-right::before,.di-E453::before{content:\"\\e453\"}.di-wayfinding-around-left::before,.di-E454::before{content:\"\\e454\"}.di-wayfinding-around-right::before,.di-E455::before{content:\"\\e455\"}.di-wayfinding-around-forward-left::before,.di-E456::before{content:\"\\e456\"}.di-wayfinding-around-forward-right::before,.di-E457::before{content:\"\\e457\"}.di-wayfinding-u-turn-right::before,.di-E458::before{content:\"\\e458\"}.di-wayfinding-u-turn-left::before,.di-E459::before{content:\"\\e459\"}.di-wayfinding-ramp-left::before,.di-E45A::before{content:\"\\e45a\"}.di-wayfinding-ramp-right::before,.di-E45B::before{content:\"\\e45b\"}.di-wayfinding-fork-left::before,.di-E45C::before{content:\"\\e45c\"}.di-wayfinding-fork-right::before,.di-E45D::before{content:\"\\e45d\"}.di-wayfinding-around-about-left::before,.di-E45E::before{content:\"\\e45e\"}.di-wayfinding-around-about-right::before,.di-E45F::before{content:\"\\e45f\"}.di-wayfinding-merge::before,.di-E460::before{content:\"\\e460\"}.di-cribs-and-playpens::before,.di-E461::before{content:\"\\e461\"}.di-baby-care-center2::before,.di-E462::before{content:\"\\e462\"}.di-epi-pen::before,.di-E463::before{content:\"\\e463\"}.di-mobile-charging-station::before,.di-E464::before{content:\"\\e464\"}.di-security-info::before,.di-E465::before{content:\"\\e465\"}.di-refrigerator-available::before,.di-E466::before{content:\"\\e466\"}.di-repellant-zika::before,.di-E467::before{content:\"\\e467\"}.di-hurricane-information::before,.di-E468::before{content:\"\\e468\"}.di-recenter-map::before,.di-E46A::before{content:\"\\e46a\"}.di-location-pin::before,.di-E46C::before{content:\"\\e46c\"}.di-transportation-parking-info::before,.di-E46D::before{content:\"\\e46d\"}.di-resort-automatic-check-out::before,.di-E46E::before{content:\"\\e46e\"}.di-service-your-way::before,.di-E46F::before{content:\"\\e46f\"}.di-direct-to-room::before,.di-E470::before{content:\"\\e470\"}.di-premium-service-shdr::before,.di-E471::before{content:\"\\e471\"}.di-virtual-queue::before,.di-E472::before{content:\"\\e472\"}.di-energy-monster::before,.di-E473::before{content:\"\\e473\"}.di-elevators::before,.di-E475::before{content:\"\\e475\"}.di-salon::before,.di-E476::before{content:\"\\e476\"}.di-clothing::before,.di-E480::before{content:\"\\e480\"}.di-accessories::before,.di-E481::before{content:\"\\e481\"}.di-home-office::before,.di-E482::before{content:\"\\e482\"}.di-toys-games::before,.di-E483::before{content:\"\\e483\"}.di-art-collectibles::before,.di-E484::before{content:\"\\e484\"}.di-entertainment::before,.di-E485::before{content:\"\\e485\"}.di-health-beauty::before,.di-E486::before{content:\"\\e486\"}.di-sweets::before,.di-E487::before{content:\"\\e487\"}.di-play-logo::before,.di-E4C0::before{content:\"\\e4c0\"}.di-rocket-race-game::before,.di-E4C1::before{content:\"\\e4c1\"}.di-peter-pan-s-flight-game::before,.di-E4C2::before{content:\"\\e4c2\"}.di-toy-story-mania-game::before,.di-E4C3::before{content:\"\\e4c3\"}.di-trivia-games::before,.di-E4C4::before{content:\"\\e4c4\"}.di-esmeralda-quest::before,.di-E4C5::before{content:\"\\e4c5\"}.di-fortune-red-quest::before,.di-E4C6::before{content:\"\\e4c6\"}.di-temple-of-mara-decoder::before,.di-E4C7::before{content:\"\\e4c7\"}.di-conservation-fund-quest::before,.di-E4C8::before{content:\"\\e4c8\"}.di-soarin-challenge::before,.di-E4C9::before{content:\"\\e4c9\"}.di-agent-p-challenge::before,.di-E4CA::before{content:\"\\e4ca\"}.di-fun-wheel-challenge::before,.di-E4CB::before{content:\"\\e4cb\"}.di-andy-s-game-board-blast::before,.di-E4CC::before{content:\"\\e4cc\"}.di-art-of-animation::before,.di-E4CD::before{content:\"\\e4cd\"}.di-flight-of-passage::before,.di-E4CE::before{content:\"\\e4ce\"}.di-dlr-magic-mural::before,.di-E4CF::before{content:\"\\e4cf\"}.di-splash-mountain::before,.di-E4D0::before{content:\"\\e4d0\"}.di-kidcot-challenge::before,.di-E4D1::before{content:\"\\e4d1\"}.di-swge-millenium-falcon::before,.di-E4D2::before{content:\"\\e4d2\"}.di-swge-star-destroyer::before,.di-E4D3::before{content:\"\\e4d3\"}.di-swge-bso-logo::before,.di-E4D4::before{content:\"\\e4d4\"}.di-add-stepper::before,.di-E500::before{content:\"\\e500\"}.di-reduce-stepper::before,.di-E501::before{content:\"\\e501\"}.di-hide-collapse::before,.di-E502::before{content:\"\\e502\"}.di-mute-volume::before,.di-E503::before{content:\"\\e503\"}.di-unmute-volume::before,.di-E504::before{content:\"\\e504\"}.di-filter-items::before,.di-E505::before{content:\"\\e505\"}.di-forward-thin::before,.di-E506::before{content:\"\\e506\"}.di-back-thin::before,.di-E507::before{content:\"\\e507\"}.di-fast-fwd-thin::before,.di-E508::before{content:\"\\e508\"}.di-rewind-thin::before,.di-E509::before{content:\"\\e509\"}.di-download-thin::before,.di-E50A::before{content:\"\\e50a\"}.di-facial-opt-in-off::before,.di-E50B::before{content:\"\\e50b\"}.di-facial-opt-in-on::before,.di-E50C::before{content:\"\\e50c\"}.di-bluetooth::before,.di-E518::before{content:\"\\e518\"}.di-norgie-closed::before,.di-E534::before{content:\"\\e534\"}.di-fastpass-order-shopping-bag-plus::before,.di-E540::before{content:\"\\e540\"}.di-fastpass-order-shopping-bag::before,.di-E542::before{content:\"\\e542\"}.di-shdr-ticket-annualpass::before,.di-E544::before{content:\"\\e544\"}.di-tickets-outlined::before,.di-E54B::before{content:\"\\e54b\"}.di-early-entry-pass::before,.di-E54C::before{content:\"\\e54c\"}.di-disney-card-member::before,.di-E54D::before{content:\"\\e54d\"}.di-club-33-dlr-member::before,.di-E54E::before{content:\"\\e54e\"}.di-shdr-ap-activation::before,.di-E54F::before{content:\"\\e54f\"}.di-disney-maxpass-alternate::before,.di-E550::before{content:\"\\e550\"}.di-ap-activation::before,.di-E552::before{content:\"\\e552\"}.di-standby-pass::before,.di-E553::before{content:\"\\e553\"}.di-early-park-entry-pass::before,.di-E554::before{content:\"\\e554\"}.di-mobile-checkout::before,.di-E555::before{content:\"\\e555\"}.di-disney-premier-access-global::before,.di-E556::before{content:\"\\e556\"}.di-disney-premier-access-secondary::before,.di-E557::before{content:\"\\e557\"}.di-disney-premier-access-new::before,.di-E558::before{content:\"\\e558\"}.di-golden-oak-resident::before,.di-E559::before{content:\"\\e559\"}.di-disability-access-service::before,.di-E55A::before{content:\"\\e55a\"}.di-lightning-lane::before,.di-E55B::before{content:\"\\e55b\"}.di-disney-plus::before,.di-E55C::before{content:\"\\e55c\"}.di-enchant-key::before,.di-E55D::before{content:\"\\e55d\"}.di-dream-key::before,.di-E55E::before{content:\"\\e55e\"}.di-imagine-key::before,.di-E55F::before{content:\"\\e55f\"}.di-believe-key::before,.di-E560::before{content:\"\\e560\"}.di-unused-character::before,.di-F8FE::before{content:\"\\f8fe\"}:host{--primary:var(--primary-theme);--primary-dark:var(--primary-dark-theme);--primary-background:var(--primary-background-theme);--primary-other:var(--primary-other-theme);--primary-disabled:var(--primary-disabled-theme);--primary-message:var(--primary-message-theme);--primary-alert:var(--primary-alert-theme);--primary-gradient-from:var(--primary-gradient-from-theme);--primary-gradient-to:var(--primary-gradient-to-theme);--secondary-focus:var(--secondary-focus-theme);--secondary-hover:var(--secondary-hover-theme);--secondary-disabled:var(--secondary-disabled-theme);--secondary-background:var(--secondary-background-theme);--secondary-other-dark:var(--secondary-other-dark-theme);--secondary-other-hover:var(--secondary-other-hover-theme);--secondary-other-disabled:var(--secondary-other-disabled-theme);--secondary-other-good-to-go:var(--secondary-other-good-to-go-theme);--secondary-message:var(--secondary-message-theme);--secondary-message-detail:var(--secondary-message-detail-theme);--secondary-message-chrome:var(--secondary-message-chrome-theme);--secondary-gradient-from:var(--secondary-gradient-from-theme);--secondary-gradient-to:var(--secondary-gradient-to-theme);--secondary-inactive:var(--secondary-inactive-theme);--reversed-hover:var(--reversed-hover-theme);--link:var(--link-theme);--outline-color:var(--outline-color-theme);--outline-style:var(--outline-style-theme);--outline-width:var(--outline-width-theme)}.primary{color:var(--primary)}.primary:hover{color:var(--secondary-hover)}.primary[disabled]{color:var(--secondary-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.primary-dark{color:var(--primary-dark)}.primary-other{color:var(--primary-other)}.primary-message{color:var(--primary-message)}.primary-alert{color:var(--primary-alert)}.background-primary-background{background-color:var(--primary-background)}.background-primary{background-color:var(--primary)}.background-primary-dark{background-color:var(--primary-dark)}.background-primary-other{background-color:var(--primary-other)}.background-primary-message{background-color:var(--primary-message)}.background-primary-alert{background-color:var(--primary-alert)}.background-primary-gradient{background:linear-gradient(45deg, var(--primary-gradient-from), var(--primary-gradient-to))}.secondary-other-dark{color:var(--secondary-other-dark)}.secondary-other-dark:hover{color:var(--secondary-other-hover)}.secondary-other-dark[disabled]{color:var(--secondary-other-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.secondary-other-good-to-go{color:var(--secondary-other-good-to-go)}.secondary-message{color:var(--secondary-message)}.secondary-message-detail{color:var(--secondary-message-detail)}.secondary-message-chrome{color:var(--secondary-message-chrome)}.background-secondary{background-color:var(--secondary-background)}.background-secondary-focus{background-color:var(--secondary-focus)}.background-secondary-hover{background-color:var(--secondary-hover)}.background-secondary-disabled{background-color:var(--secondary-disabled)}.background-secondary-other-hover{background-color:var(--secondary-other-hover)}.background-secondary-other-disabled{background-color:var(--secondary-other-disabled)}.background-secondary-other-dark{background-color:var(--secondary-other-dark)}.background-secondary-other-good-to-go{background-color:var(--secondary-other-good-to-go)}.background-secondary-message{background-color:var(--secondary-message)}.background-secondary-inactive{background-color:var(--secondary-inactive)}.background-secondary-message-detail{background-color:var(--secondary-message-detail)}.background-secondary-message-chrome{background-color:var(--secondary-message-chrome)}.background-secondary-gradient{background:linear-gradient(45deg, var(--secondary-gradient-from), var(--secondary-gradient-to))}a,.link{color:var(--link);text-decoration:none}a:link,a:visited,a:hover,a:active,.link:link,.link:visited,.link:hover,.link:active{color:var(--link)}a:hover,a:focus,.link:hover,.link:focus{text-decoration:underline}.link{color:var(--link);cursor:pointer}a:focus,.link:focus,button:focus{outline-color:var(--outline-color);outline-style:var(--outline-style);outline-width:var(--outline-width)}:host{display:inline-block;cursor:default;position:relative}:host([alignment=top]) #wrapper{align-items:flex-start}:host([alignment=center]) #wrapper{align-items:center}:host([alignment=bottom]) #wrapper{align-items:flex-end}:host([disabled]){cursor:default;pointer-events:none}:host([disabled]) .checkbox-label{color:var(--checkbox-label-disabled-color, var(--secondary-message))}:host([error]) .checkbox-label{color:var(--checkbox-label-error-color, var(--primary-alert)) !important}:host(:focus),:host(:focus-within){border-color:var(--checkbox-focus-outline);outline-style:var(--outline-style-theme, solid);outline-width:var(--outline-width-theme, 2px);outline-offset:4px}.checkbox-label{flex-grow:1;color:var(--checkbox-label-color, var(--primary-dark))}#wrapper{display:flex;align-items:center;cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}#wrapper #checkboxIcon{font-size:var(--checkbox-icon-font-size, 14px);position:relative;left:var(--checkbox-icon-left);top:var(--checkbox-icon-top)}#wrapper input{margin:var(--checkbox-icon-margin, 0px 10px 0px 0px);min-width:20px;width:20px;min-height:20px;height:20px;background:transparent;color:transparent;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;border:none;border-radius:var(--checkbox-border-radius, 2px)}#wrapper input~#checkmark{width:var(--checkbox-width, 18px);height:var(--checkbox-height, 18px);border:var(--checkbox-border, solid 1px);border-radius:var(--checkbox-border-radius, 2px);line-height:var(--checkbox-icon-line-height, 20px);border-color:var(--checkbox-unchecked-border-color);background-color:var(--checkbox-unchecked-background-color);margin:0;position:absolute}#wrapper input:focus{outline:var(--checkbox-focus-outline, auto)}#wrapper input:checked{background:transparent}#wrapper input:checked~#checkmark{border-color:var(--checkbox-checked-border-color);background-color:var(--checkbox-checked-background-color)}#wrapper input:checked~#checkmark #checkboxIcon{color:var(--checkbox-icon-color, white)}#wrapper input:disabled:not(:checked)~#checkmark{border-color:var(--checkbox-unchecked-disabled-border-color);background-color:var(--checkbox-unchecked-disabled-background-color)}#wrapper input:checked:disabled~#checkmark{border-color:var(--checkbox-checked-disabled-border-color);background-color:var(--checkbox-checked-disabled-background-color)}#wrapper input:checked:disabled~#checkmark #checkboxIcon{color:var(--checkbox-icon-disabled-color, white)}#wrapper input[error]~#checkmark{border-color:var(--checkbox-unchecked-error-border-color);background-color:var(--checkbox-unchecked-error-background-color)}#wrapper input[error]:checked~#checkmark{border-color:var(--checkbox-checked-error-border-color);background-color:var(--checkbox-checked-error-background-color)}#wrapper input[error]:checked~#checkmark #checkboxIcon{color:var(--checkbox-icon-error-color, white)}#wrapper input~#checkboxImage{margin:var(--checkbox-icon-margin, 0px 10px 0px 0px)}@media (hover: hover){#wrapper input:hover~#checkmark{border-color:var(--checkbox-unchecked-hover-border-color);background-color:var(--checkbox-unchecked-hover-background-color)}#wrapper input:checked:hover~#checkmark{border-color:var(--checkbox-checked-hover-border-color);background-color:var(--checkbox-checked-hover-background-color)}#wrapper input:checked:hover~#checkmark #checkboxIcon{color:var(--checkbox-icon-hover-color, white)}#wrapper input:disabled:hover:not(:checked)~#checkmark{border-color:var(--checkbox-unchecked-hover-disabled-border-color);background-color:var(--checkbox-unchecked-hover-disabled-background-color)}#wrapper input:checked:disabled:hover~#checkmark{border-color:var(--checkbox-checked-hover-disabled-border-color);background-color:var(--checkbox-checked-hover-disabled-background-color)}#wrapper input:checked:disabled:hover~#checkmark #checkboxIcon{color:var(--checkbox-icon-hover-disabled-color, white)}#wrapper input[error]:hover~#checkmark{border-color:var(--checkbox-unchecked-hover-error-border-color);background-color:var(--checkbox-unchecked-hover-error-background-color)}#wrapper input[error]:checked:hover~#checkmark{border-color:var(--checkbox-checked-hover-error-border-color);background-color:var(--checkbox-checked-hover-error-background-color)}#wrapper input[error]:checked:hover~#checkmark #checkboxIcon{color:var(--checkbox-icon-hover-error-color, white)}}.custom-error-aria-label-msg{color:var(--checkbox-label-error-color, var(--primary-alert)) !important;display:inline-block;top:5px;position:relative}";

const WdprCheckbox$1 = /*@__PURE__*/ proxyCustomElement(class WdprCheckbox extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dispatcher = createEvent(this, "checked-changed", 3);
        /**
         *  Handle mouse-navigation attribute.
         */
        this._labelTapped = (event) => {
            event.preventDefault();
            this.checked = !this.checked;
        };
        /**
         *  Bind changes in checkbox to checked prop
         */
        this.handleChange = (event) => {
            this.checked = event.target.checked;
        };
        this.alignment = 'center';
        this.checked = false;
        this.error = false;
        this.disabled = false;
        this.inputId = undefined;
        this.customTabindex = undefined;
        this.imagePath = '';
        this.imageExtension = 'svg';
        this.fontClass = '';
        this.displayedImage = undefined;
        this.customAriaLabel = '';
        this.customErrorAriaLabel = '';
        this.customAriaExpanded = true;
        this.customAriaInvalid = false;
        this.customAriaReadOnly = false;
        this.customAriaRequired = true;
        this.customAriaControls = '';
    }
    /**
     * Watcher upon toggle
     */
    watchHandler() {
        this._onChecked();
    }
    /**
     *  Generate a random ID for a11y. Added this method to fix linting errors
     * @return {String}
     */
    _generateRandId() {
        const length = 6;
        const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let result = '';
        for (let i = length; i > 0; --i) {
            result += chars[Math.floor(Math.random() * chars.length)];
        }
        return result;
    }
    /**
     *  Set internal values to toggle the component
     */
    _onChecked() {
        this.fontClass = this.checked ? 'di di-checkmark' : '';
        this.dispatcher.emit({ value: this.checked });
    }
    /**
     *  Determine the tabindex based on the disabled state of the checkbox
     * @param disabled the "disable" property of the component
     * @param customTabindex custom tabindex to be used instead of disabled
     * @return customTabindex if exists, otherwise 0 if the checkbox is enabled, -1 if it's disabled.
     */
    _computeTabIndex(disabled, customTabindex) {
        if (customTabindex) {
            return customTabindex;
        }
        else {
            return disabled ? -1 : 0;
        }
    }
    /**
     *  Set image for the checkbox
     * @param {String} imagePath
     * @param {String} imageExtension
     * @param {Boolean} checked
     * @param {Boolean} isDisabled
     * @param {Boolean} error
     * @return {String}
     */
    _computedImageName(imagePath, imageExtension, checked, disabled, error) {
        if (!imagePath) {
            return;
        }
        let className = this._computeElementState(checked, disabled, error);
        if (className != '') {
            className = className.substring(1, className.length).replace(/\s+/g, '-');
        }
        if (!checked) {
            return className != ''
                ? `${imagePath}kng-unchecked-${className}.${imageExtension}`
                : `${imagePath}kng-unchecked.${imageExtension}`;
        }
        else {
            return `${imagePath}kng-${className}.${imageExtension}`;
        }
    }
    /**
     *  Set class for the element state or behavior
     * @param {Boolean} checked
     * @param {Boolean} disabled
     * @param {Boolean} error
     * @return {String} className
     */
    _computeElementState(checked, disabled, error) {
        let className = '';
        if (checked) {
            className += ' checked';
        }
        if (disabled) {
            className += ' disabled';
        }
        if (error) {
            className += ' error';
        }
        return className;
    }
    /**
     *  Get id for aria-label
     * @param {String} customAriaLabel
     * @param {String} inputId
     * @return {String} aria-label id
     */
    getAriaLabel(customAriaLabel, inputId) {
        return `${customAriaLabel ? 'custom-aria-label-' : 'default-aria-label-'}${inputId}`;
    }
    /**
     * Get error for aria-label when it is available
     * @param {Boolean} error
     * @param {String} customErrorAriaLabel
     */
    computeCustomErrorAriaLabel(error, customErrorAriaLabel) {
        return (error && customErrorAriaLabel.trim() !== '') ? customErrorAriaLabel : '';
    }
    /**
     *  Add mouse-navigation attribute on mousedown
     */
    _setMouseDownGesture() {
        this.el.setAttribute('mouse-navigation', '');
    }
    /**
       *  Handle space to toggle the checked state of the input.
       */
    _setKeydownGesture(e) {
        if (e.keyCode === 32) {
            e.preventDefault();
            if (this.disabled) {
                return;
            }
            this.checked = !this.checked;
        }
        else {
            this.el.removeAttribute('mouse-navigation');
        }
    }
    componentWillLoad() {
        this.inputId = this._generateRandId();
        this.customTabindex = this._computeTabIndex(this.disabled, this.customTabindex);
        this.displayedImage = this._computedImageName(this.imagePath, this.imageExtension, this.checked, this.disabled, this.error);
        this.fontClass = this.checked ? 'di di-checkmark' : '';
    }
    componentDidLoad() {
        if (this.error)
            this.el.shadowRoot.querySelector('input').setAttribute('error', '');
    }
    render() {
        return h(Host, null, h("label", { id: "wrapper", htmlfor: this.inputId, "on-click": this._labelTapped }, h("input", { type: "checkbox", id: this.inputId, disabled: this.disabled, checked: this.checked, onChange: this.handleChange, "aria-labelledby": this.getAriaLabel(this.customAriaLabel, this.inputId), "aria-describedby": "custom-error-aria-label-" + this.inputId, "aria-expanded": this.customAriaExpanded, "aria-invalid": this.customAriaInvalid, "aria-readonly": this.customAriaReadOnly, "aria-required": this.customAriaRequired, "aria-controls": this.customAriaControls, tabindex: this.customTabindex }), this.imagePath == ''
            ? h("span", { id: "checkmark", "aria-hidden": "true" }, h("i", { id: "checkboxIcon", class: this.fontClass }))
            : h("img", { id: "checkboxImage", src: this.displayedImage, alt: this.displayedImage, "aria-hidden": "true" }), h("div", { id: "default-aria-label-" + this.inputId, class: "checkbox-label", "aria-hidden": "true" }, h("slot", null)), h("span", { id: "custom-aria-label-" + this.inputId, hidden: true }, this.customAriaLabel)), this.error && this.customErrorAriaLabel.trim() !== ''
            ? h(Fragment, null, h("span", { class: "custom-error-aria-label-msg", id: "custom-error-aria-label-" + this.inputId }, h("i", { id: "invalid-icon", class: "di di-alert", role: "img" }), this.computeCustomErrorAriaLabel(this.error, this.customErrorAriaLabel)))
            : '');
    }
    get el() { return this; }
    static get watchers() { return {
        "checked": ["watchHandler"]
    }; }
    static get style() { return wdprCheckboxCss; }
}, [1, "wdpr-checkbox", {
        "alignment": [513],
        "checked": [1540],
        "error": [4],
        "disabled": [4],
        "inputId": [1025, "input-id"],
        "customTabindex": [1026, "custom-tabindex"],
        "imagePath": [1, "image-path"],
        "imageExtension": [1, "image-extension"],
        "fontClass": [1025, "font-class"],
        "displayedImage": [1025, "displayed-image"],
        "customAriaLabel": [1, "custom-aria-label"],
        "customErrorAriaLabel": [1, "custom-error-aria-label"],
        "customAriaExpanded": [4, "custom-aria-expanded"],
        "customAriaInvalid": [8, "custom-aria-invalid"],
        "customAriaReadOnly": [4, "custom-aria-read-only"],
        "customAriaRequired": [4, "custom-aria-required"],
        "customAriaControls": [1, "custom-aria-controls"]
    }, [[0, "mousedown", "_setMouseDownGesture"], [0, "keyup", "_setKeydownGesture"]], {
        "checked": ["watchHandler"]
    }]);
function defineCustomElement$1$3() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wdpr-checkbox"];
    components.forEach(tagName => { switch (tagName) {
        case "wdpr-checkbox":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WdprCheckbox$1);
            }
            break;
    } });
}
defineCustomElement$1$3();

const wdprButtonCss = ":host{--font-family-base:var(--font-family-base-theme, InspireTWDC);--font-family-light:var(--font-family-light-theme, InspireTWDCLight);--font-family-heavy:var(--font-family-heavy-theme, InspireTWDCHeavy);--font-family-black:var(--font-family-black-theme, InspireTWDCBlack);--font-family-medium:var(--font-family-medium-theme, InspireTWDCMedium);--font-family-roman:var(--font-family-roman-theme, InspireTWDCRoman);--font-family-book:var(--font-family-book-theme, InspireTWDCBook);--font-weight-light:var(--font-weight-light-theme, 200);--font-weight-heavy:var(--font-weight-heavy-theme, 700);--font-weight-black:var(--font-weight-black-theme, 900);--font-weight-medium:var(--font-weight-medium-theme, 500);--font-weight-roman:var(--font-weight-roman-theme, 400);--font-weight-book:var(--font-weight-book-theme, 400);--font50-line-height:var(--font50-line-height-theme, 60px);--font40-line-height:var(--font40-line-height-theme, 50px);--font36-line-height:var(--font36-line-height-theme, 48px);--font28-line-height:var(--font28-line-height-theme, 36px);--font24-line-height:var(--font24-line-height-theme, 32px);--font20-line-height:var(--font20-line-height-theme, 28px);--font18-line-height:var(--font18-line-height-theme, 26px);--font16-line-height:var(--font16-line-height-theme, 24px);--font14-line-height:var(--font14-line-height-theme, 20px);--font12-line-height:var(--font12-line-height-theme, 20px)}:host{--font-base:{\n    font-family: var(--font-family-base)}; --font-light:{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}; --font-heavy:{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}; --font-black:{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}; --font-medium:{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}; --font-roman:{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}; --font-book:{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}; --font50:{font-size:50px;line-height:var(--font50-line-height)}; --font40:{font-size:40px;line-height:var(--font40-line-height)}; --font36:{font-size:36px;line-height:var(--font36-line-height)}; --font28:{font-size:28px;line-height:var(--font28-line-height)}; --font24:{font-size:24px;line-height:var(--font24-line-height)}; --font20:{font-size:20px;line-height:var(--font20-line-height)}; --font18:{font-size:18px;line-height:var(--font18-line-height)}; --font16:{font-size:16px;line-height:var(--font16-line-height)}; --font14:{font-size:14px;line-height:var(--font14-line-height)}; --font12:{font-size:12px;line-height:var(--font12-line-height)}; } .font-base{font-family:var(--font-family-base)}.light{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}.heavy{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}.black{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}.medium{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}.roman{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}.book{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.font50{font-size:50px;line-height:var(--font50-line-height)}.font40{font-size:40px;line-height:var(--font40-line-height)}.font36{font-size:36px;line-height:var(--font36-line-height)}.font28{font-size:28px;line-height:var(--font28-line-height)}.font24{font-size:24px;line-height:var(--font24-line-height)}.font20{font-size:20px;line-height:var(--font20-line-height)}.font18{font-size:18px;line-height:var(--font18-line-height)}.font16{font-size:16px;line-height:var(--font16-line-height)}.font14{font-size:14px;line-height:var(--font14-line-height)}.font12{font-size:12px;line-height:var(--font12-line-height)}.font-lg-1{font-size:50px;line-height:var(--font50-line-height)}.font-lg-2{font-size:40px;line-height:var(--font40-line-height)}.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}@media only screen and (min-width: 481px) and (max-width: 1179.98px){.font-lg-1,.font-lg-2,.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}@media only screen and (max-width: 480.98px){.font-lg-1,.font-lg-2,.font-md-1,.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}:host{font-family:var(--font-family-base)}:host{--primary:var(--primary-theme);--primary-dark:var(--primary-dark-theme);--primary-background:var(--primary-background-theme);--primary-other:var(--primary-other-theme);--primary-disabled:var(--primary-disabled-theme);--primary-message:var(--primary-message-theme);--primary-alert:var(--primary-alert-theme);--primary-gradient-from:var(--primary-gradient-from-theme);--primary-gradient-to:var(--primary-gradient-to-theme);--secondary-focus:var(--secondary-focus-theme);--secondary-hover:var(--secondary-hover-theme);--secondary-disabled:var(--secondary-disabled-theme);--secondary-background:var(--secondary-background-theme);--secondary-other-dark:var(--secondary-other-dark-theme);--secondary-other-hover:var(--secondary-other-hover-theme);--secondary-other-disabled:var(--secondary-other-disabled-theme);--secondary-other-good-to-go:var(--secondary-other-good-to-go-theme);--secondary-message:var(--secondary-message-theme);--secondary-message-detail:var(--secondary-message-detail-theme);--secondary-message-chrome:var(--secondary-message-chrome-theme);--secondary-gradient-from:var(--secondary-gradient-from-theme);--secondary-gradient-to:var(--secondary-gradient-to-theme);--secondary-inactive:var(--secondary-inactive-theme);--reversed-hover:var(--reversed-hover-theme);--link:var(--link-theme);--outline-color:var(--outline-color-theme);--outline-style:var(--outline-style-theme);--outline-width:var(--outline-width-theme)}.primary{color:var(--primary)}.primary:hover{color:var(--secondary-hover)}.primary[disabled]{color:var(--secondary-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.primary-dark{color:var(--primary-dark)}.primary-other{color:var(--primary-other)}.primary-message{color:var(--primary-message)}.primary-alert{color:var(--primary-alert)}.background-primary-background{background-color:var(--primary-background)}.background-primary{background-color:var(--primary)}.background-primary-dark{background-color:var(--primary-dark)}.background-primary-other{background-color:var(--primary-other)}.background-primary-message{background-color:var(--primary-message)}.background-primary-alert{background-color:var(--primary-alert)}.background-primary-gradient{background:linear-gradient(45deg, var(--primary-gradient-from), var(--primary-gradient-to))}.secondary-other-dark{color:var(--secondary-other-dark)}.secondary-other-dark:hover{color:var(--secondary-other-hover)}.secondary-other-dark[disabled]{color:var(--secondary-other-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.secondary-other-good-to-go{color:var(--secondary-other-good-to-go)}.secondary-message{color:var(--secondary-message)}.secondary-message-detail{color:var(--secondary-message-detail)}.secondary-message-chrome{color:var(--secondary-message-chrome)}.background-secondary{background-color:var(--secondary-background)}.background-secondary-focus{background-color:var(--secondary-focus)}.background-secondary-hover{background-color:var(--secondary-hover)}.background-secondary-disabled{background-color:var(--secondary-disabled)}.background-secondary-other-hover{background-color:var(--secondary-other-hover)}.background-secondary-other-disabled{background-color:var(--secondary-other-disabled)}.background-secondary-other-dark{background-color:var(--secondary-other-dark)}.background-secondary-other-good-to-go{background-color:var(--secondary-other-good-to-go)}.background-secondary-message{background-color:var(--secondary-message)}.background-secondary-inactive{background-color:var(--secondary-inactive)}.background-secondary-message-detail{background-color:var(--secondary-message-detail)}.background-secondary-message-chrome{background-color:var(--secondary-message-chrome)}.background-secondary-gradient{background:linear-gradient(45deg, var(--secondary-gradient-from), var(--secondary-gradient-to))}a,.link{color:var(--link);text-decoration:none}a:link,a:visited,a:hover,a:active,.link:link,.link:visited,.link:hover,.link:active{color:var(--link)}a:hover,a:focus,.link:hover,.link:focus{text-decoration:underline}.link{color:var(--link);cursor:pointer}a:focus,.link:focus,button:focus{outline-color:var(--outline-color);outline-style:var(--outline-style);outline-width:var(--outline-width)}:host{display:inline-block}:host([theme]){letter-spacing:0em;--padding-start:0px;--padding-end:0px;box-sizing:border-box;border:none;white-space:nowrap;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;display:inline-flex;align-items:center;justify-content:center;font-family:var(--button-font-family);line-height:var(--button-line-height);transition:var(--button-transition);-webkit-transition:var(--button-webkit-transition)}:host(:not([disabled])){cursor:pointer}:host([disabled]){pointer-events:none;cursor:not-allowed;outline:none}:host([size=large]){height:var(--button-large-size-height);padding:var(--button-large-size-padding)}@media only screen and (max-width: 480.98px){:host([size=large]){min-width:var(--button-mobile-size-min-width);max-width:var(--button-mobile-size-max-width);font-size:var(--button-mobile-font-size)}}@media only screen and (min-width: 481px) and (max-width: 1179.98px){:host([size=large]){min-width:var(--button-large-size-min-width);max-width:var(--button-large-size-max-width);font-size:var(--button-large-font-size)}}@media only screen and (min-width: 1180px){:host([size=large]){min-width:var(--button-large-size-min-width);max-width:var(--button-large-size-max-width);font-size:var(--button-large-font-size)}}:host([size=standard]){height:var(--button-standard-size-height);padding:var(--button-standard-size-padding)}@media only screen and (max-width: 480.98px){:host([size=standard]){min-width:var(--button-mobile-size-min-width);max-width:var(--button-mobile-size-max-width);font-size:var(--button-mobile-font-size)}}@media only screen and (min-width: 481px) and (max-width: 1179.98px){:host([size=standard]){min-width:var(--button-standard-size-min-width);max-width:var(--button-standard-size-max-width);font-size:var(--button-standard-font-size)}}@media only screen and (min-width: 1180px){:host([size=standard]){min-width:var(--button-standard-size-min-width);max-width:var(--button-standard-size-max-width);font-size:var(--button-standard-font-size)}}:host([size=medium]){height:var(--button-standard-size-height);padding:var(--button-standard-size-padding)}@media only screen and (max-width: 480.98px){:host([size=medium]){min-width:var(--button-mobile-size-min-width);max-width:var(--button-mobile-size-max-width);font-size:var(--button-mobile-font-size)}}@media only screen and (min-width: 481px) and (max-width: 1179.98px){:host([size=medium]){min-width:var(--button-standard-size-min-width);max-width:var(--button-standard-size-max-width);font-size:var(--button-standard-font-size)}}@media only screen and (min-width: 1180px){:host([size=medium]){min-width:var(--button-standard-size-min-width);max-width:var(--button-standard-size-max-width);font-size:var(--button-standard-font-size)}}:host([size=mini]){height:var(--button-mini-size-height);padding:var(--button-mini-size-padding)}@media only screen and (max-width: 480.98px){:host([size=mini]){min-width:var(--button-mobile-size-min-width);max-width:var(--button-mobile-size-max-width);font-size:var(--button-mobile-font-size)}}@media only screen and (min-width: 481px) and (max-width: 1179.98px){:host([size=mini]){min-width:var(--button-mini-size-min-width);max-width:var(--button-mini-size-max-width);font-size:var(--button-mini-font-size)}}@media only screen and (min-width: 1180px){:host([size=mini]){min-width:var(--button-mini-size-min-width);max-width:var(--button-mini-size-max-width);font-size:var(--button-mini-font-size)}}:host([size=small]){height:var(--button-mini-size-height);padding:var(--button-mini-size-padding)}@media only screen and (max-width: 480.98px){:host([size=small]){min-width:var(--button-mobile-size-min-width);max-width:var(--button-mobile-size-max-width);font-size:var(--button-mobile-font-size)}}@media only screen and (min-width: 481px) and (max-width: 1179.98px){:host([size=small]){min-width:var(--button-mini-size-min-width);max-width:var(--button-mini-size-max-width);font-size:var(--button-mini-font-size)}}@media only screen and (min-width: 1180px){:host([size=small]){min-width:var(--button-mini-size-min-width);max-width:var(--button-mini-size-max-width);font-size:var(--button-mini-font-size)}}:host(:hover){text-decoration:none}:host([theme=primary]){background-color:var(--button-primary-background-color);border:var(--button-primary-border-width) solid var(--button-primary-border-color);border-radius:var(--button-primary-border-radius);color:var(--button-primary-font-color);margin:var(--button-primary-margin)}:host([theme=primary]:not([disabled]):focus-visible){outline:var(--button-primary-focus-border-width, 2px) var(--button-primary-focus-border-style, solid) var(--button-primary-focus-border-color, --blue-900);outline-offset:var(--button-primary-focus-border-offset, 4px);transition:outline 0s;transition:outline-offset 0s}@media (hover: hover){:host([theme=primary]:not([disabled]):hover),:host([theme=primary]:not([disabled]).hover){background-color:var(--button-primary-hover-color);border:var(--button-primary-hover-border-width) solid var(--button-primary-hover-border-color);color:var(--button-primary-hover-font-color)}}:host([theme=primary][active]:not([disabled])){background-color:var(--button-primary-active-color);border:var(--button-primary-active-border-width) solid var(--button-primary-active-border-color);color:var(--button-primary-active-font-color)}:host([theme=primary]:not([disabled]):active),:host([theme=primary]:not([disabled]).active),:host([theme=primary][pressed]:not([disabled])){background-color:var(--button-primary-active-color);border:var(--button-primary-active-border-width) solid var(--button-primary-active-border-color);color:var(--button-primary-active-font-color)}:host([theme=primary][disabled]){background-color:var(--button-primary-disabled-color);border:var(--button-primary-disabled-border-width) solid var(--button-primary-disabled-border-color);color:var(--button-primary-disabled-font-color)}:host([theme=secondary]){background-color:var(--button-secondary-background-color);border:var(--button-secondary-border-width) solid var(--button-secondary-border-color);border-radius:var(--button-secondary-border-radius);color:var(--button-secondary-font-color);margin:var(--button-secondary-margin)}:host([theme=secondary]:not([disabled]):focus-visible){outline:var(--button-secondary-focus-border-width, 2px) var(--button-secondary-focus-border-style, solid) var(--button-secondary-focus-border-color, --blue-900);outline-offset:var(--button-secondary-focus-border-offset, 4px);transition:outline 0s;transition:outline-offset 0s}@media (hover: hover){:host([theme=secondary]:not([disabled]):hover),:host([theme=secondary]:not([disabled]).hover){background-color:var(--button-secondary-hover-color);border:var(--button-secondary-hover-border-width) solid var(--button-secondary-hover-border-color);color:var(--button-secondary-hover-font-color)}}:host([theme=secondary][active]:not([disabled])){background-color:var(--button-secondary-active-color);border:var(--button-secondary-active-border-width) solid var(--button-secondary-active-border-color);color:var(--button-secondary-active-font-color)}:host([theme=secondary]:not([disabled]):active),:host([theme=secondary]:not([disabled]).active),:host([theme=secondary][pressed]:not([disabled])){background-color:var(--button-secondary-active-color);border:var(--button-secondary-active-border-width) solid var(--button-secondary-active-border-color);color:var(--button-secondary-active-font-color)}:host([theme=secondary][disabled]){background-color:var(--button-secondary-disabled-color);border:var(--button-secondary-disabled-border-width) solid var(--button-secondary-disabled-border-color);color:var(--button-secondary-disabled-font-color)}:host([theme=tertiary]){background-color:var(--button-tertiary-background-color);border:var(--button-tertiary-border-width) solid var(--button-tertiary-border-color);border-radius:var(--button-tertiary-border-radius);color:var(--button-tertiary-font-color);margin:var(--button-tertiary-margin)}:host([theme=tertiary]:not([disabled]):focus-visible){outline:var(--button-tertiary-focus-border-width, 2px) var(--button-tertiary-focus-border-style, solid) var(--button-tertiary-focus-border-color, --blue-900);outline-offset:var(--button-tertiary-focus-border-offset, 4px);transition:outline 0s;transition:outline-offset 0s}@media (hover: hover){:host([theme=tertiary]:not([disabled]):hover),:host([theme=tertiary]:not([disabled]).hover){background-color:var(--button-tertiary-hover-color);border:var(--button-tertiary-hover-border-width) solid var(--button-tertiary-hover-border-color);color:var(--button-tertiary-hover-font-color)}}:host([theme=tertiary][active]:not([disabled])){background-color:var(--button-tertiary-active-color);border:var(--button-tertiary-active-border-width) solid var(--button-tertiary-active-border-color);color:var(--button-tertiary-active-font-color)}:host([theme=tertiary]:not([disabled]):active),:host([theme=tertiary]:not([disabled]).active),:host([theme=tertiary][pressed]:not([disabled])){background-color:var(--button-tertiary-active-color);border:var(--button-tertiary-active-border-width) solid var(--button-tertiary-active-border-color);color:var(--button-tertiary-active-font-color)}:host([theme=tertiary][disabled]){background-color:var(--button-tertiary-disabled-color);border:var(--button-tertiary-disabled-border-width) solid var(--button-tertiary-disabled-border-color);color:var(--button-tertiary-disabled-font-color)}:host([theme=transactional]){background-color:var(--button-transactional-background-color);border:var(--button-transactional-border-width) solid var(--button-transactional-border-color);border-radius:var(--button-transactional-border-radius);color:var(--button-transactional-font-color);margin:var(--button-transactional-margin)}:host([theme=transactional]:not([disabled]):focus-visible){outline:var(--button-transactional-focus-border-width, 2px) var(--button-transactional-focus-border-style, solid) var(--button-transactional-focus-border-color, --blue-900);outline-offset:var(--button-transactional-focus-border-offset, 4px);transition:outline 0s;transition:outline-offset 0s}@media (hover: hover){:host([theme=transactional]:not([disabled]):hover),:host([theme=transactional]:not([disabled]).hover){background-color:var(--button-transactional-hover-color);border:var(--button-transactional-hover-border-width) solid var(--button-transactional-hover-border-color);color:var(--button-transactional-hover-font-color)}}:host([theme=transactional][active]:not([disabled])){background-color:var(--button-transactional-active-color);border:var(--button-transactional-active-border-width) solid var(--button-transactional-active-border-color);color:var(--button-transactional-active-font-color)}:host([theme=transactional]:not([disabled]):active),:host([theme=transactional]:not([disabled]).active),:host([theme=transactional][pressed]:not([disabled])){background-color:var(--button-transactional-active-color);border:var(--button-transactional-active-border-width) solid var(--button-transactional-active-border-color);color:var(--button-transactional-active-font-color)}:host([theme=transactional][disabled]){background-color:var(--button-transactional-disabled-color);border:var(--button-transactional-disabled-border-width) solid var(--button-transactional-disabled-border-color);color:var(--button-transactional-disabled-font-color)}:host([theme=reversed]){background-color:var(--button-reversed-background-color);border:var(--button-reversed-border-width) solid var(--button-reversed-border-color);border-radius:var(--button-reversed-border-radius);color:var(--button-reversed-font-color);margin:var(--button-reversed-margin)}:host([theme=reversed]:not([disabled]):focus),:host([theme=reversed]:not([disabled]).focus){background-color:var(--button-reversed-focus-color);border:var(--button-reversed-focus-border-width) solid var(--button-reversed-focus-border-color);border-radius:var(--button-reversed-border-radius);color:var(--button-reversed-focus-font-color);outline:none}@media (hover: hover){:host([theme=reversed]:not([disabled]):hover),:host([theme=reversed]:not([disabled]).hover){background-color:var(--button-reversed-hover-color);border:var(--button-reversed-hover-border-width) solid var(--button-reversed-hover-border-color);color:var(--button-reversed-hover-font-color)}}:host([theme=reversed][active]:not([disabled])){background-color:var(--button-reversed-active-color);border:var(--button-reversed-active-border-width) solid var(--button-reversed-active-border-color);color:var(--button-reversed-active-font-color)}:host([theme=reversed]:not([disabled]):active),:host([theme=reversed]:not([disabled]).active),:host([theme=reversed][pressed]:not([disabled])){background-color:var(--button-reversed-active-color);--border:var(--button-reversed-active-border-width) solid var(--button-reversed-active-border-color);--color:var(--button-reversed-active-font-color)}:host([theme=reversed][disabled]){--background-color:var(--button-reversed-disabled-color);--border:var(--button-reversed-disabled-border-width) solid var(--button-reversed-disabled-border-color);--color:var(--button-reversed-disabled-font-color)}:host([theme=list-action]){background-color:var(--button-inline-secondary-background-color);border:var(--button-inline-secondary-border-width) solid var(--button-inline-secondary-border-color);border-radius:var(--button-inline-secondary-border-radius);color:var(--button-inline-secondary-font-color);margin:var(--button-inline-secondary-margin)}:host([theme=list-action]:not([disabled]):focus),:host([theme=list-action]:not([disabled]).focus){background-color:var(--button-inline-secondary-focus-color);border:var(--button-inline-secondary-focus-border-width) solid var(--button-inline-secondary-focus-border-color);border-radius:var(--button-inline-secondary-border-radius);color:var(--button-inline-secondary-focus-font-color);outline:none}@media (hover: hover){:host([theme=list-action]:not([disabled]):hover),:host([theme=list-action]:not([disabled]).hover){background-color:var(--button-inline-secondary-hover-color);border:var(--button-inline-secondary-hover-border-width) solid var(--button-inline-secondary-hover-border-color);color:var(--button-inline-secondary-hover-font-color)}}:host([theme=list-action][active]:not([disabled])){background-color:var(--button-inline-secondary-active-color);border:var(--button-inline-secondary-active-border-width) solid var(--button-inline-secondary-active-border-color);color:var(--button-inline-secondary-active-font-color)}:host([theme=list-action]:not([disabled]):active),:host([theme=list-action]:not([disabled]).active) ion-butto,:host([theme=list-action][pressed]:not([disabled])){background-color:var(--button-inline-secondary-active-color);border:var(--button-inline-secondary-active-border-width) solid var(--button-inline-secondary-active-border-color);color:var(--button-inline-secondary-active-font-color)}:host([theme=list-action][disabled]){background-color:var(--button-inline-secondary-disabled-color);border:var(--button-inline-secondary-disabled-border-width) solid var(--button-inline-secondary-disabled-border-color);color:var(--button-inline-secondary-disabled-font-color)}:host([theme=inline-primary]){background-color:var(--button-inline-primary-background-color);border:var(--button-inline-primary-border-width) solid var(--button-inline-primary-border-color);border-radius:var(--button-inline-primary-border-radius);color:var(--button-inline-primary-font-color);margin:var(--button-inline-primary-margin)}:host([theme=inline-primary]:not([disabled]):focus),:host([theme=inline-primary]:not([disabled]).focus){background-color:var(--button-inline-primary-focus-color);border:var(--button-inline-primary-focus-border-width) solid var(--button-inline-primary-focus-border-color);border-radius:var(--button-inline-primary-border-radius);color:var(--button-inline-primary-focus-font-color);outline:none}@media (hover: hover){:host([theme=inline-primary]:not([disabled]):hover),:host([theme=inline-primary]:not([disabled]).hover){background-color:var(--button-inline-primary-hover-color);border:var(--button-inline-primary-hover-border-width) solid var(--button-inline-primary-hover-border-color);color:var(--button-inline-primary-hover-font-color)}}:host([theme=inline-primary][active]:not([disabled])){background-color:var(--button-inline-primary-active-color);border:var(--button-inline-primary-active-border-width) solid var(--button-inline-primary-active-border-color);color:var(--button-inline-primary-active-font-color)}:host([theme=inline-primary]:not([disabled]):active),:host([theme=inline-primary]:not([disabled]).active),:host([theme=inline-primary][pressed]:not([disabled])){background-color:var(--button-inline-primary-active-color);border:var(--button-inline-primary-active-border-width) solid var(--button-inline-primary-active-border-color);color:var(--button-inline-primary-active-font-color)}:host([theme=inline-primary][disabled]){background-color:var(--button-inline-primary-disabled-color);border:var(--button-inline-primary-disabled-border-width) solid var(--button-inline-primary-disabled-border-color);color:var(--button-inline-primary-disabled-font-color)}:host([theme=inline-secondary]){background-color:var(--button-inline-secondary-background-color);border:var(--button-inline-secondary-border-width) solid var(--button-inline-secondary-border-color);border-radius:var(--button-inline-secondary-border-radius);color:var(--button-inline-secondary-font-color);margin:var(--button-inline-secondary-margin)}:host([theme=inline-secondary]:not([disabled]):focus),:host([theme=inline-secondary]:not([disabled]).focus){background-color:var(--button-inline-secondary-focus-color);border:var(--button-inline-secondary-focus-border-width) solid var(--button-inline-secondary-focus-border-color);border-radius:var(--button-inline-secondary-border-radius);color:var(--button-inline-secondary-focus-font-color);outline:none}@media (hover: hover){:host([theme=inline-secondary]:not([disabled]):hover),:host([theme=inline-secondary]:not([disabled]).hover){background-color:var(--button-inline-secondary-hover-color);border:var(--button-inline-secondary-hover-border-width) solid var(--button-inline-secondary-hover-border-color);color:var(--button-inline-secondary-hover-font-color)}}:host([theme=inline-secondary][active]:not([disabled])){background-color:var(--button-inline-secondary-active-color);border:var(--button-inline-secondary-active-border-width) solid var(--button-inline-secondary-active-border-color);color:var(--button-inline-secondary-active-font-color)}:host([theme=inline-secondary]:not([disabled]):active),:host([theme=inline-secondary]:not([disabled]).active),:host([theme=inline-secondary][pressed]:not([disabled])){background-color:var(--button-inline-secondary-active-color);border:var(--button-inline-secondary-active-border-width) solid var(--button-inline-secondary-active-border-color);color:var(--button-inline-secondary-active-font-color)}:host([theme=inline-secondary][disabled]){background-color:var(--button-inline-secondary-disabled-color);border:var(--button-inline-secondary-disabled-border-width) solid var(--button-inline-secondary-disabled-border-color);color:var(--button-inline-secondary-disabled-font-color)}";

const WdprButton$1 = /*@__PURE__*/ proxyCustomElement(class WdprButton extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dispatchActive = createEvent(this, "active-changed", 3);
        this.dispatchFocus = createEvent(this, "focused-changed", 3);
        this.dispatchDisabled = createEvent(this, "disabled-changed", 3);
        /**
         * On blur or focused, sets focused property accordingly
         * @param event {Event}
         */
        this._focusBlurHandler = (event) => {
            this.focused = (event.type === 'focus');
        };
        this.theme = 'primary';
        this.size = 'standard';
        this.activeTabIndex = '0';
        this.pressed = false;
        this.disabled = false;
        this.active = false;
        this.pointerDown = false;
        this.receivedFocusFromKeyboard = false;
        this.focused = false;
        this.ariaActiveAttribute = 'aria-pressed';
        this.toggles = false;
    }
    /**
     * Watcher when active prop changes
     * @param newValue {boolean}
     */
    activeHandler(newValue) {
        this._activeChanged(newValue, this.ariaActiveAttribute);
        this.dispatchActive.emit(newValue);
    }
    /**
     * Watcher when ariaActiveAttribute changes
     * @param newValue
     * @param oldValue
     */
    ariaActiveHandler(newValue, oldValue) {
        this._ariaActiveChanged(newValue, oldValue);
        this._activeChanged(this.active, newValue);
    }
    /**
     * Removes previous ariaActiveAttribute class if needed.
     * @param newValue {string}
     * @param oldValue {string}
     */
    _ariaActiveChanged(newValue, oldValue) {
        if (oldValue != undefined && oldValue != newValue && this.el.hasAttribute(oldValue)) {
            this.el.removeAttribute(oldValue);
        }
    }
    /**
     * Adds attribute for ariaActive class with the value of active.
     * Fired upon changes to active or ariaActiveAttribute attributes.
     * @param newActive {boolean}
     * @param newAriaLabel {string}
     */
    _activeChanged(newActive, newAriaLabel) {
        if (this.toggles) {
            this.el.setAttribute(newAriaLabel, newActive ? 'true' : 'false');
        }
        else {
            this.el.removeAttribute(newAriaLabel);
        }
    }
    /**
     * _disabledChanged is fired when disabled prop is changed
     */
    watchHandler(newValue, oldValue) {
        this._disabledChanged(newValue, oldValue);
    }
    /**
     * _focusedChanged is fired when focused prop is changed
     */
    watchFocused(newValue, oldValue) {
        this._focusChanged(newValue, oldValue);
    }
    _focusChanged(newValue, oldValue) {
        this._detectKeyboardFocus(newValue);
        if (!newValue) {
            this.pressed = false;
        }
        if (newValue != oldValue) {
            this.dispatchFocus.emit(newValue);
        }
    }
    /**
     * Sets receivedFocusFromKeyboard to true if it did not receive focus from a pointer event
     * @param focused {boolean}
     */
    _detectKeyboardFocus(focused) {
        this.receivedFocusFromKeyboard = (!this.pointerDown && focused);
    }
    /**
     * Presses element when space key is pressed down
     */
    _handleSpaceDown(e) {
        if (this.disabled) {
            return;
        }
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.pressed = true;
            e.preventDefault();
        }
    }
    /**
     * Fires click() event and ends button press when space or enter keyup
     */
    _handleSpaceUp(e) {
        if (this.disabled) {
            return (false);
        }
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.pressed = false;
            this.el.click();
            e.preventDefault();
        }
        else if (e.keyCode == 13) {
            this.el.click();
        }
    }
    /**
     * Handles mousedown on element
     */
    _handleMouseDown() {
        this.pointerDown = true;
        if (this.disabled) {
            return;
        }
        else {
            this.pressed = true;
        }
    }
    /**
     * Handles mouseup on element
     */
    _handleMouseUp() {
        this.pointerDown = false;
        if (this.disabled) {
            return (false);
        }
        else {
            this.pressed = false;
        }
    }
    /**
     * Handles click on an element
     */
    _clickHandler() {
        if (this.toggles) {
            // a click is needed to toggle the active state
            this._userActivate(!this.active);
        }
        else {
            this.active = false;
        }
    }
    /**
     * Toggles the active state
     * @param active
     */
    _userActivate(active) {
        if (this.active !== active) {
            this.active = active;
        }
    }
    /**
     * Toggles tabindex, aria-disabled, and pointer events when disabled is changed
     * @param disabled {boolean}
     * @param _old {boolean}
     */
    _disabledChanged(disabled, old) {
        this.el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        this.el.style.pointerEvents = disabled ? 'none' : '';
        if (disabled) {
            this.pressed = false;
            this.activeTabIndex = this.el.getAttribute('tabindex');
            this.el.setAttribute('tabindex', '-1');
            this.focused = false;
            this.el.blur();
        }
        else {
            this.el.setAttribute('tabindex', this.activeTabIndex);
        }
        if (disabled != old) {
            this.dispatchDisabled.emit(disabled);
        }
    }
    componentWillLoad() {
        //Set activeTabIndex to the user-set tabindex if it exists
        if (this.el.hasAttribute('tabindex')) {
            this.activeTabIndex = this.el.getAttribute('tabindex');
        }
        //Or set the tabindex to 0 (default) or -1 (if disabled)
        else {
            this.el.setAttribute('tabindex', this.disabled ? '-1' : '0');
        }
        this.el.setAttribute('aria-disabled', this.disabled ? 'true' : 'false');
    }
    render() {
        return (h(Host, { "on-blur": this._focusBlurHandler, "on-focus": this._focusBlurHandler }, h("slot", null)));
    }
    get el() { return this; }
    static get watchers() { return {
        "active": ["activeHandler"],
        "ariaActiveAttribute": ["ariaActiveHandler"],
        "disabled": ["watchHandler"],
        "focused": ["watchFocused"]
    }; }
    static get style() { return wdprButtonCss; }
}, [1, "wdpr-button", {
        "theme": [513],
        "size": [513],
        "activeTabIndex": [1025, "active-tab-index"],
        "pressed": [1540],
        "disabled": [516],
        "active": [1540],
        "pointerDown": [1028, "pointer-down"],
        "receivedFocusFromKeyboard": [1028, "received-focus-from-keyboard"],
        "focused": [1540],
        "ariaActiveAttribute": [1, "aria-active-attribute"],
        "toggles": [516]
    }, [[0, "keydown", "_handleSpaceDown"], [0, "keyup", "_handleSpaceUp"], [0, "mousedown", "_handleMouseDown"], [0, "mouseup", "_handleMouseUp"], [0, "click", "_clickHandler"]], {
        "active": ["activeHandler"],
        "ariaActiveAttribute": ["ariaActiveHandler"],
        "disabled": ["watchHandler"],
        "focused": ["watchFocused"]
    }]);
function defineCustomElement$1$2() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wdpr-button"];
    components.forEach(tagName => { switch (tagName) {
        case "wdpr-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WdprButton$1);
            }
            break;
    } });
}
defineCustomElement$1$2();

const QQ_COOKIE_NAME = 'roomForm_jar';
const PARTY_MIX = 'party-mix';
const RESORT_SELECT = 'resort-select';
const DATE_PICKER = 'date-picker';
const ACCESSIBILITY = 'accessibility';
const DEPART_AIRPORT = 'depart-airport';
const RETURN_AIRPORT = 'return-airport';
const SHOP_FOR_SELECT = 'shop-for-select';
const TRAVEL_CLASS_SELECT = 'travelClassSelect';

function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (encodeURIComponent(value) || '')  + expires + '; path=/';
}

function getCookie(name) {
    var re = new RegExp(name + '=([^;]+)'), // dynamic regex to parse document.cookie for the one you want
        value = re.exec(document.cookie); // the value out of the regex

    value = (value !== null) ? decodeURIComponent(value[1]) : null;

    return value;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire();
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var luxon = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

// these aren't really private, but nor are they really useful to document
/**
 * @private
 */
var LuxonError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(LuxonError, _Error);
  function LuxonError() {
    return _Error.apply(this, arguments) || this;
  }
  return LuxonError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * @private
 */
var InvalidDateTimeError = /*#__PURE__*/function (_LuxonError) {
  _inheritsLoose(InvalidDateTimeError, _LuxonError);
  function InvalidDateTimeError(reason) {
    return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
  }
  return InvalidDateTimeError;
}(LuxonError);

/**
 * @private
 */
var InvalidIntervalError = /*#__PURE__*/function (_LuxonError2) {
  _inheritsLoose(InvalidIntervalError, _LuxonError2);
  function InvalidIntervalError(reason) {
    return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
  }
  return InvalidIntervalError;
}(LuxonError);

/**
 * @private
 */
var InvalidDurationError = /*#__PURE__*/function (_LuxonError3) {
  _inheritsLoose(InvalidDurationError, _LuxonError3);
  function InvalidDurationError(reason) {
    return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
  }
  return InvalidDurationError;
}(LuxonError);

/**
 * @private
 */
var ConflictingSpecificationError = /*#__PURE__*/function (_LuxonError4) {
  _inheritsLoose(ConflictingSpecificationError, _LuxonError4);
  function ConflictingSpecificationError() {
    return _LuxonError4.apply(this, arguments) || this;
  }
  return ConflictingSpecificationError;
}(LuxonError);

/**
 * @private
 */
var InvalidUnitError = /*#__PURE__*/function (_LuxonError5) {
  _inheritsLoose(InvalidUnitError, _LuxonError5);
  function InvalidUnitError(unit) {
    return _LuxonError5.call(this, "Invalid unit " + unit) || this;
  }
  return InvalidUnitError;
}(LuxonError);

/**
 * @private
 */
var InvalidArgumentError = /*#__PURE__*/function (_LuxonError6) {
  _inheritsLoose(InvalidArgumentError, _LuxonError6);
  function InvalidArgumentError() {
    return _LuxonError6.apply(this, arguments) || this;
  }
  return InvalidArgumentError;
}(LuxonError);

/**
 * @private
 */
var ZoneIsAbstractError = /*#__PURE__*/function (_LuxonError7) {
  _inheritsLoose(ZoneIsAbstractError, _LuxonError7);
  function ZoneIsAbstractError() {
    return _LuxonError7.call(this, "Zone is an abstract class") || this;
  }
  return ZoneIsAbstractError;
}(LuxonError);

/**
 * @private
 */

var n = "numeric",
  s = "short",
  l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

/**
 * @interface
 */
var Zone = /*#__PURE__*/function () {
  function Zone() {}
  var _proto = Zone.prototype;
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  _proto.offsetName = function offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */;
  _proto.formatOffset = function formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */;
  _proto.offset = function offset(ts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */;
  _proto.equals = function equals(otherZone) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */;
  _createClass(Zone, [{
    key: "type",
    get:
    /**
     * The type of zone
     * @abstract
     * @type {string}
     */
    function get() {
      throw new ZoneIsAbstractError();
    }

    /**
     * The name of this zone.
     * @abstract
     * @type {string}
     */
  }, {
    key: "name",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }, {
    key: "ianaName",
    get: function get() {
      return this.name;
    }

    /**
     * Returns whether the offset is known to be fixed for the whole year.
     * @abstract
     * @type {boolean}
     */
  }, {
    key: "isUniversal",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }, {
    key: "isValid",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }]);
  return Zone;
}();

var singleton$1 = null;

/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */
var SystemZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(SystemZone, _Zone);
  function SystemZone() {
    return _Zone.apply(this, arguments) || this;
  }
  var _proto = SystemZone.prototype;
  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
      locale = _ref.locale;
    return parseZoneInfo(ts, format, locale);
  }

  /** @override **/;
  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/;
  _proto.offset = function offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }

  /** @override **/;
  _proto.equals = function equals(otherZone) {
    return otherZone.type === "system";
  }

  /** @override **/;
  _createClass(SystemZone, [{
    key: "type",
    get: /** @override **/
    function get() {
      return "system";
    }

    /** @override **/
  }, {
    key: "name",
    get: function get() {
      return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    /** @override **/
  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "instance",
    get:
    /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */
    function get() {
      if (singleton$1 === null) {
        singleton$1 = new SystemZone();
      }
      return singleton$1;
    }
  }]);
  return SystemZone;
}(Zone);

var dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted),
    fMonth = parsed[1],
    fDay = parsed[2],
    fYear = parsed[3],
    fadOrBc = parsed[4],
    fHour = parsed[5],
    fMinute = parsed[6],
    fSecond = parsed[7];
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date);
  var filled = [];
  for (var i = 0; i < formatted.length; i++) {
    var _formatted$i = formatted[i],
      type = _formatted$i.type,
      value = _formatted$i.value;
    var pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
var ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */
var IANAZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(IANAZone, _Zone);
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  IANAZone.create = function create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }

  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */;
  IANAZone.resetCache = function resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }

  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */;
  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
    return this.isValidZone(s);
  }

  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */;
  IANAZone.isValidZone = function isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  };
  function IANAZone(name) {
    var _this;
    _this = _Zone.call(this) || this;
    /** @private **/
    _this.zoneName = name;
    /** @private **/
    _this.valid = IANAZone.isValidZone(name);
    return _this;
  }

  /** @override **/
  var _proto = IANAZone.prototype;
  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
      locale = _ref.locale;
    return parseZoneInfo(ts, format, locale, this.name);
  }

  /** @override **/;
  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/;
  _proto.offset = function offset(ts) {
    var date = new Date(ts);
    if (isNaN(date)) return NaN;
    var dtf = makeDTF(this.name);
    var _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
      year = _ref2[0],
      month = _ref2[1],
      day = _ref2[2],
      adOrBc = _ref2[3],
      hour = _ref2[4],
      minute = _ref2[5],
      second = _ref2[6];
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }

    // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
    var adjustedHour = hour === 24 ? 0 : hour;
    var asUTC = objToLocalTS({
      year: year,
      month: month,
      day: day,
      hour: adjustedHour,
      minute: minute,
      second: second,
      millisecond: 0
    });
    var asTS = +date;
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }

  /** @override **/;
  _proto.equals = function equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }

  /** @override **/;
  _createClass(IANAZone, [{
    key: "type",
    get: function get() {
      return "iana";
    }

    /** @override **/
  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }

    /** @override **/
  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.valid;
    }
  }]);
  return IANAZone;
}(Zone);

var _excluded = ["base"],
  _excluded2 = ["padTo", "floor"];

// todo - remap caching

var intlLFCache = {};
function getCachedLF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var key = JSON.stringify([locString, opts]);
  var dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
var intlDTCache = {};
function getCachedDTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var key = JSON.stringify([locString, opts]);
  var dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
var intlNumCache = {};
function getCachedINF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var key = JSON.stringify([locString, opts]);
  var inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
var intlRelCache = {};
function getCachedRTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var _opts = opts;
    var cacheKeyOpts = _objectWithoutPropertiesLoose(_opts, _excluded); // exclude `base` from the options
  var key = JSON.stringify([locString, cacheKeyOpts]);
  var inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
var weekInfoCache = {};
function getCachedWeekInfo(locString) {
  var data = weekInfoCache[locString];
  if (!data) {
    var locale = new Intl.Locale(locString);
    // browsers currently implement this as a property, but spec says it should be a getter function
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}
function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:

  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u

  // private subtags and unicode subtags have ordering requirements,
  // and we're not properly parsing this, so just strip out the
  // private ones if they exist.
  var xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  var uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    var options;
    var selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      var smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    var _options = options,
      numberingSystem = _options.numberingSystem,
      calendar = _options.calendar;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += "-ca-" + outputCalendar;
    }
    if (numberingSystem) {
      localeStr += "-nu-" + numberingSystem;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  var ms = [];
  for (var i = 1; i <= 12; i++) {
    var dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
function mapWeekdays(f) {
  var ms = [];
  for (var i = 1; i <= 7; i++) {
    var dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
  var mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}

/**
 * @private
 */
var PolyNumberFormatter = /*#__PURE__*/function () {
  function PolyNumberFormatter(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
      var otherOpts = _objectWithoutPropertiesLoose(opts, _excluded2);
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      var intlOpts = _extends({
        useGrouping: false
      }, opts);
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  var _proto = PolyNumberFormatter.prototype;
  _proto.format = function format(i) {
    if (this.inf) {
      var fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(_fixed, this.padTo);
    }
  };
  return PolyNumberFormatter;
}();
/**
 * @private
 */
var PolyDateFormatter = /*#__PURE__*/function () {
  function PolyDateFormatter(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = undefined;
    var z = undefined;
    if (this.opts.timeZone) {
      // Don't apply any workarounds if a timeZone is explicitly provided in opts
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      var gmtOffset = -1 * (dt.offset / 60);
      var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
        // we manually apply the offset and substitute the zone as needed.
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
          minutes: dt.offset
        });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      // Custom zones can have any offset / offsetName so we just manually
      // apply the offset and substitute the zone as needed.
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({
        minutes: dt.offset
      });
      this.originalZone = dt.zone;
    }
    var intlOpts = _extends({}, this.opts);
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  var _proto2 = PolyDateFormatter.prototype;
  _proto2.format = function format() {
    if (this.originalZone) {
      // If we have to substitute in the actual zone name, we have to use
      // formatToParts so that the timezone can be replaced.
      return this.formatToParts().map(function (_ref) {
        var value = _ref.value;
        return value;
      }).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  };
  _proto2.formatToParts = function formatToParts() {
    var _this = this;
    var parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map(function (part) {
        if (part.type === "timeZoneName") {
          var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
            locale: _this.dt.locale,
            format: _this.opts.timeZoneName
          });
          return _extends({}, part, {
            value: offsetName
          });
        } else {
          return part;
        }
      });
    }
    return parts;
  };
  _proto2.resolvedOptions = function resolvedOptions() {
    return this.dtf.resolvedOptions();
  };
  return PolyDateFormatter;
}();
/**
 * @private
 */
var PolyRelFormatter = /*#__PURE__*/function () {
  function PolyRelFormatter(intl, isEnglish, opts) {
    this.opts = _extends({
      style: "long"
    }, opts);
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  var _proto3 = PolyRelFormatter.prototype;
  _proto3.format = function format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  };
  _proto3.formatToParts = function formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  };
  return PolyRelFormatter;
}();
var fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};

/**
 * @private
 */
var Locale = /*#__PURE__*/function () {
  Locale.fromOpts = function fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
  };
  Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
    if (defaultToEN === void 0) {
      defaultToEN = false;
    }
    var specifiedLocale = locale || Settings.defaultLocale;
    // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
    var localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    var numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    var outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    var weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  };
  Locale.resetCache = function resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  };
  Locale.fromObject = function fromObject(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
      locale = _ref2.locale,
      numberingSystem = _ref2.numberingSystem,
      outputCalendar = _ref2.outputCalendar,
      weekSettings = _ref2.weekSettings;
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  };
  function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    var _parseLocaleString = parseLocaleString(locale),
      parsedLocale = _parseLocaleString[0],
      parsedNumberingSystem = _parseLocaleString[1],
      parsedOutputCalendar = _parseLocaleString[2];
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  var _proto4 = Locale.prototype;
  _proto4.listingMode = function listingMode() {
    var isActuallyEn = this.isEnglish();
    var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  };
  _proto4.clone = function clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
  };
  _proto4.redefaultToEN = function redefaultToEN(alts) {
    if (alts === void 0) {
      alts = {};
    }
    return this.clone(_extends({}, alts, {
      defaultToEN: true
    }));
  };
  _proto4.redefaultToSystem = function redefaultToSystem(alts) {
    if (alts === void 0) {
      alts = {};
    }
    return this.clone(_extends({}, alts, {
      defaultToEN: false
    }));
  };
  _proto4.months = function months$1(length, format) {
    var _this2 = this;
    if (format === void 0) {
      format = false;
    }
    return listStuff(this, length, months, function () {
      var intl = format ? {
          month: length,
          day: "numeric"
        } : {
          month: length
        },
        formatStr = format ? "format" : "standalone";
      if (!_this2.monthsCache[formatStr][length]) {
        _this2.monthsCache[formatStr][length] = mapMonths(function (dt) {
          return _this2.extract(dt, intl, "month");
        });
      }
      return _this2.monthsCache[formatStr][length];
    });
  };
  _proto4.weekdays = function weekdays$1(length, format) {
    var _this3 = this;
    if (format === void 0) {
      format = false;
    }
    return listStuff(this, length, weekdays, function () {
      var intl = format ? {
          weekday: length,
          year: "numeric",
          month: "long",
          day: "numeric"
        } : {
          weekday: length
        },
        formatStr = format ? "format" : "standalone";
      if (!_this3.weekdaysCache[formatStr][length]) {
        _this3.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
          return _this3.extract(dt, intl, "weekday");
        });
      }
      return _this3.weekdaysCache[formatStr][length];
    });
  };
  _proto4.meridiems = function meridiems$1() {
    var _this4 = this;
    return listStuff(this, undefined, function () {
      return meridiems;
    }, function () {
      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
      if (!_this4.meridiemCache) {
        var intl = {
          hour: "numeric",
          hourCycle: "h12"
        };
        _this4.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
          return _this4.extract(dt, intl, "dayperiod");
        });
      }
      return _this4.meridiemCache;
    });
  };
  _proto4.eras = function eras$1(length) {
    var _this5 = this;
    return listStuff(this, length, eras, function () {
      var intl = {
        era: length
      };

      // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!_this5.eraCache[length]) {
        _this5.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
          return _this5.extract(dt, intl, "era");
        });
      }
      return _this5.eraCache[length];
    });
  };
  _proto4.extract = function extract(dt, intlOpts, field) {
    var df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find(function (m) {
        return m.type.toLowerCase() === field;
      });
    return matching ? matching.value : null;
  };
  _proto4.numberFormatter = function numberFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }
    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  };
  _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
    if (intlOpts === void 0) {
      intlOpts = {};
    }
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  };
  _proto4.relFormatter = function relFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  };
  _proto4.listFormatter = function listFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }
    return getCachedLF(this.intl, opts);
  };
  _proto4.isEnglish = function isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  };
  _proto4.getWeekSettings = function getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  };
  _proto4.getStartOfWeek = function getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  };
  _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  };
  _proto4.getWeekendDays = function getWeekendDays() {
    return this.getWeekSettings().weekend;
  };
  _proto4.equals = function equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  };
  _createClass(Locale, [{
    key: "fastNumbers",
    get: function get() {
      if (this.fastNumbersCached == null) {
        this.fastNumbersCached = supportsFastNumbers(this);
      }
      return this.fastNumbersCached;
    }
  }]);
  return Locale;
}();

var singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
var FixedOffsetZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(FixedOffsetZone, _Zone);
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  FixedOffsetZone.instance = function instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }

  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */;
  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
    if (s) {
      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  };
  function FixedOffsetZone(offset) {
    var _this;
    _this = _Zone.call(this) || this;
    /** @private **/
    _this.fixed = offset;
    return _this;
  }

  /** @override **/
  var _proto = FixedOffsetZone.prototype;
  /** @override **/
  _proto.offsetName = function offsetName() {
    return this.name;
  }

  /** @override **/;
  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.fixed, format);
  }

  /** @override **/;
  /** @override **/
  _proto.offset = function offset() {
    return this.fixed;
  }

  /** @override **/;
  _proto.equals = function equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }

  /** @override **/;
  _createClass(FixedOffsetZone, [{
    key: "type",
    get: function get() {
      return "fixed";
    }

    /** @override **/
  }, {
    key: "name",
    get: function get() {
      return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
    }
  }, {
    key: "ianaName",
    get: function get() {
      if (this.fixed === 0) {
        return "Etc/UTC";
      } else {
        return "Etc/GMT" + formatOffset(-this.fixed, "narrow");
      }
    }
  }, {
    key: "isUniversal",
    get: function get() {
      return true;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "utcInstance",
    get:
    /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */
    function get() {
      if (singleton === null) {
        singleton = new FixedOffsetZone(0);
      }
      return singleton;
    }
  }]);
  return FixedOffsetZone;
}(Zone);

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
var InvalidZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(InvalidZone, _Zone);
  function InvalidZone(zoneName) {
    var _this;
    _this = _Zone.call(this) || this;
    /**  @private */
    _this.zoneName = zoneName;
    return _this;
  }

  /** @override **/
  var _proto = InvalidZone.prototype;
  /** @override **/
  _proto.offsetName = function offsetName() {
    return null;
  }

  /** @override **/;
  _proto.formatOffset = function formatOffset() {
    return "";
  }

  /** @override **/;
  _proto.offset = function offset() {
    return NaN;
  }

  /** @override **/;
  _proto.equals = function equals() {
    return false;
  }

  /** @override **/;
  _createClass(InvalidZone, [{
    key: "type",
    get: function get() {
      return "invalid";
    }

    /** @override **/
  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }

    /** @override **/
  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);
  return InvalidZone;
}(Zone);

/**
 * @private
 */
function normalizeZone(input, defaultZone) {
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    var lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone;else if (lowered === "local" || lowered === "system") return SystemZone.instance;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

var now = function now() {
    return Date.now();
  },
  defaultZone = "system",
  defaultLocale = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  twoDigitCutoffYear = 60,
  throwOnInvalid,
  defaultWeekSettings = null;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */
var Settings = /*#__PURE__*/function () {
  function Settings() {}
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  Settings.resetCaches = function resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  };
  _createClass(Settings, null, [{
    key: "now",
    get:
    /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */
    function get() {
      return now;
    }

    /**
     * Set the callback for returning the current timestamp.
     * The function should return a number, which will be interpreted as an Epoch millisecond count
     * @type {function}
     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
     */,
    set: function set(n) {
      now = n;
    }

    /**
     * Set the default time zone to create DateTimes in. Does not affect existing instances.
     * Use the value "system" to reset this value to the system's time zone.
     * @type {string}
     */
  }, {
    key: "defaultZone",
    get:
    /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */
    function get() {
      return normalizeZone(defaultZone, SystemZone.instance);
    }

    /**
     * Get the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */,
    set: function set(zone) {
      defaultZone = zone;
    }
  }, {
    key: "defaultLocale",
    get: function get() {
      return defaultLocale;
    }

    /**
     * Set the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */,
    set: function set(locale) {
      defaultLocale = locale;
    }

    /**
     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
  }, {
    key: "defaultNumberingSystem",
    get: function get() {
      return defaultNumberingSystem;
    }

    /**
     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */,
    set: function set(numberingSystem) {
      defaultNumberingSystem = numberingSystem;
    }

    /**
     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
  }, {
    key: "defaultOutputCalendar",
    get: function get() {
      return defaultOutputCalendar;
    }

    /**
     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */,
    set: function set(outputCalendar) {
      defaultOutputCalendar = outputCalendar;
    }

    /**
     * @typedef {Object} WeekSettings
     * @property {number} firstDay
     * @property {number} minimalDays
     * @property {number[]} weekend
     */

    /**
     * @return {WeekSettings|null}
     */
  }, {
    key: "defaultWeekSettings",
    get: function get() {
      return defaultWeekSettings;
    }

    /**
     * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
     * how many days are required in the first week of a year.
     * Does not affect existing instances.
     *
     * @param {WeekSettings|null} weekSettings
     */,
    set: function set(weekSettings) {
      defaultWeekSettings = validateWeekSettings(weekSettings);
    }

    /**
     * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
     * @type {number}
     */
  }, {
    key: "twoDigitCutoffYear",
    get: function get() {
      return twoDigitCutoffYear;
    }

    /**
     * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
     * @type {number}
     * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpreted as current century
     * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
     * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
     * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
     */,
    set: function set(cutoffYear) {
      twoDigitCutoffYear = cutoffYear % 100;
    }

    /**
     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */
  }, {
    key: "throwOnInvalid",
    get: function get() {
      return throwOnInvalid;
    }

    /**
     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */,
    set: function set(t) {
      throwOnInvalid = t;
    }
  }]);
  return Settings;
}();

var Invalid = /*#__PURE__*/function () {
  function Invalid(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  var _proto = Invalid.prototype;
  _proto.toMessage = function toMessage() {
    if (this.explanation) {
      return this.reason + ": " + this.explanation;
    } else {
      return this.reason;
    }
  };
  return Invalid;
}();

var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function dayOfWeek(year, month, day) {
  var d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  var js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex(function (i) {
      return i < ordinal;
    }),
    day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day: day
  };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}

/**
 * @private
 */

function gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
  if (minDaysInFirstWeek === void 0) {
    minDaysInFirstWeek = 4;
  }
  if (startOfWeek === void 0) {
    startOfWeek = 1;
  }
  var year = gregObj.year,
    month = gregObj.month,
    day = gregObj.day,
    ordinal = computeOrdinal(year, month, day),
    weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7),
    weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return _extends({
    weekYear: weekYear,
    weekNumber: weekNumber,
    weekday: weekday
  }, timeObject(gregObj));
}
function weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
  if (minDaysInFirstWeek === void 0) {
    minDaysInFirstWeek = 4;
  }
  if (startOfWeek === void 0) {
    startOfWeek = 1;
  }
  var weekYear = weekData.weekYear,
    weekNumber = weekData.weekNumber,
    weekday = weekData.weekday,
    weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek),
    yearInDays = daysInYear(weekYear);
  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek,
    year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
    month = _uncomputeOrdinal.month,
    day = _uncomputeOrdinal.day;
  return _extends({
    year: year,
    month: month,
    day: day
  }, timeObject(weekData));
}
function gregorianToOrdinal(gregData) {
  var year = gregData.year,
    month = gregData.month,
    day = gregData.day;
  var ordinal = computeOrdinal(year, month, day);
  return _extends({
    year: year,
    ordinal: ordinal
  }, timeObject(gregData));
}
function ordinalToGregorian(ordinalData) {
  var year = ordinalData.year,
    ordinal = ordinalData.ordinal;
  var _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
    month = _uncomputeOrdinal2.month,
    day = _uncomputeOrdinal2.day;
  return _extends({
    year: year,
    month: month,
    day: day
  }, timeObject(ordinalData));
}

/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */
function usesLocalWeekValues(obj, loc) {
  var hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    var hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return {
      minDaysInFirstWeek: 4,
      startOfWeek: 1
    };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
  if (minDaysInFirstWeek === void 0) {
    minDaysInFirstWeek = 4;
  }
  if (startOfWeek === void 0) {
    startOfWeek = 1;
  }
  var validYear = isInteger(obj.weekYear),
    validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)),
    validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  var validYear = isInteger(obj.year),
    validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  var validYear = isInteger(obj.year),
    validMonth = integerBetween(obj.month, 1, 12),
    validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  var hour = obj.hour,
    minute = obj.minute,
    second = obj.second,
    millisecond = obj.millisecond;
  var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
    validMinute = integerBetween(minute, 0, 59),
    validSecond = integerBetween(second, 0, 59),
    validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

// CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce(function (best, next) {
    var pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce(function (a, k) {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function (v) {
      return !integerBetween(v, 1, 7);
    })) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}

// NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}
function padStart(input, n) {
  if (n === void 0) {
    n = 2;
  }
  var isNeg = input < 0;
  var padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    var f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}
function roundTo(number, digits, towardZero) {
  if (towardZero === void 0) {
    towardZero = false;
  }
  var factor = Math.pow(10, digits),
    rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  var modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);

  // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
    // so if obj.year is in 99, but obj.day makes it roll over into year 100,
    // the calculations done by Date.UTC are using year 2000 - which is incorrect
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}

// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  var fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
  if (minDaysInFirstWeek === void 0) {
    minDaysInFirstWeek = 4;
  }
  if (startOfWeek === void 0) {
    startOfWeek = 1;
  }
  var weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  var weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
  if (timeZone === void 0) {
    timeZone = null;
  }
  var date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  var modified = _extends({
    timeZoneName: offsetFormat
  }, intlOpts);
  var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
    return m.type.toLowerCase() === "timezonename";
  });
  return parsed ? parsed.value : null;
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  var offHour = parseInt(offHourStr, 10);

  // don't || this because we want to preserve -0
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  var offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function asNumber(value) {
  var numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  var normalized = {};
  for (var u in obj) {
    if (hasOwnProperty(obj, u)) {
      var v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
function formatOffset(offset, format) {
  var hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return "" + sign + padStart(hours, 2) + ":" + padStart(minutes, 2);
    case "narrow":
      return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
    case "techie":
      return "" + sign + padStart(hours, 2) + padStart(minutes, 2);
    default:
      throw new RangeError("Value format " + format + " is out of range for property format");
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}

/**
 * @private
 */

var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [].concat(monthsNarrow);
    case "short":
      return [].concat(monthsShort);
    case "long":
      return [].concat(monthsLong);
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [].concat(weekdaysNarrow);
    case "short":
      return [].concat(weekdaysShort);
    case "long":
      return [].concat(weekdaysLong);
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
var meridiems = ["AM", "PM"];
var erasLong = ["Before Christ", "Anno Domini"];
var erasShort = ["BC", "AD"];
var erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [].concat(erasNarrow);
    case "short":
      return [].concat(erasShort);
    case "long":
      return [].concat(erasLong);
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric, narrow) {
  if (numeric === void 0) {
    numeric = "always";
  }
  if (narrow === void 0) {
    narrow = false;
  }
  var units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    var isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : "next " + units[unit][0];
      case -1:
        return isDay ? "yesterday" : "last " + units[unit][0];
      case 0:
        return isDay ? "today" : "this " + units[unit][0];
    }
  }

  var isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}

function stringifyTokens(splits, tokenToString) {
  var s = "";
  for (var _iterator = _createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;) {
    var token = _step.value;
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}
var _macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};

/**
 * @private
 */
var Formatter = /*#__PURE__*/function () {
  Formatter.create = function create(locale, opts) {
    if (opts === void 0) {
      opts = {};
    }
    return new Formatter(locale, opts);
  };
  Formatter.parseFormat = function parseFormat(fmt) {
    // white-space is always considered a literal in user-provided formats
    // the " " token has a special meaning (see unitForToken)

    var current = null,
      currentFull = "",
      bracketed = false;
    var splits = [];
    for (var i = 0; i < fmt.length; i++) {
      var c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed || /^\s+$/.test(currentFull),
        val: currentFull
      });
    }
    return splits;
  };
  Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
    return _macroTokenToFormatOpts[token];
  };
  function Formatter(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  var _proto = Formatter.prototype;
  _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    var df = this.systemLoc.dtFormatter(dt, _extends({}, this.opts, opts));
    return df.format();
  };
  _proto.dtFormatter = function dtFormatter(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    return this.loc.dtFormatter(dt, _extends({}, this.opts, opts));
  };
  _proto.formatDateTime = function formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  };
  _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  };
  _proto.formatInterval = function formatInterval(interval, opts) {
    var df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  };
  _proto.resolvedOptions = function resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  };
  _proto.num = function num(n, p) {
    if (p === void 0) {
      p = 0;
    }
    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }
    var opts = _extends({}, this.opts);
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n);
  };
  _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
    var _this = this;
    var knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = function string(opts, extract) {
        return _this.loc.extract(dt, opts, extract);
      },
      formatOffset = function formatOffset(opts) {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }
        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = function meridiem() {
        return knownEnglish ? meridiemForDateTime(dt) : string({
          hour: "numeric",
          hourCycle: "h12"
        }, "dayperiod");
      },
      month = function month(length, standalone) {
        return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
          month: length
        } : {
          month: length,
          day: "numeric"
        }, "month");
      },
      weekday = function weekday(length, standalone) {
        return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
          weekday: length
        } : {
          weekday: length,
          month: "long",
          day: "numeric"
        }, "weekday");
      },
      maybeMacro = function maybeMacro(token) {
        var formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return _this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = function era(length) {
        return knownEnglish ? eraForDateTime(dt, length) : string({
          era: length
        }, "era");
      },
      tokenToString = function tokenToString(token) {
        // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
        switch (token) {
          // ms
          case "S":
            return _this.num(dt.millisecond);
          case "u":
          // falls through
          case "SSS":
            return _this.num(dt.millisecond, 3);
          // seconds
          case "s":
            return _this.num(dt.second);
          case "ss":
            return _this.num(dt.second, 2);
          // fractional seconds
          case "uu":
            return _this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return _this.num(Math.floor(dt.millisecond / 100));
          // minutes
          case "m":
            return _this.num(dt.minute);
          case "mm":
            return _this.num(dt.minute, 2);
          // hours
          case "h":
            return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return _this.num(dt.hour);
          case "HH":
            return _this.num(dt.hour, 2);
          // offset
          case "Z":
            // like +6
            return formatOffset({
              format: "narrow",
              allowZ: _this.opts.allowZ
            });
          case "ZZ":
            // like +06:00
            return formatOffset({
              format: "short",
              allowZ: _this.opts.allowZ
            });
          case "ZZZ":
            // like +0600
            return formatOffset({
              format: "techie",
              allowZ: _this.opts.allowZ
            });
          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, {
              format: "short",
              locale: _this.loc.locale
            });
          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, {
              format: "long",
              locale: _this.loc.locale
            });
          // zone
          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems
          case "a":
            return meridiem();
          // dates
          case "d":
            return useDateTimeFormatter ? string({
              day: "numeric"
            }, "day") : _this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({
              day: "2-digit"
            }, "day") : _this.num(dt.day, 2);
          // weekdays - standalone
          case "c":
            // like 1
            return _this.num(dt.weekday);
          case "ccc":
            // like 'Tues'
            return weekday("short", true);
          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);
          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format
          case "E":
            // like 1
            return _this.num(dt.weekday);
          case "EEE":
            // like 'Tues'
            return weekday("short", false);
          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);
          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone
          case "L":
            // like 1
            return useDateTimeFormatter ? string({
              month: "numeric",
              day: "numeric"
            }, "month") : _this.num(dt.month);
          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter ? string({
              month: "2-digit",
              day: "numeric"
            }, "month") : _this.num(dt.month, 2);
          case "LLL":
            // like Jan
            return month("short", true);
          case "LLLL":
            // like January
            return month("long", true);
          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format
          case "M":
            // like 1
            return useDateTimeFormatter ? string({
              month: "numeric"
            }, "month") : _this.num(dt.month);
          case "MM":
            // like 01
            return useDateTimeFormatter ? string({
              month: "2-digit"
            }, "month") : _this.num(dt.month, 2);
          case "MMM":
            // like Jan
            return month("short", false);
          case "MMMM":
            // like January
            return month("long", false);
          case "MMMMM":
            // like J
            return month("narrow", false);
          // years
          case "y":
            // like 2014
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year);
          case "yy":
            // like 14
            return useDateTimeFormatter ? string({
              year: "2-digit"
            }, "year") : _this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            // like 0012
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year, 4);
          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year, 6);
          // eras
          case "G":
            // like AD
            return era("short");
          case "GG":
            // like Anno Domini
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return _this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return _this.num(dt.weekYear, 4);
          case "W":
            return _this.num(dt.weekNumber);
          case "WW":
            return _this.num(dt.weekNumber, 2);
          case "n":
            return _this.num(dt.localWeekNumber);
          case "nn":
            return _this.num(dt.localWeekNumber, 2);
          case "ii":
            return _this.num(dt.localWeekYear.toString().slice(-2), 2);
          case "iiii":
            return _this.num(dt.localWeekYear, 4);
          case "o":
            return _this.num(dt.ordinal);
          case "ooo":
            return _this.num(dt.ordinal, 3);
          case "q":
            // like 1
            return _this.num(dt.quarter);
          case "qq":
            // like 01
            return _this.num(dt.quarter, 2);
          case "X":
            return _this.num(Math.floor(dt.ts / 1000));
          case "x":
            return _this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  };
  _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
    var _this2 = this;
    var tokenToField = function tokenToField(token) {
        switch (token[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "w":
            return "week";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      },
      tokenToString = function tokenToString(lildur) {
        return function (token) {
          var mapped = tokenToField(token);
          if (mapped) {
            return _this2.num(lildur.get(mapped), token.length);
          } else {
            return token;
          }
        };
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce(function (found, _ref) {
        var literal = _ref.literal,
          val = _ref.val;
        return literal ? found : found.concat(val);
      }, []),
      collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
        return t;
      }));
    return stringifyTokens(tokens, tokenToString(collapsed));
  };
  return Formatter;
}();

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes() {
  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }
  var full = regexes.reduce(function (f, r) {
    return f + r.source;
  }, "");
  return RegExp("^" + full + "$");
}
function combineExtractors() {
  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    extractors[_key2] = arguments[_key2];
  }
  return function (m) {
    return extractors.reduce(function (_ref, ex) {
      var mergedVals = _ref[0],
        mergedZone = _ref[1],
        cursor = _ref[2];
      var _ex = ex(m, cursor),
        val = _ex[0],
        zone = _ex[1],
        next = _ex[2];
      return [_extends({}, mergedVals, val), zone || mergedZone, next];
    }, [{}, null, 1]).slice(0, 2);
  };
}
function parse(s) {
  if (s == null) {
    return [null, null];
  }
  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    patterns[_key3 - 1] = arguments[_key3];
  }
  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
    var _patterns$_i = _patterns[_i],
      regex = _patterns$_i[0],
      extractor = _patterns$_i[1];
    var m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse() {
  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    keys[_key4] = arguments[_key4];
  }
  return function (match, cursor) {
    var ret = {};
    var i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = "(?:" + offsetRegex.source + "?(?:\\[(" + ianaRegex.source + ")\\])?)?";
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + isoExtendedZone);
var isoTimeExtensionRegex = RegExp("(?:T" + isoTimeRegex.source + ")?");
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?");
var sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");
function int(match, pos, fallback) {
  var m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match, cursor) {
  var item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match, cursor) {
  var item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match, cursor) {
  var local = !match[cursor] && !match[cursor + 1],
    fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match, cursor) {
  var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO time parsing

var isoTimeOnly = RegExp("^T?" + isoTimeBaseRegex.source + "$");

// ISO duration parsing

var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match) {
  var s = match[0],
    yearStr = match[1],
    monthStr = match[2],
    weekStr = match[3],
    dayStr = match[4],
    hourStr = match[5],
    minuteStr = match[6],
    secondStr = match[7],
    millisecondsStr = match[8];
  var hasNegativePrefix = s[0] === "-";
  var negativeSeconds = secondStr && secondStr[0] === "-";
  var maybeNegate = function maybeNegate(num, force) {
    if (force === void 0) {
      force = false;
    }
    return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
  };
  return [{
    years: maybeNegate(parseFloating(yearStr)),
    months: maybeNegate(parseFloating(monthStr)),
    weeks: maybeNegate(parseFloating(weekStr)),
    days: maybeNegate(parseFloating(dayStr)),
    hours: maybeNegate(parseFloating(hourStr)),
    minutes: maybeNegate(parseFloating(minuteStr)),
    seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
    milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
  }];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}

// RFC 2822/5322
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match) {
  var weekdayStr = match[1],
    dayStr = match[2],
    monthStr = match[3],
    yearStr = match[4],
    hourStr = match[5],
    minuteStr = match[6],
    secondStr = match[7],
    obsOffset = match[8],
    milOffset = match[9],
    offHourStr = match[10],
    offMinuteStr = match[11],
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  var offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset)];
}
function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}

// http date

var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match) {
  var weekdayStr = match[1],
    dayStr = match[2],
    monthStr = match[3],
    yearStr = match[4],
    hourStr = match[5],
    minuteStr = match[6],
    secondStr = match[7],
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match) {
  var weekdayStr = match[1],
    monthStr = match[2],
    dayStr = match[3],
    hourStr = match[4],
    minuteStr = match[5],
    secondStr = match[6],
    yearStr = match[7],
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);

/*
 * @private
 */

function parseISODate(s) {
  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
}
function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s) {
  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}
function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
}

var INVALID$2 = "Invalid Duration";

// unit conversion constants
var lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000
    },
    hours: {
      minutes: 60,
      seconds: 60 * 60,
      milliseconds: 60 * 60 * 1000
    },
    minutes: {
      seconds: 60,
      milliseconds: 60 * 1000
    },
    seconds: {
      milliseconds: 1000
    }
  },
  casualMatrix = _extends({
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000
    }
  }, lowOrderMatrix),
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = _extends({
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: daysInYearAccurate * 24 / 4,
      minutes: daysInYearAccurate * 24 * 60 / 4,
      seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
    }
  }, lowOrderMatrix);

// units ordered by size
var orderedUnits$1 = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
var reverseUnits = orderedUnits$1.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear) {
  if (clear === void 0) {
    clear = false;
  }
  // deep merge for vals
  var conf = {
    values: clear ? alts.values : _extends({}, dur.values, alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  var _vals$milliseconds;
  var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
  for (var _iterator = _createForOfIteratorHelperLoose(reverseUnits.slice(1)), _step; !(_step = _iterator()).done;) {
    var unit = _step.value;
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  // the logic below assumes the overall value of the duration is positive
  // if this is not the case, factor is used to make it so
  var factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        var previousVal = vals[previous] * factor;
        var conv = matrix[current][previous];

        // if (previousVal < 0):
        // lower order unit is negative (e.g. { years: 2, days: -2 })
        // normalize this by reducing the higher order unit by the appropriate amount
        // and increasing the lower order unit
        // this can never make the higher order unit negative, because this function only operates
        // on positive durations, so the amount of time represented by the lower order unit cannot
        // be larger than the higher order unit
        // else:
        // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
        // in this case we attempt to convert as much as possible from the lower order unit into
        // the higher order one
        //
        // Math.floor takes care of both of these cases, rounding away from 0
        // if previousVal < 0 it makes the absolute value larger
        // if previousVal >= it makes the absolute value smaller
        var rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);

  // try to convert any decimals into smaller units if possible
  // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
  orderedUnits$1.reduce(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        var fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
  var newVals = {};
  for (var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */
var Duration = /*#__PURE__*/function (_Symbol$for) {
  /**
   * @private
   */
  function Duration(config) {
    var accurate = config.conversionAccuracy === "longterm" || false;
    var matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }

    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.matrix = matrix;
    /**
     * @access private
     */
    this.isLuxonDuration = true;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  Duration.fromMillis = function fromMillis(count, opts) {
    return Duration.fromObject({
      milliseconds: count
    }, opts);
  }

  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */;
  Duration.fromObject = function fromObject(obj, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }

  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */;
  Duration.fromDurationLike = function fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    }
  }

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */;
  Duration.fromISO = function fromISO(text, opts) {
    var _parseISODuration = parseISODuration(text),
      parsed = _parseISODuration[0];
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }

  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */;
  Duration.fromISOTime = function fromISOTime(text, opts) {
    var _parseISOTimeOnly = parseISOTimeOnly(text),
      parsed = _parseISOTimeOnly[0];
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }

  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */;
  Duration.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({
        invalid: invalid
      });
    }
  }

  /**
   * @private
   */;
  Duration.normalizeUnit = function normalizeUnit(unit) {
    var normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }

  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */;
  Duration.isDuration = function isDuration(o) {
    return o && o.isLuxonDuration || false;
  }

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */;
  var _proto = Duration.prototype;
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    var fmtOpts = _extends({}, opts, {
      floor: opts.round !== false && opts.floor !== false
    });
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }

  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */;
  _proto.toHuman = function toHuman(opts) {
    var _this = this;
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid) return INVALID$2;
    var l = orderedUnits$1.map(function (unit) {
      var val = _this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return _this.loc.numberFormatter(_extends({
        style: "unit",
        unitDisplay: "long"
      }, opts, {
        unit: unit.slice(0, -1)
      })).format(val);
    }).filter(function (n) {
      return n;
    });
    return this.loc.listFormatter(_extends({
      type: "conjunction",
      style: opts.listStyle || "narrow"
    }, opts)).format(l);
  }

  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */;
  _proto.toObject = function toObject() {
    if (!this.isValid) return {};
    return _extends({}, this.values);
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */;
  _proto.toISO = function toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;
    var s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */;
  _proto.toISOTime = function toISOTime(opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid) return null;
    var millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;
    opts = _extends({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts, {
      includeOffset: false
    });
    var dateTime = DateTime.fromMillis(millis, {
      zone: "UTC"
    });
    return dateTime.toISOTime(opts);
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */;
  _proto.toJSON = function toJSON() {
    return this.toISO();
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */;
  _proto.toString = function toString() {
    return this.toISO();
  }

  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */;
  _proto[_Symbol$for] = function () {
    if (this.isValid) {
      return "Duration { values: " + JSON.stringify(this.values) + " }";
    } else {
      return "Duration { Invalid, reason: " + this.invalidReason + " }";
    }
  }

  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */;
  _proto.toMillis = function toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }

  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */;
  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */;
  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration),
      result = {};
    for (var _i2 = 0, _orderedUnits = orderedUnits$1; _i2 < _orderedUnits.length; _i2++) {
      var k = _orderedUnits[_i2];
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, {
      values: result
    }, true);
  }

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */;
  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }

  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */;
  _proto.mapUnits = function mapUnits(fn) {
    if (!this.isValid) return this;
    var result = {};
    for (var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++) {
      var k = _Object$keys[_i3];
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, {
      values: result
    }, true);
  }

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */;
  _proto.get = function get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */;
  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var mixed = _extends({}, this.values, normalizeObject(values, Duration.normalizeUnit));
    return clone$1(this, {
      values: mixed
    });
  }

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */;
  _proto.reconfigure = function reconfigure(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      locale = _ref.locale,
      numberingSystem = _ref.numberingSystem,
      conversionAccuracy = _ref.conversionAccuracy,
      matrix = _ref.matrix;
    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem
    });
    var opts = {
      loc: loc,
      matrix: matrix,
      conversionAccuracy: conversionAccuracy
    };
    return clone$1(this, opts);
  }

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */;
  _proto.as = function as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */;
  _proto.normalize = function normalize() {
    if (!this.isValid) return this;
    var vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, {
      values: vals
    }, true);
  }

  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */;
  _proto.rescale = function rescale() {
    if (!this.isValid) return this;
    var vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, {
      values: vals
    }, true);
  }

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */;
  _proto.shiftTo = function shiftTo() {
    for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
      units[_key] = arguments[_key];
    }
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map(function (u) {
      return Duration.normalizeUnit(u);
    });
    var built = {},
      accumulated = {},
      vals = this.toObject();
    var lastUnit;
    for (var _i4 = 0, _orderedUnits2 = orderedUnits$1; _i4 < _orderedUnits2.length; _i4++) {
      var k = _orderedUnits2[_i4];
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        var own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (var ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }

        // plus anything that's already in this unit
        if (isNumber(vals[k])) {
          own += vals[k];
        }

        // only keep the integer part for now in the hopes of putting any decimal part
        // into a smaller unit later
        var i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;

        // otherwise, keep it in the wings to boil it later
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty
    for (var key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$1(this, {
      values: built
    }, true);
  }

  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */;
  _proto.shiftToAll = function shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
  }

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */;
  _proto.negate = function negate() {
    if (!this.isValid) return this;
    var negated = {};
    for (var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++) {
      var k = _Object$keys2[_i5];
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, {
      values: negated
    }, true);
  }

  /**
   * Get the years.
   * @type {number}
   */;
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }
    for (var _i6 = 0, _orderedUnits3 = orderedUnits$1; _i6 < _orderedUnits3.length; _i6++) {
      var u = _orderedUnits3[_i6];
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  };
  _createClass(Duration, [{
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }

    /**
     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
     *
     * @type {string}
     */
  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
  }, {
    key: "years",
    get: function get() {
      return this.isValid ? this.values.years || 0 : NaN;
    }

    /**
     * Get the quarters.
     * @type {number}
     */
  }, {
    key: "quarters",
    get: function get() {
      return this.isValid ? this.values.quarters || 0 : NaN;
    }

    /**
     * Get the months.
     * @type {number}
     */
  }, {
    key: "months",
    get: function get() {
      return this.isValid ? this.values.months || 0 : NaN;
    }

    /**
     * Get the weeks
     * @type {number}
     */
  }, {
    key: "weeks",
    get: function get() {
      return this.isValid ? this.values.weeks || 0 : NaN;
    }

    /**
     * Get the days.
     * @type {number}
     */
  }, {
    key: "days",
    get: function get() {
      return this.isValid ? this.values.days || 0 : NaN;
    }

    /**
     * Get the hours.
     * @type {number}
     */
  }, {
    key: "hours",
    get: function get() {
      return this.isValid ? this.values.hours || 0 : NaN;
    }

    /**
     * Get the minutes.
     * @type {number}
     */
  }, {
    key: "minutes",
    get: function get() {
      return this.isValid ? this.values.minutes || 0 : NaN;
    }

    /**
     * Get the seconds.
     * @return {number}
     */
  }, {
    key: "seconds",
    get: function get() {
      return this.isValid ? this.values.seconds || 0 : NaN;
    }

    /**
     * Get the milliseconds.
     * @return {number}
     */
  }, {
    key: "milliseconds",
    get: function get() {
      return this.isValid ? this.values.milliseconds || 0 : NaN;
    }

    /**
     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
     * on invalid DateTimes or Intervals.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }

    /**
     * Returns an error code if this Duration became invalid, or null if the Duration is valid
     * @return {string}
     */
  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }

    /**
     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);
  return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));

var INVALID$1 = "Invalid Interval";

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
  } else {
    return null;
  }
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */
var Interval = /*#__PURE__*/function (_Symbol$for) {
  /**
   * @private
   */
  function Interval(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.isLuxonInterval = true;
  }

  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  Interval.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({
        invalid: invalid
      });
    }
  }

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */;
  Interval.fromDateTimes = function fromDateTimes(start, end) {
    var builtStart = friendlyDateTime(start),
      builtEnd = friendlyDateTime(end);
    var validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */;
  Interval.after = function after(start, duration) {
    var dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */;
  Interval.before = function before(end, duration) {
    var dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }

  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */;
  Interval.fromISO = function fromISO(text, opts) {
    var _split = (text || "").split("/", 2),
      s = _split[0],
      e = _split[1];
    if (s && e) {
      var start, startIsValid;
      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }
      var end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        var dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        var _dur = Duration.fromISO(s, opts);
        if (_dur.isValid) {
          return Interval.before(end, _dur);
        }
      }
    }
    return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
  }

  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */;
  Interval.isInterval = function isInterval(o) {
    return o && o.isLuxonInterval || false;
  }

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */;
  var _proto = Interval.prototype;
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  _proto.length = function length(unit) {
    if (unit === void 0) {
      unit = "milliseconds";
    }
    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
  }

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */;
  _proto.count = function count(unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }
    if (!this.isValid) return NaN;
    var start = this.start.startOf(unit, opts);
    var end;
    if (opts != null && opts.useLocaleWeeks) {
      end = this.end.reconfigure({
        locale: start.locale
      });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */;
  _proto.hasSame = function hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */;
  _proto.isEmpty = function isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */;
  _proto.isAfter = function isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */;
  _proto.isBefore = function isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */;
  _proto.contains = function contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */;
  _proto.set = function set(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      start = _ref.start,
      end = _ref.end;
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */;
  _proto.splitAt = function splitAt() {
    var _this = this;
    if (!this.isValid) return [];
    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }
    var sorted = dateTimes.map(friendlyDateTime).filter(function (d) {
        return _this.contains(d);
      }).sort(function (a, b) {
        return a.toMillis() - b.toMillis();
      }),
      results = [];
    var s = this.s,
      i = 0;
    while (s < this.e) {
      var added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }
    return results;
  }

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */;
  _proto.splitBy = function splitBy(duration) {
    var dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    var s = this.s,
      idx = 1,
      next;
    var results = [];
    while (s < this.e) {
      var added = this.start.plus(dur.mapUnits(function (x) {
        return x * idx;
      }));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }
    return results;
  }

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */;
  _proto.divideEqually = function divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.overlaps = function overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.abutsStart = function abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.abutsEnd = function abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }

  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.engulfs = function engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */;
  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */;
  _proto.intersection = function intersection(other) {
    if (!this.isValid) return this;
    var s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;
    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */;
  _proto.union = function union(other) {
    if (!this.isValid) return this;
    var s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }

  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */;
  Interval.merge = function merge(intervals) {
    var _intervals$sort$reduc = intervals.sort(function (a, b) {
        return a.s - b.s;
      }).reduce(function (_ref2, item) {
        var sofar = _ref2[0],
          current = _ref2[1];
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      }, [[], null]),
      found = _intervals$sort$reduc[0],
      final = _intervals$sort$reduc[1];
    if (final) {
      found.push(final);
    }
    return found;
  }

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */;
  Interval.xor = function xor(intervals) {
    var _Array$prototype;
    var start = null,
      currentCount = 0;
    var results = [],
      ends = intervals.map(function (i) {
        return [{
          time: i.s,
          type: "s"
        }, {
          time: i.e,
          type: "e"
        }];
      }),
      flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
      arr = flattened.sort(function (a, b) {
        return a.time - b.time;
      });
    for (var _iterator = _createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;) {
      var i = _step.value;
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return Interval.merge(results);
  }

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */;
  _proto.difference = function difference() {
    var _this2 = this;
    for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      intervals[_key2] = arguments[_key2];
    }
    return Interval.xor([this].concat(intervals)).map(function (i) {
      return _this2.intersection(i);
    }).filter(function (i) {
      return i && !i.isEmpty();
    });
  }

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */;
  _proto.toString = function toString() {
    if (!this.isValid) return INVALID$1;
    return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
  }

  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */;
  _proto[_Symbol$for] = function () {
    if (this.isValid) {
      return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
    } else {
      return "Interval { Invalid, reason: " + this.invalidReason + " }";
    }
  }

  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */;
  _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
    if (formatOpts === void 0) {
      formatOpts = DATE_SHORT;
    }
    if (opts === void 0) {
      opts = {};
    }
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */;
  _proto.toISO = function toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISO(opts) + "/" + this.e.toISO(opts);
  }

  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */;
  _proto.toISODate = function toISODate() {
    if (!this.isValid) return INVALID$1;
    return this.s.toISODate() + "/" + this.e.toISODate();
  }

  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */;
  _proto.toISOTime = function toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
  }

  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */;
  _proto.toFormat = function toFormat(dateFormat, _temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
      _ref3$separator = _ref3.separator,
      separator = _ref3$separator === void 0 ? " – " : _ref3$separator;
    if (!this.isValid) return INVALID$1;
    return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
  }

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */;
  _proto.toDuration = function toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }

  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */;
  _proto.mapEndpoints = function mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  };
  _createClass(Interval, [{
    key: "start",
    get: function get() {
      return this.isValid ? this.s : null;
    }

    /**
     * Returns the end of the Interval
     * @type {DateTime}
     */
  }, {
    key: "end",
    get: function get() {
      return this.isValid ? this.e : null;
    }

    /**
     * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
     * @type {boolean}
     */
  }, {
    key: "isValid",
    get: function get() {
      return this.invalidReason === null;
    }

    /**
     * Returns an error code if this Interval is invalid, or null if the Interval is valid
     * @type {string}
     */
  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }

    /**
     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);
  return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */
var Info = /*#__PURE__*/function () {
  function Info() {}
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  Info.hasDST = function hasDST(zone) {
    if (zone === void 0) {
      zone = Settings.defaultZone;
    }
    var proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.isUniversal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */;
  Info.isValidIANAZone = function isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }

  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */;
  Info.normalizeZone = function normalizeZone$1(input) {
    return normalizeZone(input, Settings.defaultZone);
  }

  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */;
  Info.getStartOfWeek = function getStartOfWeek(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? null : _ref$locale,
      _ref$locObj = _ref.locObj,
      locObj = _ref$locObj === void 0 ? null : _ref$locObj;
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }

  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */;
  Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      _ref2$locale = _ref2.locale,
      locale = _ref2$locale === void 0 ? null : _ref2$locale,
      _ref2$locObj = _ref2.locObj,
      locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }

  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */;
  Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
      _ref3$locale = _ref3.locale,
      locale = _ref3$locale === void 0 ? null : _ref3$locale,
      _ref3$locObj = _ref3.locObj,
      locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
    // copy the array, because we cache it internally
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */;
  Info.months = function months(length, _temp4) {
    if (length === void 0) {
      length = "long";
    }
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
      _ref4$locale = _ref4.locale,
      locale = _ref4$locale === void 0 ? null : _ref4$locale,
      _ref4$numberingSystem = _ref4.numberingSystem,
      numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem,
      _ref4$locObj = _ref4.locObj,
      locObj = _ref4$locObj === void 0 ? null : _ref4$locObj,
      _ref4$outputCalendar = _ref4.outputCalendar,
      outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */;
  Info.monthsFormat = function monthsFormat(length, _temp5) {
    if (length === void 0) {
      length = "long";
    }
    var _ref5 = _temp5 === void 0 ? {} : _temp5,
      _ref5$locale = _ref5.locale,
      locale = _ref5$locale === void 0 ? null : _ref5$locale,
      _ref5$numberingSystem = _ref5.numberingSystem,
      numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem,
      _ref5$locObj = _ref5.locObj,
      locObj = _ref5$locObj === void 0 ? null : _ref5$locObj,
      _ref5$outputCalendar = _ref5.outputCalendar,
      outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */;
  Info.weekdays = function weekdays(length, _temp6) {
    if (length === void 0) {
      length = "long";
    }
    var _ref6 = _temp6 === void 0 ? {} : _temp6,
      _ref6$locale = _ref6.locale,
      locale = _ref6$locale === void 0 ? null : _ref6$locale,
      _ref6$numberingSystem = _ref6.numberingSystem,
      numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem,
      _ref6$locObj = _ref6.locObj,
      locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */;
  Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
    if (length === void 0) {
      length = "long";
    }
    var _ref7 = _temp7 === void 0 ? {} : _temp7,
      _ref7$locale = _ref7.locale,
      locale = _ref7$locale === void 0 ? null : _ref7$locale,
      _ref7$numberingSystem = _ref7.numberingSystem,
      numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem,
      _ref7$locObj = _ref7.locObj,
      locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */;
  Info.meridiems = function meridiems(_temp8) {
    var _ref8 = _temp8 === void 0 ? {} : _temp8,
      _ref8$locale = _ref8.locale,
      locale = _ref8$locale === void 0 ? null : _ref8$locale;
    return Locale.create(locale).meridiems();
  }

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */;
  Info.eras = function eras(length, _temp9) {
    if (length === void 0) {
      length = "short";
    }
    var _ref9 = _temp9 === void 0 ? {} : _temp9,
      _ref9$locale = _ref9.locale,
      locale = _ref9$locale === void 0 ? null : _ref9$locale;
    return Locale.create(locale, null, "gregory").eras(length);
  }

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */;
  Info.features = function features() {
    return {
      relative: hasRelative(),
      localeWeek: hasLocaleWeekInfo()
    };
  };
  return Info;
}();

function dayDiff(earlier, later) {
  var utcDayStart = function utcDayStart(dt) {
      return dt.toUTC(0, {
        keepLocalTime: true
      }).startOf("day").valueOf();
    },
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  var differs = [["years", function (a, b) {
    return b.year - a.year;
  }], ["quarters", function (a, b) {
    return b.quarter - a.quarter + (b.year - a.year) * 4;
  }], ["months", function (a, b) {
    return b.month - a.month + (b.year - a.year) * 12;
  }], ["weeks", function (a, b) {
    var days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ["days", dayDiff]];
  var results = {};
  var earlier = cursor;
  var lowestOrder, highWater;

  /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */
  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
    var _differs$_i = _differs[_i],
      unit = _differs$_i[0],
      differ = _differs$_i[1];
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        // we overshot the end point, backtrack cursor by 1
        results[unit]--;
        cursor = earlier.plus(results);

        // if we are still overshooting now, we need to backtrack again
        // this happens in certain situations when diffing times in different zones,
        // because this calculation ignores time zones
        if (cursor > later) {
          // keep the "overshot by 1" around as highWater
          highWater = cursor;
          // backtrack cursor by 1
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function _diff (earlier, later, units, opts) {
  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
    cursor = _highOrderDiffs[0],
    results = _highOrderDiffs[1],
    highWater = _highOrderDiffs[2],
    lowestOrder = _highOrderDiffs[3];
  var remainingMillis = later - cursor;
  var lowerOrderUnits = units.filter(function (u) {
    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
  });
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      var _cursor$plus;
      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  var duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    var _Duration$fromMillis;
    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}

var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  var value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (var key in numberingSystemsUTF16) {
          var _numberingSystemsUTF = numberingSystemsUTF16[key],
            min = _numberingSystemsUTF[0],
            max = _numberingSystemsUTF[1];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
function digitRegex(_ref, append) {
  var numberingSystem = _ref.numberingSystem;
  if (append === void 0) {
    append = "";
  }
  return new RegExp("" + numberingSystems[numberingSystem || "latn"] + append);
}

var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post) {
  if (post === void 0) {
    post = function post(i) {
      return i;
    };
  }
  return {
    regex: regex,
    deser: function deser(_ref) {
      var s = _ref[0];
      return post(parseDigits(s));
    }
  };
}
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = "[ " + NBSP + "]";
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s) {
  return s.replace(/\./g, "") // ignore dots that were made optional
  .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
  .toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: function deser(_ref2) {
        var s = _ref2[0];
        return strings.findIndex(function (i) {
          return stripInsensitivities(s) === stripInsensitivities(i);
        }) + startIndex;
      }
    };
  }
}
function offset(regex, groups) {
  return {
    regex: regex,
    deser: function deser(_ref3) {
      var h = _ref3[1],
        m = _ref3[2];
      return signedOffset(h, m);
    },
    groups: groups
  };
}
function simple(regex) {
  return {
    regex: regex,
    deser: function deser(_ref4) {
      var s = _ref4[0];
      return s;
    }
  };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

/**
 * @param token
 * @param {Locale} loc
 */
function unitForToken(token, loc) {
  var one = digitRegex(loc),
    two = digitRegex(loc, "{2}"),
    three = digitRegex(loc, "{3}"),
    four = digitRegex(loc, "{4}"),
    six = digitRegex(loc, "{6}"),
    oneOrTwo = digitRegex(loc, "{1,2}"),
    oneToThree = digitRegex(loc, "{1,3}"),
    oneToSix = digitRegex(loc, "{1,6}"),
    oneToNine = digitRegex(loc, "{1,9}"),
    twoToFour = digitRegex(loc, "{2,4}"),
    fourToSix = digitRegex(loc, "{4,6}"),
    literal = function literal(t) {
      return {
        regex: RegExp(escapeToken(t.val)),
        deser: function deser(_ref5) {
          var s = _ref5[0];
          return s;
        },
        literal: true
      };
    },
    unitate = function unitate(t) {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        // era
        case "G":
          return oneOf(loc.eras("short"), 0);
        case "GG":
          return oneOf(loc.eras("long"), 0);
        // years
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        // months
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true), 1);
        case "MMMM":
          return oneOf(loc.months("long", true), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false), 1);
        // dates
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        // ordinals
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        // time
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        // meridiem
        case "a":
          return oneOf(loc.meridiems(), 0);
        // weekYear (k)
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, untruncateYear);
        // weekNumber (W)
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        // weekdays
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true), 1);
        // offset/zone
        case "Z":
        case "ZZ":
          return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
        case "ZZZ":
          return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
        // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
        // because we don't have any way to figure out what they are
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        // this special-case "token" represents a place where a macro-token expanded into a white-space literal
        // in this case we accept any non-newline white-space
        case " ":
          return simple(/[^\S\n\r]/);
        default:
          return literal(t);
      }
    };
  var unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  var type = part.type,
    value = part.value;
  if (type === "literal") {
    var isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  var style = formatOpts[type];

  // The user might have explicitly specified hour12 or hourCycle
  // if so, respect their decision
  // if not, refer back to the resolvedOpts, which are based on the locale
  var actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      // tokens only differentiate between 24 hours or not,
      // so we do not need to check hourCycle here, which is less supported anyways
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  var val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val: val
    };
  }
  return undefined;
}
function buildRegex(units) {
  var re = units.map(function (u) {
    return u.regex;
  }).reduce(function (f, r) {
    return f + "(" + r.source + ")";
  }, "");
  return ["^" + re + "$", units];
}
function match(input, regex, handlers) {
  var matches = input.match(regex);
  if (matches) {
    var all = {};
    var matchIndex = 1;
    for (var i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        var h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  var toField = function toField(token) {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  var zone = null;
  var specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  var vals = Object.keys(matches).reduce(function (r, k) {
    var f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [vals, zone, specificOffset];
}
var dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  var formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  var tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(undefined)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  var _Array$prototype;
  return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function (t) {
    return maybeExpandMacroToken(t, locale);
  }));
}

/**
 * @private
 */

function explainFromTokens(locale, input, format) {
  var tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
    units = tokens.map(function (t) {
      return unitForToken(t, locale);
    }),
    disqualifyingUnit = units.find(function (t) {
      return t.invalidReason;
    });
  if (disqualifyingUnit) {
    return {
      input: input,
      tokens: tokens,
      invalidReason: disqualifyingUnit.invalidReason
    };
  } else {
    var _buildRegex = buildRegex(units),
      regexString = _buildRegex[0],
      handlers = _buildRegex[1],
      regex = RegExp(regexString, "i"),
      _match = match(input, regex, handlers),
      rawMatches = _match[0],
      matches = _match[1],
      _ref6 = matches ? dateTimeFromMatches(matches) : [null, null, undefined],
      result = _ref6[0],
      zone = _ref6[1],
      specificOffset = _ref6[2];
    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
    }
    return {
      input: input,
      tokens: tokens,
      regex: regex,
      rawMatches: rawMatches,
      matches: matches,
      result: result,
      zone: zone,
      specificOffset: specificOffset
    };
  }
}
function parseFromTokens(locale, input, format) {
  var _explainFromTokens = explainFromTokens(locale, input, format),
    result = _explainFromTokens.result,
    zone = _explainFromTokens.zone,
    specificOffset = _explainFromTokens.specificOffset,
    invalidReason = _explainFromTokens.invalidReason;
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  var formatter = Formatter.create(locale, formatOpts);
  var df = formatter.dtFormatter(getDummyDateTime());
  var parts = df.formatToParts();
  var resolvedOpts = df.resolvedOptions();
  return parts.map(function (p) {
    return tokenForPart(p, formatOpts, resolvedOpts);
  });
}

var INVALID = "Invalid DateTime";
var MAX_DATE = 8.64e15;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}

// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}

/**
 * @param {DateTime} dt
 */
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
  }
  return dt.localWeekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
  var current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(_extends({}, current, alts, {
    old: current
  }));
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  var o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  var o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;
  var d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  var oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = _extends({}, inst.c, {
      year: year,
      month: month,
      day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }),
    millisToAdd = Duration.fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds
    }).as("milliseconds"),
    localTS = objToLocalTS(c);
  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
    ts = _fixOffset[0],
    o = _fixOffset[1];
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }
  return {
    ts: ts,
    o: o
  };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  var setZone = opts.setZone,
    zone = opts.zone;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    var interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, _extends({}, opts, {
        zone: interpretationZone,
        specificOffset: specificOffset
      }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ) {
  if (allowZ === void 0) {
    allowZ = true;
  }
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ: allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function _toISODate(o, extended) {
  var longFormat = o.c.year > 9999 || o.c.year < 0;
  var c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}
function _toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  var c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }
  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);
    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}

// defaults for unspecified units in the supported calendars
var defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  };

// Units in the supported calendars, sorted by bigness
var orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];

// standardize case and plurality in units
function normalizeUnit(unit) {
  var normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
  var zone = normalizeZone(opts.zone, Settings.defaultZone),
    loc = Locale.fromObject(opts),
    tsNow = Settings.now();
  var ts, o;

  // assume we have the higher-order units
  if (!isUndefined(obj.year)) {
    for (var _i = 0, _orderedUnits = orderedUnits; _i < _orderedUnits.length; _i++) {
      var u = _orderedUnits[_i];
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    var offsetProvis = zone.offset(tsNow);
    var _objToTS = objToTS(obj, offsetProvis, zone);
    ts = _objToTS[0];
    o = _objToTS[1];
  } else {
    ts = tsNow;
  }
  return new DateTime({
    ts: ts,
    zone: zone,
    loc: loc,
    o: o
  });
}
function diffRelative(start, end, opts) {
  var round = isUndefined(opts.round) ? true : opts.round,
    format = function format(c, unit) {
      c = roundTo(c, round || opts.calendary ? 0 : 2, true);
      var formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = function differ(unit) {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (var _iterator = _createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;) {
    var unit = _step.value;
    var count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  var opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */
var DateTime = /*#__PURE__*/function (_Symbol$for) {
  /**
   * @access private
   */
  function DateTime(config) {
    var zone = config.zone || Settings.defaultZone;
    var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    var c = null,
      o = null;
    if (!invalid) {
      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        var _ref = [config.old.c, config.old.o];
        c = _ref[0];
        o = _ref[1];
      } else {
        var ot = zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }

    /**
     * @access private
     */
    this._zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.invalid = invalid;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.localWeekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
    /**
     * @access private
     */
    this.isLuxonDateTime = true;
  }

  // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  DateTime.now = function now() {
    return new DateTime({});
  }

  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */;
  DateTime.local = function local() {
    var _lastOpts = lastOpts(arguments),
      opts = _lastOpts[0],
      args = _lastOpts[1],
      year = args[0],
      month = args[1],
      day = args[2],
      hour = args[3],
      minute = args[4],
      second = args[5],
      millisecond = args[6];
    return quickDT({
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second,
      millisecond: millisecond
    }, opts);
  }

  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */;
  DateTime.utc = function utc() {
    var _lastOpts2 = lastOpts(arguments),
      opts = _lastOpts2[0],
      args = _lastOpts2[1],
      year = args[0],
      month = args[1],
      day = args[2],
      hour = args[3],
      minute = args[4],
      second = args[5],
      millisecond = args[6];
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second,
      millisecond: millisecond
    }, opts);
  }

  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */;
  DateTime.fromJSDate = function fromJSDate(date, options) {
    if (options === void 0) {
      options = {};
    }
    var ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }
    var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }

  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */;
  DateTime.fromMillis = function fromMillis(milliseconds, options) {
    if (options === void 0) {
      options = {};
    }
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }

  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */;
  DateTime.fromSeconds = function fromSeconds(seconds, options) {
    if (options === void 0) {
      options = {};
    }
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }

  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */;
  DateTime.fromObject = function fromObject(obj, opts) {
    if (opts === void 0) {
      opts = {};
    }
    obj = obj || {};
    var zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    var loc = Locale.fromObject(opts);
    var normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    var _usesLocalWeekValues = usesLocalWeekValues(normalized, loc),
      minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek,
      startOfWeek = _usesLocalWeekValues.startOfWeek;
    var tsNow = Settings.now(),
      offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;

    // configure ourselves to deal with gregorian dates or week stuff
    var units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    var foundFirst = false;
    for (var _iterator2 = _createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;) {
      var u = _step2.value;
      var v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
      invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }

    // compute the actual time
    var gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
      _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
      tsFinal = _objToTS2[0],
      offsetFinal = _objToTS2[1],
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc: loc
      });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
    }
    return inst;
  }

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */;
  DateTime.fromISO = function fromISO(text, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _parseISODate = parseISODate(text),
      vals = _parseISODate[0],
      parsedZone = _parseISODate[1];
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */;
  DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _parseRFC2822Date = parseRFC2822Date(text),
      vals = _parseRFC2822Date[0],
      parsedZone = _parseRFC2822Date[1];
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */;
  DateTime.fromHTTP = function fromHTTP(text, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _parseHTTPDate = parseHTTPDate(text),
      vals = _parseHTTPDate[0],
      parsedZone = _parseHTTPDate[1];
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }

  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */;
  DateTime.fromFormat = function fromFormat(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    var _opts = opts,
      _opts$locale = _opts.locale,
      locale = _opts$locale === void 0 ? null : _opts$locale,
      _opts$numberingSystem = _opts.numberingSystem,
      numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
      localeToUse = Locale.fromOpts({
        locale: locale,
        numberingSystem: numberingSystem,
        defaultToEN: true
      }),
      _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
      vals = _parseFromTokens[0],
      parsedZone = _parseFromTokens[1],
      specificOffset = _parseFromTokens[2],
      invalid = _parseFromTokens[3];
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    }
  }

  /**
   * @deprecated use fromFormat instead
   */;
  DateTime.fromString = function fromString(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    return DateTime.fromFormat(text, fmt, opts);
  }

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */;
  DateTime.fromSQL = function fromSQL(text, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _parseSQL = parseSQL(text),
      vals = _parseSQL[0],
      parsedZone = _parseSQL[1];
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }

  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */;
  DateTime.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({
        invalid: invalid
      });
    }
  }

  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */;
  DateTime.isDateTime = function isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }

  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */;
  DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
    if (localeOpts === void 0) {
      localeOpts = {};
    }
    var tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map(function (t) {
      return t ? t.val : null;
    }).join("");
  }

  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */;
  DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
    if (localeOpts === void 0) {
      localeOpts = {};
    }
    var expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map(function (t) {
      return t.val;
    }).join("");
  }

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */;
  var _proto = DateTime.prototype;
  _proto.get = function get(unit) {
    return this[unit];
  }

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */;
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  _proto.getPossibleOffsets = function getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    var dayMs = 86400000;
    var minuteMs = 60000;
    var localTS = objToLocalTS(this.c);
    var oEarlier = this.zone.offset(localTS - dayMs);
    var oLater = this.zone.offset(localTS + dayMs);
    var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    var o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    var ts1 = localTS - o1 * minuteMs;
    var ts2 = localTS - o2 * minuteMs;
    var c1 = tsToObj(ts1, o1);
    var c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [clone(this, {
        ts: ts1
      }), clone(this, {
        ts: ts2
      })];
    }
    return [this];
  }

  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */;
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
    if (opts === void 0) {
      opts = {};
    }
    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
      locale = _Formatter$create$res.locale,
      numberingSystem = _Formatter$create$res.numberingSystem,
      calendar = _Formatter$create$res.calendar;
    return {
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: calendar
    };
  }

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */;
  _proto.toUTC = function toUTC(offset, opts) {
    if (offset === void 0) {
      offset = 0;
    }
    if (opts === void 0) {
      opts = {};
    }
    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */;
  _proto.toLocal = function toLocal() {
    return this.setZone(Settings.defaultZone);
  }

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */;
  _proto.setZone = function setZone(zone, _temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$keepLocalTime = _ref2.keepLocalTime,
      keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime,
      _ref2$keepCalendarTim = _ref2.keepCalendarTime,
      keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      var newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        var offsetGuess = zone.offset(this.ts);
        var asObj = this.toObject();
        var _objToTS3 = objToTS(asObj, offsetGuess, zone);
        newTS = _objToTS3[0];
      }
      return clone(this, {
        ts: newTS,
        zone: zone
      });
    }
  }

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */;
  _proto.reconfigure = function reconfigure(_temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
      locale = _ref3.locale,
      numberingSystem = _ref3.numberingSystem,
      outputCalendar = _ref3.outputCalendar;
    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: outputCalendar
    });
    return clone(this, {
      loc: loc
    });
  }

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */;
  _proto.setLocale = function setLocale(locale) {
    return this.reconfigure({
      locale: locale
    });
  }

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */;
  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    var _usesLocalWeekValues2 = usesLocalWeekValues(normalized, this.loc),
      minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek,
      startOfWeek = _usesLocalWeekValues2.startOfWeek;
    var settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    var mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(_extends({}, gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(_extends({}, gregorianToOrdinal(this.c), normalized));
    } else {
      mixed = _extends({}, this.toObject(), normalized);

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    var _objToTS4 = objToTS(mixed, this.o, this.zone),
      ts = _objToTS4[0],
      o = _objToTS4[1];
    return clone(this, {
      ts: ts,
      o: o
    });
  }

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */;
  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */;
  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */;
  _proto.startOf = function startOf(unit, _temp3) {
    var _ref4 = _temp3 === void 0 ? {} : _temp3,
      _ref4$useLocaleWeeks = _ref4.useLocaleWeeks,
      useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
    if (!this.isValid) return this;
    var o = {},
      normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        var startOfWeek = this.loc.getStartOfWeek();
        var weekday = this.weekday;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      var q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }

  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */;
  _proto.endOf = function endOf(unit, opts) {
    var _this$plus;
    return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
  }

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */;
  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */;
  _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
    if (formatOpts === void 0) {
      formatOpts = DATE_SHORT;
    }
    if (opts === void 0) {
      opts = {};
    }
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }

  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */;
  _proto.toLocaleParts = function toLocaleParts(opts) {
    if (opts === void 0) {
      opts = {};
    }
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */;
  _proto.toISO = function toISO(_temp4) {
    var _ref5 = _temp4 === void 0 ? {} : _temp4,
      _ref5$format = _ref5.format,
      format = _ref5$format === void 0 ? "extended" : _ref5$format,
      _ref5$suppressSeconds = _ref5.suppressSeconds,
      suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds,
      _ref5$suppressMillise = _ref5.suppressMilliseconds,
      suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise,
      _ref5$includeOffset = _ref5.includeOffset,
      includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset,
      _ref5$extendedZone = _ref5.extendedZone,
      extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone;
    if (!this.isValid) {
      return null;
    }
    var ext = format === "extended";
    var c = _toISODate(this, ext);
    c += "T";
    c += _toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */;
  _proto.toISODate = function toISODate(_temp5) {
    var _ref6 = _temp5 === void 0 ? {} : _temp5,
      _ref6$format = _ref6.format,
      format = _ref6$format === void 0 ? "extended" : _ref6$format;
    if (!this.isValid) {
      return null;
    }
    return _toISODate(this, format === "extended");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */;
  _proto.toISOWeekDate = function toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */;
  _proto.toISOTime = function toISOTime(_temp6) {
    var _ref7 = _temp6 === void 0 ? {} : _temp6,
      _ref7$suppressMillise = _ref7.suppressMilliseconds,
      suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise,
      _ref7$suppressSeconds = _ref7.suppressSeconds,
      suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds,
      _ref7$includeOffset = _ref7.includeOffset,
      includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset,
      _ref7$includePrefix = _ref7.includePrefix,
      includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix,
      _ref7$extendedZone = _ref7.extendedZone,
      extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone,
      _ref7$format = _ref7.format,
      format = _ref7$format === void 0 ? "extended" : _ref7$format;
    if (!this.isValid) {
      return null;
    }
    var c = includePrefix ? "T" : "";
    return c + _toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
  }

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */;
  _proto.toRFC2822 = function toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */;
  _proto.toHTTP = function toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */;
  _proto.toSQLDate = function toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return _toISODate(this, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */;
  _proto.toSQLTime = function toSQLTime(_temp7) {
    var _ref8 = _temp7 === void 0 ? {} : _temp7,
      _ref8$includeOffset = _ref8.includeOffset,
      includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset,
      _ref8$includeZone = _ref8.includeZone,
      includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone,
      _ref8$includeOffsetSp = _ref8.includeOffsetSpace,
      includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
    var fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */;
  _proto.toSQL = function toSQL(opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid) {
      return null;
    }
    return this.toSQLDate() + " " + this.toSQLTime(opts);
  }

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */;
  _proto.toString = function toString() {
    return this.isValid ? this.toISO() : INVALID;
  }

  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */;
  _proto[_Symbol$for] = function () {
    if (this.isValid) {
      return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
    } else {
      return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    }
  }

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */;
  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }

  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */;
  _proto.toMillis = function toMillis() {
    return this.isValid ? this.ts : NaN;
  }

  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */;
  _proto.toSeconds = function toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }

  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */;
  _proto.toUnixInteger = function toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1000) : NaN;
  }

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */;
  _proto.toJSON = function toJSON() {
    return this.toISO();
  }

  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */;
  _proto.toBSON = function toBSON() {
    return this.toJSDate();
  }

  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */;
  _proto.toObject = function toObject(opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid) return {};
    var base = _extends({}, this.c);
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }

  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */;
  _proto.toJSDate = function toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */;
  _proto.diff = function diff(otherDateTime, unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }
    if (opts === void 0) {
      opts = {};
    }
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    var durOpts = _extends({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);
    var units = maybeArray(unit).map(Duration.normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = _diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }

  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */;
  _proto.diffNow = function diffNow(unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }
    if (opts === void 0) {
      opts = {};
    }
    return this.diff(DateTime.now(), unit, opts);
  }

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */;
  _proto.until = function until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */;
  _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    var inputMs = otherDateTime.valueOf();
    var adjustedToZone = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }

  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */;
  _proto.equals = function equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }

  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */;
  _proto.toRelative = function toRelative(options) {
    if (options === void 0) {
      options = {};
    }
    if (!this.isValid) return null;
    var base = options.base || DateTime.fromObject({}, {
        zone: this.zone
      }),
      padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    var units = ["years", "months", "days", "hours", "minutes", "seconds"];
    var unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), _extends({}, options, {
      numeric: "always",
      units: units,
      unit: unit
    }));
  }

  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */;
  _proto.toRelativeCalendar = function toRelativeCalendar(options) {
    if (options === void 0) {
      options = {};
    }
    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({}, {
      zone: this.zone
    }), this, _extends({}, options, {
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    }));
  }

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */;
  DateTime.min = function min() {
    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.min);
  }

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */;
  DateTime.max = function max() {
    for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      dateTimes[_key2] = arguments[_key2];
    }
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.max);
  }

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */;
  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      _options$locale = _options.locale,
      locale = _options$locale === void 0 ? null : _options$locale,
      _options$numberingSys = _options.numberingSystem,
      numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
      localeToUse = Locale.fromOpts({
        locale: locale,
        numberingSystem: numberingSystem,
        defaultToEN: true
      });
    return explainFromTokens(localeToUse, text, fmt);
  }

  /**
   * @deprecated use fromFormatExplain instead
   */;
  DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }
    return DateTime.fromFormatExplain(text, fmt, options);
  }

  // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */;
  _createClass(DateTime, [{
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }

    /**
     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
     * @type {string}
     */
  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }

    /**
     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }

    /**
     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }

    /**
     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }

    /**
     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "outputCalendar",
    get: function get() {
      return this.isValid ? this.loc.outputCalendar : null;
    }

    /**
     * Get the time zone associated with this DateTime.
     * @type {Zone}
     */
  }, {
    key: "zone",
    get: function get() {
      return this._zone;
    }

    /**
     * Get the name of the time zone.
     * @type {string}
     */
  }, {
    key: "zoneName",
    get: function get() {
      return this.isValid ? this.zone.name : null;
    }

    /**
     * Get the year
     * @example DateTime.local(2017, 5, 25).year //=> 2017
     * @type {number}
     */
  }, {
    key: "year",
    get: function get() {
      return this.isValid ? this.c.year : NaN;
    }

    /**
     * Get the quarter
     * @example DateTime.local(2017, 5, 25).quarter //=> 2
     * @type {number}
     */
  }, {
    key: "quarter",
    get: function get() {
      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }

    /**
     * Get the month (1-12).
     * @example DateTime.local(2017, 5, 25).month //=> 5
     * @type {number}
     */
  }, {
    key: "month",
    get: function get() {
      return this.isValid ? this.c.month : NaN;
    }

    /**
     * Get the day of the month (1-30ish).
     * @example DateTime.local(2017, 5, 25).day //=> 25
     * @type {number}
     */
  }, {
    key: "day",
    get: function get() {
      return this.isValid ? this.c.day : NaN;
    }

    /**
     * Get the hour of the day (0-23).
     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
     * @type {number}
     */
  }, {
    key: "hour",
    get: function get() {
      return this.isValid ? this.c.hour : NaN;
    }

    /**
     * Get the minute of the hour (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
     * @type {number}
     */
  }, {
    key: "minute",
    get: function get() {
      return this.isValid ? this.c.minute : NaN;
    }

    /**
     * Get the second of the minute (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
     * @type {number}
     */
  }, {
    key: "second",
    get: function get() {
      return this.isValid ? this.c.second : NaN;
    }

    /**
     * Get the millisecond of the second (0-999).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
     * @type {number}
     */
  }, {
    key: "millisecond",
    get: function get() {
      return this.isValid ? this.c.millisecond : NaN;
    }

    /**
     * Get the week year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
     * @type {number}
     */
  }, {
    key: "weekYear",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }

    /**
     * Get the week number of the week year (1-52ish).
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
     * @type {number}
     */
  }, {
    key: "weekNumber",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }

    /**
     * Get the day of the week.
     * 1 is Monday and 7 is Sunday
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekday //=> 4
     * @type {number}
     */
  }, {
    key: "weekday",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }

    /**
     * Returns true if this date is on a weekend according to the locale, false otherwise
     * @returns {boolean}
     */
  }, {
    key: "isWeekend",
    get: function get() {
      return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
    }

    /**
     * Get the day of the week according to the locale.
     * 1 is the first day of the week and 7 is the last day of the week.
     * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
     * @returns {number}
     */
  }, {
    key: "localWeekday",
    get: function get() {
      return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
    }

    /**
     * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
     * because the week can start on different days of the week (see localWeekday) and because a different number of days
     * is required for a week to count as the first week of a year.
     * @returns {number}
     */
  }, {
    key: "localWeekNumber",
    get: function get() {
      return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
    }

    /**
     * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
     * differently, see localWeekNumber.
     * @returns {number}
     */
  }, {
    key: "localWeekYear",
    get: function get() {
      return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
    }

    /**
     * Get the ordinal (meaning the day of the year)
     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
     * @type {number|DateTime}
     */
  }, {
    key: "ordinal",
    get: function get() {
      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }

    /**
     * Get the human readable short month name, such as 'Oct'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
     * @type {string}
     */
  }, {
    key: "monthShort",
    get: function get() {
      return this.isValid ? Info.months("short", {
        locObj: this.loc
      })[this.month - 1] : null;
    }

    /**
     * Get the human readable long month name, such as 'October'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthLong //=> October
     * @type {string}
     */
  }, {
    key: "monthLong",
    get: function get() {
      return this.isValid ? Info.months("long", {
        locObj: this.loc
      })[this.month - 1] : null;
    }

    /**
     * Get the human readable short weekday, such as 'Mon'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
     * @type {string}
     */
  }, {
    key: "weekdayShort",
    get: function get() {
      return this.isValid ? Info.weekdays("short", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }

    /**
     * Get the human readable long weekday, such as 'Monday'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
     * @type {string}
     */
  }, {
    key: "weekdayLong",
    get: function get() {
      return this.isValid ? Info.weekdays("long", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }

    /**
     * Get the UTC offset of this DateTime in minutes
     * @example DateTime.now().offset //=> -240
     * @example DateTime.utc().offset //=> 0
     * @type {number}
     */
  }, {
    key: "offset",
    get: function get() {
      return this.isValid ? +this.o : NaN;
    }

    /**
     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */
  }, {
    key: "offsetNameShort",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "short",
          locale: this.locale
        });
      } else {
        return null;
      }
    }

    /**
     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */
  }, {
    key: "offsetNameLong",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "long",
          locale: this.locale
        });
      } else {
        return null;
      }
    }

    /**
     * Get whether this zone's offset ever changes, as in a DST.
     * @type {boolean}
     */
  }, {
    key: "isOffsetFixed",
    get: function get() {
      return this.isValid ? this.zone.isUniversal : null;
    }

    /**
     * Get whether the DateTime is in a DST.
     * @type {boolean}
     */
  }, {
    key: "isInDST",
    get: function get() {
      if (this.isOffsetFixed) {
        return false;
      } else {
        return this.offset > this.set({
          month: 1,
          day: 1
        }).offset || this.offset > this.set({
          month: 5
        }).offset;
      }
    }
  }, {
    key: "isInLeapYear",
    get: function get() {
      return isLeapYear(this.year);
    }

    /**
     * Returns the number of days in this DateTime's month
     * @example DateTime.local(2016, 2).daysInMonth //=> 29
     * @example DateTime.local(2016, 3).daysInMonth //=> 31
     * @type {number}
     */
  }, {
    key: "daysInMonth",
    get: function get() {
      return daysInMonth(this.year, this.month);
    }

    /**
     * Returns the number of days in this DateTime's year
     * @example DateTime.local(2016).daysInYear //=> 366
     * @example DateTime.local(2013).daysInYear //=> 365
     * @type {number}
     */
  }, {
    key: "daysInYear",
    get: function get() {
      return this.isValid ? daysInYear(this.year) : NaN;
    }

    /**
     * Returns the number of weeks in this DateTime's year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2004).weeksInWeekYear //=> 53
     * @example DateTime.local(2013).weeksInWeekYear //=> 52
     * @type {number}
     */
  }, {
    key: "weeksInWeekYear",
    get: function get() {
      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }

    /**
     * Returns the number of weeks in this DateTime's local week year
     * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
     * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
     * @type {number}
     */
  }, {
    key: "weeksInLocalWeekYear",
    get: function get() {
      return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
    }
  }], [{
    key: "DATE_SHORT",
    get: function get() {
      return DATE_SHORT;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_MED",
    get: function get() {
      return DATE_MED;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_MED_WITH_WEEKDAY",
    get: function get() {
      return DATE_MED_WITH_WEEKDAY;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_FULL",
    get: function get() {
      return DATE_FULL;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_HUGE",
    get: function get() {
      return DATE_HUGE;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_SIMPLE",
    get: function get() {
      return TIME_SIMPLE;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_SECONDS",
    get: function get() {
      return TIME_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_WITH_SHORT_OFFSET;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_WITH_LONG_OFFSET;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_SIMPLE",
    get: function get() {
      return TIME_24_SIMPLE;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_SECONDS",
    get: function get() {
      return TIME_24_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_24_WITH_SHORT_OFFSET;
    }

    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_24_WITH_LONG_OFFSET;
    }

    /**
     * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_SHORT",
    get: function get() {
      return DATETIME_SHORT;
    }

    /**
     * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_SHORT_WITH_SECONDS",
    get: function get() {
      return DATETIME_SHORT_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED",
    get: function get() {
      return DATETIME_MED;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED_WITH_SECONDS",
    get: function get() {
      return DATETIME_MED_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED_WITH_WEEKDAY",
    get: function get() {
      return DATETIME_MED_WITH_WEEKDAY;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_FULL",
    get: function get() {
      return DATETIME_FULL;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_FULL_WITH_SECONDS",
    get: function get() {
      return DATETIME_FULL_WITH_SECONDS;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_HUGE",
    get: function get() {
      return DATETIME_HUGE;
    }

    /**
     * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_HUGE_WITH_SECONDS",
    get: function get() {
      return DATETIME_HUGE_WITH_SECONDS;
    }
  }]);
  return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
  }
}

var VERSION = "3.4.4";

exports.DateTime = DateTime;
exports.Duration = Duration;
exports.FixedOffsetZone = FixedOffsetZone;
exports.IANAZone = IANAZone;
exports.Info = Info;
exports.Interval = Interval;
exports.InvalidZone = InvalidZone;
exports.Settings = Settings;
exports.SystemZone = SystemZone;
exports.VERSION = VERSION;
exports.Zone = Zone;
//# sourceMappingURL=luxon.js.map
});

const rangeDatepickerCellCss = ":host{display:block}div{font-size:14px;line-height:20px;width:100%;height:30px;margin:0;padding:0;color:var(--range-datepicker-date-text-color);display:flex;flex-direction:row;align-items:center;justify-content:center}@media only screen and (max-width: 480.98px){div{height:44px;font-size:16px}}div:not(.disabled):hover,div:not(.disabled):focus{background-color:var(--range-datepicker-hover-background);cursor:pointer}div:not(.disabled):focus{outline:2px solid var(--range-datepicker-date-selected-focus-border);outline-offset:-4px}div.selected:not(.disabled):focus{outline:2px solid var(--range-datepicker-date-selected-text);outline-offset:-4px}div.hovered{background-color:var(--range-datepicker-to-date-background) !important;color:var(--range-datepicker-to-date-text)}div.hoveredRange{background-color:var(--range-datepicker-date-range-hover-background) !important;color:var(--range-datepicker-date-range-hover-text)}div.selected{background-color:var(--range-datepicker-date-selected-background) !important;color:var(--range-datepicker-date-selected-text)}div.disabled{color:var(--range-datepicker-disabled-date-text);background-color:var(--range-datepicker-disabled-date-background)}";

const RangeDatepickerCell = /*@__PURE__*/ proxyCustomElement(class RangeDatepickerCell extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dateSelected = createEvent(this, "date-is-selected", 7);
        this.dateHovered = createEvent(this, "date-is-hovered", 7);
        /**
         * Emit selected event upon tap/click/enter
         */
        this._handleTap = () => {
            if (!this._disabled) {
                this.dateSelected.emit({ date: this.day.date });
            }
        };
        /**
         * Emit hovered event upon hover
         */
        this._handleHover = () => {
            this.dateHovered.emit({ date: this.day.date });
        };
        /**
         * Selects a date if enter or space is pressed
         */
        this._selectDayIfValidKeyPressed = (event) => {
            const { keyCode, } = event;
            const key = keyCode;
            switch (key) {
                case 13: // enter key
                case 32: // space key
                    this._handleTap();
                    break;
            }
        };
        this.day = undefined;
        this._selected = false;
        this._hovered = false;
        this._hoveredRange = false;
        this.dateTo = undefined;
        this.dateFrom = undefined;
        this.month = undefined;
        this.hoveredDate = undefined;
        this.min = undefined;
        this.max = undefined;
        this.range = undefined;
        this._disabled = false;
    }
    dayHandler(newDay) {
        this._dateChanged(this.dateFrom, this.dateTo, this.hoveredDate, newDay);
    }
    dateToHandler(newDateTo) {
        this._dateChanged(this.dateFrom, newDateTo, this.hoveredDate, this.day);
    }
    dateFromHandler(newDateFrom) {
        this._dateChanged(newDateFrom, this.dateTo, this.hoveredDate, this.day);
    }
    hoverHandler(newHover) {
        this._dateChanged(this.dateFrom, this.dateTo, newHover, this.day);
    }
    /**
     * Method to handle changes in dateFrom, dateTo, hoveredDate, and day
     * Reflects changes in _selected, _hovered, and _disabled
     * @param dateFrom
     * @param dateTo
     * @param hoveredDate
     * @param day
     */
    _dateChanged(dateFrom, dateTo, hoveredDate, day) {
        this._selected = false;
        this._hovered = false;
        this._disabled = false;
        this._hoveredRange = false;
        const parsedDateFrom = parseInt(dateFrom, 10);
        const parsedDateTo = parseInt(dateTo, 10);
        if (day) {
            if (parsedDateTo === day.date || parsedDateFrom === day.date) {
                this._selected = true;
            }
            if (((hoveredDate === day.date) &&
                !isNaN(parsedDateFrom) &&
                isNaN(parsedDateTo) &&
                (!isNaN(this.max) ? (day.date <= this.max) : true) &&
                (!isNaN(this.range) ? (day.date <= this.range) : true) &&
                parsedDateFrom !== undefined &&
                !this._selected)) {
                this._hovered = true;
            }
            if (((day.date > parsedDateFrom && day.date < hoveredDate) &&
                !isNaN(parsedDateFrom) &&
                isNaN(parsedDateTo) &&
                (!isNaN(this.max) ? (day.date <= this.max) : true) &&
                (!isNaN(this.range) ? (day.date <= this.range) : true) &&
                parsedDateFrom !== undefined &&
                !this._selected)) {
                this._hoveredRange = true;
            }
            if (day.date > parsedDateFrom && day.date < parsedDateTo) {
                this._selected = true;
            }
            if (day.date && day.date < this.min || day.date > this.max) {
                this._disabled = true;
            }
            if (this.range && (day.date > this.range)) {
                this._disabled = true;
            }
        }
    }
    /**
     * Applies 'selected' class if needed
     * @param selected
     * @returns 'selected' or ''
     */
    _isSelected(selected) {
        if (selected) {
            return 'selected';
        }
        return '';
    }
    /**
     * Applies 'hovered' class if needed
     */
    _isHovered(hovered) {
        return hovered ? 'hovered' : '';
    }
    /**
     * Applies 'hovered' class if needed
     */
    _isHoveredRange(hoveredRange) {
        return hoveredRange ? 'hoveredRange' : '';
    }
    /**
     * Applies 'enabled' class if needed
     */
    _isEnabled(day, min, max) {
        if (day && day.date) {
            if (day.date < min || day.date > max || (this.range && day.date > this.range)) {
                return 'disabled';
            }
        }
        return '';
    }
    /**
     * Calcculates tab index based on if the cell should be disabled
     */
    _getTabIndex(day, min, max) {
        return day && day.date && (day.date < min || day.date > max) ? -1 : 1;
    }
    /**
     * Before component load, calculate _selected, _hovered, and _disabled based
     * on current day.
     */
    componentWillLoad() {
        this.dayHandler(this.day);
    }
    /**
     * Provides String of cell date in ISO format for accessibility.
     * @returns aria label for seconds
     */
    _computeAriaLabel() {
        return luxon.DateTime.fromSeconds(this.day.date).toISO();
    }
    render() {
        return (h("div", { "on-click": this._handleTap, "on-mouseover": this._handleHover, tabindex: this._getTabIndex(this.day, this.min, this.max), class: this._isSelected(this._selected) + " " + this._isHovered(this._hovered) + " " + this._isHoveredRange(this._hoveredRange) + " " + this._isEnabled(this.day, this.min, this.max), "on-keydown": this._selectDayIfValidKeyPressed, "data-day": this.day.date, "data-day-number": this.day.title, "aria-label": this._computeAriaLabel() }, this.day && this.day.title));
    }
    static get watchers() { return {
        "day": ["dayHandler"],
        "dateTo": ["dateToHandler"],
        "dateFrom": ["dateFromHandler"],
        "hoveredDate": ["hoverHandler"]
    }; }
    static get style() { return rangeDatepickerCellCss; }
}, [1, "range-datepicker-cell", {
        "day": [520],
        "_selected": [1028],
        "_hovered": [1028],
        "_hoveredRange": [1028, "_hovered-range"],
        "dateTo": [2, "date-to"],
        "dateFrom": [2, "date-from"],
        "month": [1],
        "hoveredDate": [2, "hovered-date"],
        "min": [2],
        "max": [2],
        "range": [2],
        "_disabled": [1028]
    }, undefined, {
        "day": ["dayHandler"],
        "dateTo": ["dateToHandler"],
        "dateFrom": ["dateFromHandler"],
        "hoveredDate": ["hoverHandler"]
    }]);
function defineCustomElement$3() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["range-datepicker-cell"];
    components.forEach(tagName => { switch (tagName) {
        case "range-datepicker-cell":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RangeDatepickerCell);
            }
            break;
    } });
}
defineCustomElement$3();

const Formats = {
    fullDate: "MM/dd/yyyy",
    month: "MM",
    year: "yyyy",
    day: "dd",
    seconds: "X",
    monthName: "MMMM",
};

function weekStart(region, language) {
    const regionSat = 'AEAFBHDJDZEGIQIRJOKWLYOMQASDSY'.match(/../g);
    const regionSun = 'AGARASAUBDBRBSBTBWBZCACNCODMDOETGTGUHKHNIDILINJMJPKEKHKRLAMHMMMOMTMXMZNINPPAPEPHPKPRPTPYSASGSVTHTTTWUMUSVEVIWSYEZAZW'.match(/../g);
    const languageSat = ['ar', 'arq', 'arz', 'fa'];
    const languageSun = 'amasbndzengnguhehiidjajvkmknkolomhmlmrmtmyneomorpapssdsmsnsutatethtnurzhzu'.match(/../g);
    return (region ? (regionSun.includes(region) ? 6 :
        regionSat.includes(region) ? 5 : 0) : (languageSun.includes(language) ? 6 :
        languageSat.includes(language) ? 5 : 0));
}
function weekStartLocale(locale) {
    const parts = locale.match(/^([a-z]{2,3})(?:-([a-z]{3})(?=$|-))?(?:-([a-z]{4})(?=$|-))?(?:-([a-z]{2}|\d{3})(?=$|-))?/i);
    return weekStart(parts[4], parts[1]);
}

const rangeDatepickerCalendarCss = ":host{--icon-font-family:var(--icon-font-family-theme, \"pepmdx\")}.di{font-family:var(--icon-font-family, \"pepmdx\") !important;font-style:normal;font-size:inherit}.di50{font-size:50px}.di40{font-size:40px}.di36{font-size:36px}.di28{font-size:28px}.di24{font-size:24px}.di20{font-size:20px}.di18{font-size:18px}.di16{font-size:16px}.di14{font-size:14px}.di12{font-size:12px}.di10{font-size:10px}.di-disney-resort::before,.di-E001::before{content:\"\\e001\"}.di-california-adventure::before,.di-E002::before{content:\"\\e002\"}.di-disney-paris::before,.di-E003::before{content:\"\\e003\"}.di-shanghai-disney-resort::before,.di-E004::before{content:\"\\e004\"}.di-hong-kong-disney::before,.di-E005::before{content:\"\\e005\"}.di-tokyo-disney::before,.di-E006::before{content:\"\\e006\"}.di-aulani-resort-hawaii::before,.di-E007::before{content:\"\\e007\"}.di-adventure-by-disney::before,.di-E008::before{content:\"\\e008\"}.di-disney-park-generic-castle::before,.di-E009::before{content:\"\\e009\"}.di-leadership::before,.di-E00A::before{content:\"\\e00a\"}.di-selection-training::before,.di-E00B::before{content:\"\\e00b\"}.di-quality-service::before,.di-E00C::before{content:\"\\e00c\"}.di-brand-royalty::before,.di-E00D::before{content:\"\\e00d\"}.di-creativity-innovate::before,.di-E00E::before{content:\"\\e00e\"}.di-business-excellence::before,.di-E00F::before{content:\"\\e00f\"}.di-medical-excellence::before,.di-E010::before{content:\"\\e010\"}.di-catalogs::before,.di-E011::before{content:\"\\e011\"}.di-disney-park::before,.di-E012::before{content:\"\\e012\"}.di-disneyland-resort::before,.di-E013::before{content:\"\\e013\"}.di-city-hall-services::before,.di-E014::before{content:\"\\e014\"}.di-hkdl-magic-access::before,.di-E015::before{content:\"\\e015\"}.di-downtown-disney::before,.di-E016::before{content:\"\\e016\"}.di-wedding-engagements::before,.di-E017::before{content:\"\\e017\"}.di-weddings-ever-after-blog::before,.di-E018::before{content:\"\\e018\"}.di-weddings-bridal-boutique::before,.di-E019::before{content:\"\\e019\"}.di-shdr-disneytown::before,.di-E01A::before{content:\"\\e01a\"}.di-shdr-wishing-star-park::before,.di-E01B::before{content:\"\\e01b\"}.di-shop-disney-parks-app::before,.di-E01C::before{content:\"\\e01c\"}.di-shop-disney-parks-bag::before,.di-E01D::before{content:\"\\e01d\"}.di-shop-disney-bag::before,.di-E01E::before{content:\"\\e01e\"}.di-style-guide::before,.di-E020::before{content:\"\\e020\"}.di-star-wars::before,.di-E021::before{content:\"\\e021\"}.di-sw-galaxys-edge-hub::before,.di-E022::before{content:\"\\e022\"}.di-rundisney-medals::before,.di-E023::before{content:\"\\e023\"}.di-rundisney-shirts::before,.di-E024::before{content:\"\\e024\"}.di-rundisney-snacks::before,.di-E025::before{content:\"\\e025\"}.di-disneyland-calender::before,.di-E026::before{content:\"\\e026\"}.di-california-adventure-calender::before,.di-E027::before{content:\"\\e027\"}.di-genie-product::before,.di-E028::before{content:\"\\e028\"}.di-all-parks-and-resorts::before,.di-E040::before{content:\"\\e040\"}.di-magic-kingdom::before,.di-E041::before{content:\"\\e041\"}.di-epcot::before,.di-E042::before{content:\"\\e042\"}.di-animal-kingdom::before,.di-E043::before{content:\"\\e043\"}.di-hollywood-studios::before,.di-E044::before{content:\"\\e044\"}.di-typhoon-lagoon::before,.di-E045::before{content:\"\\e045\"}.di-blizzard-beach::before,.di-E046::before{content:\"\\e046\"}.di-disney-springs::before,.di-E047::before{content:\"\\e047\"}.di-espn-wide-world-sports::before,.di-E048::before{content:\"\\e048\"}.di-resorts::before,.di-E049::before{content:\"\\e049\"}.di-disney-beach-resorts::before,.di-E04A::before{content:\"\\e04a\"}.di-disney-boardwalk::before,.di-E04B::before{content:\"\\e04b\"}.di-all-categories::before,.di-E04C::before{content:\"\\e04c\"}.di-cirque-du-soleil-la-nouba::before,.di-E04D::before{content:\"\\e04d\"}.di-star-wars-galactic-starcruiser::before,.di-E04E::before{content:\"\\e04e\"}.di-disney-cruise-line::before,.di-E080::before{content:\"\\e080\"}.di-dcl-our-ships::before,.di-E081::before{content:\"\\e081\"}.di-dcl-destinations::before,.di-E082::before{content:\"\\e082\"}.di-dcl-onboard-fun::before,.di-E083::before{content:\"\\e083\"}.di-dcl-new-cruisers::before,.di-E084::before{content:\"\\e084\"}.di-dcl-port-adventures::before,.di-E085::before{content:\"\\e085\"}.di-app-instructions::before,.di-E086::before{content:\"\\e086\"}.di-featured-article::before,.di-E087::before{content:\"\\e087\"}.di-drink-of-the-day::before,.di-E088::before{content:\"\\e088\"}.di-view-folio::before,.di-E08A::before{content:\"\\e08a\"}.di-key-to-the-world::before,.di-E08B::before{content:\"\\e08b\"}.di-in-room-entertainment::before,.di-E08C::before{content:\"\\e08c\"}.di-ship-directory::before,.di-E08D::before{content:\"\\e08d\"}.di-theatre::before,.di-E08E::before{content:\"\\e08e\"}.di-disembarkation::before,.di-E08F::before{content:\"\\e08f\"}.di-wash-hands::before,.di-E094::before{content:\"\\e094\"}.di-security-notice::before,.di-E095::before{content:\"\\e095\"}.di-environmental-message::before,.di-E096::before{content:\"\\e096\"}.di-room-upgrade::before,.di-E098::before{content:\"\\e098\"}.di-castaway-club-member::before,.di-E09A::before{content:\"\\e09a\"}.di-dcl-open-house::before,.di-E09B::before{content:\"\\e09b\"}.di-stateroom-balcony::before,.di-E09F::before{content:\"\\e09f\"}.di-cart-empty::before,.di-E0C0::before{content:\"\\e0c0\"}.di-cart-full::before,.di-E0C1::before{content:\"\\e0c1\"}.di-tickets::before,.di-E0C2::before{content:\"\\e0c2\"}.di-fastpass-plus::before,.di-E0C3::before{content:\"\\e0c3\"}.di-fastpasses-set::before,.di-E0C4::before{content:\"\\e0c4\"}.di-fastpasses-copy-set::before,.di-E0C5::before{content:\"\\e0c5\"}.di-cancel-fastpasses::before,.di-E0C6::before{content:\"\\e0c6\"}.di-water-park::before,.di-E0C7::before{content:\"\\e0c7\"}.di-vacation-packages::before,.di-E0C8::before{content:\"\\e0c8\"}.di-personal-magic::before,.di-E0C9::before{content:\"\\e0c9\"}.di-florida-resident::before,.di-E0CA::before{content:\"\\e0ca\"}.di-disney-vacation-club-info::before,.di-E0CB::before{content:\"\\e0cb\"}.di-annual-passholder::before,.di-E0CC::before{content:\"\\e0cc\"}.di-us-military::before,.di-E0CD::before{content:\"\\e0cd\"}.di-special-offers-dollar-sign::before,.di-E0CE::before{content:\"\\e0ce\"}.di-booking-rooms-packages::before,.di-E0CF::before{content:\"\\e0cf\"}.di-old-fastpass::before,.di-E0D0::before{content:\"\\e0d0\"}.di-certificate::before,.di-E0D1::before{content:\"\\e0d1\"}.di-will-call-tickets::before,.di-E0D2::before{content:\"\\e0d2\"}.di-entrance-pass::before,.di-E0D3::before{content:\"\\e0d3\"}.di-guest-pass::before,.di-E0D4::before{content:\"\\e0d4\"}.di-city-pass::before,.di-E0D5::before{content:\"\\e0d5\"}.di-california::before,.di-E0D6::before{content:\"\\e0d6\"}.di-southern-california::before,.di-E0D7::before{content:\"\\e0d7\"}.di-etickets::before,.di-E0D8::before{content:\"\\e0d8\"}.di-compare-offers::before,.di-E0D9::before{content:\"\\e0d9\"}.di-baja-california-resident::before,.di-E0DA::before{content:\"\\e0da\"}.di-area-attractions::before,.di-E0DB::before{content:\"\\e0db\"}.di-anaheim-resort-transit::before,.di-E0DC::before{content:\"\\e0dc\"}.di-edit-fastpass::before,.di-E0DD::before{content:\"\\e0dd\"}.di-in-park-merchandise::before,.di-E0E0::before{content:\"\\e0e0\"}.di-travel-insurance::before,.di-E0E1::before{content:\"\\e0e1\"}.di-texas-resident::before,.di-E0E2::before{content:\"\\e0e2\"}.di-canadian-resident::before,.di-E0E3::before{content:\"\\e0e3\"}.di-add-tickets::before,.di-E0E4::before{content:\"\\e0e4\"}.di-splurge::before,.di-E0E5::before{content:\"\\e0e5\"}.di-disneyland-annual-passes::before,.di-E0E6::before{content:\"\\e0e6\"}.di-dlr-tickets-passes::before,.di-E0E7::before{content:\"\\e0e7\"}.di-get-vacation-offer-recommended::before,.di-E0E8::before{content:\"\\e0e8\"}.di-get-vacation-offer-guest-created::before,.di-E0E9::before{content:\"\\e0e9\"}.di-shdr-fastpass::before,.di-E0EA::before{content:\"\\e0ea\"}.di-currency-convertor::before,.di-E0EB::before{content:\"\\e0eb\"}.di-call-to-buy-tickets::before,.di-E0EC::before{content:\"\\e0ec\"}.di-wdw-tickets-and-passes::before,.di-E0ED::before{content:\"\\e0ed\"}.di-renew-annual-pass::before,.di-E0EE::before{content:\"\\e0ee\"}.di-renew-annual-pass-dlr::before,.di-E0EF::before{content:\"\\e0ef\"}.di-annual-pass-wdw::before,.di-E0F0::before{content:\"\\e0f0\"}.di-mobile-order::before,.di-E0F1::before{content:\"\\e0f1\"}.di-fastpass::before,.di-E0F2::before{content:\"\\e0f2\"}.di-ticket-ap-upgrade::before,.di-E0F3::before{content:\"\\e0f3\"}.di-shdr-premium-access::before,.di-E0F4::before{content:\"\\e0f4\"}.di-shdr-tickets-and-passes::before,.di-E0F5::before{content:\"\\e0f5\"}.di-shdr-seasonal-pass::before,.di-E0F6::before{content:\"\\e0f6\"}.di-shdr-fastpass-reverse::before,.di-E0F7::before{content:\"\\e0f7\"}.di-disney-maxpass::before,.di-E0F8::before{content:\"\\e0f8\"}.di-shdr-premium-access-chinese::before,.di-E0F9::before{content:\"\\e0f9\"}.di-hawaii-resident::before,.di-E0FA::before{content:\"\\e0fa\"}.di-club-33-membership::before,.di-E0FB::before{content:\"\\e0fb\"}.di-order-grocery-delivery::before,.di-E0FC::before{content:\"\\e0fc\"}.di-special-offers::before,.di-E0FD::before{content:\"\\e0fd\"}.di-prebook-fastpass::before,.di-E0FE::before{content:\"\\e0fe\"}.di-upgrade-offer::before,.di-E0FF::before{content:\"\\e0ff\"}.di-mdx::before,.di-E100::before{content:\"\\e100\"}.di-about-me::before,.di-E101::before{content:\"\\e101\"}.di-friends-family::before,.di-E102::before{content:\"\\e102\"}.di-account-settings::before,.di-E103::before{content:\"\\e103\"}.di-magicbands-v2::before,.di-E104::before{content:\"\\e104\"}.di-magic-cards::before,.di-E105::before{content:\"\\e105\"}.di-pin-payment-methods::before,.di-E106::before{content:\"\\e106\"}.di-communication-references::before,.di-E107::before{content:\"\\e107\"}.di-wishlist::before,.di-E108::before{content:\"\\e108\"}.di-link-existing-reservation::before,.di-E109::before{content:\"\\e109\"}.di-guest-entered-schedule-item::before,.di-E10A::before{content:\"\\e10a\"}.di-birthday::before,.di-E10B::before{content:\"\\e10b\"}.di-memory-maker::before,.di-E10C::before{content:\"\\e10c\"}.di-memory-maker-2::before,.di-E10D::before{content:\"\\e10d\"}.di-passes-and-memberships::before,.di-E10E::before{content:\"\\e10e\"}.di-link-mdx-tickets-passes::before,.di-E10F::before{content:\"\\e10f\"}.di-link-mdx-resort-reservations::before,.di-E110::before{content:\"\\e110\"}.di-link-mdx-dining-reservations::before,.di-E111::before{content:\"\\e111\"}.di-link-dlr-tickets::before,.di-E112::before{content:\"\\e112\"}.di-link-main-entrance::before,.di-E113::before{content:\"\\e113\"}.di-digital-key::before,.di-E115::before{content:\"\\e115\"}.di-wishlist-item-added::before,.di-E116::before{content:\"\\e116\"}.di-wishlist-empty::before,.di-E117::before{content:\"\\e117\"}.di-magicbands-original::before,.di-E118::before{content:\"\\e118\"}.di-all-activities::before,.di-E140::before{content:\"\\e140\"}.di-attractions::before,.di-E141::before{content:\"\\e141\"}.di-characters::before,.di-E142::before{content:\"\\e142\"}.di-entertainment::before,.di-E143::before{content:\"\\e143\"}.di-tours-events::before,.di-E144::before{content:\"\\e144\"}.di-in-park-shopping::before,.di-E145::before{content:\"\\e145\"}.di-spas::before,.di-E146::before{content:\"\\e146\"}.di-tour::before,.di-E14C::before{content:\"\\e14c\"}.di-spring-break::before,.di-E14D::before{content:\"\\e14d\"}.di-fireworks::before,.di-E14E::before{content:\"\\e14e\"}.di-shows::before,.di-E14F::before{content:\"\\e14f\"}.di-dining::before,.di-E180::before{content:\"\\e180\"}.di-dining-plan::before,.di-E181::before{content:\"\\e181\"}.di-dining-plan-accepted::before,.di-E182::before{content:\"\\e182\"}.di-dining-plan-not-accepted::before,.di-E183::before{content:\"\\e183\"}.di-dining-reservation::before,.di-E184::before{content:\"\\e184\"}.di-menu::before,.di-E185::before{content:\"\\e185\"}.di-prix-fixe-qsr::before,.di-E186::before{content:\"\\e186\"}.di-prix-fixe-tsr::before,.di-E187::before{content:\"\\e187\"}.di-entrees-qsr::before,.di-E188::before{content:\"\\e188\"}.di-entrees-tsr::before,.di-E189::before{content:\"\\e189\"}.di-beverages::before,.di-E18A::before{content:\"\\e18a\"}.di-wine::before,.di-E18B::before{content:\"\\e18b\"}.di-beer::before,.di-E18C::before{content:\"\\e18c\"}.di-cocktails::before,.di-E18D::before{content:\"\\e18d\"}.di-appetizers::before,.di-E18E::before{content:\"\\e18e\"}.di-sandwiches::before,.di-E18F::before{content:\"\\e18f\"}.di-beef-pork-chicken::before,.di-E190::before{content:\"\\e190\"}.di-seafood::before,.di-E191::before{content:\"\\e191\"}.di-pasta::before,.di-E192::before{content:\"\\e192\"}.di-salads::before,.di-E193::before{content:\"\\e193\"}.di-sides::before,.di-E194::before{content:\"\\e194\"}.di-desserts::before,.di-E195::before{content:\"\\e195\"}.di-buffet::before,.di-E196::before{content:\"\\e196\"}.di-favorites::before,.di-E197::before{content:\"\\e197\"}.di-kids-picks::before,.di-E198::before{content:\"\\e198\"}.di-featured-items::before,.di-E199::before{content:\"\\e199\"}.di-nutritional-content::before,.di-E19A::before{content:\"\\e19a\"}.di-nutritional-information::before,.di-E19B::before{content:\"\\e19b\"}.di-gluten-free::before,.di-E19C::before{content:\"\\e19c\"}.di-dairy-free::before,.di-E19D::before{content:\"\\e19d\"}.di-character-dining::before,.di-E19E::before{content:\"\\e19e\"}.di-mockey-food-seal::before,.di-E19F::before{content:\"\\e19f\"}.di-priority-seating::before,.di-E1A1::before{content:\"\\e1a1\"}.di-vegetarian::before,.di-E1A2::before{content:\"\\e1a2\"}.di-raw-food::before,.di-E1A3::before{content:\"\\e1a3\"}.di-guest-favorite-food::before,.di-E1A4::before{content:\"\\e1a4\"}.di-mobile-order-food::before,.di-E1A5::before{content:\"\\e1a5\"}.di-adult-table-service::before,.di-E1A6::before{content:\"\\e1a6\"}.di-celebration-cakes::before,.di-E1A7::before{content:\"\\e1a7\"}.di-disney-dining-plan::before,.di-E1A8::before{content:\"\\e1a8\"}.di-disney-deluxe-dining-plan::before,.di-E1A9::before{content:\"\\e1a9\"}.di-coffee-mug::before,.di-E1AA::before{content:\"\\e1aa\"}.di-mobile-order-food::before,.di-E1AB::before{content:\"\\e1ab\"}.di-qs-dining-card::before,.di-E1AC::before{content:\"\\e1ac\"}.di-allergy-friendly::before,.di-E1AD::before{content:\"\\e1ad\"}.di-kids-meals::before,.di-E1AE::before{content:\"\\e1ae\"}.di-dining-check-in::before,.di-E1AF::before{content:\"\\e1af\"}.di-sports-recreation::before,.di-E1C0::before{content:\"\\e1c0\"}.di-campfire::before,.di-E1C1::before{content:\"\\e1c1\"}.di-snorkeling::before,.di-E1C2::before{content:\"\\e1c2\"}.di-swimming::before,.di-E1C3::before{content:\"\\e1c3\"}.di-boating::before,.di-E1C4::before{content:\"\\e1c4\"}.di-running::before,.di-E1C5::before{content:\"\\e1c5\"}.di-fitness-room::before,.di-E1C6::before{content:\"\\e1c6\"}.di-game::before,.di-E1C7::before{content:\"\\e1c7\"}.di-shuffleboard::before,.di-E1C8::before{content:\"\\e1c8\"}.di-parasailing::before,.di-E1C9::before{content:\"\\e1c9\"}.di-playground::before,.di-E1CA::before{content:\"\\e1ca\"}.di-horseback-riding::before,.di-E1CB::before{content:\"\\e1cb\"}.di-pool-tables::before,.di-E1CC::before{content:\"\\e1cc\"}.di-fishing::before,.di-E1CD::before{content:\"\\e1cd\"}.di-volleyball::before,.di-E1CE::before{content:\"\\e1ce\"}.di-basketball::before,.di-E1CF::before{content:\"\\e1cf\"}.di-cycling::before,.di-E1D0::before{content:\"\\e1d0\"}.di-explore::before,.di-E1D1::before{content:\"\\e1d1\"}.di-disneyland-recreation::before,.di-E1D2::before{content:\"\\e1d2\"}.di-baseball::before,.di-E1D4::before{content:\"\\e1d4\"}.di-field-hockey::before,.di-E1D5::before{content:\"\\e1d5\"}.di-football::before,.di-E1D6::before{content:\"\\e1d6\"}.di-gymnastics::before,.di-E1D7::before{content:\"\\e1d7\"}.di-lacrosse::before,.di-E1D8::before{content:\"\\e1d8\"}.di-crosscountry::before,.di-E1D9::before{content:\"\\e1d9\"}.di-soccer::before,.di-E1DA::before{content:\"\\e1da\"}.di-softball-fastpitch::before,.di-E1DB::before{content:\"\\e1db\"}.di-softball-slowpitch::before,.di-E1DC::before{content:\"\\e1dc\"}.di-track-field::before,.di-E1DD::before{content:\"\\e1dd\"}.di-tennis-court::before,.di-E1DE::before{content:\"\\e1de\"}.di-generic-sports::before,.di-E1DF::before{content:\"\\e1df\"}.di-maps::before,.di-E200::before{content:\"\\e200\"}.di-guest-services::before,.di-E201::before{content:\"\\e201\"}.di-concierge::before,.di-E202::before{content:\"\\e202\"}.di-resort-checkin::before,.di-E203::before{content:\"\\e203\"}.di-celebration::before,.di-E204::before{content:\"\\e204\"}.di-aeds::before,.di-E205::before{content:\"\\e205\"}.di-smoking-area::before,.di-E206::before{content:\"\\e206\"}.di-no-smoking::before,.di-E207::before{content:\"\\e207\"}.di-lost-found::before,.di-E208::before{content:\"\\e208\"}.di-baby-care-center::before,.di-E209::before{content:\"\\e209\"}.di-currency-exchange::before,.di-E20A::before{content:\"\\e20a\"}.di-atm::before,.di-E20B::before{content:\"\\e20b\"}.di-restrooms::before,.di-E20C::before{content:\"\\e20c\"}.di-first-aid::before,.di-E20D::before{content:\"\\e20d\"}.di-laundry::before,.di-E20E::before{content:\"\\e20e\"}.di-valet::before,.di-E20F::before{content:\"\\e20f\"}.di-in-room-babysitting::before,.di-E210::before{content:\"\\e210\"}.di-business-center::before,.di-E211::before{content:\"\\e211\"}.di-cabanas::before,.di-E212::before{content:\"\\e212\"}.di-ecv::before,.di-E213::before{content:\"\\e213\"}.di-strollers::before,.di-E214::before{content:\"\\e214\"}.di-parking-lot::before,.di-E215::before{content:\"\\e215\"}.di-kennel::before,.di-E216::before{content:\"\\e216\"}.di-package-pick-up::before,.di-E217::before{content:\"\\e217\"}.di-gas-station::before,.di-E218::before{content:\"\\e218\"}.di-pin-trading::before,.di-E219::before{content:\"\\e219\"}.di-translation-devices::before,.di-E21A::before{content:\"\\e21a\"}.di-wedding-ceremonies::before,.di-E21B::before{content:\"\\e21b\"}.di-resort-amenities::before,.di-E21C::before{content:\"\\e21c\"}.di-movies-under-the-stars::before,.di-E21D::before{content:\"\\e21d\"}.di-kodak-picture-spot::before,.di-E21E::before{content:\"\\e21e\"}.di-locker-rentals::before,.di-E21F::before{content:\"\\e21f\"}.di-here-now::before,.di-E220::before{content:\"\\e220\"}.di-current-location::before,.di-E221::before{content:\"\\e221\"}.di-supervise-children::before,.di-E222::before{content:\"\\e222\"}.di-rider-swap::before,.di-E223::before{content:\"\\e223\"}.di-service-dog::before,.di-E224::before{content:\"\\e224\"}.di-free-disney-wifi::before,.di-E225::before{content:\"\\e225\"}.di-generic-wifi::before,.di-E226::before{content:\"\\e226\"}.di-location-pin::before,.di-E22B::before{content:\"\\e22b\"}.di-disney-express-luggage::before,.di-E22D::before{content:\"\\e22d\"}.di-picnic-area::before,.di-E230::before{content:\"\\e230\"}.di-nikon-picture-spot::before,.di-E236::before{content:\"\\e236\"}.di-atm-2::before,.di-E237::before{content:\"\\e237\"}.di-drinking-fountains::before,.di-E238::before{content:\"\\e238\"}.di-package-express::before,.di-E239::before{content:\"\\e239\"}.di-kingdom-club-bellman::before,.di-E23A::before{content:\"\\e23a\"}.di-in-park-info::before,.di-E23B::before{content:\"\\e23b\"}.di-magical-coin-press-machine::before,.di-E23C::before{content:\"\\e23c\"}.di-stroller-parking::before,.di-E23D::before{content:\"\\e23d\"}.di-electric-car-charging-station::before,.di-E23E::before{content:\"\\e23e\"}.di-parade-route-show-area::before,.di-E23F::before{content:\"\\e23f\"}.di-alert::before,.di-E240::before{content:\"\\e240\"}.di-checkmark::before,.di-E241::before{content:\"\\e241\"}.di-faqs::before,.di-E242::before{content:\"\\e242\"}.di-quick-answer::before,.di-E243::before{content:\"\\e243\"}.di-disney-parks-blog::before,.di-E244::before{content:\"\\e244\"}.di-sms::before,.di-E245::before{content:\"\\e245\"}.di-press-center::before,.di-E246::before{content:\"\\e246\"}.di-moms-panel::before,.di-E247::before{content:\"\\e247\"}.di-park-schedule::before,.di-E248::before{content:\"\\e248\"}.di-time::before,.di-E249::before{content:\"\\e249\"}.di-privacy-policies::before,.di-E24A::before{content:\"\\e24a\"}.di-terms-conditions::before,.di-E24B::before{content:\"\\e24b\"}.di-accessibility::before,.di-E24C::before{content:\"\\e24c\"}.di-pre-arrival-tips::before,.di-E24D::before{content:\"\\e24d\"}.di-reservations::before,.di-E24E::before{content:\"\\e24e\"}.di-registration::before,.di-E24F::before{content:\"\\e24f\"}.di-help-support::before,.di-E250::before{content:\"\\e250\"}.di-learn-more::before,.di-E251::before{content:\"\\e251\"}.di-email::before,.di-E252::before{content:\"\\e252\"}.di-chat::before,.di-E253::before{content:\"\\e253\"}.di-call::before,.di-E254::before{content:\"\\e254\"}.di-14-days-notice::before,.di-E255::before{content:\"\\e255\"}.di-6-months-notice::before,.di-E256::before{content:\"\\e256\"}.di-blackout-days::before,.di-E257::before{content:\"\\e257\"}.di-3-days-notice::before,.di-E258::before{content:\"\\e258\"}.di-website-support::before,.di-E259::before{content:\"\\e259\"}.di-restriction::before,.di-E25A::before{content:\"\\e25a\"}.di-recommendation::before,.di-E25B::before{content:\"\\e25b\"}.di-na-dash::before,.di-E25C::before{content:\"\\e25c\"}.di-magic-morning::before,.di-E25D::before{content:\"\\e25d\"}.di-global-languages::before,.di-E25E::before{content:\"\\e25e\"}.di-good-neighbor-hotel::before,.di-E25F::before{content:\"\\e25f\"}.di-travel-information::before,.di-E261::before{content:\"\\e261\"}.di-visiting-with-groups::before,.di-E262::before{content:\"\\e262\"}.di-visiting-with-children::before,.di-E263::before{content:\"\\e263\"}.di-disney-like-light::before,.di-E266::before{content:\"\\e266\"}.di-disney-like-dark::before,.di-E267::before{content:\"\\e267\"}.di-written-aids::before,.di-E268::before{content:\"\\e268\"}.di-generations-travel::before,.di-E269::before{content:\"\\e269\"}.di-empty-chat::before,.di-E26A::before{content:\"\\e26a\"}.di-filled-chat::before,.di-E26B::before{content:\"\\e26b\"}.di-empty-checkbox::before,.di-E26C::before{content:\"\\e26c\"}.di-selected-solid-checkbox::before,.di-E26D::before{content:\"\\e26d\"}.di-selected-disabled::before,.di-E26E::before{content:\"\\e26e\"}.di-indeterminate::before,.di-E26F::before{content:\"\\e26f\"}.di-10-days-notice::before,.di-E270::before{content:\"\\e270\"}.di-wdw-ap-blockout-cal::before,.di-E271::before{content:\"\\e271\"}.di-flexible-ticket::before,.di-E272::before{content:\"\\e272\"}.di-ride-height::before,.di-E275::before{content:\"\\e275\"}.di-adults::before,.di-E276::before{content:\"\\e276\"}.di-teens-tweens::before,.di-E277::before{content:\"\\e277\"}.di-kids::before,.di-E278::before{content:\"\\e278\"}.di-price-range::before,.di-E279::before{content:\"\\e279\"}.di-price-range-outlined::before,.di-E27A::before{content:\"\\e27a\"}.di-time-outlined::before,.di-E27B::before{content:\"\\e27b\"}.di-all-parks-available::before,.di-E27C::before{content:\"\\e27c\"}.di-some-parks-available::before,.di-E27D::before{content:\"\\e27d\"}.di-my-media::before,.di-E280::before{content:\"\\e280\"}.di-images::before,.di-E281::before{content:\"\\e281\"}.di-videos::before,.di-E282::before{content:\"\\e282\"}.di-photo-pass::before,.di-E283::before{content:\"\\e283\"}.di-photo-pass-plus::before,.di-E284::before{content:\"\\e284\"}.di-media-favorites::before,.di-E285::before{content:\"\\e285\"}.di-photo-fun::before,.di-E286::before{content:\"\\e286\"}.di-disney-vision::before,.di-E287::before{content:\"\\e287\"}.di-dvd-cd::before,.di-E288::before{content:\"\\e288\"}.di-shdr-photopass::before,.di-E289::before{content:\"\\e289\"}.di-order-dvd::before,.di-E28B::before{content:\"\\e28b\"}.di-presented-in-3d::before,.di-E28C::before{content:\"\\e28c\"}.di-guest-photos::before,.di-E28D::before{content:\"\\e28d\"}.di-on-demand::before,.di-E28E::before{content:\"\\e28e\"}.di-live-stream::before,.di-E28F::before{content:\"\\e28f\"}.di-photopass-lenses::before,.di-E290::before{content:\"\\e290\"}.di-monorail::before,.di-E2C0::before{content:\"\\e2c0\"}.di-bus::before,.di-E2C1::before{content:\"\\e2c1\"}.di-car::before,.di-E2C2::before{content:\"\\e2c2\"}.di-boat::before,.di-E2C3::before{content:\"\\e2c3\"}.di-taxi::before,.di-E2C4::before{content:\"\\e2c4\"}.di-flight::before,.di-E2C5::before{content:\"\\e2c5\"}.di-return-flight::before,.di-E2C6::before{content:\"\\e2c6\"}.di-walking::before,.di-E2C7::before{content:\"\\e2c7\"}.di-free-shuttle::before,.di-E2C8::before{content:\"\\e2c8\"}.di-hkdl-mtr-disney-resort-line::before,.di-E2CE::before{content:\"\\e2ce\"}.di-bus-schedule::before,.di-E2CF::before{content:\"\\e2cf\"}.di-minnie-vans-ride-share::before,.di-E2D0::before{content:\"\\e2d0\"}.di-transportation-multiple::before,.di-E2D1::before{content:\"\\e2d1\"}.di-wdw-skylinero::before,.di-E2D2::before{content:\"\\e2d2\"}.di-close-button::before,.di-E300::before{content:\"\\e300\"}.di-add-button::before,.di-E301::before{content:\"\\e301\"}.di-information::before,.di-E302::before{content:\"\\e302\"}.di-share::before,.di-E303::before{content:\"\\e303\"}.di-download::before,.di-E304::before{content:\"\\e304\"}.di-show-filters::before,.di-E305::before{content:\"\\e305\"}.di-hide-filters::before,.di-E306::before{content:\"\\e306\"}.di-3d-spin::before,.di-E307::before{content:\"\\e307\"}.di-media-play-button::before,.di-E308::before{content:\"\\e308\"}.di-media-pause-button::before,.di-E309::before{content:\"\\e309\"}.di-pdf::before,.di-E30A::before{content:\"\\e30a\"}.di-duplicate-offer::before,.di-E30B::before{content:\"\\e30b\"}.di-next::before,.di-E30C::before{content:\"\\e30c\"}.di-previous::before,.di-E30D::before{content:\"\\e30d\"}.di-print::before,.di-E30F::before{content:\"\\e30f\"}.di-search::before,.di-E310::before{content:\"\\e310\"}.di-calendar-month::before,.di-E311::before{content:\"\\e311\"}.di-calendar-day-view::before,.di-E312::before{content:\"\\e312\"}.di-more::before,.di-E313::before{content:\"\\e313\"}.di-menu-global-nav::before,.di-E314::before{content:\"\\e314\"}.di-menus-button::before,.di-E315::before{content:\"\\e315\"}.di-norgie-opened::before,.di-E316::before{content:\"\\e316\"}.di-upload::before,.di-E317::before{content:\"\\e317\"}.di-lists::before,.di-E318::before{content:\"\\e318\"}.di-filter::before,.di-E319::before{content:\"\\e319\"}.di-scan-barcode::before,.di-E31A::before{content:\"\\e31a\"}.di-keyboard-entry::before,.di-E31B::before{content:\"\\e31b\"}.di-download-mobile-app::before,.di-E31C::before{content:\"\\e31c\"}.di-view-gallery::before,.di-E31D::before{content:\"\\e31d\"}.di-see-info-page-button::before,.di-E31E::before{content:\"\\e31e\"}.di-media-gallery-photo-button::before,.di-E31F::before{content:\"\\e31f\"}.di-media-gallery-video-button::before,.di-E320::before{content:\"\\e320\"}.di-refresh::before,.di-E321::before{content:\"\\e321\"}.di-compose-message::before,.di-E322::before{content:\"\\e322\"}.di-add-contact::before,.di-E323::before{content:\"\\e323\"}.di-contact-list::before,.di-E324::before{content:\"\\e324\"}.di-norgie-up::before,.di-E325::before{content:\"\\e325\"}.di-norgie-left::before,.di-E326::before{content:\"\\e326\"}.di-mobile-app::before,.di-E327::before{content:\"\\e327\"}.di-home::before,.di-E328::before{content:\"\\e328\"}.di-return-arrow::before,.di-E329::before{content:\"\\e329\"}.di-share-2::before,.di-E32A::before{content:\"\\e32a\"}.di-delete-button::before,.di-E32B::before{content:\"\\e32b\"}.di-fast-forward-button::before,.di-E32C::before{content:\"\\e32c\"}.di-rewind-button::before,.di-E32D::before{content:\"\\e32d\"}.di-pulldown::before,.di-E32E::before{content:\"\\e32e\"}.di-increase-button::before,.di-E32F::before{content:\"\\e32f\"}.di-decrease-button::before,.di-E330::before{content:\"\\e330\"}.di-flip-turn-over::before,.di-E331::before{content:\"\\e331\"}.di-previous-2::before,.di-E332::before{content:\"\\e332\"}.di-next-2::before,.di-E333::before{content:\"\\e333\"}.di-arrow-back::before,.di-E334::before{content:\"\\e334\"}.di-arrow-up::before,.di-E335::before{content:\"\\e335\"}.di-arrow-down::before,.di-E336::before{content:\"\\e336\"}.di-expand-gallery::before,.di-E337::before{content:\"\\e337\"}.di-360-video::before,.di-E338::before{content:\"\\e338\"}.di-volume-control::before,.di-E339::before{content:\"\\e339\"}.di-app-card-info::before,.di-E33A::before{content:\"\\e33a\"}.di-app-card-flip::before,.di-E33B::before{content:\"\\e33b\"}.di-close-reversed::before,.di-E33E::before{content:\"\\e33e\"}.di-expand-show-more::before,.di-E33F::before{content:\"\\e33f\"}.di-wheelchair-accessibility::before,.di-E340::before{content:\"\\e340\"}.di-transfer-from-wheelchair::before,.di-E341::before{content:\"\\e341\"}.di-transfer-to-wheelchair::before,.di-E342::before{content:\"\\e342\"}.di-transfer-to-wheelchair-then-ride::before,.di-E343::before{content:\"\\e343\"}.di-ambulatory::before,.di-E344::before{content:\"\\e344\"}.di-visual-impairment::before,.di-E345::before{content:\"\\e345\"}.di-hearing-impairment::before,.di-E346::before{content:\"\\e346\"}.di-sign-language::before,.di-E347::before{content:\"\\e347\"}.di-audio-description::before,.di-E348::before{content:\"\\e348\"}.di-handheld-captioning::before,.di-E349::before{content:\"\\e349\"}.di-reflective-captioning::before,.di-E34A::before{content:\"\\e34a\"}.di-closed-captioning::before,.di-E34B::before{content:\"\\e34b\"}.di-physicial-consideration-red-yellow::before,.di-E34C::before{content:\"\\e34c\"}.di-scary-consideration-yellow::before,.di-E34D::before{content:\"\\e34d\"}.di-dlp-mobility-disabilities::before,.di-E34E::before{content:\"\\e34e\"}.di-dlp-hearing-disabilities::before,.di-E34F::before{content:\"\\e34f\"}.di-dlp-visual-disabilities::before,.di-E350::before{content:\"\\e350\"}.di-photosensitive-epilepsy::before,.di-E351::before{content:\"\\e351\"}.di-dlp-mental-cognitive-disabilities::before,.di-E352::before{content:\"\\e352\"}.di-suitable-for-amputees::before,.di-E353::before{content:\"\\e353\"}.di-suitable-for-difficulty-standing::before,.di-E354::before{content:\"\\e354\"}.di-capable-of-climbing-steps::before,.di-E355::before{content:\"\\e355\"}.di-disabilities-services::before,.di-E356::before{content:\"\\e356\"}.di-disabilities-guide-book::before,.di-E357::before{content:\"\\e357\"}.di-wheelchair-rental::before,.di-E358::before{content:\"\\e358\"}.di-disabilities-designated-viewing::before,.di-E359::before{content:\"\\e359\"}.di-may-remain-in-wheelchair::before,.di-E35A::before{content:\"\\e35a\"}.di-must-be-ambulatory-2::before,.di-E35B::before{content:\"\\e35b\"}.di-suitable-for-blind::before,.di-E35C::before{content:\"\\e35c\"}.di-suitable-for-autism::before,.di-E35D::before{content:\"\\e35d\"}.di-sign-language-2::before,.di-E35E::before{content:\"\\e35e\"}.di-tactile-maps::before,.di-E35F::before{content:\"\\e35f\"}.di-braille-guide-books::before,.di-E360::before{content:\"\\e360\"}.di-suitable-for-learning-disabilities::before,.di-E361::before{content:\"\\e361\"}.di-induction-loop::before,.di-E362::before{content:\"\\e362\"}.di-dimly-lit-space::before,.di-E363::before{content:\"\\e363\"}.di-light-rain-indoors::before,.di-E364::before{content:\"\\e364\"}.di-show-contains-bubble::before,.di-E365::before{content:\"\\e365\"}.di-hdd-illness::before,.di-E366::before{content:\"\\e366\"}.di-open-captioning::before,.di-E367::before{content:\"\\e367\"}.di-magnetic-fields::before,.di-E368::before{content:\"\\e368\"}.di-open-captioning-square::before,.di-E369::before{content:\"\\e369\"}.di-gifts::before,.di-E380::before{content:\"\\e380\"}.di-character-calls::before,.di-E381::before{content:\"\\e381\"}.di-performing-arts::before,.di-E382::before{content:\"\\e382\"}.di-education::before,.di-E383::before{content:\"\\e383\"}.di-lock::before,.di-E384::before{content:\"\\e384\"}.di-facebook::before,.di-E385::before{content:\"\\e385\"}.di-twitter::before,.di-E386::before{content:\"\\e386\"}.di-youtube::before,.di-E387::before{content:\"\\e387\"}.di-instagram::before,.di-E388::before{content:\"\\e388\"}.di-pinterest::before,.di-E389::before{content:\"\\e389\"}.di-google-plus::before,.di-E38A::before{content:\"\\e38a\"}.di-disney-cast::before,.di-E38B::before{content:\"\\e38b\"}.di-disney-response::before,.di-E38C::before{content:\"\\e38c\"}.di-thrill-seekers::before,.di-E38E::before{content:\"\\e38e\"}.di-doll::before,.di-E390::before{content:\"\\e390\"}.di-front-desk::before,.di-E391::before{content:\"\\e391\"}.di-movies::before,.di-E392::before{content:\"\\e392\"}.di-unlocked::before,.di-E393::before{content:\"\\e393\"}.di-tumblr::before,.di-E394::before{content:\"\\e394\"}.di-services::before,.di-E395::before{content:\"\\e395\"}.di-old-photopass-plus::before,.di-E396::before{content:\"\\e396\"}.di-hkdl-sina-weibo-social::before,.di-E397::before{content:\"\\e397\"}.di-hkdl-baidu-tieba-social::before,.di-E398::before{content:\"\\e398\"}.di-hkdl-webchat-social::before,.di-E399::before{content:\"\\e399\"}.di-disney-wild-about-safety::before,.di-E39A::before{content:\"\\e39a\"}.di-romantic-celebration::before,.di-E39B::before{content:\"\\e39b\"}.di-facebook-icon-alone::before,.di-E39C::before{content:\"\\e39c\"}.di-twitter-icon-alone::before,.di-E39D::before{content:\"\\e39d\"}.di-snapchat::before,.di-E39E::before{content:\"\\e39e\"}.di-photopass-attraction-id::before,.di-E39F::before{content:\"\\e39f\"}.di-achievement::before,.di-E3A0::before{content:\"\\e3a0\"}.di-apple-music::before,.di-E3A1::before{content:\"\\e3a1\"}.di-apple-music-alternate::before,.di-E3A2::before{content:\"\\e3a2\"}.di-watches-time::before,.di-E3A3::before{content:\"\\e3a3\"}.di-magic-coming-soon::before,.di-E3A4::before{content:\"\\e3a4\"}.di-winter::before,.di-E3E4::before{content:\"\\e3e4\"}.di-spring::before,.di-E3E5::before{content:\"\\e3e5\"}.di-summer::before,.di-E3E6::before{content:\"\\e3e6\"}.di-autumn::before,.di-E3E7::before{content:\"\\e3e7\"}.di-pack-for-weather::before,.di-E3E8::before{content:\"\\e3e8\"}.di-single-rider::before,.di-E440::before{content:\"\\e440\"}.di-atm-china::before,.di-E441::before{content:\"\\e441\"}.di-wayfinding-slight-left::before,.di-E442::before{content:\"\\e442\"}.di-wayfinding-slight-right::before,.di-E443::before{content:\"\\e443\"}.di-wayfinding-turn-left::before,.di-E444::before{content:\"\\e444\"}.di-wayfinding-turn-right::before,.di-E445::before{content:\"\\e445\"}.di-wayfinding-hard-left::before,.di-E446::before{content:\"\\e446\"}.di-wayfinding-hard-right::before,.di-E447::before{content:\"\\e447\"}.di-wayfinding-left::before,.di-E448::before{content:\"\\e448\"}.di-wayfinding-right::before,.di-E449::before{content:\"\\e449\"}.di-wayfinding-forward::before,.di-E44A::before{content:\"\\e44a\"}.di-wayfinding-back::before,.di-E44B::before{content:\"\\e44b\"}.di-wayfinding-forward-back::before,.di-E44C::before{content:\"\\e44c\"}.di-wayfinding-right-left::before,.di-E44D::before{content:\"\\e44d\"}.di-wayfinding-around-slight-left::before,.di-E44E::before{content:\"\\e44e\"}.di-wayfinding-around-slight-right::before,.di-E44F::before{content:\"\\e44f\"}.di-wayfinding-around-turn-left::before,.di-E450::before{content:\"\\e450\"}.di-wayfinding-around-turn-right::before,.di-E451::before{content:\"\\e451\"}.di-wayfinding-around-hard-left::before,.di-E452::before{content:\"\\e452\"}.di-wayfinding-around-hard-right::before,.di-E453::before{content:\"\\e453\"}.di-wayfinding-around-left::before,.di-E454::before{content:\"\\e454\"}.di-wayfinding-around-right::before,.di-E455::before{content:\"\\e455\"}.di-wayfinding-around-forward-left::before,.di-E456::before{content:\"\\e456\"}.di-wayfinding-around-forward-right::before,.di-E457::before{content:\"\\e457\"}.di-wayfinding-u-turn-right::before,.di-E458::before{content:\"\\e458\"}.di-wayfinding-u-turn-left::before,.di-E459::before{content:\"\\e459\"}.di-wayfinding-ramp-left::before,.di-E45A::before{content:\"\\e45a\"}.di-wayfinding-ramp-right::before,.di-E45B::before{content:\"\\e45b\"}.di-wayfinding-fork-left::before,.di-E45C::before{content:\"\\e45c\"}.di-wayfinding-fork-right::before,.di-E45D::before{content:\"\\e45d\"}.di-wayfinding-around-about-left::before,.di-E45E::before{content:\"\\e45e\"}.di-wayfinding-around-about-right::before,.di-E45F::before{content:\"\\e45f\"}.di-wayfinding-merge::before,.di-E460::before{content:\"\\e460\"}.di-cribs-and-playpens::before,.di-E461::before{content:\"\\e461\"}.di-baby-care-center2::before,.di-E462::before{content:\"\\e462\"}.di-epi-pen::before,.di-E463::before{content:\"\\e463\"}.di-mobile-charging-station::before,.di-E464::before{content:\"\\e464\"}.di-security-info::before,.di-E465::before{content:\"\\e465\"}.di-refrigerator-available::before,.di-E466::before{content:\"\\e466\"}.di-repellant-zika::before,.di-E467::before{content:\"\\e467\"}.di-hurricane-information::before,.di-E468::before{content:\"\\e468\"}.di-recenter-map::before,.di-E46A::before{content:\"\\e46a\"}.di-location-pin::before,.di-E46C::before{content:\"\\e46c\"}.di-transportation-parking-info::before,.di-E46D::before{content:\"\\e46d\"}.di-resort-automatic-check-out::before,.di-E46E::before{content:\"\\e46e\"}.di-service-your-way::before,.di-E46F::before{content:\"\\e46f\"}.di-direct-to-room::before,.di-E470::before{content:\"\\e470\"}.di-premium-service-shdr::before,.di-E471::before{content:\"\\e471\"}.di-virtual-queue::before,.di-E472::before{content:\"\\e472\"}.di-energy-monster::before,.di-E473::before{content:\"\\e473\"}.di-elevators::before,.di-E475::before{content:\"\\e475\"}.di-salon::before,.di-E476::before{content:\"\\e476\"}.di-clothing::before,.di-E480::before{content:\"\\e480\"}.di-accessories::before,.di-E481::before{content:\"\\e481\"}.di-home-office::before,.di-E482::before{content:\"\\e482\"}.di-toys-games::before,.di-E483::before{content:\"\\e483\"}.di-art-collectibles::before,.di-E484::before{content:\"\\e484\"}.di-entertainment::before,.di-E485::before{content:\"\\e485\"}.di-health-beauty::before,.di-E486::before{content:\"\\e486\"}.di-sweets::before,.di-E487::before{content:\"\\e487\"}.di-play-logo::before,.di-E4C0::before{content:\"\\e4c0\"}.di-rocket-race-game::before,.di-E4C1::before{content:\"\\e4c1\"}.di-peter-pan-s-flight-game::before,.di-E4C2::before{content:\"\\e4c2\"}.di-toy-story-mania-game::before,.di-E4C3::before{content:\"\\e4c3\"}.di-trivia-games::before,.di-E4C4::before{content:\"\\e4c4\"}.di-esmeralda-quest::before,.di-E4C5::before{content:\"\\e4c5\"}.di-fortune-red-quest::before,.di-E4C6::before{content:\"\\e4c6\"}.di-temple-of-mara-decoder::before,.di-E4C7::before{content:\"\\e4c7\"}.di-conservation-fund-quest::before,.di-E4C8::before{content:\"\\e4c8\"}.di-soarin-challenge::before,.di-E4C9::before{content:\"\\e4c9\"}.di-agent-p-challenge::before,.di-E4CA::before{content:\"\\e4ca\"}.di-fun-wheel-challenge::before,.di-E4CB::before{content:\"\\e4cb\"}.di-andy-s-game-board-blast::before,.di-E4CC::before{content:\"\\e4cc\"}.di-art-of-animation::before,.di-E4CD::before{content:\"\\e4cd\"}.di-flight-of-passage::before,.di-E4CE::before{content:\"\\e4ce\"}.di-dlr-magic-mural::before,.di-E4CF::before{content:\"\\e4cf\"}.di-splash-mountain::before,.di-E4D0::before{content:\"\\e4d0\"}.di-kidcot-challenge::before,.di-E4D1::before{content:\"\\e4d1\"}.di-swge-millenium-falcon::before,.di-E4D2::before{content:\"\\e4d2\"}.di-swge-star-destroyer::before,.di-E4D3::before{content:\"\\e4d3\"}.di-swge-bso-logo::before,.di-E4D4::before{content:\"\\e4d4\"}.di-add-stepper::before,.di-E500::before{content:\"\\e500\"}.di-reduce-stepper::before,.di-E501::before{content:\"\\e501\"}.di-hide-collapse::before,.di-E502::before{content:\"\\e502\"}.di-mute-volume::before,.di-E503::before{content:\"\\e503\"}.di-unmute-volume::before,.di-E504::before{content:\"\\e504\"}.di-filter-items::before,.di-E505::before{content:\"\\e505\"}.di-forward-thin::before,.di-E506::before{content:\"\\e506\"}.di-back-thin::before,.di-E507::before{content:\"\\e507\"}.di-fast-fwd-thin::before,.di-E508::before{content:\"\\e508\"}.di-rewind-thin::before,.di-E509::before{content:\"\\e509\"}.di-download-thin::before,.di-E50A::before{content:\"\\e50a\"}.di-facial-opt-in-off::before,.di-E50B::before{content:\"\\e50b\"}.di-facial-opt-in-on::before,.di-E50C::before{content:\"\\e50c\"}.di-bluetooth::before,.di-E518::before{content:\"\\e518\"}.di-norgie-closed::before,.di-E534::before{content:\"\\e534\"}.di-fastpass-order-shopping-bag-plus::before,.di-E540::before{content:\"\\e540\"}.di-fastpass-order-shopping-bag::before,.di-E542::before{content:\"\\e542\"}.di-shdr-ticket-annualpass::before,.di-E544::before{content:\"\\e544\"}.di-tickets-outlined::before,.di-E54B::before{content:\"\\e54b\"}.di-early-entry-pass::before,.di-E54C::before{content:\"\\e54c\"}.di-disney-card-member::before,.di-E54D::before{content:\"\\e54d\"}.di-club-33-dlr-member::before,.di-E54E::before{content:\"\\e54e\"}.di-shdr-ap-activation::before,.di-E54F::before{content:\"\\e54f\"}.di-disney-maxpass-alternate::before,.di-E550::before{content:\"\\e550\"}.di-ap-activation::before,.di-E552::before{content:\"\\e552\"}.di-standby-pass::before,.di-E553::before{content:\"\\e553\"}.di-early-park-entry-pass::before,.di-E554::before{content:\"\\e554\"}.di-mobile-checkout::before,.di-E555::before{content:\"\\e555\"}.di-disney-premier-access-global::before,.di-E556::before{content:\"\\e556\"}.di-disney-premier-access-secondary::before,.di-E557::before{content:\"\\e557\"}.di-disney-premier-access-new::before,.di-E558::before{content:\"\\e558\"}.di-golden-oak-resident::before,.di-E559::before{content:\"\\e559\"}.di-disability-access-service::before,.di-E55A::before{content:\"\\e55a\"}.di-lightning-lane::before,.di-E55B::before{content:\"\\e55b\"}.di-disney-plus::before,.di-E55C::before{content:\"\\e55c\"}.di-enchant-key::before,.di-E55D::before{content:\"\\e55d\"}.di-dream-key::before,.di-E55E::before{content:\"\\e55e\"}.di-imagine-key::before,.di-E55F::before{content:\"\\e55f\"}.di-believe-key::before,.di-E560::before{content:\"\\e560\"}.di-unused-character::before,.di-F8FE::before{content:\"\\f8fe\"}:host{display:block;width:100%}:host>div{overflow:hidden}@media only screen and (min-width: 1180px){:host{width:220px}}.tbody{transition:all 0ms;transform:translateX(0)}.with-transition{transition:all 100ms}.move-to-left{transform:translateX(-274px)}.move-to-right{transform:translateX(274px)}.with-transition td,.move-to-left td,.move-to-right td{border:none}.icon-button{border:none;padding:0px;cursor:pointer;background-color:transparent;color:var(--range-datepicker-enabled-arrow-one-month)}.table{box-sizing:border-box;width:100%}.table .tbody{padding-top:10px;padding-bottom:5px}@media only screen and (min-width: 1180px){.table .tbody{padding-bottom:0px}}.table .th{display:inline-block;color:var(--range-datepicker-week-days);font-size:14px;width:30px;padding:0;margin:0;text-align:center}.table .tr{width:100%;display:flex;justify-content:center}.table .tr.days-of-the-week-row{padding-top:10px;padding-bottom:10px}.table .tr.days-of-the-week-row .th{font-size:12px;line-height:16px;text-transform:uppercase}.table .td{margin:0;padding:0;width:30px}.table .separator{background-color:var(--range-datepicker-month-day-separator);height:1px;width:92%;margin:0px auto}.month-name{margin-bottom:5px;text-align:center;display:flex;flex-direction:row;align-items:center}.month-name .month-year-header{font-size:14px;line-height:20px;color:var(--range-datepicker-month-title);display:flex;flex-direction:row;flex:1;align-items:center;justify-content:center}.month-name .month-year-header:focus{outline:1px dotted var(--range-datepicker-month-title-focus)}.month-name .month-year-header .month-name-label{font-weight:bold}.month-name .month-year-header .month-name-label::first-letter{text-transform:uppercase}#prev-month-arrow:focus,#next-month-arrow:focus{outline:1px dotted var(--range-datepicker-one-month-arrow-focus)}#prev-month-arrow[disabled],#next-month-arrow[disabled]{color:var(--range-datepicker-disabled-arrow-one-month);cursor:not-allowed}:host(:not([dynamic-sizing])) .table{border:1px solid var(--range-datepicker-one-month-border);border-radius:2px}@media only screen and (min-width: 481px){:host(:not([dynamic-sizing])) .table{border:none}}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) .table .tbody{padding-left:5px;padding-right:5px}}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) .table .tr.days-of-the-week-row{padding-top:15px;padding-bottom:15px}}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) .table .tr.days-of-the-week-row .th{width:14.2857142857%;font-size:16px}}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) .table .td{width:14.2857142857%}}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) .month-name .month-year-header{font-size:15px}}@media only screen and (min-width: 481px){:host(:not([dynamic-sizing])) #prev-month-arrow,:host(:not([dynamic-sizing])) #next-month-arrow{display:none}}:host(.multi-cal) .table{border:none}:host(.multi-cal) #prev-month-arrow,:host(.multi-cal) #next-month-arrow{display:none}:host(.single-cal) .month-name .month-year-header{font-size:15px}:host(.single-cal) .table .td{width:14.2857142857%}:host(.single-cal) .table .tbody{padding-left:5px;padding-right:5px}:host(.single-cal) .table .tr.days-of-the-week-row{padding-top:15px;padding-bottom:15px}:host(.single-cal) .table .tr.days-of-the-week-row .th{width:14.2857142857%;font-size:16px}:host(.single-cal) #prev-month-arrow,:host(.single-cal) #next-month-arrow{display:block}";

const RangeDatepickerCalendar = /*@__PURE__*/ proxyCustomElement(class RangeDatepickerCalendar extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.yearChanged = createEvent(this, "year-changed", 7);
        this.dateToChanged = createEvent(this, "date-to-changed", 7);
        this.dateFromChanged = createEvent(this, "date-from-changed", 7);
        this.hoveredDateChanged = createEvent(this, "hovered-date-changed", 7);
        this.dateToClicked = createEvent(this, "date-to-clicked", 7);
        this.dateFromClicked = createEvent(this, "date-from-clicked", 7);
        this.nextMonth = createEvent(this, "next-month", 7);
        this.prevMonth = createEvent(this, "prev-month", 7);
        this._handleDateSelected = (event) => {
            const date = event.detail.date;
            if (this.dateFrom != undefined && this.dateTo != null) {
                this.dateFrom = date;
                this.dateTo = null;
                this.hoveredDate = undefined;
                this.dateFromClicked.emit();
            }
            else if (this.dateFrom == undefined || (this.dateFrom != undefined && date < this.dateFrom)) {
                this.dateFrom = date;
                this.dateFromClicked.emit();
            }
            else if (this.dateTo == null || (this.dateTo != null && date > this.dateTo)) {
                this.dateTo = date;
                this.dateToClicked.emit();
            }
        };
        this._handleDateHovered = (event) => {
            this.hoveredDate = event.detail.date;
        };
        this.month = undefined;
        this.year = undefined;
        this._dayNamesOfTheWeek = undefined;
        this.keepButtons = false;
        this.range = undefined;
        this._daysOfMonth = undefined;
        this.dynamicSizing = false;
        this.locale = "en";
        this.dateTo = undefined;
        this.prev = undefined;
        this.next = undefined;
        this.single = undefined;
        this.dateFrom = undefined;
        this.hoveredDate = undefined;
        this.min = undefined;
        this.max = undefined;
        this.currentCalendarId = undefined;
        this._animationDuration = 100;
        this._prevMonthButtonDisabled = null;
        this._nextMonthButtonDisabled = null;
        this._handleNextMonth = (callbackOrEvent) => {
            if (this._nextMonthButtonDisabled) {
                return;
            }
            const tbody = this.el.shadowRoot.querySelector('.tbody');
            const monthName = this.el.shadowRoot.querySelector('.month-name > div');
            tbody.classList.add('with-transition');
            tbody.classList.add('move-to-left');
            monthName.classList.add('with-transition');
            monthName.classList.add('move-to-left');
            this.month = luxon.DateTime.fromObject({ month: this.month }, { locale: this.locale }).plus({ months: 1 }).toFormat(Formats.month);
            if (this.month === '01') {
                this.year = luxon.DateTime.fromObject({ year: this.year }, { locale: this.locale }).plus({ years: 1 }).toFormat(Formats.year);
            }
            this.nextMonth.emit();
            setTimeout(() => {
                tbody.classList.remove('with-transition');
                tbody.classList.add('move-to-right');
                tbody.classList.remove('move-to-left');
                monthName.classList.remove('with-transition');
                monthName.classList.add('move-to-right');
                monthName.classList.remove('move-to-left');
                setTimeout(() => {
                    tbody.classList.add('with-transition');
                    tbody.classList.remove('move-to-right');
                    monthName.classList.add('with-transition');
                    monthName.classList.remove('move-to-right');
                    setTimeout(() => {
                        tbody.classList.remove('with-transition');
                        monthName.classList.remove('with-transition');
                        if (typeof callbackOrEvent === 'function') {
                            callbackOrEvent();
                        }
                    }, this._animationDuration);
                }, this._animationDuration);
            }, this._animationDuration);
            return luxon.DateTime.fromObject({ year: this.year, month: parseInt(this.month) }, { locale: this.locale });
        };
        this._handlePrevMonth = (callbackOrEvent) => {
            if (this._prevMonthButtonDisabled) {
                return;
            }
            const tbody = this.el.shadowRoot.querySelector('.tbody');
            const monthName = this.el.shadowRoot.querySelector('.month-name > div');
            tbody.classList.add('with-transition');
            tbody.classList.add('move-to-right');
            monthName.classList.add('with-transition');
            monthName.classList.add('move-to-right');
            this.month = luxon.DateTime.fromObject({ month: this.month }, { locale: this.locale }).minus({ months: 1 }).toFormat(Formats.month);
            if (this.month === '12') {
                this.year = luxon.DateTime.fromObject({ year: this.year }, { locale: this.locale }).minus({ years: 1 }).toFormat(Formats.year);
            }
            this.prevMonth.emit();
            setTimeout(() => {
                tbody.classList.remove('with-transition');
                tbody.classList.add('move-to-left');
                tbody.classList.remove('move-to-right');
                monthName.classList.remove('with-transition');
                monthName.classList.add('move-to-left');
                monthName.classList.remove('move-to-right');
                setTimeout(() => {
                    tbody.classList.add('with-transition');
                    tbody.classList.remove('move-to-left');
                    monthName.classList.add('with-transition');
                    monthName.classList.remove('move-to-left');
                    setTimeout(() => {
                        monthName.classList.remove('with-transition');
                        monthName.classList.remove('with-transition');
                        if (typeof callbackOrEvent === 'function') {
                            callbackOrEvent();
                        }
                    }, this._animationDuration);
                }, this._animationDuration);
            }, this._animationDuration);
            return luxon.DateTime.fromObject({ year: this.year, month: parseInt(this.month) }, { locale: this.locale });
        };
    }
    monthChanged(newMonth) {
        this.yearChanged.emit(newMonth);
        this._yearAndMonthChanged(this.year, newMonth);
    }
    notifyYear(newYear) {
        this.yearChanged.emit(newYear);
        this._yearAndMonthChanged(newYear, this.month);
    }
    _localeChanged() {
        let weekDays = luxon.Info.weekdays("narrow", { locale: this.locale });
        // This is currently done to go from ISO standard weeks, which start on Monday, to en-US weekdays, which start on Sun.
        // The international API is working to support firstDayOfWeek based on locale-- once that is live, this will be updated
        let localeStartOfWeek = weekStartLocale(this.locale);
        const tmp = weekDays.slice().splice(0, localeStartOfWeek);
        const newDayNamesOfTheWeek = weekDays
            .slice()
            .splice(localeStartOfWeek, weekDays.length)
            .concat(tmp)
            .map(day => day[0]);
        this._dayNamesOfTheWeek = newDayNamesOfTheWeek;
    }
    notifyDateTo(newDateTo) {
        this.dateToChanged.emit(newDateTo);
    }
    notifyDateFrom(newDateFrom) {
        this.dateFromChanged.emit(newDateFrom);
    }
    notifyHoveredDate(newHoveredDate) {
        this.hoveredDateChanged.emit(newHoveredDate);
    }
    _minChanged(newMin) {
        this._minMaxChanged(newMin, this.max);
    }
    _maxChanged(newMax) {
        this._minMaxChanged(this.min, newMax);
    }
    currentCalendarIdChanged() {
        if (this.dynamicSizing == true) {
            if (this.el.parentElement.id == 'two-calendar' || this.el.parentElement.id == 'three-calendar' || this.el.parentElement.id == 'four-calendar' || this.el.parentElement.id == 'double-calendar') {
                this.el.classList.add('multi-cal');
            }
            if (this.el.parentElement.id == 'one-calendar' || this.el.parentElement.id == 'single-calendar') {
                this.el.classList.add('single-cal');
            }
        }
    }
    _yearAndMonthChanged(year, month) {
        if (year && month) {
            let startDate = luxon.DateTime.fromObject({ year: year, month: month }, { locale: this.locale });
            let endDate = luxon.DateTime.fromISO(startDate.toISO()).endOf("month");
            const rows = [];
            let columns = [];
            const lastDayOfWeek = 6;
            while (startDate.toFormat(Formats.fullDate) !== endDate.toFormat(Formats.fullDate)) {
                const dayNumber = (startDate.weekday - weekStartLocale(this.locale) + 6) % 7;
                columns.push({
                    hover: false,
                    date: parseInt(startDate.toFormat(Formats.seconds), 10),
                    title: parseInt(startDate.toFormat(Formats.day), 10)
                });
                if (dayNumber === lastDayOfWeek) {
                    for (let i = columns.length; i < lastDayOfWeek + 1; i += 1) {
                        columns.unshift(0);
                    }
                    rows.push(columns.slice());
                    columns = [];
                }
                startDate = startDate.plus({ days: 1 });
                if (startDate.toFormat(Formats.fullDate) === endDate.toFormat(Formats.fullDate)) {
                    columns.push({
                        hover: false,
                        date: parseInt(startDate.toFormat(Formats.seconds), 10),
                        title: parseInt(startDate.toFormat(Formats.day), 10)
                    });
                    for (let i = columns.length; i <= lastDayOfWeek; i += 1) {
                        columns.push(0);
                    }
                    rows.push(columns.slice());
                    columns = [];
                }
            }
            this._daysOfMonth = (rows);
            // Enable/disable prev and next month buttons
            this._computePrevAndNextMonthButtonsDisabledValues();
        }
    }
    _computeCurrentMonthName(month, year) {
        if (month && year)
            return luxon.DateTime.fromObject({ month: month, year: year }, { locale: this.locale }).toFormat(Formats.monthName);
        return (undefined);
    }
    _tdIsEnabled(day) {
        return day ? 'enabled' : '';
    }
    _minMaxChanged(_min, _max) {
        this._computePrevAndNextMonthButtonsDisabledValues();
    }
    _computePrevAndNextMonthButtonsDisabledValues() {
        if (this.keepButtons == false) {
            const currentCalendar = luxon.DateTime.fromObject({ year: this.year, month: parseInt(this.month) });
            const minDateTimeObject = luxon.DateTime.fromSeconds(this.min, { locale: this.locale });
            const minMonth = Number(minDateTimeObject.toFormat(Formats.month));
            const minYear = minDateTimeObject.toFormat(Formats.year);
            if (this.max != undefined && this.max != null) {
                const maxDateTimeObject = luxon.DateTime.fromSeconds(this.max, { locale: this.locale });
                const maxMonth = Number(maxDateTimeObject.toFormat(Formats.month));
                const maxYear = maxDateTimeObject.toFormat(Formats.year);
                const maxEnabledCalendar = luxon.DateTime.fromObject({ year: maxYear, month: maxMonth });
                this._nextMonthButtonDisabled = currentCalendar >= maxEnabledCalendar ? true : null;
            }
            else {
                this._nextMonthButtonDisabled = null;
            }
            const minEnabledCalendar = luxon.DateTime.fromObject({ year: minYear, month: minMonth });
            this._prevMonthButtonDisabled = currentCalendar <= minEnabledCalendar ? true : null;
        }
    }
    componentWillLoad() {
        this._localeChanged();
        this._yearAndMonthChanged(this.year, this.month);
    }
    render() {
        return (h("div", null, h("div", { class: "month-name" }, h("button", { id: "prev-month-arrow", "on-click": this._handlePrevMonth, tabindex: "1", class: "icon-button arrow-button", "aria-label": "datepicker previous month button", disabled: this._prevMonthButtonDisabled, "aria-disabled": this._prevMonthButtonDisabled }, h("i", { class: "di di-previous di20" })), h("div", { class: "month-year-header", tabindex: "2" }, h("span", { class: "month-name-label" }, this._computeCurrentMonthName(this.month, this.year)), "\u00A0", this.year), h("button", { id: "next-month-arrow", "on-click": this._handleNextMonth, tabindex: "3", class: "icon-button arrow-button", "aria-label": "datepicker next month button", disabled: this._nextMonthButtonDisabled, "aria-disabled": this._nextMonthButtonDisabled }, h("i", { class: "di di-next di20" }))), h("div", { class: "table" }, h("div", { class: "thead" }, h("div", { class: "tr days-of-the-week-row" }, this._dayNamesOfTheWeek.map((dayNameOfWeek) => h("div", { class: "th" }, dayNameOfWeek)))), h("div", { class: "separator" }), h("div", { class: "tbody" }, this._daysOfMonth.map(week => h("div", { class: "tr" }, week.map((dayOfMonth) => h("div", { class: "td " + this._tdIsEnabled(dayOfMonth) }, dayOfMonth.date &&
            h("range-datepicker-cell", { id: "cell-" + dayOfMonth.title, min: this.min, max: this.max, range: this.range, month: this.month, "on-date-is-hovered": this._handleDateHovered, "hovered-date": this.hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, "on-date-is-selected": this._handleDateSelected, day: dayOfMonth })))))))));
    }
    get el() { return this; }
    static get watchers() { return {
        "month": ["monthChanged"],
        "year": ["notifyYear"],
        "locale": ["_localeChanged"],
        "dateTo": ["notifyDateTo"],
        "dateFrom": ["notifyDateFrom"],
        "hoveredDate": ["notifyHoveredDate"],
        "min": ["_minChanged"],
        "max": ["_maxChanged"],
        "currentCalendarId": ["currentCalendarIdChanged"]
    }; }
    static get style() { return rangeDatepickerCalendarCss; }
}, [1, "range-datepicker-calendar", {
        "month": [1025],
        "year": [1025],
        "_dayNamesOfTheWeek": [1032, "_day-names-of-the-week"],
        "keepButtons": [4, "keep-buttons"],
        "range": [2],
        "_daysOfMonth": [1032, "_days-of-month"],
        "dynamicSizing": [4, "dynamic-sizing"],
        "locale": [1],
        "dateTo": [1026, "date-to"],
        "prev": [516],
        "next": [516],
        "single": [516],
        "dateFrom": [1026, "date-from"],
        "hoveredDate": [1538, "hovered-date"],
        "min": [2],
        "max": [2],
        "currentCalendarId": [1, "current-calendar-id"],
        "_animationDuration": [2, "_animation-duration"],
        "_prevMonthButtonDisabled": [1028, "_prev-month-button-disabled"],
        "_nextMonthButtonDisabled": [1028, "_next-month-button-disabled"],
        "_handleNextMonth": [8, "_handle-next-month"],
        "_handlePrevMonth": [8, "_handle-prev-month"]
    }, undefined, {
        "month": ["monthChanged"],
        "year": ["notifyYear"],
        "locale": ["_localeChanged"],
        "dateTo": ["notifyDateTo"],
        "dateFrom": ["notifyDateFrom"],
        "hoveredDate": ["notifyHoveredDate"],
        "min": ["_minChanged"],
        "max": ["_maxChanged"],
        "currentCalendarId": ["currentCalendarIdChanged"]
    }]);
function defineCustomElement$2() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["range-datepicker-calendar", "range-datepicker-cell"];
    components.forEach(tagName => { switch (tagName) {
        case "range-datepicker-calendar":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RangeDatepickerCalendar);
            }
            break;
        case "range-datepicker-cell":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
    } });
}
defineCustomElement$2();

const wdprRangeDatepickerCss = ":host{--font-family-base:var(--font-family-base-theme, InspireTWDC);--font-family-light:var(--font-family-light-theme, InspireTWDCLight);--font-family-heavy:var(--font-family-heavy-theme, InspireTWDCHeavy);--font-family-black:var(--font-family-black-theme, InspireTWDCBlack);--font-family-medium:var(--font-family-medium-theme, InspireTWDCMedium);--font-family-roman:var(--font-family-roman-theme, InspireTWDCRoman);--font-family-book:var(--font-family-book-theme, InspireTWDCBook);--font-weight-light:var(--font-weight-light-theme, 200);--font-weight-heavy:var(--font-weight-heavy-theme, 700);--font-weight-black:var(--font-weight-black-theme, 900);--font-weight-medium:var(--font-weight-medium-theme, 500);--font-weight-roman:var(--font-weight-roman-theme, 400);--font-weight-book:var(--font-weight-book-theme, 400);--font50-line-height:var(--font50-line-height-theme, 60px);--font40-line-height:var(--font40-line-height-theme, 50px);--font36-line-height:var(--font36-line-height-theme, 48px);--font28-line-height:var(--font28-line-height-theme, 36px);--font24-line-height:var(--font24-line-height-theme, 32px);--font20-line-height:var(--font20-line-height-theme, 28px);--font18-line-height:var(--font18-line-height-theme, 26px);--font16-line-height:var(--font16-line-height-theme, 24px);--font14-line-height:var(--font14-line-height-theme, 20px);--font12-line-height:var(--font12-line-height-theme, 20px)}:host{--font-base:{\n    font-family: var(--font-family-base)}; --font-light:{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}; --font-heavy:{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}; --font-black:{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}; --font-medium:{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}; --font-roman:{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}; --font-book:{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}; --font50:{font-size:50px;line-height:var(--font50-line-height)}; --font40:{font-size:40px;line-height:var(--font40-line-height)}; --font36:{font-size:36px;line-height:var(--font36-line-height)}; --font28:{font-size:28px;line-height:var(--font28-line-height)}; --font24:{font-size:24px;line-height:var(--font24-line-height)}; --font20:{font-size:20px;line-height:var(--font20-line-height)}; --font18:{font-size:18px;line-height:var(--font18-line-height)}; --font16:{font-size:16px;line-height:var(--font16-line-height)}; --font14:{font-size:14px;line-height:var(--font14-line-height)}; --font12:{font-size:12px;line-height:var(--font12-line-height)}; } .font-base,:host{font-family:var(--font-family-base)}.light{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}.heavy{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}.black{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}.medium{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}.roman{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}.book{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.font50{font-size:50px;line-height:var(--font50-line-height)}.font40{font-size:40px;line-height:var(--font40-line-height)}.font36{font-size:36px;line-height:var(--font36-line-height)}.font28{font-size:28px;line-height:var(--font28-line-height)}.font24{font-size:24px;line-height:var(--font24-line-height)}.font20{font-size:20px;line-height:var(--font20-line-height)}.font18{font-size:18px;line-height:var(--font18-line-height)}.font16{font-size:16px;line-height:var(--font16-line-height)}.font14{font-size:14px;line-height:var(--font14-line-height)}.font12{font-size:12px;line-height:var(--font12-line-height)}.font-lg-1{font-size:50px;line-height:var(--font50-line-height)}.font-lg-2{font-size:40px;line-height:var(--font40-line-height)}.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}@media only screen and (min-width: 481px) and (max-width: 1179.98px){.font-lg-1,.font-lg-2,.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}@media only screen and (max-width: 480.98px){.font-lg-1,.font-lg-2,.font-md-1,.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}:host{font-family:var(--font-family-base)}:host{--icon-font-family:var(--icon-font-family-theme, \"pepmdx\")}.di{font-family:var(--icon-font-family, \"pepmdx\") !important;font-style:normal;font-size:inherit}.di50{font-size:50px}.di40{font-size:40px}.di36{font-size:36px}.di28{font-size:28px}.di24{font-size:24px}.di20{font-size:20px}.di18{font-size:18px}.di16{font-size:16px}.di14{font-size:14px}.di12{font-size:12px}.di10{font-size:10px}.di-disney-resort::before,.di-E001::before{content:\"\\e001\"}.di-california-adventure::before,.di-E002::before{content:\"\\e002\"}.di-disney-paris::before,.di-E003::before{content:\"\\e003\"}.di-shanghai-disney-resort::before,.di-E004::before{content:\"\\e004\"}.di-hong-kong-disney::before,.di-E005::before{content:\"\\e005\"}.di-tokyo-disney::before,.di-E006::before{content:\"\\e006\"}.di-aulani-resort-hawaii::before,.di-E007::before{content:\"\\e007\"}.di-adventure-by-disney::before,.di-E008::before{content:\"\\e008\"}.di-disney-park-generic-castle::before,.di-E009::before{content:\"\\e009\"}.di-leadership::before,.di-E00A::before{content:\"\\e00a\"}.di-selection-training::before,.di-E00B::before{content:\"\\e00b\"}.di-quality-service::before,.di-E00C::before{content:\"\\e00c\"}.di-brand-royalty::before,.di-E00D::before{content:\"\\e00d\"}.di-creativity-innovate::before,.di-E00E::before{content:\"\\e00e\"}.di-business-excellence::before,.di-E00F::before{content:\"\\e00f\"}.di-medical-excellence::before,.di-E010::before{content:\"\\e010\"}.di-catalogs::before,.di-E011::before{content:\"\\e011\"}.di-disney-park::before,.di-E012::before{content:\"\\e012\"}.di-disneyland-resort::before,.di-E013::before{content:\"\\e013\"}.di-city-hall-services::before,.di-E014::before{content:\"\\e014\"}.di-hkdl-magic-access::before,.di-E015::before{content:\"\\e015\"}.di-downtown-disney::before,.di-E016::before{content:\"\\e016\"}.di-wedding-engagements::before,.di-E017::before{content:\"\\e017\"}.di-weddings-ever-after-blog::before,.di-E018::before{content:\"\\e018\"}.di-weddings-bridal-boutique::before,.di-E019::before{content:\"\\e019\"}.di-shdr-disneytown::before,.di-E01A::before{content:\"\\e01a\"}.di-shdr-wishing-star-park::before,.di-E01B::before{content:\"\\e01b\"}.di-shop-disney-parks-app::before,.di-E01C::before{content:\"\\e01c\"}.di-shop-disney-parks-bag::before,.di-E01D::before{content:\"\\e01d\"}.di-shop-disney-bag::before,.di-E01E::before{content:\"\\e01e\"}.di-style-guide::before,.di-E020::before{content:\"\\e020\"}.di-star-wars::before,.di-E021::before{content:\"\\e021\"}.di-sw-galaxys-edge-hub::before,.di-E022::before{content:\"\\e022\"}.di-rundisney-medals::before,.di-E023::before{content:\"\\e023\"}.di-rundisney-shirts::before,.di-E024::before{content:\"\\e024\"}.di-rundisney-snacks::before,.di-E025::before{content:\"\\e025\"}.di-disneyland-calender::before,.di-E026::before{content:\"\\e026\"}.di-california-adventure-calender::before,.di-E027::before{content:\"\\e027\"}.di-genie-product::before,.di-E028::before{content:\"\\e028\"}.di-all-parks-and-resorts::before,.di-E040::before{content:\"\\e040\"}.di-magic-kingdom::before,.di-E041::before{content:\"\\e041\"}.di-epcot::before,.di-E042::before{content:\"\\e042\"}.di-animal-kingdom::before,.di-E043::before{content:\"\\e043\"}.di-hollywood-studios::before,.di-E044::before{content:\"\\e044\"}.di-typhoon-lagoon::before,.di-E045::before{content:\"\\e045\"}.di-blizzard-beach::before,.di-E046::before{content:\"\\e046\"}.di-disney-springs::before,.di-E047::before{content:\"\\e047\"}.di-espn-wide-world-sports::before,.di-E048::before{content:\"\\e048\"}.di-resorts::before,.di-E049::before{content:\"\\e049\"}.di-disney-beach-resorts::before,.di-E04A::before{content:\"\\e04a\"}.di-disney-boardwalk::before,.di-E04B::before{content:\"\\e04b\"}.di-all-categories::before,.di-E04C::before{content:\"\\e04c\"}.di-cirque-du-soleil-la-nouba::before,.di-E04D::before{content:\"\\e04d\"}.di-star-wars-galactic-starcruiser::before,.di-E04E::before{content:\"\\e04e\"}.di-disney-cruise-line::before,.di-E080::before{content:\"\\e080\"}.di-dcl-our-ships::before,.di-E081::before{content:\"\\e081\"}.di-dcl-destinations::before,.di-E082::before{content:\"\\e082\"}.di-dcl-onboard-fun::before,.di-E083::before{content:\"\\e083\"}.di-dcl-new-cruisers::before,.di-E084::before{content:\"\\e084\"}.di-dcl-port-adventures::before,.di-E085::before{content:\"\\e085\"}.di-app-instructions::before,.di-E086::before{content:\"\\e086\"}.di-featured-article::before,.di-E087::before{content:\"\\e087\"}.di-drink-of-the-day::before,.di-E088::before{content:\"\\e088\"}.di-view-folio::before,.di-E08A::before{content:\"\\e08a\"}.di-key-to-the-world::before,.di-E08B::before{content:\"\\e08b\"}.di-in-room-entertainment::before,.di-E08C::before{content:\"\\e08c\"}.di-ship-directory::before,.di-E08D::before{content:\"\\e08d\"}.di-theatre::before,.di-E08E::before{content:\"\\e08e\"}.di-disembarkation::before,.di-E08F::before{content:\"\\e08f\"}.di-wash-hands::before,.di-E094::before{content:\"\\e094\"}.di-security-notice::before,.di-E095::before{content:\"\\e095\"}.di-environmental-message::before,.di-E096::before{content:\"\\e096\"}.di-room-upgrade::before,.di-E098::before{content:\"\\e098\"}.di-castaway-club-member::before,.di-E09A::before{content:\"\\e09a\"}.di-dcl-open-house::before,.di-E09B::before{content:\"\\e09b\"}.di-stateroom-balcony::before,.di-E09F::before{content:\"\\e09f\"}.di-cart-empty::before,.di-E0C0::before{content:\"\\e0c0\"}.di-cart-full::before,.di-E0C1::before{content:\"\\e0c1\"}.di-tickets::before,.di-E0C2::before{content:\"\\e0c2\"}.di-fastpass-plus::before,.di-E0C3::before{content:\"\\e0c3\"}.di-fastpasses-set::before,.di-E0C4::before{content:\"\\e0c4\"}.di-fastpasses-copy-set::before,.di-E0C5::before{content:\"\\e0c5\"}.di-cancel-fastpasses::before,.di-E0C6::before{content:\"\\e0c6\"}.di-water-park::before,.di-E0C7::before{content:\"\\e0c7\"}.di-vacation-packages::before,.di-E0C8::before{content:\"\\e0c8\"}.di-personal-magic::before,.di-E0C9::before{content:\"\\e0c9\"}.di-florida-resident::before,.di-E0CA::before{content:\"\\e0ca\"}.di-disney-vacation-club-info::before,.di-E0CB::before{content:\"\\e0cb\"}.di-annual-passholder::before,.di-E0CC::before{content:\"\\e0cc\"}.di-us-military::before,.di-E0CD::before{content:\"\\e0cd\"}.di-special-offers-dollar-sign::before,.di-E0CE::before{content:\"\\e0ce\"}.di-booking-rooms-packages::before,.di-E0CF::before{content:\"\\e0cf\"}.di-old-fastpass::before,.di-E0D0::before{content:\"\\e0d0\"}.di-certificate::before,.di-E0D1::before{content:\"\\e0d1\"}.di-will-call-tickets::before,.di-E0D2::before{content:\"\\e0d2\"}.di-entrance-pass::before,.di-E0D3::before{content:\"\\e0d3\"}.di-guest-pass::before,.di-E0D4::before{content:\"\\e0d4\"}.di-city-pass::before,.di-E0D5::before{content:\"\\e0d5\"}.di-california::before,.di-E0D6::before{content:\"\\e0d6\"}.di-southern-california::before,.di-E0D7::before{content:\"\\e0d7\"}.di-etickets::before,.di-E0D8::before{content:\"\\e0d8\"}.di-compare-offers::before,.di-E0D9::before{content:\"\\e0d9\"}.di-baja-california-resident::before,.di-E0DA::before{content:\"\\e0da\"}.di-area-attractions::before,.di-E0DB::before{content:\"\\e0db\"}.di-anaheim-resort-transit::before,.di-E0DC::before{content:\"\\e0dc\"}.di-edit-fastpass::before,.di-E0DD::before{content:\"\\e0dd\"}.di-in-park-merchandise::before,.di-E0E0::before{content:\"\\e0e0\"}.di-travel-insurance::before,.di-E0E1::before{content:\"\\e0e1\"}.di-texas-resident::before,.di-E0E2::before{content:\"\\e0e2\"}.di-canadian-resident::before,.di-E0E3::before{content:\"\\e0e3\"}.di-add-tickets::before,.di-E0E4::before{content:\"\\e0e4\"}.di-splurge::before,.di-E0E5::before{content:\"\\e0e5\"}.di-disneyland-annual-passes::before,.di-E0E6::before{content:\"\\e0e6\"}.di-dlr-tickets-passes::before,.di-E0E7::before{content:\"\\e0e7\"}.di-get-vacation-offer-recommended::before,.di-E0E8::before{content:\"\\e0e8\"}.di-get-vacation-offer-guest-created::before,.di-E0E9::before{content:\"\\e0e9\"}.di-shdr-fastpass::before,.di-E0EA::before{content:\"\\e0ea\"}.di-currency-convertor::before,.di-E0EB::before{content:\"\\e0eb\"}.di-call-to-buy-tickets::before,.di-E0EC::before{content:\"\\e0ec\"}.di-wdw-tickets-and-passes::before,.di-E0ED::before{content:\"\\e0ed\"}.di-renew-annual-pass::before,.di-E0EE::before{content:\"\\e0ee\"}.di-renew-annual-pass-dlr::before,.di-E0EF::before{content:\"\\e0ef\"}.di-annual-pass-wdw::before,.di-E0F0::before{content:\"\\e0f0\"}.di-mobile-order::before,.di-E0F1::before{content:\"\\e0f1\"}.di-fastpass::before,.di-E0F2::before{content:\"\\e0f2\"}.di-ticket-ap-upgrade::before,.di-E0F3::before{content:\"\\e0f3\"}.di-shdr-premium-access::before,.di-E0F4::before{content:\"\\e0f4\"}.di-shdr-tickets-and-passes::before,.di-E0F5::before{content:\"\\e0f5\"}.di-shdr-seasonal-pass::before,.di-E0F6::before{content:\"\\e0f6\"}.di-shdr-fastpass-reverse::before,.di-E0F7::before{content:\"\\e0f7\"}.di-disney-maxpass::before,.di-E0F8::before{content:\"\\e0f8\"}.di-shdr-premium-access-chinese::before,.di-E0F9::before{content:\"\\e0f9\"}.di-hawaii-resident::before,.di-E0FA::before{content:\"\\e0fa\"}.di-club-33-membership::before,.di-E0FB::before{content:\"\\e0fb\"}.di-order-grocery-delivery::before,.di-E0FC::before{content:\"\\e0fc\"}.di-special-offers::before,.di-E0FD::before{content:\"\\e0fd\"}.di-prebook-fastpass::before,.di-E0FE::before{content:\"\\e0fe\"}.di-upgrade-offer::before,.di-E0FF::before{content:\"\\e0ff\"}.di-mdx::before,.di-E100::before{content:\"\\e100\"}.di-about-me::before,.di-E101::before{content:\"\\e101\"}.di-friends-family::before,.di-E102::before{content:\"\\e102\"}.di-account-settings::before,.di-E103::before{content:\"\\e103\"}.di-magicbands-v2::before,.di-E104::before{content:\"\\e104\"}.di-magic-cards::before,.di-E105::before{content:\"\\e105\"}.di-pin-payment-methods::before,.di-E106::before{content:\"\\e106\"}.di-communication-references::before,.di-E107::before{content:\"\\e107\"}.di-wishlist::before,.di-E108::before{content:\"\\e108\"}.di-link-existing-reservation::before,.di-E109::before{content:\"\\e109\"}.di-guest-entered-schedule-item::before,.di-E10A::before{content:\"\\e10a\"}.di-birthday::before,.di-E10B::before{content:\"\\e10b\"}.di-memory-maker::before,.di-E10C::before{content:\"\\e10c\"}.di-memory-maker-2::before,.di-E10D::before{content:\"\\e10d\"}.di-passes-and-memberships::before,.di-E10E::before{content:\"\\e10e\"}.di-link-mdx-tickets-passes::before,.di-E10F::before{content:\"\\e10f\"}.di-link-mdx-resort-reservations::before,.di-E110::before{content:\"\\e110\"}.di-link-mdx-dining-reservations::before,.di-E111::before{content:\"\\e111\"}.di-link-dlr-tickets::before,.di-E112::before{content:\"\\e112\"}.di-link-main-entrance::before,.di-E113::before{content:\"\\e113\"}.di-digital-key::before,.di-E115::before{content:\"\\e115\"}.di-wishlist-item-added::before,.di-E116::before{content:\"\\e116\"}.di-wishlist-empty::before,.di-E117::before{content:\"\\e117\"}.di-magicbands-original::before,.di-E118::before{content:\"\\e118\"}.di-all-activities::before,.di-E140::before{content:\"\\e140\"}.di-attractions::before,.di-E141::before{content:\"\\e141\"}.di-characters::before,.di-E142::before{content:\"\\e142\"}.di-entertainment::before,.di-E143::before{content:\"\\e143\"}.di-tours-events::before,.di-E144::before{content:\"\\e144\"}.di-in-park-shopping::before,.di-E145::before{content:\"\\e145\"}.di-spas::before,.di-E146::before{content:\"\\e146\"}.di-tour::before,.di-E14C::before{content:\"\\e14c\"}.di-spring-break::before,.di-E14D::before{content:\"\\e14d\"}.di-fireworks::before,.di-E14E::before{content:\"\\e14e\"}.di-shows::before,.di-E14F::before{content:\"\\e14f\"}.di-dining::before,.di-E180::before{content:\"\\e180\"}.di-dining-plan::before,.di-E181::before{content:\"\\e181\"}.di-dining-plan-accepted::before,.di-E182::before{content:\"\\e182\"}.di-dining-plan-not-accepted::before,.di-E183::before{content:\"\\e183\"}.di-dining-reservation::before,.di-E184::before{content:\"\\e184\"}.di-menu::before,.di-E185::before{content:\"\\e185\"}.di-prix-fixe-qsr::before,.di-E186::before{content:\"\\e186\"}.di-prix-fixe-tsr::before,.di-E187::before{content:\"\\e187\"}.di-entrees-qsr::before,.di-E188::before{content:\"\\e188\"}.di-entrees-tsr::before,.di-E189::before{content:\"\\e189\"}.di-beverages::before,.di-E18A::before{content:\"\\e18a\"}.di-wine::before,.di-E18B::before{content:\"\\e18b\"}.di-beer::before,.di-E18C::before{content:\"\\e18c\"}.di-cocktails::before,.di-E18D::before{content:\"\\e18d\"}.di-appetizers::before,.di-E18E::before{content:\"\\e18e\"}.di-sandwiches::before,.di-E18F::before{content:\"\\e18f\"}.di-beef-pork-chicken::before,.di-E190::before{content:\"\\e190\"}.di-seafood::before,.di-E191::before{content:\"\\e191\"}.di-pasta::before,.di-E192::before{content:\"\\e192\"}.di-salads::before,.di-E193::before{content:\"\\e193\"}.di-sides::before,.di-E194::before{content:\"\\e194\"}.di-desserts::before,.di-E195::before{content:\"\\e195\"}.di-buffet::before,.di-E196::before{content:\"\\e196\"}.di-favorites::before,.di-E197::before{content:\"\\e197\"}.di-kids-picks::before,.di-E198::before{content:\"\\e198\"}.di-featured-items::before,.di-E199::before{content:\"\\e199\"}.di-nutritional-content::before,.di-E19A::before{content:\"\\e19a\"}.di-nutritional-information::before,.di-E19B::before{content:\"\\e19b\"}.di-gluten-free::before,.di-E19C::before{content:\"\\e19c\"}.di-dairy-free::before,.di-E19D::before{content:\"\\e19d\"}.di-character-dining::before,.di-E19E::before{content:\"\\e19e\"}.di-mockey-food-seal::before,.di-E19F::before{content:\"\\e19f\"}.di-priority-seating::before,.di-E1A1::before{content:\"\\e1a1\"}.di-vegetarian::before,.di-E1A2::before{content:\"\\e1a2\"}.di-raw-food::before,.di-E1A3::before{content:\"\\e1a3\"}.di-guest-favorite-food::before,.di-E1A4::before{content:\"\\e1a4\"}.di-mobile-order-food::before,.di-E1A5::before{content:\"\\e1a5\"}.di-adult-table-service::before,.di-E1A6::before{content:\"\\e1a6\"}.di-celebration-cakes::before,.di-E1A7::before{content:\"\\e1a7\"}.di-disney-dining-plan::before,.di-E1A8::before{content:\"\\e1a8\"}.di-disney-deluxe-dining-plan::before,.di-E1A9::before{content:\"\\e1a9\"}.di-coffee-mug::before,.di-E1AA::before{content:\"\\e1aa\"}.di-mobile-order-food::before,.di-E1AB::before{content:\"\\e1ab\"}.di-qs-dining-card::before,.di-E1AC::before{content:\"\\e1ac\"}.di-allergy-friendly::before,.di-E1AD::before{content:\"\\e1ad\"}.di-kids-meals::before,.di-E1AE::before{content:\"\\e1ae\"}.di-dining-check-in::before,.di-E1AF::before{content:\"\\e1af\"}.di-sports-recreation::before,.di-E1C0::before{content:\"\\e1c0\"}.di-campfire::before,.di-E1C1::before{content:\"\\e1c1\"}.di-snorkeling::before,.di-E1C2::before{content:\"\\e1c2\"}.di-swimming::before,.di-E1C3::before{content:\"\\e1c3\"}.di-boating::before,.di-E1C4::before{content:\"\\e1c4\"}.di-running::before,.di-E1C5::before{content:\"\\e1c5\"}.di-fitness-room::before,.di-E1C6::before{content:\"\\e1c6\"}.di-game::before,.di-E1C7::before{content:\"\\e1c7\"}.di-shuffleboard::before,.di-E1C8::before{content:\"\\e1c8\"}.di-parasailing::before,.di-E1C9::before{content:\"\\e1c9\"}.di-playground::before,.di-E1CA::before{content:\"\\e1ca\"}.di-horseback-riding::before,.di-E1CB::before{content:\"\\e1cb\"}.di-pool-tables::before,.di-E1CC::before{content:\"\\e1cc\"}.di-fishing::before,.di-E1CD::before{content:\"\\e1cd\"}.di-volleyball::before,.di-E1CE::before{content:\"\\e1ce\"}.di-basketball::before,.di-E1CF::before{content:\"\\e1cf\"}.di-cycling::before,.di-E1D0::before{content:\"\\e1d0\"}.di-explore::before,.di-E1D1::before{content:\"\\e1d1\"}.di-disneyland-recreation::before,.di-E1D2::before{content:\"\\e1d2\"}.di-baseball::before,.di-E1D4::before{content:\"\\e1d4\"}.di-field-hockey::before,.di-E1D5::before{content:\"\\e1d5\"}.di-football::before,.di-E1D6::before{content:\"\\e1d6\"}.di-gymnastics::before,.di-E1D7::before{content:\"\\e1d7\"}.di-lacrosse::before,.di-E1D8::before{content:\"\\e1d8\"}.di-crosscountry::before,.di-E1D9::before{content:\"\\e1d9\"}.di-soccer::before,.di-E1DA::before{content:\"\\e1da\"}.di-softball-fastpitch::before,.di-E1DB::before{content:\"\\e1db\"}.di-softball-slowpitch::before,.di-E1DC::before{content:\"\\e1dc\"}.di-track-field::before,.di-E1DD::before{content:\"\\e1dd\"}.di-tennis-court::before,.di-E1DE::before{content:\"\\e1de\"}.di-generic-sports::before,.di-E1DF::before{content:\"\\e1df\"}.di-maps::before,.di-E200::before{content:\"\\e200\"}.di-guest-services::before,.di-E201::before{content:\"\\e201\"}.di-concierge::before,.di-E202::before{content:\"\\e202\"}.di-resort-checkin::before,.di-E203::before{content:\"\\e203\"}.di-celebration::before,.di-E204::before{content:\"\\e204\"}.di-aeds::before,.di-E205::before{content:\"\\e205\"}.di-smoking-area::before,.di-E206::before{content:\"\\e206\"}.di-no-smoking::before,.di-E207::before{content:\"\\e207\"}.di-lost-found::before,.di-E208::before{content:\"\\e208\"}.di-baby-care-center::before,.di-E209::before{content:\"\\e209\"}.di-currency-exchange::before,.di-E20A::before{content:\"\\e20a\"}.di-atm::before,.di-E20B::before{content:\"\\e20b\"}.di-restrooms::before,.di-E20C::before{content:\"\\e20c\"}.di-first-aid::before,.di-E20D::before{content:\"\\e20d\"}.di-laundry::before,.di-E20E::before{content:\"\\e20e\"}.di-valet::before,.di-E20F::before{content:\"\\e20f\"}.di-in-room-babysitting::before,.di-E210::before{content:\"\\e210\"}.di-business-center::before,.di-E211::before{content:\"\\e211\"}.di-cabanas::before,.di-E212::before{content:\"\\e212\"}.di-ecv::before,.di-E213::before{content:\"\\e213\"}.di-strollers::before,.di-E214::before{content:\"\\e214\"}.di-parking-lot::before,.di-E215::before{content:\"\\e215\"}.di-kennel::before,.di-E216::before{content:\"\\e216\"}.di-package-pick-up::before,.di-E217::before{content:\"\\e217\"}.di-gas-station::before,.di-E218::before{content:\"\\e218\"}.di-pin-trading::before,.di-E219::before{content:\"\\e219\"}.di-translation-devices::before,.di-E21A::before{content:\"\\e21a\"}.di-wedding-ceremonies::before,.di-E21B::before{content:\"\\e21b\"}.di-resort-amenities::before,.di-E21C::before{content:\"\\e21c\"}.di-movies-under-the-stars::before,.di-E21D::before{content:\"\\e21d\"}.di-kodak-picture-spot::before,.di-E21E::before{content:\"\\e21e\"}.di-locker-rentals::before,.di-E21F::before{content:\"\\e21f\"}.di-here-now::before,.di-E220::before{content:\"\\e220\"}.di-current-location::before,.di-E221::before{content:\"\\e221\"}.di-supervise-children::before,.di-E222::before{content:\"\\e222\"}.di-rider-swap::before,.di-E223::before{content:\"\\e223\"}.di-service-dog::before,.di-E224::before{content:\"\\e224\"}.di-free-disney-wifi::before,.di-E225::before{content:\"\\e225\"}.di-generic-wifi::before,.di-E226::before{content:\"\\e226\"}.di-location-pin::before,.di-E22B::before{content:\"\\e22b\"}.di-disney-express-luggage::before,.di-E22D::before{content:\"\\e22d\"}.di-picnic-area::before,.di-E230::before{content:\"\\e230\"}.di-nikon-picture-spot::before,.di-E236::before{content:\"\\e236\"}.di-atm-2::before,.di-E237::before{content:\"\\e237\"}.di-drinking-fountains::before,.di-E238::before{content:\"\\e238\"}.di-package-express::before,.di-E239::before{content:\"\\e239\"}.di-kingdom-club-bellman::before,.di-E23A::before{content:\"\\e23a\"}.di-in-park-info::before,.di-E23B::before{content:\"\\e23b\"}.di-magical-coin-press-machine::before,.di-E23C::before{content:\"\\e23c\"}.di-stroller-parking::before,.di-E23D::before{content:\"\\e23d\"}.di-electric-car-charging-station::before,.di-E23E::before{content:\"\\e23e\"}.di-parade-route-show-area::before,.di-E23F::before{content:\"\\e23f\"}.di-alert::before,.di-E240::before{content:\"\\e240\"}.di-checkmark::before,.di-E241::before{content:\"\\e241\"}.di-faqs::before,.di-E242::before{content:\"\\e242\"}.di-quick-answer::before,.di-E243::before{content:\"\\e243\"}.di-disney-parks-blog::before,.di-E244::before{content:\"\\e244\"}.di-sms::before,.di-E245::before{content:\"\\e245\"}.di-press-center::before,.di-E246::before{content:\"\\e246\"}.di-moms-panel::before,.di-E247::before{content:\"\\e247\"}.di-park-schedule::before,.di-E248::before{content:\"\\e248\"}.di-time::before,.di-E249::before{content:\"\\e249\"}.di-privacy-policies::before,.di-E24A::before{content:\"\\e24a\"}.di-terms-conditions::before,.di-E24B::before{content:\"\\e24b\"}.di-accessibility::before,.di-E24C::before{content:\"\\e24c\"}.di-pre-arrival-tips::before,.di-E24D::before{content:\"\\e24d\"}.di-reservations::before,.di-E24E::before{content:\"\\e24e\"}.di-registration::before,.di-E24F::before{content:\"\\e24f\"}.di-help-support::before,.di-E250::before{content:\"\\e250\"}.di-learn-more::before,.di-E251::before{content:\"\\e251\"}.di-email::before,.di-E252::before{content:\"\\e252\"}.di-chat::before,.di-E253::before{content:\"\\e253\"}.di-call::before,.di-E254::before{content:\"\\e254\"}.di-14-days-notice::before,.di-E255::before{content:\"\\e255\"}.di-6-months-notice::before,.di-E256::before{content:\"\\e256\"}.di-blackout-days::before,.di-E257::before{content:\"\\e257\"}.di-3-days-notice::before,.di-E258::before{content:\"\\e258\"}.di-website-support::before,.di-E259::before{content:\"\\e259\"}.di-restriction::before,.di-E25A::before{content:\"\\e25a\"}.di-recommendation::before,.di-E25B::before{content:\"\\e25b\"}.di-na-dash::before,.di-E25C::before{content:\"\\e25c\"}.di-magic-morning::before,.di-E25D::before{content:\"\\e25d\"}.di-global-languages::before,.di-E25E::before{content:\"\\e25e\"}.di-good-neighbor-hotel::before,.di-E25F::before{content:\"\\e25f\"}.di-travel-information::before,.di-E261::before{content:\"\\e261\"}.di-visiting-with-groups::before,.di-E262::before{content:\"\\e262\"}.di-visiting-with-children::before,.di-E263::before{content:\"\\e263\"}.di-disney-like-light::before,.di-E266::before{content:\"\\e266\"}.di-disney-like-dark::before,.di-E267::before{content:\"\\e267\"}.di-written-aids::before,.di-E268::before{content:\"\\e268\"}.di-generations-travel::before,.di-E269::before{content:\"\\e269\"}.di-empty-chat::before,.di-E26A::before{content:\"\\e26a\"}.di-filled-chat::before,.di-E26B::before{content:\"\\e26b\"}.di-empty-checkbox::before,.di-E26C::before{content:\"\\e26c\"}.di-selected-solid-checkbox::before,.di-E26D::before{content:\"\\e26d\"}.di-selected-disabled::before,.di-E26E::before{content:\"\\e26e\"}.di-indeterminate::before,.di-E26F::before{content:\"\\e26f\"}.di-10-days-notice::before,.di-E270::before{content:\"\\e270\"}.di-wdw-ap-blockout-cal::before,.di-E271::before{content:\"\\e271\"}.di-flexible-ticket::before,.di-E272::before{content:\"\\e272\"}.di-ride-height::before,.di-E275::before{content:\"\\e275\"}.di-adults::before,.di-E276::before{content:\"\\e276\"}.di-teens-tweens::before,.di-E277::before{content:\"\\e277\"}.di-kids::before,.di-E278::before{content:\"\\e278\"}.di-price-range::before,.di-E279::before{content:\"\\e279\"}.di-price-range-outlined::before,.di-E27A::before{content:\"\\e27a\"}.di-time-outlined::before,.di-E27B::before{content:\"\\e27b\"}.di-all-parks-available::before,.di-E27C::before{content:\"\\e27c\"}.di-some-parks-available::before,.di-E27D::before{content:\"\\e27d\"}.di-my-media::before,.di-E280::before{content:\"\\e280\"}.di-images::before,.di-E281::before{content:\"\\e281\"}.di-videos::before,.di-E282::before{content:\"\\e282\"}.di-photo-pass::before,.di-E283::before{content:\"\\e283\"}.di-photo-pass-plus::before,.di-E284::before{content:\"\\e284\"}.di-media-favorites::before,.di-E285::before{content:\"\\e285\"}.di-photo-fun::before,.di-E286::before{content:\"\\e286\"}.di-disney-vision::before,.di-E287::before{content:\"\\e287\"}.di-dvd-cd::before,.di-E288::before{content:\"\\e288\"}.di-shdr-photopass::before,.di-E289::before{content:\"\\e289\"}.di-order-dvd::before,.di-E28B::before{content:\"\\e28b\"}.di-presented-in-3d::before,.di-E28C::before{content:\"\\e28c\"}.di-guest-photos::before,.di-E28D::before{content:\"\\e28d\"}.di-on-demand::before,.di-E28E::before{content:\"\\e28e\"}.di-live-stream::before,.di-E28F::before{content:\"\\e28f\"}.di-photopass-lenses::before,.di-E290::before{content:\"\\e290\"}.di-monorail::before,.di-E2C0::before{content:\"\\e2c0\"}.di-bus::before,.di-E2C1::before{content:\"\\e2c1\"}.di-car::before,.di-E2C2::before{content:\"\\e2c2\"}.di-boat::before,.di-E2C3::before{content:\"\\e2c3\"}.di-taxi::before,.di-E2C4::before{content:\"\\e2c4\"}.di-flight::before,.di-E2C5::before{content:\"\\e2c5\"}.di-return-flight::before,.di-E2C6::before{content:\"\\e2c6\"}.di-walking::before,.di-E2C7::before{content:\"\\e2c7\"}.di-free-shuttle::before,.di-E2C8::before{content:\"\\e2c8\"}.di-hkdl-mtr-disney-resort-line::before,.di-E2CE::before{content:\"\\e2ce\"}.di-bus-schedule::before,.di-E2CF::before{content:\"\\e2cf\"}.di-minnie-vans-ride-share::before,.di-E2D0::before{content:\"\\e2d0\"}.di-transportation-multiple::before,.di-E2D1::before{content:\"\\e2d1\"}.di-wdw-skylinero::before,.di-E2D2::before{content:\"\\e2d2\"}.di-close-button::before,.di-E300::before{content:\"\\e300\"}.di-add-button::before,.di-E301::before{content:\"\\e301\"}.di-information::before,.di-E302::before{content:\"\\e302\"}.di-share::before,.di-E303::before{content:\"\\e303\"}.di-download::before,.di-E304::before{content:\"\\e304\"}.di-show-filters::before,.di-E305::before{content:\"\\e305\"}.di-hide-filters::before,.di-E306::before{content:\"\\e306\"}.di-3d-spin::before,.di-E307::before{content:\"\\e307\"}.di-media-play-button::before,.di-E308::before{content:\"\\e308\"}.di-media-pause-button::before,.di-E309::before{content:\"\\e309\"}.di-pdf::before,.di-E30A::before{content:\"\\e30a\"}.di-duplicate-offer::before,.di-E30B::before{content:\"\\e30b\"}.di-next::before,.di-E30C::before{content:\"\\e30c\"}.di-previous::before,.di-E30D::before{content:\"\\e30d\"}.di-print::before,.di-E30F::before{content:\"\\e30f\"}.di-search::before,.di-E310::before{content:\"\\e310\"}.di-calendar-month::before,.di-E311::before{content:\"\\e311\"}.di-calendar-day-view::before,.di-E312::before{content:\"\\e312\"}.di-more::before,.di-E313::before{content:\"\\e313\"}.di-menu-global-nav::before,.di-E314::before{content:\"\\e314\"}.di-menus-button::before,.di-E315::before{content:\"\\e315\"}.di-norgie-opened::before,.di-E316::before{content:\"\\e316\"}.di-upload::before,.di-E317::before{content:\"\\e317\"}.di-lists::before,.di-E318::before{content:\"\\e318\"}.di-filter::before,.di-E319::before{content:\"\\e319\"}.di-scan-barcode::before,.di-E31A::before{content:\"\\e31a\"}.di-keyboard-entry::before,.di-E31B::before{content:\"\\e31b\"}.di-download-mobile-app::before,.di-E31C::before{content:\"\\e31c\"}.di-view-gallery::before,.di-E31D::before{content:\"\\e31d\"}.di-see-info-page-button::before,.di-E31E::before{content:\"\\e31e\"}.di-media-gallery-photo-button::before,.di-E31F::before{content:\"\\e31f\"}.di-media-gallery-video-button::before,.di-E320::before{content:\"\\e320\"}.di-refresh::before,.di-E321::before{content:\"\\e321\"}.di-compose-message::before,.di-E322::before{content:\"\\e322\"}.di-add-contact::before,.di-E323::before{content:\"\\e323\"}.di-contact-list::before,.di-E324::before{content:\"\\e324\"}.di-norgie-up::before,.di-E325::before{content:\"\\e325\"}.di-norgie-left::before,.di-E326::before{content:\"\\e326\"}.di-mobile-app::before,.di-E327::before{content:\"\\e327\"}.di-home::before,.di-E328::before{content:\"\\e328\"}.di-return-arrow::before,.di-E329::before{content:\"\\e329\"}.di-share-2::before,.di-E32A::before{content:\"\\e32a\"}.di-delete-button::before,.di-E32B::before{content:\"\\e32b\"}.di-fast-forward-button::before,.di-E32C::before{content:\"\\e32c\"}.di-rewind-button::before,.di-E32D::before{content:\"\\e32d\"}.di-pulldown::before,.di-E32E::before{content:\"\\e32e\"}.di-increase-button::before,.di-E32F::before{content:\"\\e32f\"}.di-decrease-button::before,.di-E330::before{content:\"\\e330\"}.di-flip-turn-over::before,.di-E331::before{content:\"\\e331\"}.di-previous-2::before,.di-E332::before{content:\"\\e332\"}.di-next-2::before,.di-E333::before{content:\"\\e333\"}.di-arrow-back::before,.di-E334::before{content:\"\\e334\"}.di-arrow-up::before,.di-E335::before{content:\"\\e335\"}.di-arrow-down::before,.di-E336::before{content:\"\\e336\"}.di-expand-gallery::before,.di-E337::before{content:\"\\e337\"}.di-360-video::before,.di-E338::before{content:\"\\e338\"}.di-volume-control::before,.di-E339::before{content:\"\\e339\"}.di-app-card-info::before,.di-E33A::before{content:\"\\e33a\"}.di-app-card-flip::before,.di-E33B::before{content:\"\\e33b\"}.di-close-reversed::before,.di-E33E::before{content:\"\\e33e\"}.di-expand-show-more::before,.di-E33F::before{content:\"\\e33f\"}.di-wheelchair-accessibility::before,.di-E340::before{content:\"\\e340\"}.di-transfer-from-wheelchair::before,.di-E341::before{content:\"\\e341\"}.di-transfer-to-wheelchair::before,.di-E342::before{content:\"\\e342\"}.di-transfer-to-wheelchair-then-ride::before,.di-E343::before{content:\"\\e343\"}.di-ambulatory::before,.di-E344::before{content:\"\\e344\"}.di-visual-impairment::before,.di-E345::before{content:\"\\e345\"}.di-hearing-impairment::before,.di-E346::before{content:\"\\e346\"}.di-sign-language::before,.di-E347::before{content:\"\\e347\"}.di-audio-description::before,.di-E348::before{content:\"\\e348\"}.di-handheld-captioning::before,.di-E349::before{content:\"\\e349\"}.di-reflective-captioning::before,.di-E34A::before{content:\"\\e34a\"}.di-closed-captioning::before,.di-E34B::before{content:\"\\e34b\"}.di-physicial-consideration-red-yellow::before,.di-E34C::before{content:\"\\e34c\"}.di-scary-consideration-yellow::before,.di-E34D::before{content:\"\\e34d\"}.di-dlp-mobility-disabilities::before,.di-E34E::before{content:\"\\e34e\"}.di-dlp-hearing-disabilities::before,.di-E34F::before{content:\"\\e34f\"}.di-dlp-visual-disabilities::before,.di-E350::before{content:\"\\e350\"}.di-photosensitive-epilepsy::before,.di-E351::before{content:\"\\e351\"}.di-dlp-mental-cognitive-disabilities::before,.di-E352::before{content:\"\\e352\"}.di-suitable-for-amputees::before,.di-E353::before{content:\"\\e353\"}.di-suitable-for-difficulty-standing::before,.di-E354::before{content:\"\\e354\"}.di-capable-of-climbing-steps::before,.di-E355::before{content:\"\\e355\"}.di-disabilities-services::before,.di-E356::before{content:\"\\e356\"}.di-disabilities-guide-book::before,.di-E357::before{content:\"\\e357\"}.di-wheelchair-rental::before,.di-E358::before{content:\"\\e358\"}.di-disabilities-designated-viewing::before,.di-E359::before{content:\"\\e359\"}.di-may-remain-in-wheelchair::before,.di-E35A::before{content:\"\\e35a\"}.di-must-be-ambulatory-2::before,.di-E35B::before{content:\"\\e35b\"}.di-suitable-for-blind::before,.di-E35C::before{content:\"\\e35c\"}.di-suitable-for-autism::before,.di-E35D::before{content:\"\\e35d\"}.di-sign-language-2::before,.di-E35E::before{content:\"\\e35e\"}.di-tactile-maps::before,.di-E35F::before{content:\"\\e35f\"}.di-braille-guide-books::before,.di-E360::before{content:\"\\e360\"}.di-suitable-for-learning-disabilities::before,.di-E361::before{content:\"\\e361\"}.di-induction-loop::before,.di-E362::before{content:\"\\e362\"}.di-dimly-lit-space::before,.di-E363::before{content:\"\\e363\"}.di-light-rain-indoors::before,.di-E364::before{content:\"\\e364\"}.di-show-contains-bubble::before,.di-E365::before{content:\"\\e365\"}.di-hdd-illness::before,.di-E366::before{content:\"\\e366\"}.di-open-captioning::before,.di-E367::before{content:\"\\e367\"}.di-magnetic-fields::before,.di-E368::before{content:\"\\e368\"}.di-open-captioning-square::before,.di-E369::before{content:\"\\e369\"}.di-gifts::before,.di-E380::before{content:\"\\e380\"}.di-character-calls::before,.di-E381::before{content:\"\\e381\"}.di-performing-arts::before,.di-E382::before{content:\"\\e382\"}.di-education::before,.di-E383::before{content:\"\\e383\"}.di-lock::before,.di-E384::before{content:\"\\e384\"}.di-facebook::before,.di-E385::before{content:\"\\e385\"}.di-twitter::before,.di-E386::before{content:\"\\e386\"}.di-youtube::before,.di-E387::before{content:\"\\e387\"}.di-instagram::before,.di-E388::before{content:\"\\e388\"}.di-pinterest::before,.di-E389::before{content:\"\\e389\"}.di-google-plus::before,.di-E38A::before{content:\"\\e38a\"}.di-disney-cast::before,.di-E38B::before{content:\"\\e38b\"}.di-disney-response::before,.di-E38C::before{content:\"\\e38c\"}.di-thrill-seekers::before,.di-E38E::before{content:\"\\e38e\"}.di-doll::before,.di-E390::before{content:\"\\e390\"}.di-front-desk::before,.di-E391::before{content:\"\\e391\"}.di-movies::before,.di-E392::before{content:\"\\e392\"}.di-unlocked::before,.di-E393::before{content:\"\\e393\"}.di-tumblr::before,.di-E394::before{content:\"\\e394\"}.di-services::before,.di-E395::before{content:\"\\e395\"}.di-old-photopass-plus::before,.di-E396::before{content:\"\\e396\"}.di-hkdl-sina-weibo-social::before,.di-E397::before{content:\"\\e397\"}.di-hkdl-baidu-tieba-social::before,.di-E398::before{content:\"\\e398\"}.di-hkdl-webchat-social::before,.di-E399::before{content:\"\\e399\"}.di-disney-wild-about-safety::before,.di-E39A::before{content:\"\\e39a\"}.di-romantic-celebration::before,.di-E39B::before{content:\"\\e39b\"}.di-facebook-icon-alone::before,.di-E39C::before{content:\"\\e39c\"}.di-twitter-icon-alone::before,.di-E39D::before{content:\"\\e39d\"}.di-snapchat::before,.di-E39E::before{content:\"\\e39e\"}.di-photopass-attraction-id::before,.di-E39F::before{content:\"\\e39f\"}.di-achievement::before,.di-E3A0::before{content:\"\\e3a0\"}.di-apple-music::before,.di-E3A1::before{content:\"\\e3a1\"}.di-apple-music-alternate::before,.di-E3A2::before{content:\"\\e3a2\"}.di-watches-time::before,.di-E3A3::before{content:\"\\e3a3\"}.di-magic-coming-soon::before,.di-E3A4::before{content:\"\\e3a4\"}.di-winter::before,.di-E3E4::before{content:\"\\e3e4\"}.di-spring::before,.di-E3E5::before{content:\"\\e3e5\"}.di-summer::before,.di-E3E6::before{content:\"\\e3e6\"}.di-autumn::before,.di-E3E7::before{content:\"\\e3e7\"}.di-pack-for-weather::before,.di-E3E8::before{content:\"\\e3e8\"}.di-single-rider::before,.di-E440::before{content:\"\\e440\"}.di-atm-china::before,.di-E441::before{content:\"\\e441\"}.di-wayfinding-slight-left::before,.di-E442::before{content:\"\\e442\"}.di-wayfinding-slight-right::before,.di-E443::before{content:\"\\e443\"}.di-wayfinding-turn-left::before,.di-E444::before{content:\"\\e444\"}.di-wayfinding-turn-right::before,.di-E445::before{content:\"\\e445\"}.di-wayfinding-hard-left::before,.di-E446::before{content:\"\\e446\"}.di-wayfinding-hard-right::before,.di-E447::before{content:\"\\e447\"}.di-wayfinding-left::before,.di-E448::before{content:\"\\e448\"}.di-wayfinding-right::before,.di-E449::before{content:\"\\e449\"}.di-wayfinding-forward::before,.di-E44A::before{content:\"\\e44a\"}.di-wayfinding-back::before,.di-E44B::before{content:\"\\e44b\"}.di-wayfinding-forward-back::before,.di-E44C::before{content:\"\\e44c\"}.di-wayfinding-right-left::before,.di-E44D::before{content:\"\\e44d\"}.di-wayfinding-around-slight-left::before,.di-E44E::before{content:\"\\e44e\"}.di-wayfinding-around-slight-right::before,.di-E44F::before{content:\"\\e44f\"}.di-wayfinding-around-turn-left::before,.di-E450::before{content:\"\\e450\"}.di-wayfinding-around-turn-right::before,.di-E451::before{content:\"\\e451\"}.di-wayfinding-around-hard-left::before,.di-E452::before{content:\"\\e452\"}.di-wayfinding-around-hard-right::before,.di-E453::before{content:\"\\e453\"}.di-wayfinding-around-left::before,.di-E454::before{content:\"\\e454\"}.di-wayfinding-around-right::before,.di-E455::before{content:\"\\e455\"}.di-wayfinding-around-forward-left::before,.di-E456::before{content:\"\\e456\"}.di-wayfinding-around-forward-right::before,.di-E457::before{content:\"\\e457\"}.di-wayfinding-u-turn-right::before,.di-E458::before{content:\"\\e458\"}.di-wayfinding-u-turn-left::before,.di-E459::before{content:\"\\e459\"}.di-wayfinding-ramp-left::before,.di-E45A::before{content:\"\\e45a\"}.di-wayfinding-ramp-right::before,.di-E45B::before{content:\"\\e45b\"}.di-wayfinding-fork-left::before,.di-E45C::before{content:\"\\e45c\"}.di-wayfinding-fork-right::before,.di-E45D::before{content:\"\\e45d\"}.di-wayfinding-around-about-left::before,.di-E45E::before{content:\"\\e45e\"}.di-wayfinding-around-about-right::before,.di-E45F::before{content:\"\\e45f\"}.di-wayfinding-merge::before,.di-E460::before{content:\"\\e460\"}.di-cribs-and-playpens::before,.di-E461::before{content:\"\\e461\"}.di-baby-care-center2::before,.di-E462::before{content:\"\\e462\"}.di-epi-pen::before,.di-E463::before{content:\"\\e463\"}.di-mobile-charging-station::before,.di-E464::before{content:\"\\e464\"}.di-security-info::before,.di-E465::before{content:\"\\e465\"}.di-refrigerator-available::before,.di-E466::before{content:\"\\e466\"}.di-repellant-zika::before,.di-E467::before{content:\"\\e467\"}.di-hurricane-information::before,.di-E468::before{content:\"\\e468\"}.di-recenter-map::before,.di-E46A::before{content:\"\\e46a\"}.di-location-pin::before,.di-E46C::before{content:\"\\e46c\"}.di-transportation-parking-info::before,.di-E46D::before{content:\"\\e46d\"}.di-resort-automatic-check-out::before,.di-E46E::before{content:\"\\e46e\"}.di-service-your-way::before,.di-E46F::before{content:\"\\e46f\"}.di-direct-to-room::before,.di-E470::before{content:\"\\e470\"}.di-premium-service-shdr::before,.di-E471::before{content:\"\\e471\"}.di-virtual-queue::before,.di-E472::before{content:\"\\e472\"}.di-energy-monster::before,.di-E473::before{content:\"\\e473\"}.di-elevators::before,.di-E475::before{content:\"\\e475\"}.di-salon::before,.di-E476::before{content:\"\\e476\"}.di-clothing::before,.di-E480::before{content:\"\\e480\"}.di-accessories::before,.di-E481::before{content:\"\\e481\"}.di-home-office::before,.di-E482::before{content:\"\\e482\"}.di-toys-games::before,.di-E483::before{content:\"\\e483\"}.di-art-collectibles::before,.di-E484::before{content:\"\\e484\"}.di-entertainment::before,.di-E485::before{content:\"\\e485\"}.di-health-beauty::before,.di-E486::before{content:\"\\e486\"}.di-sweets::before,.di-E487::before{content:\"\\e487\"}.di-play-logo::before,.di-E4C0::before{content:\"\\e4c0\"}.di-rocket-race-game::before,.di-E4C1::before{content:\"\\e4c1\"}.di-peter-pan-s-flight-game::before,.di-E4C2::before{content:\"\\e4c2\"}.di-toy-story-mania-game::before,.di-E4C3::before{content:\"\\e4c3\"}.di-trivia-games::before,.di-E4C4::before{content:\"\\e4c4\"}.di-esmeralda-quest::before,.di-E4C5::before{content:\"\\e4c5\"}.di-fortune-red-quest::before,.di-E4C6::before{content:\"\\e4c6\"}.di-temple-of-mara-decoder::before,.di-E4C7::before{content:\"\\e4c7\"}.di-conservation-fund-quest::before,.di-E4C8::before{content:\"\\e4c8\"}.di-soarin-challenge::before,.di-E4C9::before{content:\"\\e4c9\"}.di-agent-p-challenge::before,.di-E4CA::before{content:\"\\e4ca\"}.di-fun-wheel-challenge::before,.di-E4CB::before{content:\"\\e4cb\"}.di-andy-s-game-board-blast::before,.di-E4CC::before{content:\"\\e4cc\"}.di-art-of-animation::before,.di-E4CD::before{content:\"\\e4cd\"}.di-flight-of-passage::before,.di-E4CE::before{content:\"\\e4ce\"}.di-dlr-magic-mural::before,.di-E4CF::before{content:\"\\e4cf\"}.di-splash-mountain::before,.di-E4D0::before{content:\"\\e4d0\"}.di-kidcot-challenge::before,.di-E4D1::before{content:\"\\e4d1\"}.di-swge-millenium-falcon::before,.di-E4D2::before{content:\"\\e4d2\"}.di-swge-star-destroyer::before,.di-E4D3::before{content:\"\\e4d3\"}.di-swge-bso-logo::before,.di-E4D4::before{content:\"\\e4d4\"}.di-add-stepper::before,.di-E500::before{content:\"\\e500\"}.di-reduce-stepper::before,.di-E501::before{content:\"\\e501\"}.di-hide-collapse::before,.di-E502::before{content:\"\\e502\"}.di-mute-volume::before,.di-E503::before{content:\"\\e503\"}.di-unmute-volume::before,.di-E504::before{content:\"\\e504\"}.di-filter-items::before,.di-E505::before{content:\"\\e505\"}.di-forward-thin::before,.di-E506::before{content:\"\\e506\"}.di-back-thin::before,.di-E507::before{content:\"\\e507\"}.di-fast-fwd-thin::before,.di-E508::before{content:\"\\e508\"}.di-rewind-thin::before,.di-E509::before{content:\"\\e509\"}.di-download-thin::before,.di-E50A::before{content:\"\\e50a\"}.di-facial-opt-in-off::before,.di-E50B::before{content:\"\\e50b\"}.di-facial-opt-in-on::before,.di-E50C::before{content:\"\\e50c\"}.di-bluetooth::before,.di-E518::before{content:\"\\e518\"}.di-norgie-closed::before,.di-E534::before{content:\"\\e534\"}.di-fastpass-order-shopping-bag-plus::before,.di-E540::before{content:\"\\e540\"}.di-fastpass-order-shopping-bag::before,.di-E542::before{content:\"\\e542\"}.di-shdr-ticket-annualpass::before,.di-E544::before{content:\"\\e544\"}.di-tickets-outlined::before,.di-E54B::before{content:\"\\e54b\"}.di-early-entry-pass::before,.di-E54C::before{content:\"\\e54c\"}.di-disney-card-member::before,.di-E54D::before{content:\"\\e54d\"}.di-club-33-dlr-member::before,.di-E54E::before{content:\"\\e54e\"}.di-shdr-ap-activation::before,.di-E54F::before{content:\"\\e54f\"}.di-disney-maxpass-alternate::before,.di-E550::before{content:\"\\e550\"}.di-ap-activation::before,.di-E552::before{content:\"\\e552\"}.di-standby-pass::before,.di-E553::before{content:\"\\e553\"}.di-early-park-entry-pass::before,.di-E554::before{content:\"\\e554\"}.di-mobile-checkout::before,.di-E555::before{content:\"\\e555\"}.di-disney-premier-access-global::before,.di-E556::before{content:\"\\e556\"}.di-disney-premier-access-secondary::before,.di-E557::before{content:\"\\e557\"}.di-disney-premier-access-new::before,.di-E558::before{content:\"\\e558\"}.di-golden-oak-resident::before,.di-E559::before{content:\"\\e559\"}.di-disability-access-service::before,.di-E55A::before{content:\"\\e55a\"}.di-lightning-lane::before,.di-E55B::before{content:\"\\e55b\"}.di-disney-plus::before,.di-E55C::before{content:\"\\e55c\"}.di-enchant-key::before,.di-E55D::before{content:\"\\e55d\"}.di-dream-key::before,.di-E55E::before{content:\"\\e55e\"}.di-imagine-key::before,.di-E55F::before{content:\"\\e55f\"}.di-believe-key::before,.di-E560::before{content:\"\\e560\"}.di-unused-character::before,.di-F8FE::before{content:\"\\f8fe\"}:host{--primary:var(--primary-theme);--primary-dark:var(--primary-dark-theme);--primary-background:var(--primary-background-theme);--primary-other:var(--primary-other-theme);--primary-disabled:var(--primary-disabled-theme);--primary-message:var(--primary-message-theme);--primary-alert:var(--primary-alert-theme);--primary-gradient-from:var(--primary-gradient-from-theme);--primary-gradient-to:var(--primary-gradient-to-theme);--secondary-focus:var(--secondary-focus-theme);--secondary-hover:var(--secondary-hover-theme);--secondary-disabled:var(--secondary-disabled-theme);--secondary-background:var(--secondary-background-theme);--secondary-other-dark:var(--secondary-other-dark-theme);--secondary-other-hover:var(--secondary-other-hover-theme);--secondary-other-disabled:var(--secondary-other-disabled-theme);--secondary-other-good-to-go:var(--secondary-other-good-to-go-theme);--secondary-message:var(--secondary-message-theme);--secondary-message-detail:var(--secondary-message-detail-theme);--secondary-message-chrome:var(--secondary-message-chrome-theme);--secondary-gradient-from:var(--secondary-gradient-from-theme);--secondary-gradient-to:var(--secondary-gradient-to-theme);--secondary-inactive:var(--secondary-inactive-theme);--reversed-hover:var(--reversed-hover-theme);--link:var(--link-theme);--outline-color:var(--outline-color-theme);--outline-style:var(--outline-style-theme);--outline-width:var(--outline-width-theme)}.primary{color:var(--primary)}.primary:hover{color:var(--secondary-hover)}.primary[disabled]{color:var(--secondary-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.primary-dark{color:var(--primary-dark)}.primary-other{color:var(--primary-other)}.primary-message{color:var(--primary-message)}.primary-alert{color:var(--primary-alert)}.background-primary-background{background-color:var(--primary-background)}.background-primary{background-color:var(--primary)}.background-primary-dark{background-color:var(--primary-dark)}.background-primary-other{background-color:var(--primary-other)}.background-primary-message{background-color:var(--primary-message)}.background-primary-alert{background-color:var(--primary-alert)}.background-primary-gradient{background:linear-gradient(45deg, var(--primary-gradient-from), var(--primary-gradient-to))}.secondary-other-dark{color:var(--secondary-other-dark)}.secondary-other-dark:hover{color:var(--secondary-other-hover)}.secondary-other-dark[disabled]{color:var(--secondary-other-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.secondary-other-good-to-go{color:var(--secondary-other-good-to-go)}.secondary-message{color:var(--secondary-message)}.secondary-message-detail{color:var(--secondary-message-detail)}.secondary-message-chrome{color:var(--secondary-message-chrome)}.background-secondary{background-color:var(--secondary-background)}.background-secondary-focus{background-color:var(--secondary-focus)}.background-secondary-hover{background-color:var(--secondary-hover)}.background-secondary-disabled{background-color:var(--secondary-disabled)}.background-secondary-other-hover{background-color:var(--secondary-other-hover)}.background-secondary-other-disabled{background-color:var(--secondary-other-disabled)}.background-secondary-other-dark{background-color:var(--secondary-other-dark)}.background-secondary-other-good-to-go{background-color:var(--secondary-other-good-to-go)}.background-secondary-message{background-color:var(--secondary-message)}.background-secondary-inactive{background-color:var(--secondary-inactive)}.background-secondary-message-detail{background-color:var(--secondary-message-detail)}.background-secondary-message-chrome{background-color:var(--secondary-message-chrome)}.background-secondary-gradient{background:linear-gradient(45deg, var(--secondary-gradient-from), var(--secondary-gradient-to))}a,.link{color:var(--link);text-decoration:none}a:link,a:visited,a:hover,a:active,.link:link,.link:visited,.link:hover,.link:active{color:var(--link)}a:hover,a:focus,.link:hover,.link:focus{text-decoration:underline}.link{color:var(--link);cursor:pointer}a:focus,.link:focus,button:focus{outline-color:var(--outline-color);outline-style:var(--outline-style);outline-width:var(--outline-width)}:host{display:block;position:relative;width:240px;padding-top:15px}@media only screen and (max-width: 480.98px){:host{width:100%}}:host(:not([range-datepicker-hidden])) #input-container{border-color:var(--range-datepicker-button-clicked-border)}:host(:not([range-datepicker-hidden])) #input-container label,:host(:not([range-datepicker-hidden])) #input-container button i{color:var(--range-datepicker-button-clicked)}:host([range-datepicker-hidden]) #input-container:hover{border-color:var(--range-datepicker-button-hover-border)}:host([range-datepicker-hidden]) #input-container:hover label,:host([range-datepicker-hidden]) #input-container:hover span,:host([range-datepicker-hidden]) #input-container:hover button i{color:var(--range-datepicker-button-hover)}:host([range-datepicker-hidden]) #input-container:focus{border-color:var(--range-datepicker-button-hover-border);border-width:4px;outline:none}:host([range-datepicker-hidden]) #input-container.invalid{border-color:#DD3700;border-width:4px;outline:none}:host([range-datepicker-hidden]) #calendars-container{display:none}:host([selecting-date-to]) #calendars-container #outer-up-arrow{left:120px}#input-container{position:relative;width:var(--range-datepicker-width, 240px);border-bottom:2px solid var(--range-datepicker-border-bottom);padding-right:22px;box-sizing:border-box;cursor:pointer;line-height:normal}@media only screen and (max-width: 480.98px){#input-container{width:100%}}#input-container label{position:absolute;top:0px;left:0px;transform:translateY(-75%) scale(0.75);transform-origin:left top;width:133%;pointer-events:none;white-space:nowrap;color:var(--range-datepicker-label-color)}#input-container span{color:var(--range-datepicker-date-selected-color);display:inline-block}#input-container button{position:absolute;right:0px;top:0px}#input-container button i{color:var(--range-datepicker-button)}#calendars-container{padding-top:15px;background-color:white;z-index:1000}@media only screen and (min-width: 481px){#calendars-container{position:absolute;width:fit-content;min-height:270px;padding-top:30px;margin-top:30px;margin-bottom:10px;border:1px solid var(--range-datepicker-calendar-border)}}#calendars-container #outer-up-arrow{position:absolute;top:-1px;left:18px;display:inline-block;width:31px;height:31px;border-top:1px solid var(--range-datepicker-outer-arrow-left-border);border-right:1px solid var(--range-datepicker-outer-arrow-right-border);background-color:white;transform:rotate(-45deg);transform-origin:top left}@media only screen and (max-width: 480.98px){#calendars-container #outer-up-arrow{display:none}}#calendars-container #four-calendar{display:flex;flex-direction:row;justify-content:center;min-height:270px}#calendars-container #four-calendar #first-datepicker{margin-right:30px}#calendars-container #four-calendar #second-datepicker{margin-right:30px}#calendars-container #four-calendar #third-datepicker{margin-right:30px}#calendars-container #three-calendar{display:flex;flex-direction:row;justify-content:center;min-height:270px}#calendars-container #three-calendar #first-datepicker{margin-right:30px}#calendars-container #three-calendar #second-datepicker{margin-right:30px}#calendars-container #two-calendar{display:flex;flex-direction:row;justify-content:center;min-height:270px}#calendars-container #two-calendar #first-datepicker{margin-right:30px}#calendars-container #one-calendar{width:100%;margin-bottom:10px}#calendars-container #double-calendar{display:flex;flex-direction:row;justify-content:center;min-height:270px}#calendars-container #double-calendar #first-datepicker{margin-right:40px}#calendars-container #single-calendar{width:100%;margin-bottom:10px}.icon-button{border:none;padding:0px;cursor:pointer;background-color:transparent;color:var(--range-datepicker-enabled-arrow-color)}.icon-button:focus{outline:2px solid;color:#083C5D}.big-arrow-button{margin-top:-30px}.big-arrow-button[disabled]{color:var(--range-datepicker-disabled-arrow-color);cursor:not-allowed}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) #calendars-container #four-calendar{display:none}}@media only screen and (min-width: 481px) and (max-width: 767.98px){:host(:not([dynamic-sizing])) #calendars-container #four-calendar{display:none}}@media only screen and (min-width: 768px) and (max-width: 1179.98px){:host(:not([dynamic-sizing])) #calendars-container #four-calendar{display:none}}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) #calendars-container #three-calendar{display:none}}@media only screen and (min-width: 481px) and (max-width: 767.98px){:host(:not([dynamic-sizing])) #calendars-container #three-calendar{display:none}}@media only screen and (min-width: 1180px) and (max-width: 1919.98px){:host(:not([dynamic-sizing])) #calendars-container #three-calendar{display:none}}@media only screen and (min-width: 1180px){:host(:not([dynamic-sizing])) #calendars-container #three-calendar{display:none}}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) #calendars-container #two-calendar{display:none}}@media only screen and (min-width: 768px) and (max-width: 1179.98px){:host(:not([dynamic-sizing])) #calendars-container #two-calendar{display:none}}@media only screen and (min-width: 1180px) and (max-width: 1919.98px){:host(:not([dynamic-sizing])) #calendars-container #two-calendar{display:none}}@media only screen and (min-width: 1180px){:host(:not([dynamic-sizing])) #calendars-container #two-calendar{display:none}}@media only screen and (min-width: 481px) and (max-width: 767.98px){:host(:not([dynamic-sizing])) #calendars-container #one-calendar{display:none}}@media only screen and (min-width: 768px) and (max-width: 1179.98px){:host(:not([dynamic-sizing])) #calendars-container #one-calendar{display:none}}@media only screen and (min-width: 1180px) and (max-width: 1919.98px){:host(:not([dynamic-sizing])) #calendars-container #one-calendar{display:none}}@media only screen and (min-width: 1180px){:host(:not([dynamic-sizing])) #calendars-container #one-calendar{display:none}}@media only screen and (max-width: 480.98px){:host(:not([dynamic-sizing])) #calendars-container #double-calendar{display:none}}@media only screen and (min-width: 481px) and (max-width: 767.98px){:host(:not([dynamic-sizing])) #calendars-container #single-calendar{display:none}}@media only screen and (min-width: 768px) and (max-width: 1179.98px){:host(:not([dynamic-sizing])) #calendars-container #single-calendar{display:none}}@media only screen and (min-width: 1180px) and (max-width: 1919.98px){:host(:not([dynamic-sizing])) #calendars-container #single-calendar{display:none}}@media only screen and (min-width: 1180px){:host(:not([dynamic-sizing])) #calendars-container #single-calendar{display:none}}:host(:not([dynamic-sizing])) .big-arrow-button{align-self:center}:host(:not([dynamic-sizing])) .big-arrow-button.previous-button{margin-right:40px}:host(:not([dynamic-sizing])) .big-arrow-button.next-button{margin-left:40px}:host([dynamic-sizing]) .big-arrow-button{margin-left:auto;margin-right:auto}:host(.four) #calendars-container #three-calendar{display:none}:host(.four) #calendars-container #two-calendar{display:none}:host(.four) #calendars-container #one-calendar{display:none}:host(.three) #calendars-container #four-calendar{display:none}:host(.three) #calendars-container #two-calendar{display:none}:host(.three) #calendars-container #one-calendar{display:none}:host(.two) #calendars-container #four-calendar{display:none}:host(.two) #calendars-container #three-calendar{display:none}:host(.two) #calendars-container #one-calendar{display:none}:host(.one) #calendars-container #four-calendar{display:none}:host(.one) #calendars-container #three-calendar{display:none}:host(.one) #calendars-container #two-calendar{display:none}:host(.double) #calendars-container #single-calendar{display:none}:host(.single) #calendars-container #double-calendar{display:none}.input-control{font:var(--font-family-base-theme);height:100%;padding:0;outline:none;font-size:16px;border:none;text-align:left;box-shadow:none;width:90px;color:#00233C;display:inline-block}.input-control[disabled],.input-control[readonly]{background-color:transparent}::placeholder{color:#00233C}#description{color:var(--range-datepicker-label-color);font-size:12px;margin-top:2px}#error-message{font-size:15px;color:#DD3700;margin-top:2px}";

const WdprRangeDatepicker$1 = /*@__PURE__*/ proxyCustomElement(class WdprRangeDatepicker extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dateFromChangedEvent = createEvent(this, "date-from-changed", 7);
        this.dateFromSelected = createEvent(this, "date-from-selected", 7);
        this.dateToChangedEvent = createEvent(this, "date-to-changed", 7);
        this.dateToSelected = createEvent(this, "date-to-selected", 7);
        this.invalidToChanged = createEvent(this, "invalid-to-changed", 7);
        this.invalidFromChanged = createEvent(this, "invalid-from-changed", 7);
        this.openState = createEvent(this, "open-state", 7);
        this.dynamicResize = () => {
            if (this.dynamicSizing == true) {
                const outerDivWidth = getComputedStyle(this.querySelectorDeep('#' + this.sizeId)).width;
                const calcontain = this.host.shadowRoot.querySelector('#calendars-container');
                calcontain.style.width = outerDivWidth;
                const edgecal = this.host.shadowRoot.querySelector('#calendars-container').getBoundingClientRect().x;
                if (this.dateFrom != null && this.dateTo == null) {
                    const inputTo = this.host.shadowRoot.querySelector('#input2').getBoundingClientRect().x;
                    const math = inputTo - edgecal;
                    const arrow = this.host.shadowRoot.querySelector('#outer-up-arrow');
                    arrow.setAttribute('style', 'left:' + math + 'px');
                }
                else {
                    const inputFrom = this.host.shadowRoot.querySelector('#input1').getBoundingClientRect().x;
                    const math = inputFrom - edgecal;
                    const arrow = this.host.shadowRoot.querySelector('#outer-up-arrow');
                    arrow.setAttribute('style', 'left:' + math + 'px');
                }
                if (outerDivWidth != 'auto') {
                    if (this.fourMonth) {
                        if (parseInt(outerDivWidth) < 550) {
                            if (this.host.classList.contains('four')) {
                                this.host.classList.remove('four');
                            }
                            if (this.host.classList.contains('three')) {
                                this.host.classList.remove('three');
                            }
                            if (this.host.classList.contains('two')) {
                                this.host.classList.remove('two');
                            }
                            this.host.classList.add('one');
                            this.currentCalendarId = 'one-calendar';
                        }
                        else if ((parseInt(outerDivWidth) >= 550) && (parseInt(outerDivWidth) < 768.98)) {
                            if (this.host.classList.contains('four')) {
                                this.host.classList.remove('four');
                            }
                            if (this.host.classList.contains('three')) {
                                this.host.classList.remove('three');
                            }
                            if (this.host.classList.contains('one')) {
                                this.host.classList.remove('one');
                            }
                            this.host.classList.add('two');
                            this.currentCalendarId = 'two-calendar';
                        }
                        else if ((parseInt(outerDivWidth) >= 768.98) && (parseInt(outerDivWidth) < 1100)) {
                            if (this.host.classList.contains('four')) {
                                this.host.classList.remove('four');
                            }
                            if (this.host.classList.contains('two')) {
                                this.host.classList.remove('two');
                            }
                            if (this.host.classList.contains('one')) {
                                this.host.classList.remove('one');
                            }
                            this.host.classList.add('three');
                            this.currentCalendarId = 'three-calendar';
                        }
                        else {
                            if (this.host.classList.contains('three')) {
                                this.host.classList.remove('three');
                            }
                            if (this.host.classList.contains('two')) {
                                this.host.classList.remove('two');
                            }
                            if (this.host.classList.contains('one')) {
                                this.host.classList.remove('one');
                            }
                            this.host.classList.add('four');
                            this.currentCalendarId = 'four-calendar';
                        }
                    }
                    else {
                        if (parseInt(outerDivWidth) < 550) {
                            if (this.host.classList.contains('double')) {
                                this.host.classList.remove('double');
                            }
                            this.host.classList.add('single');
                            this.currentCalendarId = 'single-calendar';
                        }
                        else {
                            if (this.host.classList.contains('single')) {
                                this.host.classList.remove('single');
                            }
                            this.host.classList.add('double');
                            this.currentCalendarId = 'double-calendar';
                        }
                    }
                }
            }
        };
        this._toggleCalendar = () => {
            this._computePrevAndNextMonthButtonsDisabledValues();
            if (this.rangeDatepickerHidden) {
                this._openCalendar();
            }
            else {
                this._closeCalendar();
            }
            if (!(this.dateFrom && (this.dateTo == null))) {
                this.rangeTimestamp = null;
            }
        };
        this._toggleCalendarInput = () => {
            this._dispatchEventRangeDatepickerOpen(true);
            this.rangeDatepickerHidden = false;
        };
        this._handleOuterPrevMonth = (callback) => {
            const leftCalendarDateTimeObject = this.host.shadowRoot.querySelector('range-datepicker-calendar[prev]')._handlePrevMonth(callback);
            if (!leftCalendarDateTimeObject) { // In case the prev month button was disabled, the calendars didn't change
                return;
            }
            this.month = leftCalendarDateTimeObject.toFormat(Formats.month);
            this.year = leftCalendarDateTimeObject.toFormat(Formats.year);
            this._computePrevAndNextMonthButtonsDisabledValues();
        };
        this._handleOuterNextMonth = (callback) => {
            let rightCalendarDateTimeObject = this.host.shadowRoot.querySelector('range-datepicker-calendar[next]')._handleNextMonth(callback);
            if (!rightCalendarDateTimeObject) { // In case the next month button was disabled, the calendars didn't change
                return;
            }
            rightCalendarDateTimeObject = rightCalendarDateTimeObject.minus({ months: 1 }); // Compute the left calendar month/year
            this.month = rightCalendarDateTimeObject.toFormat(Formats.month);
            this.year = rightCalendarDateTimeObject.toFormat(Formats.year);
            this._computePrevAndNextMonthButtonsDisabledValues();
        };
        this._handleDateFromClicked = () => {
            this.invalidFrom = false;
            this.host.shadowRoot.querySelector("#input-container").removeAttribute("class");
            this.selectingDateTo = true;
        };
        this._handleDateToClicked = () => {
            this.invalidTo = false;
            this.host.shadowRoot.querySelector("#input-container").removeAttribute("class");
            this.selectingDateTo = false;
        };
        // range-datepicker-behaviours
        this._handlePrevMonth = () => {
            this.host.shadowRoot.querySelector('range-datepicker-calendar[next]')._handlePrevMonth(undefined);
        };
        this._handleNextMonth = () => {
            this.host.shadowRoot.querySelector('range-datepicker-calendar[prev]')._handleNextMonth(undefined);
        };
        this._handleNewHover = (event) => {
            this._hoveredDate = event.detail.date;
        };
        this._handleNewDateFrom = (event) => {
            this.dateFrom = event.detail;
            if (this.editableInput == true) {
                this.invalidFrom = false;
                this.host.shadowRoot.querySelector("#input-container").removeAttribute("class");
                this._fillInputBoxFrom(this.dateFrom);
            }
        };
        this._handleNewDateTo = (event) => {
            if (this.disableSelectSameDate && +this.dateFrom === +event.detail) {
                return;
            }
            this.dateTo = event.detail;
            if (this.editableInput == true) {
                this.invalidTo = false;
                this.host.shadowRoot.querySelector("#input-container").removeAttribute("class");
                this._fillInputBoxTo(this.dateTo);
            }
        };
        // Performs input validation on range datepicker
        this.onChange = (str, eventStr) => {
            // Converts input string to date time object based on calendar locale
            var strictLocaleObject = luxon.DateTime.fromFormat(eventStr, this.dateFormat, { locale: this.locale });
            // Converts any min/max/dateFrom/dateTo value into date time object for comparison
            if (this.max != null) {
                var maxi = luxon.DateTime.fromSeconds(this.max, { locale: this.locale }).ts;
            }
            if (this.min != null) {
                var mini = luxon.DateTime.fromSeconds(this.min, { locale: this.locale }).ts;
            }
            if (this.dateFrom != null) {
                var dateF = luxon.DateTime.fromSeconds(parseInt(this.dateFrom), { locale: this.locale }).ts;
                if (this.range != null) {
                    const date = new Date(dateF * 1000);
                    date.setDate(date.getDate() + this.range);
                    var maxRangeF = date.setHours(0, 0, 0, 0) / 1000;
                }
            }
            if (this.dateTo != null) {
                var dateT = luxon.DateTime.fromSeconds(parseInt(this.dateTo), { locale: this.locale }).ts;
                if (this.range != null) {
                    const date = new Date(dateF * 1000);
                    date.setDate(date.getDate() - this.range);
                    var maxRangeT = date.setHours(0, 0, 0, 0) / 1000;
                }
            }
            // If the user is inputing a dateTo and it is less than the current dateFrom it is invalid
            if ((str == "to" && (dateF > strictLocaleObject.ts))) {
                this.invalidTo = true;
                this.host.shadowRoot.querySelector("#input-container").setAttribute("class", "invalid");
            }
            // If the user is inputing a dateFrom and it is greater than the current dateTo it is invalid
            else if ((str == "from" && (dateT < strictLocaleObject.ts))) {
                this.invalidFrom = true;
                this.host.shadowRoot.querySelector("#input-container").setAttribute("class", "invalid");
            }
            // If it is a calendar where the selection of the same date is disabled, the input is invalid if it is the same as the current dateFrom
            else if (this.disableSelectSameDate && (str == "from" && (dateT == strictLocaleObject.ts))) {
                this.invalidFrom = true;
                this.host.shadowRoot.querySelector("#input-container").setAttribute("class", "invalid");
            }
            // If it is a calendar where the selection of the same date is disabled, the input is invalid if it is the same as the current dateTo
            else if (this.disableSelectSameDate && (str == "to" && (dateF == strictLocaleObject.ts))) {
                this.invalidTo = true;
                this.host.shadowRoot.querySelector("#input-container").setAttribute("class", "invalid");
            }
            // If you are entering a from date and it exceeds the range allowed, it is invalid
            else if (str == "from" && (strictLocaleObject.ts < maxRangeT)) {
                this.invalidFrom = true;
                this.host.shadowRoot.querySelector("#input-container").setAttribute("class", "invalid");
            }
            // If you are entering a to date and it exceeds the range allowed, it is invalid
            else if (str == "to" && (strictLocaleObject.ts > maxRangeF)) {
                this.invalidTo = true;
                this.host.shadowRoot.querySelector("#input-container").setAttribute("class", "invalid");
            }
            // If the input is a valid date time object and it is an enabled date, select the date and move the focus
            else if (!strictLocaleObject.invalid && (strictLocaleObject.ts >= mini || mini == undefined) && (strictLocaleObject.ts <= maxi || maxi == undefined)) {
                this.host.shadowRoot.querySelector("#input-container").removeAttribute("class");
                if (str == "from") {
                    this.invalidFrom = false;
                    this.bindValueFrom(eventStr);
                    this.host.shadowRoot.querySelector("#input1").setAttribute("value", eventStr);
                    this.inputDateFrom = eventStr;
                }
                if (str == "to") {
                    this.invalidTo = false;
                    this.bindValueTo(eventStr);
                    this.host.shadowRoot.querySelector("#input2").setAttribute("value", eventStr);
                    this.inputDateTo = eventStr;
                }
            }
            // All other cases are invalid
            else {
                this.host.shadowRoot.querySelector("#input-container").setAttribute("class", "invalid");
                if (str == "from") {
                    this.invalidFrom = true;
                }
                if (str == "to") {
                    this.invalidTo = true;
                }
            }
        };
        this._validateKeyDown = (str, event) => {
            var key = event.keyCode;
            if ((key == 13) || (key == 9)) {
                this.onChange(str, event.target.value);
            }
        };
        this._storeInputValue = (str, event) => {
            if (str == "from") {
                this.host.shadowRoot.querySelector("#input1").setAttribute("value", event.target.value);
            }
            if (str == "to") {
                this.host.shadowRoot.querySelector("#input2").setAttribute("value", event.target.value);
            }
        };
        this._getEditFromValue = () => {
            return (this.inputDateFrom != null) ? this.inputDateFrom : this.textInputValueFrom;
        };
        this._getEditToValue = () => {
            return (this.inputDateTo != null) ? this.inputDateTo : this.textInputValueTo;
        };
        this.locale = "en";
        this.month = undefined;
        this._monthPlus = undefined;
        this._monthPlusTwo = undefined;
        this._monthPlusThree = undefined;
        this._yearPlus = undefined;
        this._yearPlusTwo = undefined;
        this._yearPlusThree = undefined;
        this.width = undefined;
        this.currentCalendarId = undefined;
        this.sizeId = undefined;
        this.year = undefined;
        this.dateFrom = null;
        this.dateTo = null;
        this._hoveredDate = undefined;
        this.min = new Date().setHours(0, 0, 0, 0) / 1000;
        this.max = undefined;
        this.range = undefined;
        this.rangeTimestamp = undefined;
        this.dateFormat = "MM/dd/yyyy";
        this.instances = () => [];
        this.instance = () => { return {}; };
        this.invalidTo = false;
        this.invalidFrom = false;
        this.invalidToMessage = "Invalid date to selected";
        this.invalidFromMessage = "Invalid date from selected";
        this.messageHidden = false;
        this.rangeDatepickerHidden = true;
        this.selectingDateTo = false;
        this.dynamicSizing = false;
        this.inputLabel = "Dates";
        this.description = "MM/DD/YYYY - MM/DD/YYYY";
        this.dateFromPlaceholder = "";
        this.dateToPlaceholder = "";
        this.inputDateFrom = undefined;
        this.inputDateTo = undefined;
        this.dash = undefined;
        this._prevMonthButtonDisabled = null;
        this._nextMonthButtonDisabled = null;
        this.keepButtons = false;
        this.disableSelectSameDate = false;
        this.fourMonth = false;
        this.editableInput = true;
        this.textInputValueFrom = '';
        this.textInputValueTo = '';
        this.bindValueFrom = (value) => {
            this.textInputValueFrom = value;
            value = this.textInputValueFrom;
        };
        this.bindValueTo = (value) => {
            this.textInputValueTo = value;
            value = this.textInputValueTo;
        };
    }
    _localeChanged(locale) {
        if (this.month == undefined) {
            if (this.dateFrom != undefined) {
                // Selected "date from" month
                this.month = luxon.DateTime.fromSeconds(parseInt(this.dateFrom), { locale: locale }).toFormat(Formats.month);
            }
            else {
                // Min enabled month
                this.month = luxon.DateTime.fromSeconds(this.min, { locale: locale }).toFormat(Formats.month);
            }
        }
        if (this.year == undefined) {
            if (this.dateFrom != undefined) {
                // Selected "date from" year
                this.year = luxon.DateTime.fromSeconds(parseInt(this.dateFrom), { locale: locale }).toFormat(Formats.year);
            }
            else {
                // Min enabled year
                this.year = luxon.DateTime.fromSeconds(this.min, { locale: locale }).toFormat(Formats.year);
            }
        }
    }
    newMonth(newMonth) {
        this._monthChanged(newMonth, this.year);
    }
    newYear(newYear) {
        this._monthChanged(this.month, newYear);
    }
    _dateFromChanged(newDate) {
        if (this.instance) {
            this.instance.dateFrom = this._formatDate(this.dateFrom);
            this.dateFromSelected.emit({ date: this._formatDate(this.dateFrom) });
        }
        const date = new Date(newDate * 1000);
        date.setDate(date.getDate() + this.range);
        this.rangeTimestamp = date.setHours(0, 0, 0, 0) / 1000;
        this.dateFromChangedEvent.emit(newDate);
        this.dynamicResize();
    }
    _dateToChanged(newDate) {
        if (this.instance) {
            this.instance.dateTo = this._formatDate(this.dateTo);
            this.instance.dateFrom = this._formatDate(this.dateFrom);
            if (newDate) {
                this.dateToSelected.emit({ date: this._formatDate(this.dateTo) });
                this._closeCalendar();
            }
        }
        this.dateToChangedEvent.emit(newDate);
        if (newDate) {
            this.rangeTimestamp = null;
        }
    }
    _minChanged(newMin) {
        this._minMaxChanged(newMin, this.max);
    }
    _maxChanged(newMax) {
        this._minMaxChanged(this.min, newMax);
    }
    _invalidToChanged(newValue) {
        this.invalidToChanged.emit(newValue);
    }
    _invalidFromChanged(newValue) {
        this.invalidFromChanged.emit(newValue);
    }
    _textInputValueFromObserver(newValue) {
        if (this.editableInput == true) {
            if (newValue.length != 10) {
                return;
            }
            this.dateFrom = luxon.DateTime.fromFormat(newValue, this.dateFormat).toSeconds();
        }
    }
    _textInputValueToObserver(newValue) {
        if (this.editableInput == true) {
            if ((this._formatDate(newValue)).length != 10) {
                return;
            }
            this.dateTo = luxon.DateTime.fromFormat(newValue, this.dateFormat).toSeconds();
        }
    }
    _formatDate(date) {
        return date ? luxon.DateTime.fromSeconds(parseInt(date), { locale: this.locale }).toFormat(this.dateFormat) : "";
    }
    componentWillRender() {
        // Recompute current dates and dash upon reload
        this.inputDateFrom = this.computeDateFromInputValue(this.dateFrom);
        this.inputDateTo = this.computeDateToInputValue(this.dateTo);
        this.dash = this.computeDash(this.dateFrom);
    }
    componentWillLoad() {
        // On load, add locale and check for disabled buttons
        this._localeChanged(this.locale);
        this.newMonth(this.month);
        this.newYear(this.year);
        this._computePrevAndNextMonthButtonsDisabledValues();
    }
    componentDidLoad() {
        if (this.dynamicSizing == true) {
            var outerDiv = this.querySelectorDeep('#' + this.sizeId);
            this.dynamicSizing = true;
            let resizeObserver = new ResizeObserver(() => {
                if (this.rangeDatepickerHidden == false) {
                    this.dynamicResize();
                }
            });
            resizeObserver.observe(outerDiv);
        }
    }
    querySelectorDeep(selector) {
        let lightElement = document.querySelector(selector);
        if (lightElement) {
            return lightElement;
        }
        const splitSelector = selector.replace(/\s*([,>+~]+)\s*/g, '$1').split(' ');
        let possibleElementsIndex = splitSelector.length - 1;
        let possibleElements = this.collectAllElementsDeep(splitSelector[possibleElementsIndex]);
        return possibleElements.find((element) => {
            let position = possibleElementsIndex;
            let parent = element;
            let foundElement = false;
            while (parent) {
                const foundMatch = parent.matches(splitSelector[position]);
                if (foundMatch && position === 0) {
                    foundElement = true;
                    break;
                }
                if (foundMatch) {
                    position--;
                }
                parent = this.findParentOrHost(parent);
            }
            return foundElement;
        });
    }
    findParentOrHost(element) {
        const parentNode = element.parentNode;
        return parentNode && parentNode.host ? parentNode.host : parentNode === document ? null : parentNode;
    }
    /**
     * Finds all elements on the page, inclusive of those within shadow roots.
     */
    collectAllElementsDeep(selector = null) {
        const allElements = [];
        const findAllElements = function (nodes) {
            for (let i = 0, el; el = nodes[i]; ++i) {
                allElements.push(el);
                if (el.shadowRoot) {
                    findAllElements(el.shadowRoot.querySelectorAll('*'));
                }
            }
        };
        findAllElements(document.querySelectorAll('*'));
        return selector ? allElements.filter(el => el.matches(selector)) : allElements;
    }
    // Selects the proper range datepicker cell to focus on calendar open
    _onOpenFocus(calendar, style, focusDate) {
        var computedStyle = window.getComputedStyle(calendar);
        var display = computedStyle.getPropertyValue('display');
        if (display == style) {
            var calendarDivs = calendar.querySelectorAll('range-datepicker-calendar');
            for (let i = 0; i < calendarDivs.length; i++) {
                var cellDivs = calendarDivs[i].shadowRoot.querySelectorAll('range-datepicker-cell');
                for (let i = 0; i < cellDivs.length; i++) {
                    var dateDiv = cellDivs[i].shadowRoot.querySelector('div');
                    var day = dateDiv.getAttribute('data-day');
                    if (day == focusDate) {
                        var focusCell = dateDiv;
                        focusCell.setAttribute('tabindex', 0);
                    }
                }
            }
            if (focusCell != null) {
                setTimeout(() => focusCell.focus(), 10);
            }
        }
    }
    // Opens the calendar and properly focuses the elements within depending on the type of calendar
    _openCalendar() {
        if (this.dynamicSizing == true) {
            setTimeout(() => this.dynamicResize(), 10);
        }
        this._dispatchEventRangeDatepickerOpen(true);
        if (this.dateFrom != null) {
            if (this.fourMonth) {
                var fourmonth = this.host.shadowRoot.querySelector('#four-calendar');
                this._onOpenFocus(fourmonth, 'flex', this.dateFrom);
                var threemonth = this.host.shadowRoot.querySelector('#three-calendar');
                this._onOpenFocus(threemonth, 'flex', this.dateFrom);
                var twomonth = this.host.shadowRoot.querySelector('#two-calendar');
                this._onOpenFocus(twomonth, 'flex', this.dateFrom);
                var onemonth = this.host.shadowRoot.querySelector('#one-calendar');
                this._onOpenFocus(onemonth, 'block', this.dateFrom);
            }
            else {
                var twomonth = this.host.shadowRoot.querySelector('#double-calendar');
                this._onOpenFocus(twomonth, 'flex', this.dateFrom);
                var onemonth = this.host.shadowRoot.querySelector('#single-calendar');
                this._onOpenFocus(onemonth, 'block', this.dateFrom);
            }
        }
        else {
            if (this.fourMonth) {
                var fourmonth = this.host.shadowRoot.querySelector('#four-calendar');
                this._onOpenFocus(fourmonth, 'flex', this.min);
                var threemonth = this.host.shadowRoot.querySelector('#three-calendar');
                this._onOpenFocus(threemonth, 'flex', this.min);
                var twomonth = this.host.shadowRoot.querySelector('#two-calendar');
                this._onOpenFocus(twomonth, 'flex', this.min);
                var onemonth = this.host.shadowRoot.querySelector('#one-calendar');
                this._onOpenFocus(onemonth, 'block', this.min);
            }
            else {
                var twomonth = this.host.shadowRoot.querySelector('#double-calendar');
                this._onOpenFocus(twomonth, 'flex', this.min);
                var onemonth = this.host.shadowRoot.querySelector('#single-calendar');
                this._onOpenFocus(onemonth, 'block', this.min);
            }
        }
        this.rangeDatepickerHidden = false;
    }
    _closeCalendar() {
        if (this.editableInput == true) {
            setTimeout(() => {
                var inputFrom = this.host.shadowRoot.querySelector('#input1').value;
                var inputTo = this.host.shadowRoot.querySelector('#input2').value;
                this.onChange("from", inputFrom);
                this.onChange("to", inputTo);
            }, 1);
        }
        this._dispatchEventRangeDatepickerOpen(false);
        this.rangeDatepickerHidden = true;
    }
    _dispatchEventRangeDatepickerOpen(isOpen) {
        this.openState.emit({ isOpen: isOpen });
    }
    computeDateFromInputValue(dateFrom) {
        return dateFrom ? this._formatDate(dateFrom) : "";
    }
    computeDateToInputValue(dateTo) {
        return dateTo ? this._formatDate(dateTo) : "";
    }
    computeDash(dateFrom) {
        return ((this.dateFromPlaceholder && this.dateToPlaceholder) || dateFrom) ? '-' : '';
    }
    /**
     * Method to traverse calendars if an arrow key is pressed
     * @param event key event
     */
    async _moveDayIfValidKeyPressed(event) {
        const { keyCode } = event;
        const key = keyCode;
        let currentDayNumber = event.path && event.path[2] && event.path[2].day && event.path[2].day.title;
        if (currentDayNumber) {
            let currentMonth = event.target;
            switch (key) {
                case 39: // right arrow key
                    event.preventDefault();
                    this._handleKeyboardNavigation(currentDayNumber, currentMonth, +1); // +1 day
                    break;
                case 37: // left arrow key
                    event.preventDefault();
                    this._handleKeyboardNavigation(currentDayNumber, currentMonth, -1); // -1 day
                    break;
                case 38: // up arrow key
                    event.preventDefault();
                    this._handleKeyboardNavigation(currentDayNumber, currentMonth, -7); // -1 week
                    break;
                case 40: // down arrow key
                    event.preventDefault();
                    this._handleKeyboardNavigation(currentDayNumber, currentMonth, +7); // +1 week
                    break;
            }
        }
    }
    focusElement(element) {
        element.focus();
    }
    _handleKeyboardNavigation(currentDayNumber, currentMonth, variation) {
        let cellToFocus = this._validateDayCellElement(currentDayNumber, currentMonth, variation);
        if (cellToFocus && this._isCellEnabled(cellToFocus)) {
            this.focusElement(cellToFocus);
        }
    }
    _validateDayCellElement(currentDayNumber, currentMonth, variation) {
        let cellToSelect;
        if (currentDayNumber > 0) {
            let dayNumberToSelect = currentDayNumber + variation;
            cellToSelect = this._findDayOfMonth(currentMonth, dayNumberToSelect);
            if (cellToSelect) { // Day was found in current month
                if (this._isCellEnabled(cellToSelect)) {
                    return cellToSelect;
                }
            }
            else { // Day is not in current month
                if (variation > 0) { // Day is in next month
                    if (variation === 1) { // Move to first day of next month (right arrow key)
                        if (currentMonth.prev) { // Multiple calendars view, currently in the first calendar
                            let nextMonth = currentMonth.parentElement.querySelector('range-datepicker-calendar[next]');
                            return this._findFirstDayOfMonth(nextMonth);
                        }
                        else if (currentMonth.next) { // Multiple calendars view, currently in the second calendar
                            /* istanbul ignore next */
                            this._handleOuterNextMonth(() => {
                                let nextMonth = currentMonth.parentElement.querySelector('range-datepicker-calendar[next]');
                                cellToSelect = this._findFirstDayOfMonth(nextMonth);
                                if (this._isCellEnabled(cellToSelect)) {
                                    this.focusElement(cellToSelect);
                                }
                                else {
                                    this.focusElement(nextMonth);
                                }
                            });
                        }
                        else if (currentMonth.single) { // Single calendar
                            /* istanbul ignore next */
                            currentMonth._handleNextMonth(() => {
                                cellToSelect = this._findFirstDayOfMonth(currentMonth);
                                if (this._isCellEnabled(cellToSelect)) {
                                    this.focusElement(cellToSelect);
                                }
                                else {
                                    this.focusElement(currentMonth);
                                }
                            });
                        }
                    }
                    else if (variation === 7) { // Move to next month, same day of the week (down arrow key)
                        let lastDayOfCurrentMonthCell = this._findLastDayOfMonth(currentMonth);
                        let lastDayOfCurrentMonthNumber = Number(lastDayOfCurrentMonthCell.getAttribute('data-day-number'));
                        let dayToSearchInNextMonth = dayNumberToSelect - lastDayOfCurrentMonthNumber;
                        if (currentMonth.prev) { // Multiple calendars view, currently in the first calendar
                            let nextMonth = currentMonth.parentElement.querySelector('range-datepicker-calendar[next]');
                            return this._findDayOfMonth(nextMonth, dayToSearchInNextMonth);
                        }
                        else if (currentMonth.next) { // Multiple calendars view, currently in the second calendar
                            /* istanbul ignore next */
                            this._handleOuterNextMonth(() => {
                                let nextMonth = currentMonth.parentElement.querySelector('range-datepicker-calendar[next]');
                                cellToSelect = this._findDayOfMonth(nextMonth, dayToSearchInNextMonth);
                                if (this._isCellEnabled(cellToSelect)) {
                                    this.focusElement(cellToSelect);
                                }
                                else {
                                    this.focusElement(nextMonth);
                                }
                            });
                        }
                        else if (currentMonth.single) { // Single calendar
                            /* istanbul ignore next */
                            currentMonth._handleNextMonth(() => {
                                cellToSelect = this._findDayOfMonth(currentMonth, dayToSearchInNextMonth);
                                if (this._isCellEnabled(cellToSelect)) {
                                    this.focusElement(cellToSelect);
                                }
                                else {
                                    this.focusElement(currentMonth);
                                }
                            });
                        }
                    }
                }
                else { // Day is in previous month
                    if (variation === -1) { // Move to last day of prev month (left arrow key)
                        if (currentMonth.next) { // Multiple calendars view, currently in the second calendar
                            let prevMonth = currentMonth.parentElement.querySelector('range-datepicker-calendar[prev]');
                            return this._findLastDayOfMonth(prevMonth);
                        }
                        else if (currentMonth.prev) { // Multiple calendars view, currently in the first calendar
                            /* istanbul ignore next */
                            this._handleOuterPrevMonth(() => {
                                let prevMonth = currentMonth.parentElement.querySelector('range-datepicker-calendar[prev]');
                                cellToSelect = this._findLastDayOfMonth(prevMonth);
                                if (cellToSelect && this._isCellEnabled(cellToSelect)) {
                                    this.focusElement(cellToSelect);
                                }
                                else {
                                    this.focusElement(prevMonth);
                                }
                            });
                        }
                        else if (currentMonth.single) { // Single calendar
                            /* istanbul ignore next */
                            currentMonth._handlePrevMonth(() => {
                                cellToSelect = this._findLastDayOfMonth(currentMonth);
                                if (cellToSelect && this._isCellEnabled(cellToSelect)) {
                                    this.focusElement(cellToSelect);
                                }
                                else {
                                    this.focusElement(currentMonth);
                                }
                            });
                        }
                    }
                    else if (variation === -7) { // Move to prev month, same day of the week (up arrow key)
                        if (currentMonth.next) { // Multiple calendars view, currently in the second calendar
                            let prevMonth = currentMonth.parentElement.querySelector('range-datepicker-calendar[prev]');
                            let lastDayOfPrevMonthCell = this._findLastDayOfMonth(prevMonth);
                            let lastDayOfPrevMonthNumber = Number(lastDayOfPrevMonthCell.getAttribute('data-day-number'));
                            let dayToSearchInPrevMonth = dayNumberToSelect + lastDayOfPrevMonthNumber;
                            return this._findDayOfMonth(prevMonth, dayToSearchInPrevMonth);
                        }
                        else if (currentMonth.prev) { // Multiple calendars view, currently in the first calendar
                            /* istanbul ignore next */
                            this._handleOuterPrevMonth(() => {
                                let prevMonth = currentMonth.parentElement.querySelector('range-datepicker-calendar[prev]');
                                let lastDayOfPrevMonthCell = this._findLastDayOfMonth(prevMonth);
                                let lastDayOfPrevMonthNumber = Number(lastDayOfPrevMonthCell.getAttribute('data-day-number'));
                                let dayToSearchInPrevMonth = dayNumberToSelect + lastDayOfPrevMonthNumber;
                                cellToSelect = this._findDayOfMonth(prevMonth, dayToSearchInPrevMonth);
                                if (cellToSelect && this._isCellEnabled(cellToSelect)) {
                                    this.focusElement(cellToSelect);
                                }
                                else {
                                    this.focusElement(currentMonth);
                                }
                            });
                        }
                        else if (currentMonth.single) { // Single calendar
                            /* istanbul ignore next */
                            currentMonth._handlePrevMonth(() => {
                                let lastDayOfPrevMonthCell = this._findLastDayOfMonth(currentMonth);
                                let lastDayOfPrevMonthNumber = Number(lastDayOfPrevMonthCell.getAttribute('data-day-number'));
                                let dayToSearchInPrevMonth = dayNumberToSelect + lastDayOfPrevMonthNumber;
                                cellToSelect = this._findDayOfMonth(currentMonth, dayToSearchInPrevMonth);
                                if (cellToSelect && this._isCellEnabled(cellToSelect)) {
                                    this.focusElement(cellToSelect);
                                }
                                else {
                                    this.focusElement(currentMonth);
                                }
                            });
                        }
                    }
                }
            }
        }
    }
    _isCellEnabled(cell) {
        if (!cell) {
            return false;
        }
        return cell.getAttribute('tabindex') !== '-1';
    }
    _findDayOfMonth(calendar, dayNumber) {
        let cellToReturn;
        for (let week of calendar._daysOfMonth) {
            for (let day of week) {
                if (day !== 0 && day.title === dayNumber) {
                    cellToReturn = calendar.shadowRoot.querySelector('#cell-' + dayNumber);
                    if (cellToReturn) {
                        return cellToReturn.shadowRoot.querySelector('div');
                    }
                }
            }
        }
    }
    _findFirstDayOfMonth(calendar) {
        let firstDayCell = calendar.shadowRoot.querySelector('#cell-1');
        firstDayCell = firstDayCell.shadowRoot.querySelector('div');
        if (this._isCellEnabled(firstDayCell)) {
            return firstDayCell;
        }
    }
    _findLastDayOfMonth(calendar) {
        let weeksOfMonth = calendar._daysOfMonth;
        let totalWeeks = weeksOfMonth && weeksOfMonth.length;
        let lastWeekOfMonth = weeksOfMonth[totalWeeks - 1];
        for (let i = lastWeekOfMonth.length - 1; i >= 0; i--) {
            let day = lastWeekOfMonth[i];
            if (day !== 0) {
                let dayNumberToSelect = day.title;
                let lastDayCell = calendar.shadowRoot.querySelector('#cell-' + dayNumberToSelect);
                lastDayCell = lastDayCell.shadowRoot.querySelector('div');
                if (this._isCellEnabled(lastDayCell)) {
                    return lastDayCell;
                }
            }
        }
    }
    _monthChanged(month, year) {
        if (year && month) {
            this._monthPlus = luxon.DateTime.fromObject({ month: month }, { locale: this.locale }).plus({ month: 1 }).toFormat(Formats.month);
            this._monthPlusTwo = luxon.DateTime.fromObject({ month: month }, { locale: this.locale }).plus({ month: 2 }).toFormat(Formats.month);
            this._monthPlusThree = luxon.DateTime.fromObject({ month: month }, { locale: this.locale }).plus({ month: 3 }).toFormat(Formats.month);
            this._yearPlus = parseInt(year, 10);
            this._yearPlusTwo = parseInt(year, 10);
            this._yearPlusThree = parseInt(year, 10);
            if (this._monthPlus === '01') {
                this._yearPlus = parseInt(year, 10) + 1;
            }
            if ((this._monthPlusTwo === '01') || (this._monthPlusTwo === '02')) {
                this._yearPlusTwo = parseInt(year, 10) + 1;
            }
            if (this._monthPlusThree === '01' || this._monthPlusThree === '02' || this._monthPlusThree === '03') {
                this._yearPlusThree = parseInt(year, 10) + 1;
            }
        }
    }
    _minMaxChanged(_min, _max) {
        this._computePrevAndNextMonthButtonsDisabledValues();
    }
    _computePrevAndNextMonthButtonsDisabledValues() {
        if (this.keepButtons == false) {
            const currentLeftCalendar = luxon.DateTime.fromObject({ year: this.year, month: parseInt(this.month) }, { locale: this.locale });
            const minDTObject = luxon.DateTime.fromSeconds(this.min, { locale: this.locale });
            const minMonth = Number(minDTObject.toFormat(Formats.month));
            const minYear = minDTObject.toFormat(Formats.year);
            if (this.max != null) {
                const maxDTObject = luxon.DateTime.fromSeconds(this.max, { locale: this.locale });
                let maxMonth = Number(maxDTObject.toFormat(Formats.month));
                const maxYear = maxDTObject.toFormat(Formats.year);
                const maxEnabledCalendar = luxon.DateTime.fromObject({ year: maxYear, month: maxMonth });
                this._nextMonthButtonDisabled = maxEnabledCalendar.c !== null && currentLeftCalendar.plus({ month: 1 }) >= (maxEnabledCalendar) ? true : null;
            }
            const minEnabledCalendar = luxon.DateTime.fromObject({ year: minYear, month: minMonth });
            this._prevMonthButtonDisabled = currentLeftCalendar <= (minEnabledCalendar) ? true : null;
        }
    }
    _fillInputBoxFrom(dateTime) {
        this.textInputValueFrom = this._formatDate(dateTime);
    }
    _fillInputBoxTo(dateTime) {
        this.textInputValueTo = this._formatDate(dateTime);
    }
    render() {
        return (h(Host, { ref: (el) => this.host = el }, this.editableInput === true &&
            h("div", null, h("div", { id: "input-container" }, h("label", { "aria-label": this.inputLabel }, this.inputLabel), h("input", { type: "text", id: "input1", class: "input-control", "aria-describedby": "error-message description", minlength: "10", tabindex: "1", maxlength: "10", "aria-label": this.dateFromPlaceholder, placeholder: this.dateFromPlaceholder, value: this._getEditFromValue(), onKeyDown: (e) => this._validateKeyDown("from", e), onKeyUp: (e) => this._storeInputValue("from", e), "on-click": this._toggleCalendarInput }), h("span", { class: "font16" }, "\u00A0", this.dash, "\u00A0"), h("input", { type: "text", id: "input2", class: "input-control", "aria-describedby": "error-message description", minlength: "10", maxlength: "10", tabindex: "2", "aria-label": this.dateToPlaceholder, placeholder: this.dateToPlaceholder, value: this._getEditToValue(), onKeyDown: (e) => this._validateKeyDown("to", e), onKeyUp: (e) => this._storeInputValue("to", e), "on-click": this._toggleCalendarInput }), h("button", { id: "calendar-button", class: "icon-button", "aria-label": "calendar", tabindex: "3", "on-click": this._toggleCalendar }, h("i", { class: "di di-calendar-month di18" }))), h("span", { id: "description", class: "desc" }, this.description)), this.editableInput === false &&
            h("div", null, h("div", { id: "input-container", tabindex: "1", "on-click": this._toggleCalendar }, h("label", { "aria-label": this.inputLabel }, this.inputLabel), h("span", { class: "font16", "aria-describedby": "description", "aria-label": this.inputDateFrom + " " + this.dash + " " + this.inputDateTo }, this.inputDateFrom, "\u00A0", this.dash, "\u00A0", this.inputDateTo), h("button", { class: "icon-button", "aria-label": "calendar", tabindex: "2" }, h("i", { class: "di di-calendar-month di18" }))), h("span", { id: "description", class: "desc" }, this.description)), (this.invalidFrom && !this.messageHidden) &&
            h("div", { id: "error-message" }, this.invalidFromMessage), (this.invalidTo && !this.messageHidden) &&
            h("div", { id: "error-message" }, this.invalidToMessage), h("div", { id: "calendars-container", role: "dialog", "aria-label": "date picker" }, h("div", null, h("div", { id: "outer-up-arrow" }), this.fourMonth === true &&
            h("div", null, h("div", { id: "four-calendar" }, h("button", { "on-click": this._handleOuterPrevMonth, tabindex: "2", class: "icon-button big-arrow-button previous-button di di-previous-2 di40", "aria-label": "datepicker previous month button", disabled: this._prevMonthButtonDisabled, "aria-disabled": this._prevMonthButtonDisabled }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-prev-month": this._handlePrevMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, id: "first-datepicker", locale: this.locale, month: this.month, year: this.year, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-next-month": this._handleNextMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, id: "second-datepicker", locale: this.locale, month: this._monthPlus, year: "" + this._yearPlus, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-next-month": this._handleNextMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, id: "third-datepicker", locale: this.locale, month: this._monthPlusTwo, year: "" + this._yearPlusTwo, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-next-month": this._handleNextMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, locale: this.locale, month: this._monthPlusThree, year: "" + this._yearPlusThree, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("button", { "on-click": this._handleOuterNextMonth, tabindex: "4", class: "icon-button big-arrow-button next-button di di-next-2 di40", "aria-label": "datepicker next month button", disabled: this._nextMonthButtonDisabled, "aria-disabled": this._nextMonthButtonDisabled })), h("div", { id: "three-calendar" }, h("button", { "on-click": this._handleOuterPrevMonth, tabindex: "2", class: "icon-button big-arrow-button previous-button di di-previous-2 di40", "aria-label": "datepicker previous month button", disabled: this._prevMonthButtonDisabled, "aria-disabled": this._prevMonthButtonDisabled }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-prev-month": this._handlePrevMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, id: "first-datepicker", locale: this.locale, month: this.month, year: this.year, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-next-month": this._handleNextMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, id: "second-datepicker", locale: this.locale, month: this._monthPlus, year: "" + this._yearPlus, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-next-month": this._handleNextMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, locale: this.locale, month: this._monthPlusTwo, year: "" + this._yearPlusTwo, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("button", { "on-click": this._handleOuterNextMonth, tabindex: "4", class: "icon-button big-arrow-button next-button di di-next-2 di40", "aria-label": "datepicker next month button", disabled: this._nextMonthButtonDisabled, "aria-disabled": this._nextMonthButtonDisabled })), h("div", { id: "two-calendar" }, h("button", { "on-click": this._handleOuterPrevMonth, tabindex: "2", class: "icon-button big-arrow-button previous-button di di-previous-2 di40", "aria-label": "datepicker previous month button", disabled: this._prevMonthButtonDisabled, "aria-disabled": this._prevMonthButtonDisabled }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-prev-month": this._handlePrevMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, id: "first-datepicker", locale: this.locale, month: this.month, year: this.year, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", prev: true, "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-next-month": this._handleNextMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, locale: this.locale, month: this._monthPlus, year: "" + this._yearPlus, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", next: true, "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("button", { "on-click": this._handleOuterNextMonth, tabindex: "4", class: "icon-button big-arrow-button next-button di di-next-2 di40", "aria-label": "datepicker next month button", disabled: this._nextMonthButtonDisabled, "aria-disabled": this._nextMonthButtonDisabled })), h("div", { id: "one-calendar" }, h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, locale: this.locale, month: this.month, year: this.year, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, "on-date-to-changed": this._handleNewDateTo, "on-date-from-changed": this._handleNewDateFrom, single: true, "on-keydown": (e) => this._moveDayIfValidKeyPressed(e), tabindex: "3" }))), this.fourMonth === false &&
            h("div", null, h("div", { id: "double-calendar" }, h("button", { "on-click": this._handleOuterPrevMonth, tabindex: "2", class: "icon-button big-arrow-button previous-button di di-previous-2 di40", "aria-label": "datepicker previous month button", disabled: this._prevMonthButtonDisabled, "aria-disabled": this._prevMonthButtonDisabled }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-prev-month": this._handlePrevMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, id: "first-datepicker", locale: this.locale, month: this.month, year: this.year, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", prev: true, "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "on-next-month": this._handleNextMonth, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, locale: this.locale, month: this._monthPlus, year: "" + this._yearPlus, "on-date-from-changed": this._handleNewDateFrom, "on-date-to-changed": this._handleNewDateTo, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, tabindex: "3", next: true, "on-keydown": (e) => this._moveDayIfValidKeyPressed(e) }), h("button", { "on-click": this._handleOuterNextMonth, tabindex: "4", class: "icon-button big-arrow-button next-button di di-next-2 di40", "aria-label": "datepicker next month button", disabled: this._nextMonthButtonDisabled, "aria-disabled": this._nextMonthButtonDisabled })), h("div", { id: "single-calendar" }, h("range-datepicker-calendar", { dynamicSizing: this.dynamicSizing, currentCalendarId: this.currentCalendarId, range: this.rangeTimestamp, keepButtons: this.keepButtons, min: this.min, max: this.max, "on-date-is-hovered": this._handleNewHover, "hovered-date": this._hoveredDate, "date-to": this.dateTo, "date-from": this.dateFrom, locale: this.locale, month: this.month, year: this.year, "on-date-from-clicked": this._handleDateFromClicked, "on-date-to-clicked": this._handleDateToClicked, "on-date-to-changed": this._handleNewDateTo, "on-date-from-changed": this._handleNewDateFrom, single: true, "on-keydown": (e) => this._moveDayIfValidKeyPressed(e), tabindex: "3" })))))));
    }
    static get watchers() { return {
        "locale": ["_localeChanged"],
        "month": ["newMonth"],
        "year": ["newYear"],
        "dateFrom": ["_dateFromChanged"],
        "dateTo": ["_dateToChanged"],
        "min": ["_minChanged"],
        "max": ["_maxChanged"],
        "invalidTo": ["_invalidToChanged"],
        "invalidFrom": ["_invalidFromChanged"],
        "textInputValueFrom": ["_textInputValueFromObserver"],
        "textInputValueTo": ["_textInputValueToObserver"]
    }; }
    static get style() { return wdprRangeDatepickerCss; }
}, [1, "wdpr-range-datepicker", {
        "locale": [1],
        "month": [1025],
        "_monthPlus": [1025, "_month-plus"],
        "_monthPlusTwo": [1025, "_month-plus-two"],
        "_monthPlusThree": [1025, "_month-plus-three"],
        "_yearPlus": [1026, "_year-plus"],
        "_yearPlusTwo": [1026, "_year-plus-two"],
        "_yearPlusThree": [1026, "_year-plus-three"],
        "width": [1],
        "currentCalendarId": [1025, "current-calendar-id"],
        "sizeId": [1, "size-id"],
        "year": [1025],
        "dateFrom": [1025, "date-from"],
        "dateTo": [1025, "date-to"],
        "_hoveredDate": [1025, "_hovered-date"],
        "min": [2],
        "max": [2],
        "range": [514],
        "rangeTimestamp": [2, "range-timestamp"],
        "dateFormat": [1, "date-format"],
        "instances": [8],
        "instance": [8],
        "invalidTo": [4, "invalid-to"],
        "invalidFrom": [4, "invalid-from"],
        "invalidToMessage": [513, "invalid-to-message"],
        "invalidFromMessage": [1, "invalid-from-message"],
        "messageHidden": [4, "message-hidden"],
        "rangeDatepickerHidden": [1540, "range-datepicker-hidden"],
        "selectingDateTo": [1540, "selecting-date-to"],
        "dynamicSizing": [1540, "dynamic-sizing"],
        "inputLabel": [1, "input-label"],
        "description": [1],
        "dateFromPlaceholder": [1, "date-from-placeholder"],
        "dateToPlaceholder": [1, "date-to-placeholder"],
        "inputDateFrom": [1025, "input-date-from"],
        "inputDateTo": [1025, "input-date-to"],
        "dash": [1025],
        "_prevMonthButtonDisabled": [1028, "_prev-month-button-disabled"],
        "_nextMonthButtonDisabled": [1028, "_next-month-button-disabled"],
        "keepButtons": [4, "keep-buttons"],
        "disableSelectSameDate": [4, "disable-select-same-date"],
        "fourMonth": [4, "four-month"],
        "editableInput": [4, "editable-input"],
        "textInputValueFrom": [1025, "text-input-value-from"],
        "textInputValueTo": [1025, "text-input-value-to"],
        "bindValueFrom": [16],
        "bindValueTo": [16],
        "_moveDayIfValidKeyPressed": [64]
    }, undefined, {
        "locale": ["_localeChanged"],
        "month": ["newMonth"],
        "year": ["newYear"],
        "dateFrom": ["_dateFromChanged"],
        "dateTo": ["_dateToChanged"],
        "min": ["_minChanged"],
        "max": ["_maxChanged"],
        "invalidTo": ["_invalidToChanged"],
        "invalidFrom": ["_invalidFromChanged"],
        "textInputValueFrom": ["_textInputValueFromObserver"],
        "textInputValueTo": ["_textInputValueToObserver"]
    }]);
function defineCustomElement$1$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wdpr-range-datepicker", "range-datepicker-calendar", "range-datepicker-cell"];
    components.forEach(tagName => { switch (tagName) {
        case "wdpr-range-datepicker":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WdprRangeDatepicker$1);
            }
            break;
        case "range-datepicker-calendar":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "range-datepicker-cell":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
    } });
}
defineCustomElement$1$1();

class WdprDatePicker {
    constructor(lodgingQuickQuote) {
        this.invalidFromInput = false;
        this.invalidToInput = false;
        this.DEFAULT_MAX_CHECKIN_DAYS = 500;
        this.getDefaultCheckinDate = () => {
            var _a;
            return this.getTimestampAfterToday(Number((_a = this.lodgingQuickQuoteInstance.dateRangeOptions) === null || _a === void 0 ? void 0 : _a.defaultCheckinDate) || 0);
        };
        this.getDefaultMaxCheckinDate = () => {
            var _a;
            const maxCheckinDate = luxon$1.DateTime.fromFormat(((_a = this.lodgingQuickQuoteInstance.dateRangeOptions) === null || _a === void 0 ? void 0 : _a.maxCheckinDate) || '', this.lodgingQuickQuoteInstance.apiDateFormat);
            if ((maxCheckinDate === null || maxCheckinDate === void 0 ? void 0 : maxCheckinDate.invalid) === null) {
                return maxCheckinDate.toUnixInteger();
            }
            else {
                return this.getTimestampAfterToday(this.DEFAULT_MAX_CHECKIN_DAYS);
            }
        };
        this.getMaxCheckoutDate = () => {
            const { dateRangeOptions } = this.lodgingQuickQuoteInstance;
            const maxDaysPastProductLoad = parseInt(dateRangeOptions.maxDaysPastProductLoad) || 0;
            let maxCheckoutDate = this.getDefaultCheckinDate();
            if (dateRangeOptions.productLoadEndDate && maxDaysPastProductLoad > 0) {
                maxCheckoutDate = this.getFutureTimestamp(dateRangeOptions.productLoadEndDate, maxDaysPastProductLoad, this.lodgingQuickQuoteInstance.apiDateFormat);
            }
            else {
                const { maxCheckinDate, maxLengthOfStay } = this.lodgingQuickQuoteInstance.dateRangeOptions;
                maxCheckoutDate = this.getFutureTimestamp(maxCheckinDate, Number(maxLengthOfStay), this.lodgingQuickQuoteInstance.apiDateFormat) || maxCheckoutDate;
            }
            return maxCheckoutDate;
        };
        this.getFutureTimestamp = (selectedDate, daysToAdd, dateFormat = this.lodgingQuickQuoteInstance.dateFormat) => {
            const selectedDateFormatted = luxon$1.DateTime.fromFormat(selectedDate, dateFormat);
            const computedDate = selectedDateFormatted.plus({ days: daysToAdd });
            return computedDate.toUnixInteger();
        };
        this.onOpenState = (event) => {
            const datepicker = this.lodgingQuickQuoteInstance.datePickerElement;
            this.handleResize();
            if (!event.detail.isOpen && !this.lodgingQuickQuoteInstance.dateToValue && !this.lodgingQuickQuoteInstance.dateFromValue) {
                this.lodgingQuickQuoteInstance.datepickerError = '';
            }
            const calendarContainer = datepicker.shadowRoot.getElementById('calendars-container');
            const twoCal = calendarContainer.querySelector('#two-calendar');
            const twoCalArrows = twoCal.querySelectorAll('.big-arrow-button');
            twoCalArrows.forEach(node => {
                node.style.marginRight = '8px';
                node.style.marginLeft = '8px';
            });
            const threeCal = calendarContainer.querySelector('#three-calendar');
            const threeCalArrows = threeCal.querySelectorAll('.big-arrow-button');
            threeCalArrows.forEach(node => {
                node.style.marginRight = '8px';
                node.style.marginLeft = '8px';
            });
            const threeCalCalendars = threeCal.querySelectorAll('range-datepicker-calendar');
            threeCalCalendars.forEach(node => {
                node.style.marginRight = '15px';
            });
            if (event.detail.isOpen && this.lodgingQuickQuoteInstance.dateFromValue && this.lodgingQuickQuoteInstance.dateToValue) {
                // Reset minDate and maxDate when picking a new set of dates
                this.minDate = this.getDefaultCheckinDate();
                this.maxDate = this.maxSelectableDate = this.getDefaultMaxCheckinDate();
            }
        };
        this.onDateSelected = (selectedDate, type) => {
            this.updateDateData(type, selectedDate);
        };
        this.lodgingQuickQuoteInstance = lodgingQuickQuote;
    }
    init() {
        let { dateFormat, localePreferredLanguage } = this.lodgingQuickQuoteInstance;
        // Convert moment format to luxon format tokens
        this.lodgingQuickQuoteInstance.dateFormat = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.replace(/D/g, 'd').replace(/Y/g, 'y');
        this.minDate = this.getDefaultCheckinDate();
        this.maxDate = this.maxSelectableDate = this.getDefaultMaxCheckinDate();
        this.maxCheckoutDate = this.getMaxCheckoutDate();
        // Make sure localePreferredLanguage is truthy
        // If an empty string is passed to locale, the month picker will show up empty
        if (!localePreferredLanguage) {
            this.lodgingQuickQuoteInstance.localePreferredLanguage = 'en';
        }
        // Styling for mobile view
        // Since this element is in the shadow root of the RA component, we can't use CSS
        const datePicker = this.lodgingQuickQuoteInstance.datePickerElement;
        const calendarInput = datePicker.shadowRoot.getElementById('input-container');
        calendarInput.style.width = '100%';
    }
    parseShorthandDate(dateInputValue) {
        // Replace any "-" or "." date separators with "/"
        const dateStr = dateInputValue.replaceAll(/[\-\.]/g, '/');
        const dateFormat = this.lodgingQuickQuoteInstance.dateFormat;
        let abbrYrFormat = 'M/d/yy';
        let fullYrFormat = 'M/d/yyyy';
        // EU/UK date format
        if (dateFormat[0].toLowerCase() === 'd') {
            abbrYrFormat = 'd/M/yy';
            fullYrFormat = 'd/M/yyyy';
        }
        const parsedDate = (luxon$1.DateTime.fromFormat(dateStr, abbrYrFormat).isValid)
            ? luxon$1.DateTime.fromFormat(dateStr, abbrYrFormat)
            : luxon$1.DateTime.fromFormat(dateStr, fullYrFormat);
        return parsedDate;
    }
    formatShorthandDate(dateInputValue, type) {
        try {
            // Parse the date string using Luxon
            const parsedDate = this.parseShorthandDate(dateInputValue);
            const maxDate = luxon$1.DateTime.fromSeconds(this.maxDate);
            const today = new Date(new Date().toDateString());
            const todayDate = luxon$1.DateTime.fromJSDate(today);
            if (!!parsedDate.invalid || parsedDate < todayDate || parsedDate > maxDate) {
                this.lodgingQuickQuoteInstance.datepickerError = this.getDateErrorByType(type);
                return false;
            }
            if (type === 'from') {
                const maxSelectableDate = luxon$1.DateTime.fromSeconds(this.maxSelectableDate);
                if (parsedDate > maxSelectableDate) {
                    return false;
                }
            }
            if (type === 'to') {
                const fromDate = luxon$1.DateTime.fromSeconds(this.lodgingQuickQuoteInstance.dateFromValue);
                if (parsedDate < fromDate) {
                    this.lodgingQuickQuoteInstance.datepickerError = this.getDateErrorByType(type);
                    return false;
                }
            }
            const formattedDate = parsedDate.toFormat(this.lodgingQuickQuoteInstance.dateFormat);
            return formattedDate;
        }
        catch (error) {
            return false;
        }
    }
    getDateErrorByType(type) {
        return this.lodgingQuickQuoteInstance.datepickerError = (type === 'from' ?
            this.lodgingQuickQuoteInstance.config.qqForm.validationErrors.invalidCheckInDate :
            this.lodgingQuickQuoteInstance.config.qqForm.validationErrors.invalidCheckOutDate);
    }
    onInvalidDateInput(type) {
        const datepicker = this.lodgingQuickQuoteInstance.datePickerElement;
        const inputElement = datepicker.shadowRoot.querySelector(`#input${type === 'from' ? '1' : '2'}`);
        const inputValue = inputElement.getAttribute('value');
        const formattedInvalidDate = this.formatShorthandDate(inputValue, type);
        // if user clicks calendar dates instead of typing them in, inputvalue will be undefined
        if (!inputValue) {
            return;
        }
        // if to and from values are the same throw an error
        const fromValue = datepicker.shadowRoot.querySelector('#input1').getAttribute('value');
        if (fromValue === formattedInvalidDate) {
            return this.lodgingQuickQuoteInstance.datepickerError = this.lodgingQuickQuoteInstance.config.qqForm.validationErrors.minLengthOfStay;
        }
        // invalid event fires for shorthand values like 9/24/24 --> this value catches those cases and reformats them
        if (formattedInvalidDate) {
            inputElement.setAttribute('value', formattedInvalidDate);
            this.lodgingQuickQuoteInstance.forceQQUpdate();
            this.onDateSelected(formattedInvalidDate, type);
        }
        datepicker.setAttribute(`invalid-${type}`, 'false');
        const holdFrom = datepicker.shadowRoot.querySelector(`#input${type === 'from' ? '1' : '2'}`);
        if (formattedInvalidDate) {
            holdFrom.value = formattedInvalidDate;
            this.lodgingQuickQuoteInstance.datepickerError = '';
        }
        else {
            holdFrom.value = '';
            holdFrom.removeAttribute('value');
            // if user opens and closes calendar with no date selected, error should not be thrown
            if (!this.lodgingQuickQuoteInstance.datepickerError &&
                !this.lodgingQuickQuoteInstance.dateToValue &&
                !this.lodgingQuickQuoteInstance.dateFromValue) {
                return;
            }
            const newError = this.getDateErrorByType(type);
            if (newError !== this.lodgingQuickQuoteInstance.datepickerError) {
                this.lodgingQuickQuoteInstance.datepickerError = newError;
            }
        }
    }
    prohibitNonDateChars(event) {
        const inputCharacter = event.data;
        // Only allow numbers or date separators ("/", ".", or "-")
        if (inputCharacter && !inputCharacter.match(/[0-9\/\-\.]/)) {
            // If it's an invalid character, replace with empty string
            event.target.value = event.target.value.replace(inputCharacter, '');
        }
    }
    getTimestampAfterToday(daysAfterToday) {
        const today = new Date(new Date().toDateString());
        const todayFormatted = luxon$1.DateTime.fromJSDate(today).toFormat(this.lodgingQuickQuoteInstance.dateFormat);
        return this.getFutureTimestamp(todayFormatted, daysAfterToday);
    }
    handleResize() {
        const qqPadding = 40;
        const qqContainer = this.lodgingQuickQuoteInstance.element;
        const qqRect = qqContainer.getBoundingClientRect();
        const datepicker = this.lodgingQuickQuoteInstance.datePickerElement;
        const datepickerRect = datepicker.getBoundingClientRect();
        const calendar = datepicker.shadowRoot.getElementById('calendars-container');
        const calendarLeft = datepickerRect.x - qqRect.x - (qqPadding / 2);
        if (window.innerWidth <= 480) { // 1-cal
            const oneCal = calendar.querySelector('#one-calendar');
            oneCal.style.width = '100%';
            calendar.setAttribute('style', '');
        }
        else if (window.innerWidth > 480 && window.innerWidth <= 1024) { // 2-cal & 3-cal
            calendar.setAttribute('style', `left: -${calendarLeft}px; width: 100vw; width: ${qqRect.width - qqPadding}px`);
        }
        else if (window.innerWidth > 1024) { // 4-cal
            calendar.setAttribute('style', `left: -${calendarLeft}px; width: ${qqRect.width - qqPadding}px`);
        }
        const arrow = datepicker.shadowRoot.getElementById('outer-up-arrow');
        arrow.setAttribute('style', `left: ${calendarLeft}px;`);
    }
    updateDateData(type, date) {
        const { maxLengthOfStay, checkInDateName, checkOutDateName } = this.lodgingQuickQuoteInstance.dateRangeOptions;
        let { updateRoomFormDataHandler, dateFormat, apiDateFormat } = this.lodgingQuickQuoteInstance;
        const dateTime = luxon$1.DateTime.fromFormat(date, dateFormat);
        const dateFormatted = dateTime.toFormat(apiDateFormat);
        const dateTimeUnixValue = dateTime.toUnixInteger();
        if (!!dateTime.invalid) {
            return;
        }
        if (type === 'from') {
            // Set min and max dates accordingly and reset date-to value
            this.lodgingQuickQuoteInstance.dateFromValue = dateTimeUnixValue;
            const maxLengthOfStayDate = this.getFutureTimestamp(date, Number(maxLengthOfStay));
            if (this.maxCheckoutDate && maxLengthOfStayDate > this.maxCheckoutDate) {
                this.maxDate = this.maxSelectableDate = this.maxCheckoutDate;
            }
            else {
                this.maxDate = this.maxSelectableDate = maxLengthOfStayDate;
            }
            updateRoomFormDataHandler({
                [checkInDateName]: dateFormatted,
                [checkOutDateName]: undefined
            });
            this.lodgingQuickQuoteInstance.datepickerError = '';
        }
        else if (type === 'to') {
            if (dateTimeUnixValue === this.lodgingQuickQuoteInstance.dateFromValue) {
                this.lodgingQuickQuoteInstance.datepickerError = this.lodgingQuickQuoteInstance.config.qqForm.validationErrors.minLengthOfStay;
                return;
            }
            updateRoomFormDataHandler({ [checkOutDateName]: dateFormatted });
            this.lodgingQuickQuoteInstance.dateToValue = dateTimeUnixValue;
            const defaultMaxCheckinDate = this.getDefaultMaxCheckinDate();
            this.lodgingQuickQuoteInstance.datepickerError = '';
            // Allow the maxDate to be the selected value so that the calendar does not trigger the invalid event
            if (this.maxCheckoutDate && dateTimeUnixValue > defaultMaxCheckinDate) {
                this.maxDate = dateTimeUnixValue;
            }
            else {
                this.maxDate = defaultMaxCheckinDate;
            }
            // Set maxSelectableDate to the default max checkin date - Required for case when max checkin date is before the current max date
            // e.g. Max checkin date of 12/31/25 but a selected checkout date of 01/02/26 is selected
            this.maxSelectableDate = defaultMaxCheckinDate;
        }
    }
    computeDateInTheFuture(daysNumber) {
        const date = new Date();
        date.setDate(date.getDate() + daysNumber);
        return date.setHours(0, 0, 0, 0) / 1000; // Unix timestamp format
    }
}

const wdprLodgingQuickquoteCss = ":host{--font-family-base:var(--font-family-base-theme, InspireTWDC);--font-family-light:var(--font-family-light-theme, InspireTWDCLight);--font-family-heavy:var(--font-family-heavy-theme, InspireTWDCHeavy);--font-family-black:var(--font-family-black-theme, InspireTWDCBlack);--font-family-medium:var(--font-family-medium-theme, InspireTWDCMedium);--font-family-roman:var(--font-family-roman-theme, InspireTWDCRoman);--font-family-book:var(--font-family-book-theme, InspireTWDCBook);--font-weight-light:var(--font-weight-light-theme, 200);--font-weight-heavy:var(--font-weight-heavy-theme, 700);--font-weight-black:var(--font-weight-black-theme, 900);--font-weight-medium:var(--font-weight-medium-theme, 500);--font-weight-roman:var(--font-weight-roman-theme, 400);--font-weight-book:var(--font-weight-book-theme, 400);--font50-line-height:var(--font50-line-height-theme, 60px);--font40-line-height:var(--font40-line-height-theme, 50px);--font36-line-height:var(--font36-line-height-theme, 48px);--font28-line-height:var(--font28-line-height-theme, 36px);--font24-line-height:var(--font24-line-height-theme, 32px);--font20-line-height:var(--font20-line-height-theme, 28px);--font18-line-height:var(--font18-line-height-theme, 26px);--font16-line-height:var(--font16-line-height-theme, 24px);--font14-line-height:var(--font14-line-height-theme, 20px);--font12-line-height:var(--font12-line-height-theme, 20px)}:host{--font-base:{\n    font-family: var(--font-family-base)}; --font-light:{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}; --font-heavy:{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}; --font-black:{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}; --font-medium:{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}; --font-roman:{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}; --font-book:{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}; --font50:{font-size:50px;line-height:var(--font50-line-height)}; --font40:{font-size:40px;line-height:var(--font40-line-height)}; --font36:{font-size:36px;line-height:var(--font36-line-height)}; --font28:{font-size:28px;line-height:var(--font28-line-height)}; --font24:{font-size:24px;line-height:var(--font24-line-height)}; --font20:{font-size:20px;line-height:var(--font20-line-height)}; --font18:{font-size:18px;line-height:var(--font18-line-height)}; --font16:{font-size:16px;line-height:var(--font16-line-height)}; --font14:{font-size:14px;line-height:var(--font14-line-height)}; --font12:{font-size:12px;line-height:var(--font12-line-height)}; } .font-base{font-family:var(--font-family-base)}.light{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}.heavy,wdpr-single-select::part(option-item-subhead){font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}.black{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}.medium{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}.roman{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}.book{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.font50{font-size:50px;line-height:var(--font50-line-height)}.font40{font-size:40px;line-height:var(--font40-line-height)}.font36{font-size:36px;line-height:var(--font36-line-height)}.font28{font-size:28px;line-height:var(--font28-line-height)}.font24{font-size:24px;line-height:var(--font24-line-height)}.font20{font-size:20px;line-height:var(--font20-line-height)}.font18{font-size:18px;line-height:var(--font18-line-height)}.font16{font-size:16px;line-height:var(--font16-line-height)}.font14,wdpr-single-select::part(option-value-inner){font-size:14px;line-height:var(--font14-line-height)}.font12{font-size:12px;line-height:var(--font12-line-height)}.font-lg-1{font-size:50px;line-height:var(--font50-line-height)}.font-lg-2{font-size:40px;line-height:var(--font40-line-height)}.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}@media only screen and (min-width: 481px) and (max-width: 1179.98px){.font-lg-1,.font-lg-2,.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}@media only screen and (max-width: 480.98px){.font-lg-1,.font-lg-2,.font-md-1,.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}:host{font-family:var(--font-family-base)}:host{--icon-font-family:var(--icon-font-family-theme, \"pepmdx\")}.di{font-family:var(--icon-font-family, \"pepmdx\") !important;font-style:normal;font-size:inherit}.di50{font-size:50px}.di40{font-size:40px}.di36{font-size:36px}.di28{font-size:28px}.di24{font-size:24px}.di20{font-size:20px}.di18{font-size:18px}.di16{font-size:16px}.di14{font-size:14px}.di12{font-size:12px}.di10{font-size:10px}.di-disney-resort::before,.di-E001::before{content:\"\\e001\"}.di-california-adventure::before,.di-E002::before{content:\"\\e002\"}.di-disney-paris::before,.di-E003::before{content:\"\\e003\"}.di-shanghai-disney-resort::before,.di-E004::before{content:\"\\e004\"}.di-hong-kong-disney::before,.di-E005::before{content:\"\\e005\"}.di-tokyo-disney::before,.di-E006::before{content:\"\\e006\"}.di-aulani-resort-hawaii::before,.di-E007::before{content:\"\\e007\"}.di-adventure-by-disney::before,.di-E008::before{content:\"\\e008\"}.di-disney-park-generic-castle::before,.di-E009::before{content:\"\\e009\"}.di-leadership::before,.di-E00A::before{content:\"\\e00a\"}.di-selection-training::before,.di-E00B::before{content:\"\\e00b\"}.di-quality-service::before,.di-E00C::before{content:\"\\e00c\"}.di-brand-royalty::before,.di-E00D::before{content:\"\\e00d\"}.di-creativity-innovate::before,.di-E00E::before{content:\"\\e00e\"}.di-business-excellence::before,.di-E00F::before{content:\"\\e00f\"}.di-medical-excellence::before,.di-E010::before{content:\"\\e010\"}.di-catalogs::before,.di-E011::before{content:\"\\e011\"}.di-disney-park::before,.di-E012::before{content:\"\\e012\"}.di-disneyland-resort::before,.di-E013::before{content:\"\\e013\"}.di-city-hall-services::before,.di-E014::before{content:\"\\e014\"}.di-hkdl-magic-access::before,.di-E015::before{content:\"\\e015\"}.di-downtown-disney::before,.di-E016::before{content:\"\\e016\"}.di-wedding-engagements::before,.di-E017::before{content:\"\\e017\"}.di-weddings-ever-after-blog::before,.di-E018::before{content:\"\\e018\"}.di-weddings-bridal-boutique::before,.di-E019::before{content:\"\\e019\"}.di-shdr-disneytown::before,.di-E01A::before{content:\"\\e01a\"}.di-shdr-wishing-star-park::before,.di-E01B::before{content:\"\\e01b\"}.di-shop-disney-parks-app::before,.di-E01C::before{content:\"\\e01c\"}.di-shop-disney-parks-bag::before,.di-E01D::before{content:\"\\e01d\"}.di-shop-disney-bag::before,.di-E01E::before{content:\"\\e01e\"}.di-style-guide::before,.di-E020::before{content:\"\\e020\"}.di-star-wars::before,.di-E021::before{content:\"\\e021\"}.di-sw-galaxys-edge-hub::before,.di-E022::before{content:\"\\e022\"}.di-rundisney-medals::before,.di-E023::before{content:\"\\e023\"}.di-rundisney-shirts::before,.di-E024::before{content:\"\\e024\"}.di-rundisney-snacks::before,.di-E025::before{content:\"\\e025\"}.di-disneyland-calender::before,.di-E026::before{content:\"\\e026\"}.di-california-adventure-calender::before,.di-E027::before{content:\"\\e027\"}.di-genie-product::before,.di-E028::before{content:\"\\e028\"}.di-all-parks-and-resorts::before,.di-E040::before{content:\"\\e040\"}.di-magic-kingdom::before,.di-E041::before{content:\"\\e041\"}.di-epcot::before,.di-E042::before{content:\"\\e042\"}.di-animal-kingdom::before,.di-E043::before{content:\"\\e043\"}.di-hollywood-studios::before,.di-E044::before{content:\"\\e044\"}.di-typhoon-lagoon::before,.di-E045::before{content:\"\\e045\"}.di-blizzard-beach::before,.di-E046::before{content:\"\\e046\"}.di-disney-springs::before,.di-E047::before{content:\"\\e047\"}.di-espn-wide-world-sports::before,.di-E048::before{content:\"\\e048\"}.di-resorts::before,.di-E049::before{content:\"\\e049\"}.di-disney-beach-resorts::before,.di-E04A::before{content:\"\\e04a\"}.di-disney-boardwalk::before,.di-E04B::before{content:\"\\e04b\"}.di-all-categories::before,.di-E04C::before{content:\"\\e04c\"}.di-cirque-du-soleil-la-nouba::before,.di-E04D::before{content:\"\\e04d\"}.di-star-wars-galactic-starcruiser::before,.di-E04E::before{content:\"\\e04e\"}.di-disney-cruise-line::before,.di-E080::before{content:\"\\e080\"}.di-dcl-our-ships::before,.di-E081::before{content:\"\\e081\"}.di-dcl-destinations::before,.di-E082::before{content:\"\\e082\"}.di-dcl-onboard-fun::before,.di-E083::before{content:\"\\e083\"}.di-dcl-new-cruisers::before,.di-E084::before{content:\"\\e084\"}.di-dcl-port-adventures::before,.di-E085::before{content:\"\\e085\"}.di-app-instructions::before,.di-E086::before{content:\"\\e086\"}.di-featured-article::before,.di-E087::before{content:\"\\e087\"}.di-drink-of-the-day::before,.di-E088::before{content:\"\\e088\"}.di-view-folio::before,.di-E08A::before{content:\"\\e08a\"}.di-key-to-the-world::before,.di-E08B::before{content:\"\\e08b\"}.di-in-room-entertainment::before,.di-E08C::before{content:\"\\e08c\"}.di-ship-directory::before,.di-E08D::before{content:\"\\e08d\"}.di-theatre::before,.di-E08E::before{content:\"\\e08e\"}.di-disembarkation::before,.di-E08F::before{content:\"\\e08f\"}.di-wash-hands::before,.di-E094::before{content:\"\\e094\"}.di-security-notice::before,.di-E095::before{content:\"\\e095\"}.di-environmental-message::before,.di-E096::before{content:\"\\e096\"}.di-room-upgrade::before,.di-E098::before{content:\"\\e098\"}.di-castaway-club-member::before,.di-E09A::before{content:\"\\e09a\"}.di-dcl-open-house::before,.di-E09B::before{content:\"\\e09b\"}.di-stateroom-balcony::before,.di-E09F::before{content:\"\\e09f\"}.di-cart-empty::before,.di-E0C0::before{content:\"\\e0c0\"}.di-cart-full::before,.di-E0C1::before{content:\"\\e0c1\"}.di-tickets::before,.di-E0C2::before{content:\"\\e0c2\"}.di-fastpass-plus::before,.di-E0C3::before{content:\"\\e0c3\"}.di-fastpasses-set::before,.di-E0C4::before{content:\"\\e0c4\"}.di-fastpasses-copy-set::before,.di-E0C5::before{content:\"\\e0c5\"}.di-cancel-fastpasses::before,.di-E0C6::before{content:\"\\e0c6\"}.di-water-park::before,.di-E0C7::before{content:\"\\e0c7\"}.di-vacation-packages::before,.di-E0C8::before{content:\"\\e0c8\"}.di-personal-magic::before,.di-E0C9::before{content:\"\\e0c9\"}.di-florida-resident::before,.di-E0CA::before{content:\"\\e0ca\"}.di-disney-vacation-club-info::before,.di-E0CB::before{content:\"\\e0cb\"}.di-annual-passholder::before,.di-E0CC::before{content:\"\\e0cc\"}.di-us-military::before,.di-E0CD::before{content:\"\\e0cd\"}.di-special-offers-dollar-sign::before,.di-E0CE::before{content:\"\\e0ce\"}.di-booking-rooms-packages::before,.di-E0CF::before{content:\"\\e0cf\"}.di-old-fastpass::before,.di-E0D0::before{content:\"\\e0d0\"}.di-certificate::before,.di-E0D1::before{content:\"\\e0d1\"}.di-will-call-tickets::before,.di-E0D2::before{content:\"\\e0d2\"}.di-entrance-pass::before,.di-E0D3::before{content:\"\\e0d3\"}.di-guest-pass::before,.di-E0D4::before{content:\"\\e0d4\"}.di-city-pass::before,.di-E0D5::before{content:\"\\e0d5\"}.di-california::before,.di-E0D6::before{content:\"\\e0d6\"}.di-southern-california::before,.di-E0D7::before{content:\"\\e0d7\"}.di-etickets::before,.di-E0D8::before{content:\"\\e0d8\"}.di-compare-offers::before,.di-E0D9::before{content:\"\\e0d9\"}.di-baja-california-resident::before,.di-E0DA::before{content:\"\\e0da\"}.di-area-attractions::before,.di-E0DB::before{content:\"\\e0db\"}.di-anaheim-resort-transit::before,.di-E0DC::before{content:\"\\e0dc\"}.di-edit-fastpass::before,.di-E0DD::before{content:\"\\e0dd\"}.di-in-park-merchandise::before,.di-E0E0::before{content:\"\\e0e0\"}.di-travel-insurance::before,.di-E0E1::before{content:\"\\e0e1\"}.di-texas-resident::before,.di-E0E2::before{content:\"\\e0e2\"}.di-canadian-resident::before,.di-E0E3::before{content:\"\\e0e3\"}.di-add-tickets::before,.di-E0E4::before{content:\"\\e0e4\"}.di-splurge::before,.di-E0E5::before{content:\"\\e0e5\"}.di-disneyland-annual-passes::before,.di-E0E6::before{content:\"\\e0e6\"}.di-dlr-tickets-passes::before,.di-E0E7::before{content:\"\\e0e7\"}.di-get-vacation-offer-recommended::before,.di-E0E8::before{content:\"\\e0e8\"}.di-get-vacation-offer-guest-created::before,.di-E0E9::before{content:\"\\e0e9\"}.di-shdr-fastpass::before,.di-E0EA::before{content:\"\\e0ea\"}.di-currency-convertor::before,.di-E0EB::before{content:\"\\e0eb\"}.di-call-to-buy-tickets::before,.di-E0EC::before{content:\"\\e0ec\"}.di-wdw-tickets-and-passes::before,.di-E0ED::before{content:\"\\e0ed\"}.di-renew-annual-pass::before,.di-E0EE::before{content:\"\\e0ee\"}.di-renew-annual-pass-dlr::before,.di-E0EF::before{content:\"\\e0ef\"}.di-annual-pass-wdw::before,.di-E0F0::before{content:\"\\e0f0\"}.di-mobile-order::before,.di-E0F1::before{content:\"\\e0f1\"}.di-fastpass::before,.di-E0F2::before{content:\"\\e0f2\"}.di-ticket-ap-upgrade::before,.di-E0F3::before{content:\"\\e0f3\"}.di-shdr-premium-access::before,.di-E0F4::before{content:\"\\e0f4\"}.di-shdr-tickets-and-passes::before,.di-E0F5::before{content:\"\\e0f5\"}.di-shdr-seasonal-pass::before,.di-E0F6::before{content:\"\\e0f6\"}.di-shdr-fastpass-reverse::before,.di-E0F7::before{content:\"\\e0f7\"}.di-disney-maxpass::before,.di-E0F8::before{content:\"\\e0f8\"}.di-shdr-premium-access-chinese::before,.di-E0F9::before{content:\"\\e0f9\"}.di-hawaii-resident::before,.di-E0FA::before{content:\"\\e0fa\"}.di-club-33-membership::before,.di-E0FB::before{content:\"\\e0fb\"}.di-order-grocery-delivery::before,.di-E0FC::before{content:\"\\e0fc\"}.di-special-offers::before,.di-E0FD::before{content:\"\\e0fd\"}.di-prebook-fastpass::before,.di-E0FE::before{content:\"\\e0fe\"}.di-upgrade-offer::before,.di-E0FF::before{content:\"\\e0ff\"}.di-mdx::before,.di-E100::before{content:\"\\e100\"}.di-about-me::before,.di-E101::before{content:\"\\e101\"}.di-friends-family::before,.di-E102::before{content:\"\\e102\"}.di-account-settings::before,.di-E103::before{content:\"\\e103\"}.di-magicbands-v2::before,.di-E104::before{content:\"\\e104\"}.di-magic-cards::before,.di-E105::before{content:\"\\e105\"}.di-pin-payment-methods::before,.di-E106::before{content:\"\\e106\"}.di-communication-references::before,.di-E107::before{content:\"\\e107\"}.di-wishlist::before,.di-E108::before{content:\"\\e108\"}.di-link-existing-reservation::before,.di-E109::before{content:\"\\e109\"}.di-guest-entered-schedule-item::before,.di-E10A::before{content:\"\\e10a\"}.di-birthday::before,.di-E10B::before{content:\"\\e10b\"}.di-memory-maker::before,.di-E10C::before{content:\"\\e10c\"}.di-memory-maker-2::before,.di-E10D::before{content:\"\\e10d\"}.di-passes-and-memberships::before,.di-E10E::before{content:\"\\e10e\"}.di-link-mdx-tickets-passes::before,.di-E10F::before{content:\"\\e10f\"}.di-link-mdx-resort-reservations::before,.di-E110::before{content:\"\\e110\"}.di-link-mdx-dining-reservations::before,.di-E111::before{content:\"\\e111\"}.di-link-dlr-tickets::before,.di-E112::before{content:\"\\e112\"}.di-link-main-entrance::before,.di-E113::before{content:\"\\e113\"}.di-digital-key::before,.di-E115::before{content:\"\\e115\"}.di-wishlist-item-added::before,.di-E116::before{content:\"\\e116\"}.di-wishlist-empty::before,.di-E117::before{content:\"\\e117\"}.di-magicbands-original::before,.di-E118::before{content:\"\\e118\"}.di-all-activities::before,.di-E140::before{content:\"\\e140\"}.di-attractions::before,.di-E141::before{content:\"\\e141\"}.di-characters::before,.di-E142::before{content:\"\\e142\"}.di-entertainment::before,.di-E143::before{content:\"\\e143\"}.di-tours-events::before,.di-E144::before{content:\"\\e144\"}.di-in-park-shopping::before,.di-E145::before{content:\"\\e145\"}.di-spas::before,.di-E146::before{content:\"\\e146\"}.di-tour::before,.di-E14C::before{content:\"\\e14c\"}.di-spring-break::before,.di-E14D::before{content:\"\\e14d\"}.di-fireworks::before,.di-E14E::before{content:\"\\e14e\"}.di-shows::before,.di-E14F::before{content:\"\\e14f\"}.di-dining::before,.di-E180::before{content:\"\\e180\"}.di-dining-plan::before,.di-E181::before{content:\"\\e181\"}.di-dining-plan-accepted::before,.di-E182::before{content:\"\\e182\"}.di-dining-plan-not-accepted::before,.di-E183::before{content:\"\\e183\"}.di-dining-reservation::before,.di-E184::before{content:\"\\e184\"}.di-menu::before,.di-E185::before{content:\"\\e185\"}.di-prix-fixe-qsr::before,.di-E186::before{content:\"\\e186\"}.di-prix-fixe-tsr::before,.di-E187::before{content:\"\\e187\"}.di-entrees-qsr::before,.di-E188::before{content:\"\\e188\"}.di-entrees-tsr::before,.di-E189::before{content:\"\\e189\"}.di-beverages::before,.di-E18A::before{content:\"\\e18a\"}.di-wine::before,.di-E18B::before{content:\"\\e18b\"}.di-beer::before,.di-E18C::before{content:\"\\e18c\"}.di-cocktails::before,.di-E18D::before{content:\"\\e18d\"}.di-appetizers::before,.di-E18E::before{content:\"\\e18e\"}.di-sandwiches::before,.di-E18F::before{content:\"\\e18f\"}.di-beef-pork-chicken::before,.di-E190::before{content:\"\\e190\"}.di-seafood::before,.di-E191::before{content:\"\\e191\"}.di-pasta::before,.di-E192::before{content:\"\\e192\"}.di-salads::before,.di-E193::before{content:\"\\e193\"}.di-sides::before,.di-E194::before{content:\"\\e194\"}.di-desserts::before,.di-E195::before{content:\"\\e195\"}.di-buffet::before,.di-E196::before{content:\"\\e196\"}.di-favorites::before,.di-E197::before{content:\"\\e197\"}.di-kids-picks::before,.di-E198::before{content:\"\\e198\"}.di-featured-items::before,.di-E199::before{content:\"\\e199\"}.di-nutritional-content::before,.di-E19A::before{content:\"\\e19a\"}.di-nutritional-information::before,.di-E19B::before{content:\"\\e19b\"}.di-gluten-free::before,.di-E19C::before{content:\"\\e19c\"}.di-dairy-free::before,.di-E19D::before{content:\"\\e19d\"}.di-character-dining::before,.di-E19E::before{content:\"\\e19e\"}.di-mockey-food-seal::before,.di-E19F::before{content:\"\\e19f\"}.di-priority-seating::before,.di-E1A1::before{content:\"\\e1a1\"}.di-vegetarian::before,.di-E1A2::before{content:\"\\e1a2\"}.di-raw-food::before,.di-E1A3::before{content:\"\\e1a3\"}.di-guest-favorite-food::before,.di-E1A4::before{content:\"\\e1a4\"}.di-mobile-order-food::before,.di-E1A5::before{content:\"\\e1a5\"}.di-adult-table-service::before,.di-E1A6::before{content:\"\\e1a6\"}.di-celebration-cakes::before,.di-E1A7::before{content:\"\\e1a7\"}.di-disney-dining-plan::before,.di-E1A8::before{content:\"\\e1a8\"}.di-disney-deluxe-dining-plan::before,.di-E1A9::before{content:\"\\e1a9\"}.di-coffee-mug::before,.di-E1AA::before{content:\"\\e1aa\"}.di-mobile-order-food::before,.di-E1AB::before{content:\"\\e1ab\"}.di-qs-dining-card::before,.di-E1AC::before{content:\"\\e1ac\"}.di-allergy-friendly::before,.di-E1AD::before{content:\"\\e1ad\"}.di-kids-meals::before,.di-E1AE::before{content:\"\\e1ae\"}.di-dining-check-in::before,.di-E1AF::before{content:\"\\e1af\"}.di-sports-recreation::before,.di-E1C0::before{content:\"\\e1c0\"}.di-campfire::before,.di-E1C1::before{content:\"\\e1c1\"}.di-snorkeling::before,.di-E1C2::before{content:\"\\e1c2\"}.di-swimming::before,.di-E1C3::before{content:\"\\e1c3\"}.di-boating::before,.di-E1C4::before{content:\"\\e1c4\"}.di-running::before,.di-E1C5::before{content:\"\\e1c5\"}.di-fitness-room::before,.di-E1C6::before{content:\"\\e1c6\"}.di-game::before,.di-E1C7::before{content:\"\\e1c7\"}.di-shuffleboard::before,.di-E1C8::before{content:\"\\e1c8\"}.di-parasailing::before,.di-E1C9::before{content:\"\\e1c9\"}.di-playground::before,.di-E1CA::before{content:\"\\e1ca\"}.di-horseback-riding::before,.di-E1CB::before{content:\"\\e1cb\"}.di-pool-tables::before,.di-E1CC::before{content:\"\\e1cc\"}.di-fishing::before,.di-E1CD::before{content:\"\\e1cd\"}.di-volleyball::before,.di-E1CE::before{content:\"\\e1ce\"}.di-basketball::before,.di-E1CF::before{content:\"\\e1cf\"}.di-cycling::before,.di-E1D0::before{content:\"\\e1d0\"}.di-explore::before,.di-E1D1::before{content:\"\\e1d1\"}.di-disneyland-recreation::before,.di-E1D2::before{content:\"\\e1d2\"}.di-baseball::before,.di-E1D4::before{content:\"\\e1d4\"}.di-field-hockey::before,.di-E1D5::before{content:\"\\e1d5\"}.di-football::before,.di-E1D6::before{content:\"\\e1d6\"}.di-gymnastics::before,.di-E1D7::before{content:\"\\e1d7\"}.di-lacrosse::before,.di-E1D8::before{content:\"\\e1d8\"}.di-crosscountry::before,.di-E1D9::before{content:\"\\e1d9\"}.di-soccer::before,.di-E1DA::before{content:\"\\e1da\"}.di-softball-fastpitch::before,.di-E1DB::before{content:\"\\e1db\"}.di-softball-slowpitch::before,.di-E1DC::before{content:\"\\e1dc\"}.di-track-field::before,.di-E1DD::before{content:\"\\e1dd\"}.di-tennis-court::before,.di-E1DE::before{content:\"\\e1de\"}.di-generic-sports::before,.di-E1DF::before{content:\"\\e1df\"}.di-maps::before,.di-E200::before{content:\"\\e200\"}.di-guest-services::before,.di-E201::before{content:\"\\e201\"}.di-concierge::before,.di-E202::before{content:\"\\e202\"}.di-resort-checkin::before,.di-E203::before{content:\"\\e203\"}.di-celebration::before,.di-E204::before{content:\"\\e204\"}.di-aeds::before,.di-E205::before{content:\"\\e205\"}.di-smoking-area::before,.di-E206::before{content:\"\\e206\"}.di-no-smoking::before,.di-E207::before{content:\"\\e207\"}.di-lost-found::before,.di-E208::before{content:\"\\e208\"}.di-baby-care-center::before,.di-E209::before{content:\"\\e209\"}.di-currency-exchange::before,.di-E20A::before{content:\"\\e20a\"}.di-atm::before,.di-E20B::before{content:\"\\e20b\"}.di-restrooms::before,.di-E20C::before{content:\"\\e20c\"}.di-first-aid::before,.di-E20D::before{content:\"\\e20d\"}.di-laundry::before,.di-E20E::before{content:\"\\e20e\"}.di-valet::before,.di-E20F::before{content:\"\\e20f\"}.di-in-room-babysitting::before,.di-E210::before{content:\"\\e210\"}.di-business-center::before,.di-E211::before{content:\"\\e211\"}.di-cabanas::before,.di-E212::before{content:\"\\e212\"}.di-ecv::before,.di-E213::before{content:\"\\e213\"}.di-strollers::before,.di-E214::before{content:\"\\e214\"}.di-parking-lot::before,.di-E215::before{content:\"\\e215\"}.di-kennel::before,.di-E216::before{content:\"\\e216\"}.di-package-pick-up::before,.di-E217::before{content:\"\\e217\"}.di-gas-station::before,.di-E218::before{content:\"\\e218\"}.di-pin-trading::before,.di-E219::before{content:\"\\e219\"}.di-translation-devices::before,.di-E21A::before{content:\"\\e21a\"}.di-wedding-ceremonies::before,.di-E21B::before{content:\"\\e21b\"}.di-resort-amenities::before,.di-E21C::before{content:\"\\e21c\"}.di-movies-under-the-stars::before,.di-E21D::before{content:\"\\e21d\"}.di-kodak-picture-spot::before,.di-E21E::before{content:\"\\e21e\"}.di-locker-rentals::before,.di-E21F::before{content:\"\\e21f\"}.di-here-now::before,.di-E220::before{content:\"\\e220\"}.di-current-location::before,.di-E221::before{content:\"\\e221\"}.di-supervise-children::before,.di-E222::before{content:\"\\e222\"}.di-rider-swap::before,.di-E223::before{content:\"\\e223\"}.di-service-dog::before,.di-E224::before{content:\"\\e224\"}.di-free-disney-wifi::before,.di-E225::before{content:\"\\e225\"}.di-generic-wifi::before,.di-E226::before{content:\"\\e226\"}.di-location-pin::before,.di-E22B::before{content:\"\\e22b\"}.di-disney-express-luggage::before,.di-E22D::before{content:\"\\e22d\"}.di-picnic-area::before,.di-E230::before{content:\"\\e230\"}.di-nikon-picture-spot::before,.di-E236::before{content:\"\\e236\"}.di-atm-2::before,.di-E237::before{content:\"\\e237\"}.di-drinking-fountains::before,.di-E238::before{content:\"\\e238\"}.di-package-express::before,.di-E239::before{content:\"\\e239\"}.di-kingdom-club-bellman::before,.di-E23A::before{content:\"\\e23a\"}.di-in-park-info::before,.di-E23B::before{content:\"\\e23b\"}.di-magical-coin-press-machine::before,.di-E23C::before{content:\"\\e23c\"}.di-stroller-parking::before,.di-E23D::before{content:\"\\e23d\"}.di-electric-car-charging-station::before,.di-E23E::before{content:\"\\e23e\"}.di-parade-route-show-area::before,.di-E23F::before{content:\"\\e23f\"}.di-alert::before,.di-E240::before{content:\"\\e240\"}.di-checkmark::before,.di-E241::before{content:\"\\e241\"}.di-faqs::before,.di-E242::before{content:\"\\e242\"}.di-quick-answer::before,.di-E243::before{content:\"\\e243\"}.di-disney-parks-blog::before,.di-E244::before{content:\"\\e244\"}.di-sms::before,.di-E245::before{content:\"\\e245\"}.di-press-center::before,.di-E246::before{content:\"\\e246\"}.di-moms-panel::before,.di-E247::before{content:\"\\e247\"}.di-park-schedule::before,.di-E248::before{content:\"\\e248\"}.di-time::before,.di-E249::before{content:\"\\e249\"}.di-privacy-policies::before,.di-E24A::before{content:\"\\e24a\"}.di-terms-conditions::before,.di-E24B::before{content:\"\\e24b\"}.di-accessibility::before,.di-E24C::before{content:\"\\e24c\"}.di-pre-arrival-tips::before,.di-E24D::before{content:\"\\e24d\"}.di-reservations::before,.di-E24E::before{content:\"\\e24e\"}.di-registration::before,.di-E24F::before{content:\"\\e24f\"}.di-help-support::before,.di-E250::before{content:\"\\e250\"}.di-learn-more::before,.di-E251::before{content:\"\\e251\"}.di-email::before,.di-E252::before{content:\"\\e252\"}.di-chat::before,.di-E253::before{content:\"\\e253\"}.di-call::before,.di-E254::before{content:\"\\e254\"}.di-14-days-notice::before,.di-E255::before{content:\"\\e255\"}.di-6-months-notice::before,.di-E256::before{content:\"\\e256\"}.di-blackout-days::before,.di-E257::before{content:\"\\e257\"}.di-3-days-notice::before,.di-E258::before{content:\"\\e258\"}.di-website-support::before,.di-E259::before{content:\"\\e259\"}.di-restriction::before,.di-E25A::before{content:\"\\e25a\"}.di-recommendation::before,.di-E25B::before{content:\"\\e25b\"}.di-na-dash::before,.di-E25C::before{content:\"\\e25c\"}.di-magic-morning::before,.di-E25D::before{content:\"\\e25d\"}.di-global-languages::before,.di-E25E::before{content:\"\\e25e\"}.di-good-neighbor-hotel::before,.di-E25F::before{content:\"\\e25f\"}.di-travel-information::before,.di-E261::before{content:\"\\e261\"}.di-visiting-with-groups::before,.di-E262::before{content:\"\\e262\"}.di-visiting-with-children::before,.di-E263::before{content:\"\\e263\"}.di-disney-like-light::before,.di-E266::before{content:\"\\e266\"}.di-disney-like-dark::before,.di-E267::before{content:\"\\e267\"}.di-written-aids::before,.di-E268::before{content:\"\\e268\"}.di-generations-travel::before,.di-E269::before{content:\"\\e269\"}.di-empty-chat::before,.di-E26A::before{content:\"\\e26a\"}.di-filled-chat::before,.di-E26B::before{content:\"\\e26b\"}.di-empty-checkbox::before,.di-E26C::before{content:\"\\e26c\"}.di-selected-solid-checkbox::before,.di-E26D::before{content:\"\\e26d\"}.di-selected-disabled::before,.di-E26E::before{content:\"\\e26e\"}.di-indeterminate::before,.di-E26F::before{content:\"\\e26f\"}.di-10-days-notice::before,.di-E270::before{content:\"\\e270\"}.di-wdw-ap-blockout-cal::before,.di-E271::before{content:\"\\e271\"}.di-flexible-ticket::before,.di-E272::before{content:\"\\e272\"}.di-ride-height::before,.di-E275::before{content:\"\\e275\"}.di-adults::before,.di-E276::before{content:\"\\e276\"}.di-teens-tweens::before,.di-E277::before{content:\"\\e277\"}.di-kids::before,.di-E278::before{content:\"\\e278\"}.di-price-range::before,.di-E279::before{content:\"\\e279\"}.di-price-range-outlined::before,.di-E27A::before{content:\"\\e27a\"}.di-time-outlined::before,.di-E27B::before{content:\"\\e27b\"}.di-all-parks-available::before,.di-E27C::before{content:\"\\e27c\"}.di-some-parks-available::before,.di-E27D::before{content:\"\\e27d\"}.di-my-media::before,.di-E280::before{content:\"\\e280\"}.di-images::before,.di-E281::before{content:\"\\e281\"}.di-videos::before,.di-E282::before{content:\"\\e282\"}.di-photo-pass::before,.di-E283::before{content:\"\\e283\"}.di-photo-pass-plus::before,.di-E284::before{content:\"\\e284\"}.di-media-favorites::before,.di-E285::before{content:\"\\e285\"}.di-photo-fun::before,.di-E286::before{content:\"\\e286\"}.di-disney-vision::before,.di-E287::before{content:\"\\e287\"}.di-dvd-cd::before,.di-E288::before{content:\"\\e288\"}.di-shdr-photopass::before,.di-E289::before{content:\"\\e289\"}.di-order-dvd::before,.di-E28B::before{content:\"\\e28b\"}.di-presented-in-3d::before,.di-E28C::before{content:\"\\e28c\"}.di-guest-photos::before,.di-E28D::before{content:\"\\e28d\"}.di-on-demand::before,.di-E28E::before{content:\"\\e28e\"}.di-live-stream::before,.di-E28F::before{content:\"\\e28f\"}.di-photopass-lenses::before,.di-E290::before{content:\"\\e290\"}.di-monorail::before,.di-E2C0::before{content:\"\\e2c0\"}.di-bus::before,.di-E2C1::before{content:\"\\e2c1\"}.di-car::before,.di-E2C2::before{content:\"\\e2c2\"}.di-boat::before,.di-E2C3::before{content:\"\\e2c3\"}.di-taxi::before,.di-E2C4::before{content:\"\\e2c4\"}.di-flight::before,.di-E2C5::before{content:\"\\e2c5\"}.di-return-flight::before,.di-E2C6::before{content:\"\\e2c6\"}.di-walking::before,.di-E2C7::before{content:\"\\e2c7\"}.di-free-shuttle::before,.di-E2C8::before{content:\"\\e2c8\"}.di-hkdl-mtr-disney-resort-line::before,.di-E2CE::before{content:\"\\e2ce\"}.di-bus-schedule::before,.di-E2CF::before{content:\"\\e2cf\"}.di-minnie-vans-ride-share::before,.di-E2D0::before{content:\"\\e2d0\"}.di-transportation-multiple::before,.di-E2D1::before{content:\"\\e2d1\"}.di-wdw-skylinero::before,.di-E2D2::before{content:\"\\e2d2\"}.di-close-button::before,.di-E300::before{content:\"\\e300\"}.di-add-button::before,.di-E301::before{content:\"\\e301\"}.di-information::before,.di-E302::before{content:\"\\e302\"}.di-share::before,.di-E303::before{content:\"\\e303\"}.di-download::before,.di-E304::before{content:\"\\e304\"}.di-show-filters::before,.di-E305::before{content:\"\\e305\"}.di-hide-filters::before,.di-E306::before{content:\"\\e306\"}.di-3d-spin::before,.di-E307::before{content:\"\\e307\"}.di-media-play-button::before,.di-E308::before{content:\"\\e308\"}.di-media-pause-button::before,.di-E309::before{content:\"\\e309\"}.di-pdf::before,.di-E30A::before{content:\"\\e30a\"}.di-duplicate-offer::before,.di-E30B::before{content:\"\\e30b\"}.di-next::before,.di-E30C::before{content:\"\\e30c\"}.di-previous::before,.di-E30D::before{content:\"\\e30d\"}.di-print::before,.di-E30F::before{content:\"\\e30f\"}.di-search::before,.di-E310::before{content:\"\\e310\"}.di-calendar-month::before,.di-E311::before{content:\"\\e311\"}.di-calendar-day-view::before,.di-E312::before{content:\"\\e312\"}.di-more::before,.di-E313::before{content:\"\\e313\"}.di-menu-global-nav::before,.di-E314::before{content:\"\\e314\"}.di-menus-button::before,.di-E315::before{content:\"\\e315\"}.di-norgie-opened::before,.di-E316::before{content:\"\\e316\"}.di-upload::before,.di-E317::before{content:\"\\e317\"}.di-lists::before,.di-E318::before{content:\"\\e318\"}.di-filter::before,.di-E319::before{content:\"\\e319\"}.di-scan-barcode::before,.di-E31A::before{content:\"\\e31a\"}.di-keyboard-entry::before,.di-E31B::before{content:\"\\e31b\"}.di-download-mobile-app::before,.di-E31C::before{content:\"\\e31c\"}.di-view-gallery::before,.di-E31D::before{content:\"\\e31d\"}.di-see-info-page-button::before,.di-E31E::before{content:\"\\e31e\"}.di-media-gallery-photo-button::before,.di-E31F::before{content:\"\\e31f\"}.di-media-gallery-video-button::before,.di-E320::before{content:\"\\e320\"}.di-refresh::before,.di-E321::before{content:\"\\e321\"}.di-compose-message::before,.di-E322::before{content:\"\\e322\"}.di-add-contact::before,.di-E323::before{content:\"\\e323\"}.di-contact-list::before,.di-E324::before{content:\"\\e324\"}.di-norgie-up::before,.di-E325::before{content:\"\\e325\"}.di-norgie-left::before,.di-E326::before{content:\"\\e326\"}.di-mobile-app::before,.di-E327::before{content:\"\\e327\"}.di-home::before,.di-E328::before{content:\"\\e328\"}.di-return-arrow::before,.di-E329::before{content:\"\\e329\"}.di-share-2::before,.di-E32A::before{content:\"\\e32a\"}.di-delete-button::before,.di-E32B::before{content:\"\\e32b\"}.di-fast-forward-button::before,.di-E32C::before{content:\"\\e32c\"}.di-rewind-button::before,.di-E32D::before{content:\"\\e32d\"}.di-pulldown::before,.di-E32E::before{content:\"\\e32e\"}.di-increase-button::before,.di-E32F::before{content:\"\\e32f\"}.di-decrease-button::before,.di-E330::before{content:\"\\e330\"}.di-flip-turn-over::before,.di-E331::before{content:\"\\e331\"}.di-previous-2::before,.di-E332::before{content:\"\\e332\"}.di-next-2::before,.di-E333::before{content:\"\\e333\"}.di-arrow-back::before,.di-E334::before{content:\"\\e334\"}.di-arrow-up::before,.di-E335::before{content:\"\\e335\"}.di-arrow-down::before,.di-E336::before{content:\"\\e336\"}.di-expand-gallery::before,.di-E337::before{content:\"\\e337\"}.di-360-video::before,.di-E338::before{content:\"\\e338\"}.di-volume-control::before,.di-E339::before{content:\"\\e339\"}.di-app-card-info::before,.di-E33A::before{content:\"\\e33a\"}.di-app-card-flip::before,.di-E33B::before{content:\"\\e33b\"}.di-close-reversed::before,.di-E33E::before{content:\"\\e33e\"}.di-expand-show-more::before,.di-E33F::before{content:\"\\e33f\"}.di-wheelchair-accessibility::before,.di-E340::before{content:\"\\e340\"}.di-transfer-from-wheelchair::before,.di-E341::before{content:\"\\e341\"}.di-transfer-to-wheelchair::before,.di-E342::before{content:\"\\e342\"}.di-transfer-to-wheelchair-then-ride::before,.di-E343::before{content:\"\\e343\"}.di-ambulatory::before,.di-E344::before{content:\"\\e344\"}.di-visual-impairment::before,.di-E345::before{content:\"\\e345\"}.di-hearing-impairment::before,.di-E346::before{content:\"\\e346\"}.di-sign-language::before,.di-E347::before{content:\"\\e347\"}.di-audio-description::before,.di-E348::before{content:\"\\e348\"}.di-handheld-captioning::before,.di-E349::before{content:\"\\e349\"}.di-reflective-captioning::before,.di-E34A::before{content:\"\\e34a\"}.di-closed-captioning::before,.di-E34B::before{content:\"\\e34b\"}.di-physicial-consideration-red-yellow::before,.di-E34C::before{content:\"\\e34c\"}.di-scary-consideration-yellow::before,.di-E34D::before{content:\"\\e34d\"}.di-dlp-mobility-disabilities::before,.di-E34E::before{content:\"\\e34e\"}.di-dlp-hearing-disabilities::before,.di-E34F::before{content:\"\\e34f\"}.di-dlp-visual-disabilities::before,.di-E350::before{content:\"\\e350\"}.di-photosensitive-epilepsy::before,.di-E351::before{content:\"\\e351\"}.di-dlp-mental-cognitive-disabilities::before,.di-E352::before{content:\"\\e352\"}.di-suitable-for-amputees::before,.di-E353::before{content:\"\\e353\"}.di-suitable-for-difficulty-standing::before,.di-E354::before{content:\"\\e354\"}.di-capable-of-climbing-steps::before,.di-E355::before{content:\"\\e355\"}.di-disabilities-services::before,.di-E356::before{content:\"\\e356\"}.di-disabilities-guide-book::before,.di-E357::before{content:\"\\e357\"}.di-wheelchair-rental::before,.di-E358::before{content:\"\\e358\"}.di-disabilities-designated-viewing::before,.di-E359::before{content:\"\\e359\"}.di-may-remain-in-wheelchair::before,.di-E35A::before{content:\"\\e35a\"}.di-must-be-ambulatory-2::before,.di-E35B::before{content:\"\\e35b\"}.di-suitable-for-blind::before,.di-E35C::before{content:\"\\e35c\"}.di-suitable-for-autism::before,.di-E35D::before{content:\"\\e35d\"}.di-sign-language-2::before,.di-E35E::before{content:\"\\e35e\"}.di-tactile-maps::before,.di-E35F::before{content:\"\\e35f\"}.di-braille-guide-books::before,.di-E360::before{content:\"\\e360\"}.di-suitable-for-learning-disabilities::before,.di-E361::before{content:\"\\e361\"}.di-induction-loop::before,.di-E362::before{content:\"\\e362\"}.di-dimly-lit-space::before,.di-E363::before{content:\"\\e363\"}.di-light-rain-indoors::before,.di-E364::before{content:\"\\e364\"}.di-show-contains-bubble::before,.di-E365::before{content:\"\\e365\"}.di-hdd-illness::before,.di-E366::before{content:\"\\e366\"}.di-open-captioning::before,.di-E367::before{content:\"\\e367\"}.di-magnetic-fields::before,.di-E368::before{content:\"\\e368\"}.di-open-captioning-square::before,.di-E369::before{content:\"\\e369\"}.di-gifts::before,.di-E380::before{content:\"\\e380\"}.di-character-calls::before,.di-E381::before{content:\"\\e381\"}.di-performing-arts::before,.di-E382::before{content:\"\\e382\"}.di-education::before,.di-E383::before{content:\"\\e383\"}.di-lock::before,.di-E384::before{content:\"\\e384\"}.di-facebook::before,.di-E385::before{content:\"\\e385\"}.di-twitter::before,.di-E386::before{content:\"\\e386\"}.di-youtube::before,.di-E387::before{content:\"\\e387\"}.di-instagram::before,.di-E388::before{content:\"\\e388\"}.di-pinterest::before,.di-E389::before{content:\"\\e389\"}.di-google-plus::before,.di-E38A::before{content:\"\\e38a\"}.di-disney-cast::before,.di-E38B::before{content:\"\\e38b\"}.di-disney-response::before,.di-E38C::before{content:\"\\e38c\"}.di-thrill-seekers::before,.di-E38E::before{content:\"\\e38e\"}.di-doll::before,.di-E390::before{content:\"\\e390\"}.di-front-desk::before,.di-E391::before{content:\"\\e391\"}.di-movies::before,.di-E392::before{content:\"\\e392\"}.di-unlocked::before,.di-E393::before{content:\"\\e393\"}.di-tumblr::before,.di-E394::before{content:\"\\e394\"}.di-services::before,.di-E395::before{content:\"\\e395\"}.di-old-photopass-plus::before,.di-E396::before{content:\"\\e396\"}.di-hkdl-sina-weibo-social::before,.di-E397::before{content:\"\\e397\"}.di-hkdl-baidu-tieba-social::before,.di-E398::before{content:\"\\e398\"}.di-hkdl-webchat-social::before,.di-E399::before{content:\"\\e399\"}.di-disney-wild-about-safety::before,.di-E39A::before{content:\"\\e39a\"}.di-romantic-celebration::before,.di-E39B::before{content:\"\\e39b\"}.di-facebook-icon-alone::before,.di-E39C::before{content:\"\\e39c\"}.di-twitter-icon-alone::before,.di-E39D::before{content:\"\\e39d\"}.di-snapchat::before,.di-E39E::before{content:\"\\e39e\"}.di-photopass-attraction-id::before,.di-E39F::before{content:\"\\e39f\"}.di-achievement::before,.di-E3A0::before{content:\"\\e3a0\"}.di-apple-music::before,.di-E3A1::before{content:\"\\e3a1\"}.di-apple-music-alternate::before,.di-E3A2::before{content:\"\\e3a2\"}.di-watches-time::before,.di-E3A3::before{content:\"\\e3a3\"}.di-magic-coming-soon::before,.di-E3A4::before{content:\"\\e3a4\"}.di-winter::before,.di-E3E4::before{content:\"\\e3e4\"}.di-spring::before,.di-E3E5::before{content:\"\\e3e5\"}.di-summer::before,.di-E3E6::before{content:\"\\e3e6\"}.di-autumn::before,.di-E3E7::before{content:\"\\e3e7\"}.di-pack-for-weather::before,.di-E3E8::before{content:\"\\e3e8\"}.di-single-rider::before,.di-E440::before{content:\"\\e440\"}.di-atm-china::before,.di-E441::before{content:\"\\e441\"}.di-wayfinding-slight-left::before,.di-E442::before{content:\"\\e442\"}.di-wayfinding-slight-right::before,.di-E443::before{content:\"\\e443\"}.di-wayfinding-turn-left::before,.di-E444::before{content:\"\\e444\"}.di-wayfinding-turn-right::before,.di-E445::before{content:\"\\e445\"}.di-wayfinding-hard-left::before,.di-E446::before{content:\"\\e446\"}.di-wayfinding-hard-right::before,.di-E447::before{content:\"\\e447\"}.di-wayfinding-left::before,.di-E448::before{content:\"\\e448\"}.di-wayfinding-right::before,.di-E449::before{content:\"\\e449\"}.di-wayfinding-forward::before,.di-E44A::before{content:\"\\e44a\"}.di-wayfinding-back::before,.di-E44B::before{content:\"\\e44b\"}.di-wayfinding-forward-back::before,.di-E44C::before{content:\"\\e44c\"}.di-wayfinding-right-left::before,.di-E44D::before{content:\"\\e44d\"}.di-wayfinding-around-slight-left::before,.di-E44E::before{content:\"\\e44e\"}.di-wayfinding-around-slight-right::before,.di-E44F::before{content:\"\\e44f\"}.di-wayfinding-around-turn-left::before,.di-E450::before{content:\"\\e450\"}.di-wayfinding-around-turn-right::before,.di-E451::before{content:\"\\e451\"}.di-wayfinding-around-hard-left::before,.di-E452::before{content:\"\\e452\"}.di-wayfinding-around-hard-right::before,.di-E453::before{content:\"\\e453\"}.di-wayfinding-around-left::before,.di-E454::before{content:\"\\e454\"}.di-wayfinding-around-right::before,.di-E455::before{content:\"\\e455\"}.di-wayfinding-around-forward-left::before,.di-E456::before{content:\"\\e456\"}.di-wayfinding-around-forward-right::before,.di-E457::before{content:\"\\e457\"}.di-wayfinding-u-turn-right::before,.di-E458::before{content:\"\\e458\"}.di-wayfinding-u-turn-left::before,.di-E459::before{content:\"\\e459\"}.di-wayfinding-ramp-left::before,.di-E45A::before{content:\"\\e45a\"}.di-wayfinding-ramp-right::before,.di-E45B::before{content:\"\\e45b\"}.di-wayfinding-fork-left::before,.di-E45C::before{content:\"\\e45c\"}.di-wayfinding-fork-right::before,.di-E45D::before{content:\"\\e45d\"}.di-wayfinding-around-about-left::before,.di-E45E::before{content:\"\\e45e\"}.di-wayfinding-around-about-right::before,.di-E45F::before{content:\"\\e45f\"}.di-wayfinding-merge::before,.di-E460::before{content:\"\\e460\"}.di-cribs-and-playpens::before,.di-E461::before{content:\"\\e461\"}.di-baby-care-center2::before,.di-E462::before{content:\"\\e462\"}.di-epi-pen::before,.di-E463::before{content:\"\\e463\"}.di-mobile-charging-station::before,.di-E464::before{content:\"\\e464\"}.di-security-info::before,.di-E465::before{content:\"\\e465\"}.di-refrigerator-available::before,.di-E466::before{content:\"\\e466\"}.di-repellant-zika::before,.di-E467::before{content:\"\\e467\"}.di-hurricane-information::before,.di-E468::before{content:\"\\e468\"}.di-recenter-map::before,.di-E46A::before{content:\"\\e46a\"}.di-location-pin::before,.di-E46C::before{content:\"\\e46c\"}.di-transportation-parking-info::before,.di-E46D::before{content:\"\\e46d\"}.di-resort-automatic-check-out::before,.di-E46E::before{content:\"\\e46e\"}.di-service-your-way::before,.di-E46F::before{content:\"\\e46f\"}.di-direct-to-room::before,.di-E470::before{content:\"\\e470\"}.di-premium-service-shdr::before,.di-E471::before{content:\"\\e471\"}.di-virtual-queue::before,.di-E472::before{content:\"\\e472\"}.di-energy-monster::before,.di-E473::before{content:\"\\e473\"}.di-elevators::before,.di-E475::before{content:\"\\e475\"}.di-salon::before,.di-E476::before{content:\"\\e476\"}.di-clothing::before,.di-E480::before{content:\"\\e480\"}.di-accessories::before,.di-E481::before{content:\"\\e481\"}.di-home-office::before,.di-E482::before{content:\"\\e482\"}.di-toys-games::before,.di-E483::before{content:\"\\e483\"}.di-art-collectibles::before,.di-E484::before{content:\"\\e484\"}.di-entertainment::before,.di-E485::before{content:\"\\e485\"}.di-health-beauty::before,.di-E486::before{content:\"\\e486\"}.di-sweets::before,.di-E487::before{content:\"\\e487\"}.di-play-logo::before,.di-E4C0::before{content:\"\\e4c0\"}.di-rocket-race-game::before,.di-E4C1::before{content:\"\\e4c1\"}.di-peter-pan-s-flight-game::before,.di-E4C2::before{content:\"\\e4c2\"}.di-toy-story-mania-game::before,.di-E4C3::before{content:\"\\e4c3\"}.di-trivia-games::before,.di-E4C4::before{content:\"\\e4c4\"}.di-esmeralda-quest::before,.di-E4C5::before{content:\"\\e4c5\"}.di-fortune-red-quest::before,.di-E4C6::before{content:\"\\e4c6\"}.di-temple-of-mara-decoder::before,.di-E4C7::before{content:\"\\e4c7\"}.di-conservation-fund-quest::before,.di-E4C8::before{content:\"\\e4c8\"}.di-soarin-challenge::before,.di-E4C9::before{content:\"\\e4c9\"}.di-agent-p-challenge::before,.di-E4CA::before{content:\"\\e4ca\"}.di-fun-wheel-challenge::before,.di-E4CB::before{content:\"\\e4cb\"}.di-andy-s-game-board-blast::before,.di-E4CC::before{content:\"\\e4cc\"}.di-art-of-animation::before,.di-E4CD::before{content:\"\\e4cd\"}.di-flight-of-passage::before,.di-E4CE::before{content:\"\\e4ce\"}.di-dlr-magic-mural::before,.di-E4CF::before{content:\"\\e4cf\"}.di-splash-mountain::before,.di-E4D0::before{content:\"\\e4d0\"}.di-kidcot-challenge::before,.di-E4D1::before{content:\"\\e4d1\"}.di-swge-millenium-falcon::before,.di-E4D2::before{content:\"\\e4d2\"}.di-swge-star-destroyer::before,.di-E4D3::before{content:\"\\e4d3\"}.di-swge-bso-logo::before,.di-E4D4::before{content:\"\\e4d4\"}.di-add-stepper::before,.di-E500::before{content:\"\\e500\"}.di-reduce-stepper::before,.di-E501::before{content:\"\\e501\"}.di-hide-collapse::before,.di-E502::before{content:\"\\e502\"}.di-mute-volume::before,.di-E503::before{content:\"\\e503\"}.di-unmute-volume::before,.di-E504::before{content:\"\\e504\"}.di-filter-items::before,.di-E505::before{content:\"\\e505\"}.di-forward-thin::before,.di-E506::before{content:\"\\e506\"}.di-back-thin::before,.di-E507::before{content:\"\\e507\"}.di-fast-fwd-thin::before,.di-E508::before{content:\"\\e508\"}.di-rewind-thin::before,.di-E509::before{content:\"\\e509\"}.di-download-thin::before,.di-E50A::before{content:\"\\e50a\"}.di-facial-opt-in-off::before,.di-E50B::before{content:\"\\e50b\"}.di-facial-opt-in-on::before,.di-E50C::before{content:\"\\e50c\"}.di-bluetooth::before,.di-E518::before{content:\"\\e518\"}.di-norgie-closed::before,.di-E534::before{content:\"\\e534\"}.di-fastpass-order-shopping-bag-plus::before,.di-E540::before{content:\"\\e540\"}.di-fastpass-order-shopping-bag::before,.di-E542::before{content:\"\\e542\"}.di-shdr-ticket-annualpass::before,.di-E544::before{content:\"\\e544\"}.di-tickets-outlined::before,.di-E54B::before{content:\"\\e54b\"}.di-early-entry-pass::before,.di-E54C::before{content:\"\\e54c\"}.di-disney-card-member::before,.di-E54D::before{content:\"\\e54d\"}.di-club-33-dlr-member::before,.di-E54E::before{content:\"\\e54e\"}.di-shdr-ap-activation::before,.di-E54F::before{content:\"\\e54f\"}.di-disney-maxpass-alternate::before,.di-E550::before{content:\"\\e550\"}.di-ap-activation::before,.di-E552::before{content:\"\\e552\"}.di-standby-pass::before,.di-E553::before{content:\"\\e553\"}.di-early-park-entry-pass::before,.di-E554::before{content:\"\\e554\"}.di-mobile-checkout::before,.di-E555::before{content:\"\\e555\"}.di-disney-premier-access-global::before,.di-E556::before{content:\"\\e556\"}.di-disney-premier-access-secondary::before,.di-E557::before{content:\"\\e557\"}.di-disney-premier-access-new::before,.di-E558::before{content:\"\\e558\"}.di-golden-oak-resident::before,.di-E559::before{content:\"\\e559\"}.di-disability-access-service::before,.di-E55A::before{content:\"\\e55a\"}.di-lightning-lane::before,.di-E55B::before{content:\"\\e55b\"}.di-disney-plus::before,.di-E55C::before{content:\"\\e55c\"}.di-enchant-key::before,.di-E55D::before{content:\"\\e55d\"}.di-dream-key::before,.di-E55E::before{content:\"\\e55e\"}.di-imagine-key::before,.di-E55F::before{content:\"\\e55f\"}.di-believe-key::before,.di-E560::before{content:\"\\e560\"}.di-unused-character::before,.di-F8FE::before{content:\"\\f8fe\"}:host{--primary:var(--primary-theme);--primary-dark:var(--primary-dark-theme);--primary-background:var(--primary-background-theme);--primary-other:var(--primary-other-theme);--primary-disabled:var(--primary-disabled-theme);--primary-message:var(--primary-message-theme);--primary-alert:var(--primary-alert-theme);--primary-gradient-from:var(--primary-gradient-from-theme);--primary-gradient-to:var(--primary-gradient-to-theme);--secondary-focus:var(--secondary-focus-theme);--secondary-hover:var(--secondary-hover-theme);--secondary-disabled:var(--secondary-disabled-theme);--secondary-background:var(--secondary-background-theme);--secondary-other-dark:var(--secondary-other-dark-theme);--secondary-other-hover:var(--secondary-other-hover-theme);--secondary-other-disabled:var(--secondary-other-disabled-theme);--secondary-other-good-to-go:var(--secondary-other-good-to-go-theme);--secondary-message:var(--secondary-message-theme);--secondary-message-detail:var(--secondary-message-detail-theme);--secondary-message-chrome:var(--secondary-message-chrome-theme);--secondary-gradient-from:var(--secondary-gradient-from-theme);--secondary-gradient-to:var(--secondary-gradient-to-theme);--secondary-inactive:var(--secondary-inactive-theme);--reversed-hover:var(--reversed-hover-theme);--link:var(--link-theme);--outline-color:var(--outline-color-theme);--outline-style:var(--outline-style-theme);--outline-width:var(--outline-width-theme)}.primary{color:var(--primary)}.primary:hover{color:var(--secondary-hover)}.primary[disabled]{color:var(--secondary-disabled);cursor:not-allowed;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.primary-dark{color:var(--primary-dark)}.primary-other{color:var(--primary-other)}.primary-message{color:var(--primary-message)}.primary-alert{color:var(--primary-alert)}.background-primary-background{background-color:var(--primary-background)}.background-primary{background-color:var(--primary)}.background-primary-dark{background-color:var(--primary-dark)}.background-primary-other{background-color:var(--primary-other)}.background-primary-message{background-color:var(--primary-message)}.background-primary-alert{background-color:var(--primary-alert)}.background-primary-gradient{background:linear-gradient(45deg, var(--primary-gradient-from), var(--primary-gradient-to))}.secondary-other-dark{color:var(--secondary-other-dark)}.secondary-other-dark:hover{color:var(--secondary-other-hover)}.secondary-other-dark[disabled]{color:var(--secondary-other-disabled);cursor:not-allowed;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.secondary-other-good-to-go{color:var(--secondary-other-good-to-go)}.secondary-message{color:var(--secondary-message)}.secondary-message-detail{color:var(--secondary-message-detail)}.secondary-message-chrome{color:var(--secondary-message-chrome)}.background-secondary{background-color:var(--secondary-background)}.background-secondary-focus{background-color:var(--secondary-focus)}.background-secondary-hover{background-color:var(--secondary-hover)}.background-secondary-disabled{background-color:var(--secondary-disabled)}.background-secondary-other-hover{background-color:var(--secondary-other-hover)}.background-secondary-other-disabled{background-color:var(--secondary-other-disabled)}.background-secondary-other-dark{background-color:var(--secondary-other-dark)}.background-secondary-other-good-to-go{background-color:var(--secondary-other-good-to-go)}.background-secondary-message{background-color:var(--secondary-message)}.background-secondary-inactive{background-color:var(--secondary-inactive)}.background-secondary-message-detail{background-color:var(--secondary-message-detail)}.background-secondary-message-chrome{background-color:var(--secondary-message-chrome)}.background-secondary-gradient{background:linear-gradient(45deg, var(--secondary-gradient-from), var(--secondary-gradient-to))}a,.link{color:var(--link);text-decoration:none}a:link,a:visited,a:hover,a:active,.link:link,.link:visited,.link:hover,.link:active{color:var(--link)}a:hover,a:focus,.link:hover,.link:focus{text-decoration:underline}.link{color:var(--link);cursor:pointer}a:focus,.link:focus,button:focus{outline-color:var(--outline-color);outline-style:var(--outline-style);outline-width:var(--outline-width)}wdpr-checkbox{--checkbox-checked-border-color:#1c468e;--checkbox-checked-background-color:#1c468e;--checkbox-unchecked-hover-border-color:#0079bc;--checkbox-checked-hover-border-color:#0079bc;--checkbox-checked-hover-background-color:#0079bc}wdpr-counter{--counter-icon-color:#1c468e;--primary-theme:#1c468e;--secondary-hover:#0079bc;--counter-icon-hover-color:#0079bc}#mobileToggle{--primary-theme:#1c468e}#titleContainer{color:#1c468e}wdpr-checkbox{--checkbox-checked-border-color:#1c468e;--checkbox-checked-background-color:#1c468e;--checkbox-unchecked-hover-border-color:#0079bc;--checkbox-checked-hover-border-color:#0079bc;--checkbox-checked-hover-background-color:#0079bc}.panel-body{--fast-light-blue:#82b0cf;--fast-medium-blue:#0079BC;--fast-dark-blue:#1C468E}.panel.showfast .panel-body{top:16px;position:relative}.panel.showfast .panel-body .qq-rounded-spacer{position:absolute;width:100%;margin-top:-16px;height:16px;border-radius:16px 16px 0px 0px;background-color:#FFF;z-index:100}.panel.showfast .panel-body #purchaseTicketsButton{display:none}.panel.showfast .panel-body h1{display:block;color:var(--fast-dark-blue);font-size:24px;font-style:normal;font-weight:600;line-height:36px;margin:0 31px 24px;text-align:center}.panel.showfast .panel-body wdpr-button .dpo-icon{font-family:\"pepmdx\"}.panel.showfast .panel-body wdpr-button .fast-button{color:var(--fast-medium-blue);margin-left:6px}.panel.showfast .panel-body wdpr-button span.collapsed,.panel.showfast .panel-body wdpr-button span.expanded{right:20px;position:absolute;color:var(--fast-medium-blue)}.panel.showfast .panel-body wdpr-range-datepicker #input-container button i{color:var(--fast-medium-blue)}@media only screen and (min-width: 768px){.panel.showfast .panel-body{border-radius:0px 0px 16px 16px;top:28px}.panel.showfast .panel-body .qq-rounded-spacer{margin-top:-36px;height:28px;left:0px;border-radius:24px 24px 0px 0px}.panel.showfast .panel-body hr,.panel.showfast .panel-body h1{display:none}}@media only screen and (min-width: 1024px){.panel.showfast .panel-body{top:0px}.panel.showfast .panel-body .qq-rounded-spacer{display:none}}.panel{border:none;padding:0 20px}.panel-body{padding:8px 10px;background-color:var(--wdpr-lodging-quickquote-background-color, #fff)}.panel-footer{padding:10px 15px;background-color:var(--warm-gray-100);border-top:1px solid var(--warm-gray-300);border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel-footer hr{border:0;border-top:1px solid var(--warm-gray-300)}.title{color:var(--primary)}wdpr-range-datepicker{--range-datepicker-label-color:#607682}wdpr-single-select{--wdpr-single-select-custom-options-list-width:150%;--wdpr-single-select-custom-option-item-height:auto;--wdpr-single-select-custom-option-item-padding:9px 8px;--wdpr-single-select-label-color:#607682}wdpr-single-select::part(option-item-subhead){margin-top:18px}wdpr-single-select::part(option-item-subitem){padding-left:16px}wdpr-single-select::part(option-value-inner){white-space:normal}.errorWrapper{color:var(--primary-alert);display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding:8px 0px 0px}.partyMixError a{text-decoration:underline}wdpr-button{--button-standard-font-size:--font16;--button-primary-margin:none;--button-primary-background-color:#008900;--button-primary-border-color:#008900;--button-primary-hover-color:#006C00;--button-primary-hover-border-color:#006C00;--button-primary-active-color:#005026;--button-primary-active-border-color:#005026;--button-primary-disabled-color:#A8EF9F;--button-primary-disabled-border-color:#A8EF9F}wdpr-checkbox{margin:auto 0}.mobile-view{display:none}#collapseToggle{display:-ms-flexbox;display:flex;gap:5px;font-size:0.9em;line-height:1em;cursor:pointer}#collapseToggle span.expanded{-webkit-transform:rotate(90deg);transform:rotate(90deg);display:block}#collapseToggle.collapsed~.hide-on-collapse{display:none}#collapseToggle.expanded~.hide-on-collapse{display:block}#collapseToggle:hover{color:var(--button-primary-hover-color)}.fields-container{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:start;align-content:flex-start;row-gap:10px;max-width:1340px;-webkit-transition:height 0.5s ease;transition:height 0.5s ease;padding:8px 0px}.fields-container:not(.flightHoliday){-ms-flex-pack:justify;justify-content:space-between}.field{-ms-flex-order:0;order:0;padding:0 10px}#titleContainer{-ms-flex:0 auto;flex:0 auto;padding:0 10px;font-size:16px;font-weight:700;text-align:left;margin:auto 0}#findPricesButton{width:12%;height:44px;text-wrap:wrap}#rangeDatePicker{padding-top:15px}.flightHoliday #findPricesButton{-ms-flex-order:1;order:1}.flightHoliday #collapseToggle,.flightHoliday .hide-on-collapse{-ms-flex-order:2;order:2}.flightHoliday #partyMixSelect{min-width:240px}.hide{display:none}.shadow-form{padding-bottom:10px;display:-ms-flexbox;display:flex;gap:10px;-ms-flex-wrap:wrap;flex-wrap:wrap}.shadow-form .shadow-form-field{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}@media only screen and (min-width: 1401px){#titleContainer,#accessibilityCheckbox{max-width:14%}.fields-container:not(.flightHoliday) #resortSelect,.fields-container:not(.flightHoliday) #shopForSelect{max-width:16%}}@media only screen and (max-width: 767.98px){:host{display:block}#purchaseTicketsAnchor{display:block;padding:0px 15px 0 15px;font-size:16px}#purchaseTicketsAnchor #purchaseTicketsButton{width:100%;padding:20px 0;border-radius:22px}#purchaseTicketsAnchor.hide{display:none}#partyMixSelect{margin-bottom:0px}.panel-body{padding:0px;margin:0 auto;max-width:418px}#mobileToggle{min-height:64px;font-size:16px;font-weight:500;font-family:inherit;line-height:24px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:left;justify-content:left;padding:20px 8px;cursor:pointer;color:var(--primary-theme);background-color:transparent;border:none;width:100%}#mobileToggle span{-webkit-transition:0.2s;transition:0.2s}#mobileToggle.collapsed span.collapsed{-webkit-transform:rotate(-90deg);transform:rotate(-90deg);display:block}#mobileToggle.collapsed~.fields-container{max-height:0;-webkit-transition:max-height 0.5s ease-out;transition:max-height 0.5s ease-out;padding:0 15px;display:none}:host(:not(.has-flights)) #mobileToggle.ticketOnly{display:none}:host(:not(.has-flights)) #mobileToggle.ticketOnly.collapsed~.fields-container.ticketOnly{max-height:1000px;display:block}#mobileToggle.fast-not-collapsible{display:none}#mobileToggle.fast-not-collapsible.collapsed~.fields-container{max-height:1000px;display:block}.fields-container{display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;padding:8px 15px;width:auto;overflow:visible;height:auto;max-height:1000px;-webkit-transition:max-height 0.5s ease-in;transition:max-height 0.5s ease-in}.fields-container.flightHoliday.toggle-expanded{height:auto}.fields-container.has-children{height:auto}.fields-container.has-children.flightHoliday.toggle-expanded,.fields-container.has-children.flightHoliday.toggle-collapsed{height:auto}.field{-ms-flex:0 auto;flex:0 auto;margin-bottom:30px;padding:0}wdpr-party-mix-select,wdpr-range-datepicker{margin:0px;width:100%}wdpr-single-select{--wdpr-single-select-max-width:none;--wdpr-single-select-custom-options-list-width:100%;--outline-style-theme:none}wdpr-button{--button-standard-size-max-width:none}#collapseToggle.collapsed~.hide-on-collapse{display:block}#collapseToggle{display:none}#titleContainer{display:none}#accessibilityCheckbox{-ms-flex-item-align:start;align-self:start}#findPricesButton{width:100%}#rangeDatePicker{padding-top:0px}.flightHoliday #collapseToggle,.flightHoliday .hide-on-collapse{-ms-flex-order:0;order:0}.flightHoliday #travelClassSelect,.flightHoliday #accessibilityCheckbox,.flightHoliday #findPricesButton{-ms-flex-order:1;order:1}}@media only screen and (min-width: 1024px) and (max-width: 1400px){#titleContainer{-ms-flex:0 100%;flex:0 100%}#accessibilityCheckbox{max-width:14%}#resortSelect,#shopForSelect{max-width:16%}#findPricesButton{width:auto}.flightHoliday .field:not(.hide-on-collapse,#tripDatesPicker,#rangeDatePicker,#collapseToggle),.flightHoliday #travelClassSelect{max-width:16%}.flightHoliday #collapseToggle{max-width:5%}.flightHoliday #findPricesButton{width:auto}}@media only screen and (min-width: 768px) and (max-width: 1023px){:host{display:block}.fields-container{display:-ms-flexbox;display:flex;-ms-flex-flow:column wrap;flex-flow:column wrap;-ms-flex-line-pack:justify;align-content:space-between;-ms-flex-align:start;align-items:flex-start;height:auto;max-height:350px;width:auto;overflow:visible}.fields-container.flightHoliday{max-height:425px}.fields-container.hotelVilla,.fields-container.hotelOnly,.fields-container.show-title,.fields-container.ticketOnly{max-height:350px}.fields-container.has-children{height:auto}.fields-container.has-children.flightHoliday.toggle-expanded,.fields-container.has-children.flightHoliday.toggle-collapsed{height:auto}.fields-container.has-children.hotelVilla,.fields-container.has-children.hotelOnly{max-height:450px}.fields-container.has-children.show-title{max-height:525px}.fields-container.has-children.ticketOnly{max-height:600px}.fields-container.show-title #partyMixSelect{margin-top:50px}.field{-ms-flex:0 auto;flex:0 auto;width:50%;max-width:260px;margin-bottom:30px;padding:0 15px}wdpr-party-mix-select,wdpr-date-picker{margin:0px}wdpr-range-datepicker{padding-left:15px}#collapseToggle.collapsed~.hide-on-collapse{display:block}#collapseToggle{display:none}#titleContainer{-ms-flex:0 auto;flex:0 auto}#findPricesButton{width:150px;-ms-flex-item-align:start;align-self:start;margin-left:15px}#rangeDatePicker{margin-top:16px;margin-bottom:38px;padding-top:0px}.tablet-col-1{-ms-flex-order:0 !important;order:0 !important}.tablet-col-2{-ms-flex-order:2 !important;order:2 !important}}@media only screen and (max-width: 768px){.errorWrapper{padding:8px 0px}}";

var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const WdprLodgingQuickQuote = /*@__PURE__*/ proxyCustomElement(class WdprLodgingQuickQuote extends HTMLElement {
    _handleConfigChange() {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        this.setParamNames();
        this.partyMixChildCount = parseInt((_b = (_a = this.config.elements.numberOfChildren) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.value) || 0;
        this.dateRangeOptions = this.getDefaultDateRangeOptions();
        // Initialize values in RoomFormData
        this.updateRoomFormDataHandler({ [this.paramNames.numberOfAdults]: parseInt((_d = (_c = this.config.elements.numberOfAdults) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.value) || 0 });
        this.updateRoomFormDataHandler({ [this.paramNames.numberOfChildren]: parseInt((_g = (_f = this.config.elements.numberOfChildren) === null || _f === void 0 ? void 0 : _f.options) === null || _g === void 0 ? void 0 : _g.value) || 0 });
        this.initializeDropdown('resort', this.resortOptions, true, true);
        this.initializeDropdown('shopFor', this.shopForOptions);
        this.initializeDropdown('tickets', this.ticketsOptions);
        this.initializeDropdown('departAirport', this.departAirportOptions, true);
        this.initializeDropdown('returnAirport', this.returnAirportOptions);
        this.initializeDropdown('travelClass', this.travelClassOptions);
        if (this.shouldDisplay('planType')) {
            this.planType = (_k = (_j = (_h = this.config.elements) === null || _h === void 0 ? void 0 : _h.planType) === null || _j === void 0 ? void 0 : _j.options) === null || _k === void 0 ? void 0 : _k.value;
            this.updateRoomFormDataHandler({ [this.paramNames.planType]: this.planType });
        }
        this.setDatePickerVariables();
        this.setValuesFromCookie();
        // Initialize shopForLinkId for EU/UK analytics
        this.shopForLinkId = ((_p = (_o = (_m = (_l = this.config.elements.shopFor) === null || _l === void 0 ? void 0 : _l.options) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o[this.roomFormData['shopFor']]) === null || _p === void 0 ? void 0 : _p.linkId) || '';
        this.analyticsLinkIds = ANALYTICS_LINK_IDS[this.getBrand((_q = this.config.PEP_Store) === null || _q === void 0 ? void 0 : _q.storeID)];
    }
    partyMixErrorMsgsUpdatedHandler(event) {
        this.partyMixErrorMsgs = Array.from(event.detail);
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.updateRoomFormData = createEvent(this, "updateRoomFormData", 7);
        this.setValuesFromCookie = () => {
            const roomFormCookie = JSON.parse(getCookie(QQ_COOKIE_NAME));
            if (roomFormCookie) {
                Object.entries(this.paramNames).map(entry => {
                    var _a;
                    const [elem, paramName] = entry;
                    // Set values only for elements that should display
                    if (!this.shouldDisplay(elem) && ((_a = this.roomFormData) === null || _a === void 0 ? void 0 : _a[paramName])) {
                        this.deleteRoomFormDataHandler(paramName);
                        return;
                    }
                    // Dropdown field cookie values get set in initializeDropdown function
                    if (DROPDOWN_FIELDS.includes(elem)) {
                        return;
                    }
                    if (paramName === this.paramNames.checkInDate || paramName === this.paramNames.checkOutDate) {
                        const isCheckInDate = paramName === this.paramNames.checkInDate;
                        this.setDateFromCookie(isCheckInDate);
                        return;
                    }
                    if (roomFormCookie[paramName]) {
                        this.updateRoomFormDataHandler({ [paramName]: roomFormCookie[paramName] });
                    }
                });
                this.setChildAgesFromCookie();
            }
        };
        this.setDateFromCookie = (isCheckInDate) => {
            const roomFormCookie = JSON.parse(getCookie(QQ_COOKIE_NAME));
            const dateParamName = isCheckInDate ? this.paramNames.checkInDate : this.paramNames.checkOutDate;
            const date = roomFormCookie[dateParamName];
            const parsedDate = luxon$1.DateTime.fromISO(date);
            const today = new Date(new Date().toDateString());
            const parsedTodayDate = luxon$1.DateTime.fromJSDate(today);
            if (date && (parsedDate >= parsedTodayDate)) {
                isCheckInDate ? this.dateFromValue = parsedDate.toSeconds() : this.dateToValue = parsedDate.toSeconds();
            }
            else {
                // Remove date from the cookie if it's in the past
                isCheckInDate ? this.dateFromValue = undefined : this.dateToValue = undefined;
                const _a = roomFormCookie, _b = dateParamName, filteredRoomFormCookie = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                setCookie(QQ_COOKIE_NAME, JSON.stringify(filteredRoomFormCookie));
            }
        };
        this.setChildAgesFromCookie = () => {
            // Set child age selections
            const roomFormCookie = JSON.parse(getCookie(QQ_COOKIE_NAME));
            const childAgesData = {};
            const childrenWithAges = [];
            Object.entries(roomFormCookie)
                .filter(entry => {
                // e.g. 'kid1' or 'child2'
                return entry[0].match(new RegExp(this.paramNames.child + "[0-9]{1,2}"));
            })
                .map(entry => {
                const [paramName, value] = entry;
                childrenWithAges.push({
                    id: parseInt(paramName.split(this.paramNames.child)[1]),
                    age: parseInt(value.toString())
                });
                childAgesData[paramName] = value;
            });
            this.childrenWithAges = childrenWithAges;
            this.updateRoomFormDataHandler(childAgesData);
        };
        this.initializeDropdown = (key, dropdownOptions, isMultiOptions = false, showLabelAsOption = false) => {
            if (this.shouldDisplay(key)) {
                const optionsArray = isMultiOptions ? this.getMultiOptions(key, showLabelAsOption) : this.getOptions(key);
                if (optionsArray) {
                    // Populate dropdown
                    optionsArray.map(option => {
                        dropdownOptions.push(option);
                    });
                    // Initialize selected value in roomFormData
                    const dropdownName = this.paramNames[key];
                    if (dropdownName) {
                        let defaultValue = dropdownOptions[0].key;
                        const roomFormCookie = JSON.parse(getCookie(QQ_COOKIE_NAME));
                        // Default to value from cookie if it exists and is a valid dropdown option
                        if (roomFormCookie) {
                            const cookieValue = roomFormCookie[dropdownName];
                            const optionMatch = optionsArray.filter(option => {
                                return option.key === cookieValue;
                            });
                            if (optionMatch && optionMatch.length > 0) {
                                defaultValue = cookieValue;
                            }
                        }
                        this.updateRoomFormDataHandler({ [dropdownName]: defaultValue });
                    }
                }
            }
        };
        this._handleSubmit = () => {
            if (!this.validateChildAges()) {
                this.isCollapsed = false;
                return false;
            }
            this.validateDates();
            this.validateResort();
            setCookie(QQ_COOKIE_NAME, JSON.stringify(this.roomFormData));
            if (this.shopForLinkId) {
                this.analyticsClickAndPageTransition(this.analyticsLinkIds.viewRatesEuUkBtn, { 'linkId': this.shopForLinkId });
            }
            else {
                this.analyticsClickAndPageTransition(this.analyticsLinkIds.viewRatesBtn, { 'linkId': this.analyticsLinkIds.viewRatesBtn });
            }
            this.submitShadowForm();
        };
        this.analyticsClickAndPageTransition = (linkId, modelProps) => {
            // Page view event
            this.analyticsTrackingEvent(linkId, Object.assign(Object.assign({}, modelProps), { 'pageTransitionLink': true }));
            // Click event
            this.analyticsTrackingEvent(linkId, Object.assign({}, modelProps));
        };
        this.submitShadowForm = () => {
            setTimeout(() => {
                // if config action is fully qualified url, use it otherwise prefix with pathname to preserve locale
                this.shadowForm.setAttribute('action', this.config.action.indexOf('//') > -1 ?
                    this.config.action : (location.pathname + this.config.action + '?bestValue=1').replace('//', '/'));
                this.shadowForm.submit();
                // Small delay to wait for any changes from validate functions
            }, 100);
        };
        /** setParamNames: Sets parameter names to use in form fields.
         * Although the element key is consistent,
         * some locales have a different 'paramName' for fields in the config
         * e.g. 'accessibleRoomRequest' for the 'accessible' element in en-gb
        */
        this.setParamNames = () => {
            var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
            const { elements } = this.config;
            this.paramNames = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.paramNames), ((_b = (_a = elements.checkInDate) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.paramName) && { checkInDate: (_d = (_c = elements.checkInDate) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.paramName }), ((_g = (_f = elements.checkOutDate) === null || _f === void 0 ? void 0 : _f.options) === null || _g === void 0 ? void 0 : _g.paramName) && { checkOutDate: (_j = (_h = elements.checkOutDate) === null || _h === void 0 ? void 0 : _h.options) === null || _j === void 0 ? void 0 : _j.paramName }), ((_l = (_k = elements.numberOfAdults) === null || _k === void 0 ? void 0 : _k.options) === null || _l === void 0 ? void 0 : _l.paramName) && { numberOfAdults: (_o = (_m = elements.numberOfAdults) === null || _m === void 0 ? void 0 : _m.options) === null || _o === void 0 ? void 0 : _o.paramName }), ((_q = (_p = elements.numberOfChildren) === null || _p === void 0 ? void 0 : _p.options) === null || _q === void 0 ? void 0 : _q.paramName) && { numberOfChildren: (_s = (_r = elements.numberOfChildren) === null || _r === void 0 ? void 0 : _r.options) === null || _s === void 0 ? void 0 : _s.paramName }), ((_u = (_t = elements.child) === null || _t === void 0 ? void 0 : _t.options) === null || _u === void 0 ? void 0 : _u.nameTemplate) && { child: ((_w = (_v = elements.child) === null || _v === void 0 ? void 0 : _v.options) === null || _w === void 0 ? void 0 : _w.nameTemplate).replace(/({{)(.*)(}})/g, '') }), ((_y = (_x = elements.accessible) === null || _x === void 0 ? void 0 : _x.options) === null || _y === void 0 ? void 0 : _y.paramName) && { accessible: (_0 = (_z = elements.accessible) === null || _z === void 0 ? void 0 : _z.options) === null || _0 === void 0 ? void 0 : _0.paramName });
        };
        this.updateRoomFormDataHandler = (newData) => {
            this.roomFormData = Object.assign(Object.assign({}, this.roomFormData), newData);
            this.partyMixChildCount = this.roomFormData[this.paramNames.numberOfChildren] || 0;
            this.updateRoomFormData.emit(newData);
        };
        this.deleteRoomFormDataHandler = (property) => {
            var _a;
            if ((_a = this.roomFormData) === null || _a === void 0 ? void 0 : _a[property]) {
                delete this.roomFormData[property];
                this.updateRoomFormData.emit(this.roomFormData);
            }
        };
        this.getDefaultDateRangeOptions = () => {
            var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            const defaultLengthOfStay = ((_a = this.config.constraints) === null || _a === void 0 ? void 0 : _a.defaultLengthOfStay)
                || DATE_RANGE_DEFAULTS.defaultLengthOfStay;
            const minLengthOfStay = ((_b = this.config.constraints) === null || _b === void 0 ? void 0 : _b.minLengthOfStay) || DATE_RANGE_DEFAULTS.minLengthOfStay;
            const maxLengthOfStay = ((_c = this.config.constraints) === null || _c === void 0 ? void 0 : _c.maxLengthOfStay) || DATE_RANGE_DEFAULTS.maxLengthOfStay;
            const defaultCheckinDate = ((_d = this.config.constraints) === null || _d === void 0 ? void 0 : _d.defaultCheckinDate)
                || ((_h = (_g = (_f = this.config.elements) === null || _f === void 0 ? void 0 : _f.checkInDate) === null || _g === void 0 ? void 0 : _g.options) === null || _h === void 0 ? void 0 : _h.minDate)
                || DATE_RANGE_DEFAULTS.defaultCheckinDate;
            return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ defaultLengthOfStay,
                minLengthOfStay,
                maxLengthOfStay,
                defaultCheckinDate }, { maxCheckinDate: (_j = this.config.constraints) === null || _j === void 0 ? void 0 : _j.maxCheckinDate }), { checkInDateName: this.paramNames.checkInDate }), { checkOutDateName: this.paramNames.checkOutDate }), { productLoadEndDate: (_m = (_l = (_k = this.config.elements) === null || _k === void 0 ? void 0 : _k.checkInDate) === null || _l === void 0 ? void 0 : _l.options) === null || _m === void 0 ? void 0 : _m.productLoadEndDate }), { maxDaysPastProductLoad: (_q = (_p = (_o = this.config.elements) === null || _o === void 0 ? void 0 : _o.checkOutDate) === null || _p === void 0 ? void 0 : _p.options) === null || _q === void 0 ? void 0 : _q.maxDaysPastProductLoad });
        };
        this.updateDateRangeOptions = (options) => {
            // Set to new values if defined, otherwise reset to default values
            const defaultOptions = this.getDefaultDateRangeOptions();
            this.dateRangeOptions = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, defaultOptions), (options.defaultLengthOfStay && { defaultLengthOfStay: options.defaultLengthOfStay })), (options.minLengthOfStay && { minLengthOfStay: options.minLengthOfStay })), (options.maxLengthOfStay && { maxLengthOfStay: options.maxLengthOfStay })), (options.defaultCheckinDate && { defaultCheckinDate: options.defaultCheckinDate }));
        };
        /** validateDates: Set default dates if dates are invalid */
        this.validateDates = () => {
            const { checkInDateName, checkOutDateName, defaultCheckinDate, defaultLengthOfStay } = this.dateRangeOptions;
            // If checkInDate is invalid, set to today
            if (this.roomFormData === undefined || !this.roomFormData[checkInDateName]) {
                const today = new Date(new Date().toDateString());
                const todayJS = luxon$1.DateTime.fromJSDate(today);
                const checkInDate = todayJS.plus({ days: defaultCheckinDate });
                const checkInDateFormatted = checkInDate.toFormat(this.apiDateFormat);
                this.updateRoomFormDataHandler({ [checkInDateName]: checkInDateFormatted });
            }
            // If checkOutDate is invalid, set to defaultLengthOfStay days after checkInDate
            if (this.roomFormData === undefined || !this.roomFormData[checkOutDateName]) {
                const checkInDate = luxon$1.DateTime.fromFormat(this.roomFormData[checkInDateName], this.apiDateFormat);
                const checkOutDate = checkInDate.plus({ days: defaultLengthOfStay });
                const checkOutDateFormatted = checkOutDate.toFormat(this.apiDateFormat);
                this.updateRoomFormDataHandler({ [checkOutDateName]: checkOutDateFormatted });
            }
            this.updateDuration();
        };
        /** validateResort: Remove from form data if 'All Resort Hotels' is selected */
        this.validateResort = () => {
            if (this.roomFormData[this.paramNames.resort] === '0') {
                this.deleteRoomFormDataHandler(this.paramNames.resort);
            }
        };
        /** validateChildAges: Returns true if each child has a valid age selection */
        this.validateChildAges = () => {
            var _a, _b;
            if (!this.partyMixChildCount || ((_b = (_a = this.config.collections.partyMixTickets) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.suppressChildAges)) {
                return true;
            }
            // Identify which child elements are missing an age selection
            const existingKeys = Object.keys(this.roomFormData);
            const errorsArray = [];
            for (let i = 1; i <= this.partyMixChildCount; i++) {
                if (existingKeys.indexOf(`${this.paramNames.child}${i.toString()}`) === -1) {
                    errorsArray.push(i);
                }
            }
            this.partyMixChildErrorsArray = [...errorsArray];
            return this.partyMixChildErrorsArray.length === 0;
        };
        this.updateFlightSelection = (key, defaultSelection) => {
            const displaySelection = this.shouldDisplay(key);
            const fieldName = this.paramNames[key];
            if (!displaySelection && this.roomFormData[fieldName]) {
                this.deleteRoomFormDataHandler(fieldName);
            }
            else if (displaySelection && !this.roomFormData[fieldName]) {
                this.updateRoomFormDataHandler({ [fieldName]: defaultSelection });
            }
        };
        this.updateFlightSelections = () => {
            var _a, _b, _c;
            this.updateFlightSelection('departAirport', (_a = this.departAirportOptions[0]) === null || _a === void 0 ? void 0 : _a.key);
            this.updateFlightSelection('returnAirport', (_b = this.returnAirportOptions[0]) === null || _b === void 0 ? void 0 : _b.key);
            this.updateFlightSelection('travelClass', (_c = this.travelClassOptions[0]) === null || _c === void 0 ? void 0 : _c.key);
        };
        this.updateOption = (fieldName, value) => {
            if (this.shouldDisplay(fieldName)) {
                this.updateRoomFormDataHandler({ [fieldName]: value });
            }
            else {
                this.deleteRoomFormDataHandler(fieldName);
            }
        };
        this.updateDuration = () => {
            if (this.roomFormData[this.paramNames.checkInDate] && this.roomFormData[this.paramNames.checkOutDate]) {
                let duration = 0;
                const checkInDate = luxon$1.DateTime.fromFormat(this.roomFormData[this.paramNames.checkInDate], this.apiDateFormat);
                const checkOutDate = luxon$1.DateTime.fromFormat(this.roomFormData[this.paramNames.checkOutDate], this.apiDateFormat);
                duration = checkOutDate.diff(checkInDate, 'days').toObject().days - 1;
                this.updateOption(this.paramNames.Duration, duration);
            }
        };
        this.handleAccessibleCheckbox = (e) => {
            this.updateRoomFormDataHandler({ [this.paramNames.accessible]: e.detail.value ? 1 : 0 });
        };
        this.handleShopForSelect = (e) => {
            var _a, _b, _c;
            const shopForOptions = (_a = this.config.elements.shopFor.options.data) === null || _a === void 0 ? void 0 : _a[e.detail.key];
            this.shopForLinkId = shopForOptions.linkId;
            this.isCollapsed = false;
            this.updateRoomFormDataHandler({ [this.paramNames.shopFor]: e.detail.key });
            this.updateFlightSelections();
            this.updateOption(this.paramNames.Sorting, (_c = (_b = this.config.elements.Sorting) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.value);
            this.updateOption(this.paramNames.planType, shopForOptions.planType || this.planType);
            this.updateDuration();
            this.updateDateRangeOptions(shopForOptions);
        };
        this.handleSelect = (e, fieldName) => {
            this.updateRoomFormDataHandler({ [fieldName]: e.detail.key });
        };
        this.handleToggle = () => {
            this.isCollapsed = !this.isCollapsed;
        };
        this.handleKeydown = (e, callbackFn) => {
            // Enter or spacebar key is pressed
            if (e.code === 'Enter' || e.code === 'Space') {
                e.preventDefault();
                callbackFn();
            }
        };
        this.handleMobileToggle = (_e) => {
            this.isMobileCollapsed = !this.isMobileCollapsed;
            if (!this.isMobileCollapsed) {
                this.analyticsTrackingEvent(this.analyticsLinkIds.mobileToggle, { 'linkId': this.analyticsLinkIds.mobileToggle });
            }
        };
        this.disableSubmitButton = () => {
            return !!this.datepickerError || this.partyMixErrorMsgs.length > 0;
        };
        this.config = undefined;
        this.isFast = false;
        this.isFastCollapsible = true;
        this.analyticsTrackingEvent = undefined;
        this.isCollapsed = true;
        this.isMobileCollapsed = true;
        this.apiDateFormat = 'yyyy-MM-dd';
        this.planType = undefined;
        this.resortOptions = [];
        this.shopForOptions = [];
        this.shopForLinkId = '';
        this.ticketsOptions = [];
        this.departAirportOptions = [];
        this.returnAirportOptions = [];
        this.travelClassOptions = [];
        this.roomFormData = undefined;
        this.paramNames = DEFAULT_PARAM_NAMES;
        this.dateRangeOptions = DATE_RANGE_DEFAULTS;
        this.partyMixChildCount = 0;
        this.partyMixChildErrorsArray = [];
        this.partyMixErrorMsgs = [];
        this.childrenWithAges = [];
        this.activeElementTag = undefined;
        this.wdprDatePicker = undefined;
        this.inputLabel = undefined;
        this.dateFromPlaceholder = undefined;
        this.dateToPlaceholder = undefined;
        this.dateFormat = undefined;
        this.dateFromValue = undefined;
        this.dateToValue = undefined;
        this.localePreferredLanguage = undefined;
        this.datePickerElement = undefined;
        this.dateInputChanged = false;
        this.analyticsLinkIds = undefined;
        this.datepickerError = undefined;
        this.wdprDatePicker = new WdprDatePicker(this);
    }
    componentDidLoad() {
        // Make sure shadowRoot is ready before adding event listeners 
        const shadowRoot = this.element.shadowRoot;
        if (shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.innerHTML) {
            this.addActiveElementEventListeners();
        }
        else {
            const observer = new MutationObserver(() => {
                if (shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.innerHTML) {
                    this.addActiveElementEventListeners();
                    observer.disconnect();
                }
            });
            observer.observe(shadowRoot, { childList: true });
        }
        this.setValuesFromCookie();
    }
    getLanguageFromLocale(locale) {
        if (!locale)
            return ''; // Return an empty string if no input is provided
        // Normalize the locale string to lowercase and replace underscores with dashes
        const normalizedLocale = locale.toLowerCase().replace('_', '-');
        // Extract the first part before the dash
        const [language] = normalizedLocale.split('-');
        return language;
    }
    setDatePickerVariables() {
        var _a;
        this.dateFormat = this.config.options.momentDateFormat;
        const localePreferredLanguage = (_a = this.config._info.registry) === null || _a === void 0 ? void 0 : _a.localePreferredLanguage;
        this.localePreferredLanguage = this.getLanguageFromLocale(localePreferredLanguage);
        this.dateFromValue = this.roomFormData[this.paramNames.checkInDate];
        this.dateToValue = this.roomFormData[this.paramNames.checkOutDate];
    }
    getBrand(storeID) {
        let brand = 'default';
        // Some storeID values include the locale, e.g. 'wdw_lacd_ar'
        if (storeID.startsWith('wdw')) {
            brand = 'wdw';
        }
        else if (storeID.startsWith('dlr')) {
            brand = 'dlr';
        }
        return brand;
    }
    debounce() {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.handleResize();
        }, 100);
    }
    handleResize() {
        this.wdprDatePicker.handleResize();
    }
    addActiveElementEventListeners() {
        var _a, _b, _c;
        // TODO: move these to component template attributes when RA has added them
        const shadowRoot = this.element.shadowRoot;
        const datePickerElement = shadowRoot.querySelector('wdpr-range-datepicker');
        this.datePickerElement = datePickerElement;
        (_a = this.datePickerElement.shadowRoot.querySelector('#input1')) === null || _a === void 0 ? void 0 : _a.addEventListener('input', (e) => this.wdprDatePicker.prohibitNonDateChars(e));
        (_b = this.datePickerElement.shadowRoot.querySelector('#input2')) === null || _b === void 0 ? void 0 : _b.addEventListener('input', (e) => this.wdprDatePicker.prohibitNonDateChars(e));
        this.wdprDatePicker.init();
        (_c = this.datePickerElement) === null || _c === void 0 ? void 0 : _c.addEventListener('click', () => {
            this.setActiveElement(DATE_PICKER);
        });
        const tripDatesPicker = shadowRoot.getElementById('tripDatesPicker');
        tripDatesPicker === null || tripDatesPicker === void 0 ? void 0 : tripDatesPicker.addEventListener('click', () => {
            this.setActiveElement(DATE_PICKER);
        });
        const partyMixSelect = shadowRoot.querySelector('wdpr-party-mix-select');
        partyMixSelect.addEventListener('click', () => {
            this.setActiveElement(PARTY_MIX);
        });
        const accessibilityCheckbox = shadowRoot.getElementById('accessibilityCheckbox');
        accessibilityCheckbox === null || accessibilityCheckbox === void 0 ? void 0 : accessibilityCheckbox.addEventListener('click', () => {
            this.setActiveElement(ACCESSIBILITY);
        });
        document.addEventListener('click', (event) => {
            const { target } = event;
            if (target.getAttribute('id') !== 'lodging-qq-container') {
                this.setActiveElement('');
            }
        });
    }
    componentWillUnload() {
        var _a;
        const shadowRoot = this.element.shadowRoot;
        (_a = this.datePickerElement) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', () => {
            this.setActiveElement(DATE_PICKER);
        });
        const tripDatesPicker = shadowRoot.getElementById('tripDatesPicker');
        tripDatesPicker === null || tripDatesPicker === void 0 ? void 0 : tripDatesPicker.removeEventListener('click', () => {
            this.setActiveElement(DATE_PICKER);
        });
        const partyMixSelect = shadowRoot.querySelector('wdpr-party-mix-select');
        partyMixSelect === null || partyMixSelect === void 0 ? void 0 : partyMixSelect.removeEventListener('click', () => {
            this.setActiveElement(PARTY_MIX);
        });
        const accessibilityCheckbox = shadowRoot.getElementById('accessibilityCheckbox');
        accessibilityCheckbox === null || accessibilityCheckbox === void 0 ? void 0 : accessibilityCheckbox.removeEventListener('click', () => {
            this.setActiveElement(ACCESSIBILITY);
        });
        document.removeEventListener('click', (event) => {
            const { target } = event;
            if (target.getAttribute('id') !== 'lodging-qq-container') {
                this.setActiveElement('');
            }
        });
    }
    setActiveElement(elementName) {
        this.activeElementTag = elementName;
        this.updateComponentsBasedOnActiveElement();
    }
    updateComponentsBasedOnActiveElement() {
        const shadowRoot = this.element.shadowRoot;
        this.datePickerElement = shadowRoot.querySelector('wdpr-range-datepicker');
        const tripDatesPicker = shadowRoot.getElementById('tripDatesPicker');
        const tripPickerRange = tripDatesPicker === null || tripDatesPicker === void 0 ? void 0 : tripDatesPicker.shadowRoot.querySelector('wdpr-range-datepicker');
        this.isCollapsed = false;
        if (this.activeElementTag === DATE_PICKER) {
            tripPickerRange === null || tripPickerRange === void 0 ? void 0 : tripPickerRange.removeAttribute('range-datepicker-hidden');
            this.datePickerElement.removeAttribute('range-datepicker-hidden');
        }
        else if (!this.datePickerElement.hasAttribute('range-datepicker-hidden') || !(tripPickerRange === null || tripPickerRange === void 0 ? void 0 : tripPickerRange.hasAttribute('range-datepicker-hidden'))) {
            tripPickerRange === null || tripPickerRange === void 0 ? void 0 : tripPickerRange.setAttribute('range-datepicker-hidden', 'range-datepicker-hidden');
            this.datePickerElement.setAttribute('range-datepicker-hidden', 'range-datepicker-hidden');
        }
    }
    forceQQUpdate() {
        forceUpdate(this);
    }
    shouldDisplay(name) {
        var _a, _b, _c;
        const elem = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b[name];
        const options = elem === null || elem === void 0 ? void 0 : elem.options;
        let display = false;
        if (elem === undefined) {
            display = false;
        }
        else if (!options.dependency) {
            display = true;
        }
        else if (!this.roomFormData[(_c = options === null || options === void 0 ? void 0 : options.dependency) === null || _c === void 0 ? void 0 : _c.field]) {
            display = false;
        }
        else {
            if (options.dependency.value.indexOf('!') !== -1) {
                display = this.roomFormData[options.dependency.field] !== options.dependency.value.replace('!', '');
            }
            else {
                display = this.roomFormData[options.dependency.field] ?
                    this.roomFormData[options.dependency.field] === options.dependency.value :
                    false;
            }
        }
        return display;
    }
    getOptions(name) {
        var _a, _b;
        const options = (_b = (_a = this.config.elements) === null || _a === void 0 ? void 0 : _a[name]) === null || _b === void 0 ? void 0 : _b.options;
        const keys = Object.keys(options.data);
        return [
            ...lodash.map(keys, (key) => ({
                key,
                value: options.data[key].text
            }))
        ];
    }
    getMultiOptions(name, showLabelAsOption = false) {
        var _a, _b, _c;
        const options = (_b = (_a = this.config.elements) === null || _a === void 0 ? void 0 : _a[name]) === null || _b === void 0 ? void 0 : _b.options;
        const multiOptions = [
            ...lodash.map(options.multiOptions, option => this.getOptionTypeList(option)).flat()
        ];
        if (showLabelAsOption) {
            multiOptions.unshift({ key: '0', value: ((_c = options.attribs) === null || _c === void 0 ? void 0 : _c.defaultLabel) || options.label });
        }
        return multiOptions;
    }
    getOptionTypeList(type) {
        const optionTypeList = [];
        const hasSubHeading = !!type.text;
        const hasSubItems = !!type.list;
        // Add sub heading
        if (hasSubHeading) {
            optionTypeList.push(Object.assign({ key: type.id, value: type.text }, (hasSubItems && { partsOverride: { 'option-item': 'option-item-subhead' } })));
        }
        // Add sub items
        if (hasSubItems) {
            lodash.map(type.list, (option) => (optionTypeList.push(Object.assign({ key: option.id, value: option.text }, (hasSubHeading && { partsOverride: { 'option-item': 'option-item-subitem' } })))));
        }
        return optionTypeList;
    }
    get ready() {
        try {
            this.config = JSON.parse(this.config);
            console.info('QQ Config Parsed and Ready');
        }
        catch (error) {
            console.info('QQ Config Ready');
        }
        return (this.config &&
            this.config._info &&
            this.config.elements &&
            this.config.collections &&
            this.config.class &&
            this.config.options &&
            this.config.constraints &&
            this.roomFormData);
    }
    render() {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
        if (!this.ready) {
            return h(Host, null);
        }
        return (h(Host, { class: this.config.class, id: 'lodging-qq-container' }, h("div", { class: 'panel ' + (this.isFast ? 'showfast' : '') }, h("div", { class: 'panel-body', id: 'panel-body' }, this.isFast && (h("div", { class: "qq-rounded-spacer" })), this.shouldDisplay('purchaseTickets') &&
            h("a", { id: 'purchaseTicketsAnchor', class: `mobile-view ${((_c = (_b = (_a = this.config.elements.purchaseTickets) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.attribs) === null || _c === void 0 ? void 0 : _c.class) || ''}`, href: (_f = (_d = this.config.elements.purchaseTickets) === null || _d === void 0 ? void 0 : _d.options) === null || _f === void 0 ? void 0 : _f.href, target: '_self' }, h("wdpr-button", { id: 'purchaseTicketsButton', onClick: () => {
                    this.analyticsClickAndPageTransition(this.analyticsLinkIds.purchaseTicketsBtn, { linkId: this.analyticsLinkIds.purchaseTicketsBtn });
                } }, (_h = (_g = this.config.elements.purchaseTickets) === null || _g === void 0 ? void 0 : _g.options) === null || _h === void 0 ? void 0 : _h.label)), this.datepickerError &&
            h("div", { class: 'errorWrapper' }, h("span", { class: 'di di20 di-alert alert-icon' }), h("div", { class: 'error' }, this.datepickerError)), this.partyMixErrorMsgs.length > 0 &&
            h("div", null, this.partyMixErrorMsgs.map((errorMsg, index) => {
                return (h("div", { class: 'errorWrapper' }, h("span", { class: 'di di20 di-alert alert-icon' }), h("div", { class: 'partyMixError', key: `partyMixError${index}`, innerHTML: errorMsg })));
            })), this.isFast && !this.isFastCollapsible &&
            h("div", null, h("h1", { class: 'mobile-view header', "aria-expanded": `${!this.isMobileCollapsed}`, "aria-controls": 'fieldsContainer' }, (_k = (_j = this.config.elements.title) === null || _j === void 0 ? void 0 : _j.options) === null || _k === void 0 ? void 0 : _k.label)), h("wdpr-button", { id: 'mobileToggle', class: `mobile-view ${this.isMobileCollapsed ? 'collapsed' : 'expanded'}` +
                ` ${((_l = this.roomFormData) === null || _l === void 0 ? void 0 : _l.shopFor) || ''}` +
                ` ${(this.isFast && !this.isFastCollapsible) ? 'fast-not-collapsible' : ''}`, onClick: (e) => this.handleMobileToggle(e), "aria-expanded": `${!this.isMobileCollapsed}`, "aria-controls": 'fieldsContainer' }, h("span", { class: `di di18 di-norgie-opened ${this.isMobileCollapsed ? 'collapsed' : 'expanded'}`, "aria-hidden": 'true' }), this.isFast ? (h("span", { class: 'fast-button' }, h("span", { class: "dpo-icon" }, "\uE0C8"), (_o = (_m = this.config.elements.title) === null || _m === void 0 ? void 0 : _m.options) === null || _o === void 0 ? void 0 :
            _o.label)) : (h("span", null, (_q = (_p = this.config.elements.title) === null || _p === void 0 ? void 0 : _p.options) === null || _q === void 0 ? void 0 : _q.label))), h("div", null), h("div", { id: "fieldsContainer", class: `fields-container collapse expand quickquote-active` +
                ` ${((_r = this.roomFormData) === null || _r === void 0 ? void 0 : _r.shopFor) || 'show-title'}` +
                ` ${((this.childrenWithAges.filter(child => child.age === undefined).length > 0 || (this.activeElementTag === PARTY_MIX && this.childrenWithAges.length > 0)) && !((_t = (_s = this.config.collections.partyMixTickets) === null || _s === void 0 ? void 0 : _s.options) === null || _t === void 0 ? void 0 : _t.suppressChildAges)) ? 'has-children' : ''}` + //child age dropdown should only be shown if ages are not selected or if party mix is active
                ` ${(this.isCollapsed) ? 'toggle-collapsed' : 'toggle-expanded'}` }, !this.config.elements.shopFor &&
            h("div", { id: 'titleContainer', class: 'title field' }, (_v = (_u = this.config.elements.title) === null || _u === void 0 ? void 0 : _u.options) === null || _v === void 0 ? void 0 : _v.label), this.shouldDisplay('shopFor') &&
            h("wdpr-single-select", { id: 'shopForSelect', options: this.shopForOptions, value: this.roomFormData[this.paramNames.shopFor], "onItem-selected": (e) => { this.handleShopForSelect(e); }, "onDropdown-opened": () => { this.setActiveElement(SHOP_FOR_SELECT); }, label: (_x = (_w = this.config.elements.shopFor) === null || _w === void 0 ? void 0 : _w.options) === null || _x === void 0 ? void 0 : _x.label, class: `field ${((_z = (_y = this.config.elements.shopFor) === null || _y === void 0 ? void 0 : _y.options) === null || _z === void 0 ? void 0 : _z.class) || ''}` }), this.shouldDisplay('tickets') &&
            h("wdpr-single-select", { id: 'ticketsSelect', options: this.ticketsOptions, value: this.ticketsOptions[0].key, label: (_1 = (_0 = this.config.elements.tickets) === null || _0 === void 0 ? void 0 : _0.options) === null || _1 === void 0 ? void 0 : _1.label, class: 'field' }), this.shouldDisplay('checkInDate') &&
            h("wdpr-range-datepicker", { id: 'rangeDatePicker', "input-label": (_3 = (_2 = this.config.collections.dateRangeConfig) === null || _2 === void 0 ? void 0 : _2.options) === null || _3 === void 0 ? void 0 : _3.label, "date-format": this.dateFormat, "date-from": this.dateFromValue, "date-to": this.dateToValue, "date-from-placeholder": (_5 = (_4 = this.config.elements.checkInDate) === null || _4 === void 0 ? void 0 : _4.options) === null || _5 === void 0 ? void 0 : _5.label, "date-to-placeholder": (_7 = (_6 = this.config.elements.checkOutDate) === null || _6 === void 0 ? void 0 : _6.options) === null || _7 === void 0 ? void 0 : _7.label, "four-month": true, max: this.wdprDatePicker.maxDate, min: this.wdprDatePicker.minDate, "selectable-max": this.wdprDatePicker.maxSelectableDate, "onOpen-state": (e) => { this.wdprDatePicker.onOpenState(e); }, "onDate-from-selected": (e) => { this.wdprDatePicker.onDateSelected(e.detail.date.toString(), 'from'); }, "onDate-to-selected": (e) => { this.wdprDatePicker.onDateSelected(e.detail.date.toString(), 'to'); }, "onInvalid-from-changed": () => this.wdprDatePicker.onInvalidDateInput('from'), "onInvalid-to-changed": () => this.wdprDatePicker.onInvalidDateInput('to'), "editable-input": "true", "message-hidden": true, "invalid-from-message": "", "invalid-to-message": "", "invalid-from": this.wdprDatePicker.invalidFromInput, "invalid-to": this.wdprDatePicker.invalidToInput, description: '', locale: this.localePreferredLanguage, dynamicSizing: false, class: 'field' }), this.shouldDisplay('departAirport') &&
            h("wdpr-single-select", { id: 'departAirportSelect', options: this.departAirportOptions, value: this.roomFormData[this.paramNames.departAirport], "onItem-selected": (e) => { this.handleSelect(e, this.paramNames.departAirport); }, "onDropdown-opened": () => { this.setActiveElement(DEPART_AIRPORT); }, label: (_9 = (_8 = this.config.elements.departAirport) === null || _8 === void 0 ? void 0 : _8.options) === null || _9 === void 0 ? void 0 : _9.label, class: 'field tablet-col-2' }), this.shouldDisplay('returnAirport') &&
            h("wdpr-single-select", { id: 'returnAirportSelect', options: this.returnAirportOptions, value: this.roomFormData[this.paramNames.returnAirport], "onItem-selected": (e) => { this.handleSelect(e, this.paramNames.returnAirport); }, "onDropdown-opened": () => { this.setActiveElement(RETURN_AIRPORT); }, label: (_11 = (_10 = this.config.elements.returnAirport) === null || _10 === void 0 ? void 0 : _10.options) === null || _11 === void 0 ? void 0 : _11.label, class: 'field tablet-col-2' }), ((_12 = this.roomFormData) === null || _12 === void 0 ? void 0 : _12.shopFor) === 'flightHoliday' &&
            h("div", { id: 'collapseToggle', class: `field ${this.isCollapsed ? 'collapsed' : 'expanded'}`, onClick: (_e) => this.handleToggle(), onKeyDown: (e) => this.handleKeydown(e, this.handleToggle), role: 'button', tabIndex: 0, "aria-expanded": (!this.isCollapsed).toString(), "aria-controls": 'travelClassSelect partyMixSelect accessibilityCheckbox' }, h("span", { "aria-hidden": 'true', class: `di di18 di-next-2 ${this.isCollapsed ? 'collapsed' : 'expanded'}` }), h("div", null, this.isCollapsed ? 'Open' : 'Close')), this.shouldDisplay('travelClass') &&
            h("wdpr-single-select", { id: 'travelClassSelect', options: this.travelClassOptions, value: this.roomFormData[this.paramNames.travelClass], "onItem-selected": (e) => { this.handleSelect(e, this.paramNames.travelClass); }, "onDropdown-opened": () => { this.setActiveElement(TRAVEL_CLASS_SELECT); }, label: (_14 = (_13 = this.config.elements.travelClass) === null || _13 === void 0 ? void 0 : _13.options) === null || _14 === void 0 ? void 0 : _14.label, class: 'field hide-on-collapse tablet-col-1', "aria-hidden": (this.isCollapsed).toString() }), h("wdpr-party-mix-select", { id: 'partyMixSelect', updateRoomFormDataHandler: this.updateRoomFormDataHandler, deleteRoomFormDataHandler: this.deleteRoomFormDataHandler, config: this.config, adultCount: this.roomFormData[this.paramNames.numberOfAdults], childCount: this.roomFormData[this.paramNames.numberOfChildren], childrenWithAges: this.childrenWithAges, adultCountParamName: this.paramNames.numberOfAdults, childCountParamName: this.paramNames.numberOfChildren, childParamName: this.paramNames.child, minAdults: this.config.constraints.minNumberOfAdults, maxAdults: this.config.constraints.maxNumberOfAdults, minChildren: this.config.constraints.minNumberOfChildren, maxChildren: this.config.constraints.maxNumberOfChildren, maxPartySize: this.config.constraints.maxPartySize, childErrorsArray: this.partyMixChildErrorsArray, class: 'field hide-on-collapse tablet-col-2', displayChildAges: this.activeElementTag === PARTY_MIX, "aria-hidden": (this.isCollapsed).toString() }), this.shouldDisplay('resort') &&
            h("wdpr-single-select", { id: 'resortSelect', value: this.roomFormData[this.paramNames.resort] || this.resortOptions[0].key, options: this.resortOptions, "onItem-selected": (e) => { this.handleSelect(e, this.paramNames.resort); }, "onDropdown-opened": () => { this.setActiveElement(RESORT_SELECT); }, label: (_16 = (_15 = this.config.elements.resort) === null || _15 === void 0 ? void 0 : _15.options) === null || _16 === void 0 ? void 0 : _16.label, class: 'field' }), this.shouldDisplay('accessible') &&
            ((_17 = this.roomFormData) === null || _17 === void 0 ? void 0 : _17.shopFor) !== 'ticketOnly' &&
            h("wdpr-checkbox", { checked: parseInt(this.roomFormData[this.paramNames.accessible]) === 1, id: 'accessibilityCheckbox', class: 'field hide-on-collapse tablet-col-1', "onChecked-changed": this.handleAccessibleCheckbox, "aria-hidden": (this.isCollapsed).toString() }, (_19 = (_18 = this.config.elements.accessible) === null || _18 === void 0 ? void 0 : _18.options) === null || _19 === void 0 ? void 0 : _19.label), h("wdpr-button", { id: 'findPricesButton', onClick: this._handleSubmit, class: 'field', disabled: this.disableSubmitButton() }, (_21 = (_20 = this.config.elements.findRoomButton) === null || _20 === void 0 ? void 0 : _20.options) === null || _21 === void 0 ? void 0 : _21.label))), h("div", { class: `panel-footer ${this.config.debug ? '' : 'hide'}` }, h("div", { is: 'shadowFormContainer' }, h("h4", null, "For Office Use Only"), h("hr", null), h("form", { id: 'shadowForm', name: 'shadowForm', class: 'shadow-form', method: this.config.method || 'POST', ref: (el) => this.shadowForm = el }, h("input", { type: 'hidden', name: 'pep_csrf', placeholder: 'pep_csrf', value: (_22 = this.config._info) === null || _22 === void 0 ? void 0 : _22.csrfToken }), h("input", { type: "hidden", name: "pageLocation", value: this.config.destination }), h("input", { type: "hidden", name: "offer", value: '' }), Object.keys(this.roomFormData).map(key => {
            return (h("div", { class: 'shadow-form-field' }, h("label", { htmlFor: key }, key), h("input", { type: 'text', name: key, placeholder: key, value: this.roomFormData[key] })));
        })), h("hr", null))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "config": ["_handleConfigChange"]
    }; }
    static get style() { return wdprLodgingQuickquoteCss; }
}, [1, "wdpr-lodging-quickquote", {
        "config": [8],
        "isFast": [4, "is-fast"],
        "isFastCollapsible": [4, "is-fast-collapsible"],
        "analyticsTrackingEvent": [16],
        "isCollapsed": [32],
        "isMobileCollapsed": [32],
        "apiDateFormat": [32],
        "planType": [32],
        "resortOptions": [32],
        "shopForOptions": [32],
        "shopForLinkId": [32],
        "ticketsOptions": [32],
        "departAirportOptions": [32],
        "returnAirportOptions": [32],
        "travelClassOptions": [32],
        "roomFormData": [32],
        "paramNames": [32],
        "dateRangeOptions": [32],
        "partyMixChildCount": [32],
        "partyMixChildErrorsArray": [32],
        "partyMixErrorMsgs": [32],
        "childrenWithAges": [32],
        "activeElementTag": [32],
        "wdprDatePicker": [32],
        "inputLabel": [32],
        "dateFromPlaceholder": [32],
        "dateToPlaceholder": [32],
        "dateFormat": [32],
        "dateFromValue": [32],
        "dateToValue": [32],
        "localePreferredLanguage": [32],
        "datePickerElement": [32],
        "dateInputChanged": [32],
        "analyticsLinkIds": [32],
        "datepickerError": [32]
    }, [[0, "partyMixErrorMsgsUpdated", "partyMixErrorMsgsUpdatedHandler"], [9, "resize", "debounce"]], {
        "config": ["_handleConfigChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wdpr-lodging-quickquote", "wdpr-party-mix-select"];
    components.forEach(tagName => { switch (tagName) {
        case "wdpr-lodging-quickquote":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WdprLodgingQuickQuote);
            }
            break;
        case "wdpr-party-mix-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
    } });
}

const WdprLodgingQuickquote = WdprLodgingQuickQuote;
const defineCustomElement = defineCustomElement$1;

export { WdprLodgingQuickquote, defineCustomElement };

